webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ApiService = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

__webpack_require__(36);

var ApiService = exports.ApiService = angular.module('checkout.apiService', ['app.constants']).service('apiService', ['BASE_API_URL', '$http', function (BASE_API_URL, $http) {
    var tenantId = void 0;
    var shopperId = void 0;

    var apiUrls = {
        addressAutocomplete: getApiUrl('/addresses/autocomplete'),
        addressAutocompleteDetails: getApiUrl('/addresses/autocomplete/details'),
        addressVerification: getApiUrl('/addresses/addressverification'),
        legacyCart: getApiUrl('/carts'),
        cart: getApiUrl('/public/rest/carts'),
        discount: getApiUrl('/discounts'),
        bag: getApiUrl('/store/bag'),
        order: getApiUrl('/store/orders'),
        paypal: getApiUrl('/public/rest/paypal/orders'),
        paypalClientToken: getApiUrl('/paypal/getToken'),
        legacyPaypal: getApiUrl('/paypal'),
        storeInfo: getApiUrl('/storeinformation'),
        paymentKeys: getApiUrl('/store/paymentkeys'),
        shopperAuth: getApiUrl('/shopper/shoppers'),
        shopper: getApiUrl('/shoppers'),
        client: getApiUrl('/shoppers/client'),
        shipToLocations: getApiUrl('/store/shiptolocations'),
        shippingMethods: getApiUrl('/store/shippingmethods'),
        storeCredit: getApiUrl('/store/storeCredit'),
        variant: getApiUrl('/public/rest/variants')
    };

    function getApiUrl(urlEnding) {
        return '' + BASE_API_URL + urlEnding;
    }

    function getHttpConfig(skipAuth) {
        var config = {
            headers: {
                'x-mat-tenant': tenantId
            },
            skipAuthorization: skipAuth
        };

        if (shopperId && !skipAuth) {
            config.headers['x-vol-shopper'] = shopperId;
        }

        return config;
    }

    function setTenantId(id) {
        tenantId = id;
    }

    function getTenantId() {
        return tenantId;
    }

    function setShopperId(id) {
        shopperId = id;
    }

    function getShopperId() {
        return shopperId;
    }

    function getLegacyCart(cartId) {
        return $http.get(apiUrls.legacyCart + '/' + cartId, getHttpConfig(true)).then(function (response) {
            return response.data;
        });
    }

    function getCart(cartId) {
        var cartPath = apiUrls.cart + '/' + cartId;
        return $http.get(cartPath, getHttpConfig(true)).then(function (response) {
            var cart = response.data;
            if ((typeof cart === 'undefined' ? 'undefined' : _typeof(cart)) === 'object' && cart !== null && Array.isArray(cart.items)) {
                return Promise.all(cart.items.map(function (item) {
                    return getVariant(item);
                })).then(function (itemResponses) {
                    itemResponses.forEach(function (itemResponse, index) {
                        cart.items[index].variant = itemResponse;
                    });
                    return cart;
                });
            }
            return cart;
        });
    }

    function fetchShippingMethods(_ref) {
        var cartId = _ref.cartId,
            country = _ref.country,
            state = _ref.state;

        var cartPath = apiUrls.cart + '/' + cartId;
        return $http.get(cartPath + '/shippingmethods', _extends({}, getHttpConfig(true), {
            params: { country: country, state: state }
        })).then(function (res) {
            return res.data.availableShippingMethods;
        });
    }

    function getVariant(cartItem) {
        if (!cartItem.variantId) {
            return undefined;
        }
        return $http.get(apiUrls.variant + '/' + cartItem.variantId, getHttpConfig(true)).then(function (itemResponse) {
            return itemResponse.data;
        });
    }

    function updateLegacyCart(cartId, data) {
        return $http.put(apiUrls.legacyCart + '/' + cartId, data, getHttpConfig(true)).then(function (response) {
            return response.data;
        });
    }

    function updateCart(cartId, data) {
        return $http.patch(apiUrls.cart + '/' + cartId, data, getHttpConfig(true)).then(function (response) {
            return response.data;
        });
    }

    function getClientId() {
        return $http.get(apiUrls.client, _extends({}, getHttpConfig(true), {
            transformResponse: angular.identity
        })).then(function (response) {
            return response.data;
        });
    }

    function getBag(bagId) {
        return $http.get(apiUrls.bag + '/' + bagId, getHttpConfig(true)).then(function (response) {
            return response.data;
        });
    }

    function createOrder(data) {
        return $http.post(apiUrls.order, data, getHttpConfig(true)).then(function (response) {
            return response.data;
        });
    }

    function getOrder(orderNumber, orderEmail) {
        var query = encodeURIComponent(orderNumber) + '?email=' + encodeURIComponent(orderEmail);
        return $http.get(apiUrls.order + '/' + query, getHttpConfig(true)).then(function (response) {
            return response.data;
        });
    }

    function createPaypalExpressCheckout(data) {
        return $http.post('' + apiUrls.paypal, data, getHttpConfig(true)).then(function (response) {
            return response.data;
        });
    }

    function legacyCreatePaypalExpressCheckout(data) {
        return $http.post(apiUrls.legacyPaypal + '/setExpressCheckout', data, getHttpConfig(true)).then(function (response) {
            return response.data;
        });
    }

    function getPaypalExpressCheckout(data) {
        return $http.post(apiUrls.legacyPaypal + '/getExpressCheckoutDetails', data, getHttpConfig(true)).then(function (response) {
            return response.data;
        });
    }

    function getPayPalClientToken() {
        return $http.post('' + apiUrls.paypalClientToken).then(function (response) {
            return response.data;
        }, function (response) {
            return new Error('getPayPalClientToken: error: ' + response);
        });
    }

    function getStoreInformation() {
        return $http.get(apiUrls.storeInfo, getHttpConfig(true)).then(function (response) {
            return response.data;
        });
    }

    function getStripePublishableKey() {
        return $http.get(apiUrls.paymentKeys, getHttpConfig(true)).then(function (response) {
            return response.data;
        });
    }

    function getDiscountValidity(shopperEmail, discountId) {
        var query = 'email/' + encodeURIComponent(shopperEmail) + '/discount/' + encodeURIComponent(discountId);
        return $http.get(apiUrls.discount + '/' + query, getHttpConfig(true)).then(function (response) {
            return response.data;
        });
    }

    function addDiscountCodeToCart(code, cartId) {
        return $http.post(apiUrls.cart + '/' + cartId + '/discounts', {
            discountCode: code
        }, getHttpConfig());
    }

    function removeDiscountCodeFromCart(code, cartId) {
        return $http.delete(apiUrls.cart + '/' + cartId + '/discounts/' + code, getHttpConfig());
    }

    function getStoreCreditByCode(code) {
        return $http.get(apiUrls.storeCredit + '/' + code, getHttpConfig(true)).then(function (response) {
            return response.data;
        });
    }

    function getShipToLocations() {
        return $http.get(apiUrls.shipToLocations, getHttpConfig(true)).then(function (response) {
            return response.data;
        });
    }

    // Shopper account functions

    function login(email, password) {
        return $http.post(apiUrls.shopper + '/login', { email: email, password: password }, getHttpConfig()).then(function (response) {
            return response.data;
        });
    }

    function isEmailRegistered(email) {
        return $http.get(apiUrls.shopper + '/registered/' + email, getHttpConfig()).then(function (response) {
            return response.data;
        });
    }

    function sendPasswordResetEmail(email) {
        return $http.post(apiUrls.shopper + '/sendResetPasswordEmail/' + email, {}, getHttpConfig()).then(function (response) {
            return response.data;
        });
    }

    function verifyResetPasswordCode(email, code) {
        return $http.get(apiUrls.shopper + '/validateResetPasswordToken/' + email + '/' + code, getHttpConfig()).then(function (response) {
            return response.data;
        });
    }

    function updatePassword(email, password, code) {
        return $http.post(apiUrls.shopper + '/resetShopperPassword/' + email + '/' + code, { password: password }, getHttpConfig()).then(function (response) {
            return response.data;
        });
    }

    function createShopper(emailAddress, password) {
        return $http.post(apiUrls.shopper, { emailAddress: emailAddress, password: password }, getHttpConfig()).then(function (response) {
            return response.data;
        });
    }

    function getShopper() {
        return $http.get('' + apiUrls.shopperAuth, getHttpConfig()).then(function (response) {
            return response.data;
        });
    }

    function updateShopper(shopper) {
        return $http.put('' + apiUrls.shopperAuth, shopper, getHttpConfig()).then(function (response) {
            return response.data;
        });
    }

    function addPaymentMethod(creditCardToken, isDefault) {
        return $http.post(apiUrls.shopperAuth + '/card', { creditCardToken: creditCardToken, isDefault: isDefault }, getHttpConfig()).then(function (response) {
            return response.data;
        });
    }

    function getPaymentMethodById(cardId) {
        return $http.get(apiUrls.shopperAuth + '/card/' + cardId, getHttpConfig()).then(function (response) {
            return response.data;
        });
    }

    function getPaymentMethods() {
        return $http.get(apiUrls.shopperAuth + '/card', getHttpConfig()).then(function (response) {
            return response.data;
        });
    }

    function updatePaymentMethod(cardId, paymentMethod) {
        return $http.put(apiUrls.shopperAuth + '/card/' + cardId, paymentMethod, getHttpConfig()).then(function (response) {
            return response.data;
        });
    }

    function deletePaymentMethod(cardId) {
        return $http.delete(apiUrls.shopperAuth + '/card/' + cardId, getHttpConfig());
    }

    function addShippingAddress(shippingAddress) {
        return $http.post(apiUrls.shopperAuth + '/shippingaddress', shippingAddress, getHttpConfig()).then(function (response) {
            return response.data;
        });
    }

    function getShippingAddressById(shippingAddressId) {
        return $http.get(apiUrls.shopperAuth + '/shippingaddress/' + shippingAddressId, getHttpConfig()).then(function (response) {
            return response.data;
        });
    }

    function getShippingAddresses() {
        return $http.get(apiUrls.shopperAuth + '/shippingaddress', getHttpConfig()).then(function (response) {
            return response.data;
        });
    }

    function updateShippingAddress(shippingAddressId, shippingAddress) {
        return $http.put(apiUrls.shopperAuth + '/shippingaddress/' + shippingAddressId, shippingAddress, getHttpConfig()).then(function (response) {
            return response.data;
        });
    }

    function deleteShippingAddress(shippingAddressId) {
        return $http.delete(apiUrls.shopperAuth + '/shippingaddress/' + shippingAddressId, getHttpConfig());
    }

    function getShippingMethods() {
        return $http.get(apiUrls.shippingMethods, getHttpConfig(true)).then(function (response) {
            return response.data;
        });
    }

    function getTax(cartId, shippingPrice, shippingAddress) {
        return $http.post(apiUrls.cart + '/' + cartId + '/taxes', { shippingPrice: shippingPrice, shippingAddress: shippingAddress }, getHttpConfig()).then(function (response) {
            return response.data;
        });
    }

    function verifyAddress(address) {
        if (!address) return Promise.reject();

        return $http.post('' + apiUrls.addressVerification, {
            address1: address.address1,
            address2: address.address2,
            locality: address.city,
            administrativeArea: address.state,
            country: address.country || 'US',
            postalCode: address.postalCode
        }, getHttpConfig()).then(function (response) {
            return response.data;
        });
    }

    function autocompleteAddress(address, components) {
        if (!address) return Promise.reject();

        var escapedAddress = encodeURIComponent(address);

        return $http.get(apiUrls.addressAutocomplete + '?input=' + escapedAddress + '&components=' + components, getHttpConfig(true)).then(function (response) {
            return response.data.matches;
        });
    }

    function getAutocompleteAddressParts(addressId) {
        if (!addressId) return Promise.reject();

        var escapedAddressId = encodeURIComponent(addressId);

        return $http.get(apiUrls.addressAutocompleteDetails + '?placeId=' + escapedAddressId);
    }

    return {
        setTenantId: setTenantId,
        getTenantId: getTenantId,
        setShopperId: setShopperId,
        getShopperId: getShopperId,
        getLegacyCart: getLegacyCart,
        getCart: getCart,
        fetchShippingMethods: fetchShippingMethods,
        updateLegacyCart: updateLegacyCart,
        updateCart: updateCart,
        getClientId: getClientId,
        getBag: getBag,
        createOrder: createOrder,
        getOrder: getOrder,
        legacyCreatePaypalExpressCheckout: legacyCreatePaypalExpressCheckout,
        createPaypalExpressCheckout: createPaypalExpressCheckout,
        getPaypalExpressCheckout: getPaypalExpressCheckout,
        getPayPalClientToken: getPayPalClientToken,
        getStoreInformation: getStoreInformation,
        getStripePublishableKey: getStripePublishableKey,
        getDiscountValidity: getDiscountValidity,
        addDiscountCodeToCart: addDiscountCodeToCart,
        removeDiscountCodeFromCart: removeDiscountCodeFromCart,
        getStoreCreditByCode: getStoreCreditByCode,
        getShipToLocations: getShipToLocations,
        getShippingMethods: getShippingMethods,
        getTax: getTax,
        autocompleteAddress: autocompleteAddress,
        getAutocompleteAddressParts: getAutocompleteAddressParts,
        verifyAddress: verifyAddress,
        account: {
            login: login,
            isEmailRegistered: isEmailRegistered,
            sendPasswordResetEmail: sendPasswordResetEmail,
            verifyResetPasswordCode: verifyResetPasswordCode,
            updatePassword: updatePassword,
            create: createShopper,
            get: getShopper,
            update: updateShopper,
            shippingAddress: {
                add: addShippingAddress,
                get: getShippingAddressById,
                getAll: getShippingAddresses,
                update: updateShippingAddress,
                delete: deleteShippingAddress
            },
            paymentMethod: {
                add: addPaymentMethod,
                get: getPaymentMethodById,
                getAll: getPaymentMethods,
                update: updatePaymentMethod,
                delete: deletePaymentMethod
            }
        }
    };
}]).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CheckoutService = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _differenceWith = __webpack_require__(615);

var _differenceWith2 = _interopRequireDefault(_differenceWith);

var _find = __webpack_require__(76);

var _find2 = _interopRequireDefault(_find);

var _filter = __webpack_require__(667);

var _filter2 = _interopRequireDefault(_filter);

var _isArray = __webpack_require__(21);

var _isArray2 = _interopRequireDefault(_isArray);

var _map = __webpack_require__(673);

var _map2 = _interopRequireDefault(_map);

var _reduce = __webpack_require__(297);

var _reduce2 = _interopRequireDefault(_reduce);

var _api = __webpack_require__(14);

var _storeInfo = __webpack_require__(192);

__webpack_require__(36);

var _cartUtils = __webpack_require__(19);

var _shipToLocations = __webpack_require__(195);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var CheckoutService = exports.CheckoutService = angular.module('checkout.checkoutService', [_api.ApiService, _storeInfo.StoreInfoService, _shipToLocations.ShipToLocationsService, 'app.constants', 'ngMaterial']).service('checkoutService', ['$q', 'apiService', 'storeInfoService', 'shipToLocationsService', '$mdDialog', 'PAYMENT_TYPES', '$window', function ($q, apiService, storeInfoService, shipToLocationsService, $mdDialog, PAYMENT_TYPES, $window) {
    var cartId = void 0;

    function setCartId(id) {
        cartId = id;
    }

    function isGiftCodeAlreadyApplied(code, storeCreditInfo) {
        var appliedCodes = (storeCreditInfo.items || []).reduce(function (acc, item) {
            return [].concat(_toConsumableArray(acc), [item.giftCardCode]);
        }, []);
        return appliedCodes.includes(code.toUpperCase());
    }

    function applyPromoCode(code) {
        var storeCreditInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var currentCart = arguments[2];
        var currentCartGrandTotal = arguments[3];

        if (isGiftCodeAlreadyApplied(code, storeCreditInfo)) {
            return $q.reject(new Error('giftCardAlreadyApplied'));
        }

        return apiService.getStoreCreditByCode(code).then(function (storeCredit) {
            if (storeCredit.status !== 'active') {
                throw new Error('inactiveGiftCard');
            }
            if ((0, _cartUtils.isGiftCardInCart)(currentCart.items)) {
                throw new Error('giftCardNotAllowed');
            }
            var duplicateIndex = storeCreditInfo.items.findIndex(function (item) {
                return item.giftCardCode === code;
            });
            if (duplicateIndex > -1) {
                storeCreditInfo.items[duplicateIndex] = storeCredit;
            } else {
                if (storeCreditInfo.storeCreditAmountInCents / 100 >= currentCartGrandTotal) {
                    throw new Error('cannotAddMoreStoreCredit');
                }
                storeCreditInfo.items.push(storeCredit);
            }

            return currentCart;
        }).catch(function (error) {
            if (error.message === 'inactiveGiftCard') {
                throw new Error('inactiveGiftCard');
            }
            if (error.message === 'giftCardNotAllowed') {
                throw new Error('giftCardNotAllowed');
            }
            if (error.message === 'cannotAddMoreStoreCredit') {
                throw new Error('cannotAddMoreStoreCredit');
            }
            return apiService.addDiscountCodeToCart(code, currentCart.cartId).then(function () {
                return apiService.getCart(currentCart.cartId);
            }).catch(function (e) {
                if (e.status === 404) {
                    throw new Error('promoCodeNotFound');
                }
                if (e.status === 409) {
                    throw new Error('discountCodeExistsInCart');
                }
                // TODO: add checks for other 4XX code errors, e.g.
                //       discount code found but expired,
                //       discount code found but has no usages left

                // the "catch-all" error to ensure an error is bubbled up
                throw new Error('Unhandled error');
            });
        });
    }

    function legacyApplyPromoCode(code) {
        var storeCreditInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var currentCart = arguments[2];

        if (isGiftCodeAlreadyApplied(code, storeCreditInfo)) {
            return $q.reject(new Error('giftCardAlreadyApplied'));
        }

        return apiService.getStoreCreditByCode(code).then(function (storeCredit) {
            if (storeCredit.status !== 'active') {
                throw new Error('inactiveGiftCard');
            }
            if ((0, _cartUtils.isGiftCardInLegacyCart)(currentCart.items)) {
                throw new Error('giftCardNotAllowed');
            }
            var duplicateIndex = storeCreditInfo.items.findIndex(function (item) {
                return item.giftCardCode === code;
            });
            if (duplicateIndex > -1) {
                storeCreditInfo.items[duplicateIndex] = storeCredit;
            } else {
                if (storeCreditInfo.storeCreditAmountInCents / 100 >= currentCart.grandTotal) {
                    throw new Error('cannotAddMoreStoreCredit');
                }
                storeCreditInfo.items.push(storeCredit);
            }
            return getAndUpdateCart(function (cart) {
                return _extends({}, cart);
            });
        }).catch(function (error) {
            if (error.message === 'inactiveGiftCard') {
                throw new Error('inactiveGiftCard');
            }
            if (error.message === 'giftCardNotAllowed') {
                throw new Error('giftCardNotAllowed');
            }
            if (error.message === 'cannotAddMoreStoreCredit') {
                throw new Error('cannotAddMoreStoreCredit');
            }
            return getAndUpdateCart(function (cart) {
                return _extends({}, cart, {
                    discountCode: code
                });
            });
        });
    }

    function createCartAddressFromForm(addressFormModel) {
        return (0, _cartUtils.createCartAddress)(addressFormModel.address1, addressFormModel.address2, addressFormModel.city, addressFormModel.state, addressFormModel.postalCode, addressFormModel.country, addressFormModel.firstName, addressFormModel.lastName, addressFormModel.phone);
    }

    function removeDiscountCodeItem(discountCode) {
        return apiService.removeDiscountCodeFromCart(discountCode, cartId).then(function () {
            return apiService.getCart(cartId);
        });
    }

    /**
     * accepts ID as either a string or an array of strings
     * @param discountId
     */
    function legacyRemoveDiscountCodeItem(discountId) {
        return getAndUpdateCart(function (cart) {
            return _returnCartWithUpdatedDiscounts(cart, discountId);
        });
    }

    function _returnCartWithUpdatedDiscounts(cart, discountId) {
        return _extends({}, cart, {
            discountCode: null,
            discount: null,
            discounts: _removeDiscountFromArray(cart.discounts, discountId)
        });
    }

    function _removeDiscountFromArray(discounts, discountId) {
        if ((0, _isArray2.default)(discountId)) {
            var dif = (0, _differenceWith2.default)(discounts, discountId, function (item, id) {
                return item.discount.id === id;
            });
            return dif;
        }
        return discounts.filter(function (appliedDiscount) {
            return appliedDiscount.discount.id !== discountId;
        });
    }

    function applyContactInfoAndShippingAddressToCart(stepOneData) {
        var validateCountry = stepOneData.shippingAddressModel.country ? shipToLocationsService.isCountryAvailable(stepOneData.shippingAddressModel.country) : $q.resolve();

        return validateCountry.then(function () {
            return service.getAndUpdateCart(function (cart) {
                var cartAddress = createCartAddressFromForm(stepOneData.shippingAddressModel);
                cartAddress.phoneNumber = stepOneData.contactInfoModel.phone;

                return _extends({}, cart, {
                    shippingAddress: cartAddress,
                    billingAddress: stepOneData.shippingAddressModel.shippingAsBilling ? cartAddress : {},
                    selectedShippingAddressId: undefined,
                    contactInfo: {
                        email: stepOneData.contactInfoModel.email,
                        phoneNumber: stepOneData.contactInfoModel.phone
                    },
                    emailOptIn: stepOneData.contactInfoModel.emailOptIn,
                    postalCode: stepOneData.shippingAddressModel.postalCode,
                    state: stepOneData.shippingAddressModel.state,
                    country: stepOneData.shippingAddressModel.country
                });
            });
        });
    }

    function saveContactInfoAndShippingAddress(stepOneData) {
        var validateCountry = stepOneData.shippingAddressModel.country ? shipToLocationsService.isCountryAvailable(stepOneData.shippingAddressModel.country) : $q.resolve();

        return validateCountry.then(function () {
            var cartAddress = createCartAddressFromForm(stepOneData.shippingAddressModel);
            cartAddress.phoneNumber = stepOneData.contactInfoModel.phone;
            (0, _cartUtils.setSavedCartInfo)(_extends({}, (0, _cartUtils.getSavedCartInfo)(), {
                billingAddress: stepOneData.shippingAddressModel.shippingAsBilling ? cartAddress : {},
                selectedShippingAddressId: undefined,
                contactInfo: {
                    email: stepOneData.contactInfoModel.email,
                    phoneNumber: stepOneData.contactInfoModel.phone
                },
                emailOptIn: stepOneData.contactInfoModel.emailOptIn,
                postalCode: stepOneData.shippingAddressModel.postalCode,
                state: stepOneData.shippingAddressModel.state,
                country: stepOneData.shippingAddressModel.country,
                shippingAddress: cartAddress
            }));

            return $q.resolve();
        });
    }

    function applyUpdatedPhoneNumberToShopper(shopperAccount, phoneNumber) {
        shopperAccount.contactInformation.phoneNumber = phoneNumber;
        return apiService.account.update(shopperAccount);
    }

    function applyShippingMethodToCartObject(cart, selectedShippingMethodIndex) {
        var cartObject = _extends({}, cart, {
            shippingMethod: {
                name: cart.availableShippingMethods[selectedShippingMethodIndex].name,
                shippingBand: {
                    shippingPrice: cart.availableShippingMethods[selectedShippingMethodIndex].shippingPrice
                }
            }
        });

        if (isCurbsidePickupShippingMethod(cart.availableShippingMethods[selectedShippingMethodIndex])) {
            cartObject.shippingMethod.pickupAddress = cart.availableShippingMethods[selectedShippingMethodIndex].pickupAddress;
        }

        return cartObject;
    }

    function isCurbsidePickupShippingMethod(shippingMethod) {
        return shippingMethod.name === 'Curbside Pickup';
    }

    function applyShippingMethodToCart(selectedShippingMethodIndex) {
        return service.getAndUpdateCart(function (cart) {
            return applyShippingMethodToCartObject(cart, selectedShippingMethodIndex);
        });
    }

    function applyBillingAddressToCart(billingAddressModel) {
        return service.getAndUpdateCart(function (cart) {
            return _extends({}, cart, {
                billingAddress: createCartAddressFromForm(billingAddressModel)
            });
        });
    }

    function applyCheckoutUrl(returnUri, bagId) {
        return getAndUpdateCart(function (cart) {
            return _extends({}, cart, {
                checkoutUrl: returnUri + '/checkout/?bag=' + bagId
            });
        });
    }

    function getAndUpdateCart(updateCartLogic) {
        return _getAndUpdateCart(updateCartLogic).catch(function (error) {
            // Retry in case of 409
            if (isConflictError(error)) return _getAndUpdateCart(updateCartLogic);
            throw error;
        });
    }

    function _getAndUpdateCart(updateCartLogic) {
        return apiService.getLegacyCart(cartId).then(function (cart) {
            return updateCartLogic(cart);
        }).then(function (updatedCart) {
            return apiService.updateLegacyCart(cartId, updatedCart);
        });
    }

    function isConflictError(error) {
        return error.data && error.data.statusCode === 409 || error.status === 409;
    }

    function showErrorDialog(message) {
        var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Error';
        var reload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        var buttonText = reload ? 'Return to Checkout' : 'OK';
        return $mdDialog.show($mdDialog.alert({
            clickOutsideToClose: true,
            title: title,
            textContent: message,
            ariaLabel: 'Error',
            escapeToClose: true,
            ok: buttonText,
            onComplete: function onComplete() {
                checkModalTopPositioning();
            }
        })).then(function () {
            if (reload) $window.location.reload();
        });
    }

    function checkModalTopPositioning() {
        var bodyTopPosition = parseInt($window.getComputedStyle($window.document.body).top);

        if ($window.document.querySelector('.md-dialog-container')) {
            var dialogTopPosition = parseInt($window.getComputedStyle($window.document.querySelector('.md-dialog-container')).top);

            if (bodyTopPosition + dialogTopPosition !== 0) fixModalTopPositioning(dialogTopPosition);
        }
    }

    function fixModalTopPositioning(dialogTopPosition) {
        $window.document.querySelector('.md-dialog-container').style.top = parseInt(dialogTopPosition) / 2 + 'px';
    }

    function getAvailablePaymentMethods() {
        return storeInfoService.get().then(function (storeInfo) {
            var availablePaymentTypes = [];

            var authorizeNet = storeInfo.authorizeNet;
            var acceptsAuthorizeNet = !!(authorizeNet && authorizeNet.isEnabled);
            var acceptsPaypal = storeInfo.paypal && storeInfo.paypal.isEnabled;
            var acceptsPayPalAcp = storeInfo.paypal && storeInfo.paypal.acpStatus === 'SUBSCRIBED' && !storeInfo.paypal.acpLimitReached;

            if (storeInfo.acceptsStripeAsPayment || acceptsAuthorizeNet || acceptsPayPalAcp) {
                availablePaymentTypes.push((0, _find2.default)(PAYMENT_TYPES, { value: 'Credit Card' }));
            }

            if (acceptsPaypal) {
                availablePaymentTypes.push((0, _find2.default)(PAYMENT_TYPES, { value: 'PayPal' }));
            }

            if (!acceptsPaypal && !storeInfo.acceptsStripeAsPayment && !acceptsAuthorizeNet) {
                availablePaymentTypes.push((0, _find2.default)(PAYMENT_TYPES, { value: 'Cash' }));
            }

            return availablePaymentTypes;
        });
    }

    function getOptimalDefaultPaymentMethod(paymentMethods) {
        var hasPayPal = (0, _find2.default)(paymentMethods, { value: 'PayPal' });
        var hasCard = (0, _find2.default)(paymentMethods, { value: 'Credit Card' });

        var defaultPaymentMethod = void 0;

        if (hasCard) {
            defaultPaymentMethod = 'Credit Card';
        } else if (hasPayPal) {
            defaultPaymentMethod = 'PayPal';
        } else {
            defaultPaymentMethod = 'Cash';
        }

        return defaultPaymentMethod;
    }

    function forceFormValidation(form) {
        if (form) {
            angular.forEach(form.$error.required, function (field) {
                field.$setDirty();
                field.$setTouched();
            });
        }
    }

    function validateDiscounts(cart) {
        var deferred = $q.defer();
        var discounts = cart.discounts;
        if (!discounts || discounts.length === 0) return ok();
        if (!cart.contactInfo || !cart.contactInfo.email) return error('Email Required');

        var validationPromises = discounts.map(function (discount) {
            return apiService.getDiscountValidity(cart.contactInfo.email, discount.discount.id);
        });

        var errorMessage = void 0;
        return $q.all(validationPromises).then(function (results) {
            var invalidDiscounts = (0, _filter2.default)(results, ['isValid', false]);

            var baseMessage = invalidDiscounts.length === 1 ? 'The following discount has already been used:' : 'The following discounts have already been used:';
            errorMessage = (0, _reduce2.default)(invalidDiscounts, function (result, discount) {
                return result + ' ' + (discount.code || discount.name);
            }, baseMessage);

            return invalidDiscounts;
        }).then(function (invalidDiscounts) {
            if (invalidDiscounts.length === 0) return ok();
            var discountIds = (0, _map2.default)(invalidDiscounts, 'id');
            return error(errorMessage, discountIds);
        });

        function ok() {
            deferred.resolve('OK');
            return deferred.promise;
        }
        function error(message) {
            var invalidDiscounts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

            var err = {
                title: invalidDiscounts ? 'Discount no longer valid' : 'Error',
                message: message,
                invalidDiscounts: invalidDiscounts
            };
            deferred.reject(err);
            return deferred.promise;
        }
    }

    var service = {
        applyBillingAddressToCart: applyBillingAddressToCart,
        applyCheckoutUrl: applyCheckoutUrl,
        applyContactInfoAndShippingAddressToCart: applyContactInfoAndShippingAddressToCart,
        applyPromoCode: applyPromoCode,
        applyShippingMethodToCart: applyShippingMethodToCart,
        applyShippingMethodToCartObject: applyShippingMethodToCartObject,
        applyUpdatedPhoneNumberToShopper: applyUpdatedPhoneNumberToShopper,
        createCartAddressFromForm: createCartAddressFromForm,
        forceFormValidation: forceFormValidation,
        getAndUpdateCart: getAndUpdateCart,
        getAvailablePaymentMethods: getAvailablePaymentMethods,
        getOptimalDefaultPaymentMethod: getOptimalDefaultPaymentMethod,
        legacyApplyPromoCode: legacyApplyPromoCode,
        legacyRemoveDiscountCodeItem: legacyRemoveDiscountCodeItem,
        removeDiscountCodeItem: removeDiscountCodeItem,
        saveContactInfoAndShippingAddress: saveContactInfoAndShippingAddress,
        setCartId: setCartId,
        showErrorDialog: showErrorDialog,
        validateDiscounts: validateDiscounts
    };

    return service;
}]).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.dollarsToCents = exports.getCartTotalAmountInCents = exports.isGiftCardInCart = exports.clearSavedStoreCreditInfo = exports.setSavedStoreCreditInfo = exports.getSavedStoreCreditInfo = exports.setSavedCartInfo = exports.getSavedCartInfo = exports.isGiftCardInLegacyCart = exports.isShippingRequiredOnCart = exports.getOfferPrice = exports.getItemsTotal = exports.hasValidShippingMethod = exports.getShippingMethodIndex = exports.isShippingAndBillingAddressSame = exports.getNumberOfCartItems = exports.getProductSubtotal = exports.getProductPrice = exports.getProductListPrice = exports.productIsOnSale = exports.getProductSalePrice = exports.createCartAddress = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.formatZipCode = formatZipCode;

var _get = __webpack_require__(16);

var _get2 = _interopRequireDefault(_get);

var _reduce = __webpack_require__(297);

var _reduce2 = _interopRequireDefault(_reduce);

var _isUndefined = __webpack_require__(677);

var _isUndefined2 = _interopRequireDefault(_isUndefined);

var _isEqual = __webpack_require__(193);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _findIndex = __webpack_require__(295);

var _findIndex2 = _interopRequireDefault(_findIndex);

var _isNil = __webpack_require__(678);

var _isNil2 = _interopRequireDefault(_isNil);

var _constants = __webpack_require__(194);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GIFT_CARD_PREFIX = 'v-gift-card';

var createCartAddress = exports.createCartAddress = function createCartAddress(address1, address2, city, state, postalCode, country, firstName, lastName, phoneNumber) {
    return {
        address1: address1,
        address2: address2,
        city: city,
        state: state,
        postalCode: postalCode,
        country: country,
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber
    };
};

var getProductSalePrice = exports.getProductSalePrice = function getProductSalePrice(sale) {
    // Because the type of `null` is `object` :unamused:
    if ((typeof sale === 'undefined' ? 'undefined' : _typeof(sale)) === 'object' && sale !== null) {
        return sale.value;
    }
    return sale;
};

var productIsOnSale = exports.productIsOnSale = function productIsOnSale(product) {
    if (product.pricing && product.pricing.salePrice) {
        return !!getProductSalePrice(product.pricing.salePrice);
    }
    return false;
};

var getProductListPrice = exports.getProductListPrice = function getProductListPrice(product) {
    return product.pricing ? product.pricing.listPrice : product.price;
};

var getProductPrice = exports.getProductPrice = function getProductPrice(product) {
    return productIsOnSale(product) ? getProductSalePrice(product.pricing.salePrice) : getProductListPrice(product);
};

var getProductSubtotal = exports.getProductSubtotal = function getProductSubtotal(product, quantity) {
    var price = parseFloat(getProductPrice(product), 10);
    return price * parseFloat(quantity, 10);
};

var getNumberOfCartItems = exports.getNumberOfCartItems = function getNumberOfCartItems(cartItems) {
    return (0, _reduce2.default)(cartItems, function (result, item) {
        return result + item.quantity;
    }, 0);
};

var isShippingAndBillingAddressSame = exports.isShippingAndBillingAddressSame = function isShippingAndBillingAddressSame(_ref) {
    var shippingAddress = _ref.shippingAddress,
        billingAddress = _ref.billingAddress;

    return !(0, _isUndefined2.default)(shippingAddress) && !(0, _isUndefined2.default)(billingAddress) && (0, _isEqual2.default)(shippingAddress, billingAddress);
};

var getShippingMethodIndex = exports.getShippingMethodIndex = function getShippingMethodIndex(availableShippingMethods, shippingMethod) {
    var notFoundIndex = -1;
    if ((0, _isUndefined2.default)(availableShippingMethods)) return notFoundIndex;
    if ((0, _isUndefined2.default)(shippingMethod)) return undefined;

    var index = void 0;
    if (shippingMethod.shippingBand && !(0, _isUndefined2.default)(shippingMethod.shippingBand.shippingPrice)) {
        index = (0, _findIndex2.default)(availableShippingMethods, {
            name: shippingMethod.name,
            shippingPrice: shippingMethod.shippingBand.shippingPrice
        });
        if (index === notFoundIndex) {
            index = (0, _findIndex2.default)(availableShippingMethods, {
                name: shippingMethod.name,
                shippingCost: shippingMethod.shippingBand.shippingPrice
            });
        }
    } else {
        index = (0, _findIndex2.default)(availableShippingMethods, {
            name: shippingMethod.name,
            shippingCost: shippingMethod.shippingCost
        });
        if (index === notFoundIndex) {
            index = (0, _findIndex2.default)(availableShippingMethods, {
                name: shippingMethod.name,
                shippingPrice: shippingMethod.shippingPrice
            });
        }
    }
    return index !== notFoundIndex ? index : undefined;
};

var hasValidShippingMethod = exports.hasValidShippingMethod = function hasValidShippingMethod(availableShippingMethods, shippingMethod) {
    var index = getShippingMethodIndex(availableShippingMethods, shippingMethod);
    return angular.isDefined(index) && index >= 0;
};

var getItemsTotal = exports.getItemsTotal = function getItemsTotal() {
    var cartItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return cartItems.reduce(function (total, item) {
        if (item.product) {
            return total + item.quantity * getOfferPrice(item.product.pricing, item.product.price);
        }

        return total + item.quantity * item.price.amount / 100;
    }, 0);
};

var getOfferPrice = exports.getOfferPrice = function getOfferPrice(pricing, price) {
    if ((0, _isNil2.default)(pricing)) {
        return price;
    }
    return !(0, _isNil2.default)(pricing.salePrice) ? pricing.salePrice : pricing.listPrice;
};

var isShippingRequiredOnCart = exports.isShippingRequiredOnCart = function isShippingRequiredOnCart() {
    var cartItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return cartItems.some(function (cartItem) {
        return cartItem.isShippable || cartItem.isShippable === null || cartItem.product && (cartItem.product.requiresShipping || cartItem.product.requiresShipping === null);
    });
};

var isGiftCardInLegacyCart = exports.isGiftCardInLegacyCart = function isGiftCardInLegacyCart() {
    var cartItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return cartItems.findIndex(function (cartItem) {
        return cartItem.product.sku.toLowerCase().startsWith(GIFT_CARD_PREFIX);
    }) > -1;
};

var getSavedCartInfo = exports.getSavedCartInfo = function getSavedCartInfo() {
    var stringifiedCart = window.sessionStorage.getItem(_constants.SAVED_CART_KEY) || '{}';
    return JSON.parse(stringifiedCart);
};

var setSavedCartInfo = exports.setSavedCartInfo = function setSavedCartInfo(cart) {
    var stringifiedCart = JSON.stringify(cart);
    window.sessionStorage.setItem(_constants.SAVED_CART_KEY, stringifiedCart);
};

var getSavedStoreCreditInfo = exports.getSavedStoreCreditInfo = function getSavedStoreCreditInfo() {
    var stringifiedStoreCreditInfo = window.sessionStorage.getItem(_constants.SAVED_STORECREDIT_KEY);

    if (!stringifiedStoreCreditInfo) {
        return { items: [], storeCreditAmountInCents: 0 };
    }

    return JSON.parse(stringifiedStoreCreditInfo);
};

var setSavedStoreCreditInfo = exports.setSavedStoreCreditInfo = function setSavedStoreCreditInfo(storeCreditInfo) {
    var stringifiedStoreCreditInfo = JSON.stringify(storeCreditInfo);
    window.sessionStorage.setItem(_constants.SAVED_STORECREDIT_KEY, stringifiedStoreCreditInfo);
};

var clearSavedStoreCreditInfo = exports.clearSavedStoreCreditInfo = function clearSavedStoreCreditInfo() {
    var defaultStoreCreditInfo = { items: [], storeCreditAmountInCents: 0 };
    setSavedStoreCreditInfo(defaultStoreCreditInfo);
};

// new cart utils

var isGiftCardInCart = exports.isGiftCardInCart = function isGiftCardInCart() {
    var cartItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return cartItems.findIndex(function (cartItem) {
        return cartItem.variant.sku.toLowerCase().startsWith(GIFT_CARD_PREFIX);
    }) > -1;
};

var getCartTotalAmountInCents = exports.getCartTotalAmountInCents = function getCartTotalAmountInCents(cart) {
    return (0, _get2.default)(cart, 'pricing.total.amount', 0);
};

var dollarsToCents = exports.dollarsToCents = function dollarsToCents(dollars) {
    return Math.round(dollars * 100);
};

function formatZipCode(zip, country) {
    if (country === 'US') {
        if (zip.length === 9) {
            return zip.slice(0, 5) + '-' + zip.slice(5);
        }
    }
    return zip;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(angular) {/* harmony default export */ __webpack_exports__["default"] = (angular.module("app.constants", [])
  .constant("GOOGLE_STATIC_MAPS_KEY", "AIzaSyBVvRYGnSTIFppjaVB_qmdi8Enl5suNW4s")
  .constant("GA_CHECKOUT_STEPS", {"entrance":1,"contactInfo":2,"shippingAddress":3,"shippingMethod":4,"paymentMethod":5,"billingAddress":6})
  .constant("PAYMENT_TYPES", [{"name":"Credit/debit card","value":"Credit Card"},{"name":"Cash","value":"Cash"},{"name":"PayPal","value":"PayPal","type":"other","imageUrl":"https://www.paypalobjects.com/webstatic/en_US/i/buttons/PP_logo_h_200x51.png"}])
  .constant("CART_LOCAL_STORAGE_KEY", "VOL_CART_ID")
  .constant("TENANT_LOCAL_STORAGE_KEY", "VOL_TENANT_ID")
  .constant("USE_NEW_CART_SERVICE_KEY", "VOL_USE_NEW_CARTS")
  .constant("DEFAULT_ERROR_MSG", "Unexpected error occurred. Please refresh and try again.")
  .constant("PAYPAL_ENV", "production")
  .constant("PAYPAL_ID", "3EEAHLVZY3RJW")
  .constant("LAUNCH_DARKLY_KEY", "57fd29f7760ce0074f27ff9b")
  .constant("BASE_API_URL", "https://api.material.com")
  .constant("PAYPAL_CLIENT_ID", "AdybeG3hNG3xDrQ0QNDw9Rbjf2KMxqoNn5vbNYhgQowqMIlsvvz1X3jOsaTWu-1TM0NnvcSsLm1bkNXA")
  .constant("BN_CODE", "Volusion_PCP"));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(1)))

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InputContainer = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(742);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var InputContainer = exports.InputContainer = angular.module('checkout.components.inputContainer', []).component('inputContainer', {
    bindings: {
        formInput: '<'
    },
    template: '\n            <div class="checkout-input-container" ng-class="$ctrl.inputNeedsAttention()">\n                <ng-transclude></ng-transclude>\n            </div>\n        ',
    transclude: true,
    controller: function () {
        function InputContainerCtrl() {
            _classCallCheck(this, InputContainerCtrl);
        }

        _createClass(InputContainerCtrl, [{
            key: 'inputNeedsAttention',
            value: function inputNeedsAttention() {
                return {
                    'checkout-input-container--error': this.formInput && this.formInput.$invalid && this.formInput.$dirty && this.formInput.$touched && this.formInput.$invalid
                };
            }
        }]);

        return InputContainerCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AddressForm = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debounce = __webpack_require__(736);

var _debounce2 = _interopRequireDefault(_debounce);

var _addressVerification = __webpack_require__(79);

var _shipToLocations = __webpack_require__(195);

var _validatePostalCode = __webpack_require__(738);

var _formatZip = __webpack_require__(739);

var _googleAutocomplete = __webpack_require__(740);

var _inputContainer = __webpack_require__(37);

var _constants = __webpack_require__(194);

var _addressUtils = __webpack_require__(743);

var _countryData = __webpack_require__(201);

var _addressForm = __webpack_require__(745);

var _addressForm2 = _interopRequireDefault(_addressForm);

__webpack_require__(746);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AddressForm = exports.AddressForm = angular.module('checkout.components.addressForm', [_addressVerification.AddressVerificationService, _shipToLocations.ShipToLocationsService, _validatePostalCode.ValidatePostalCode, _formatZip.FormatZip, _googleAutocomplete.GoogleAutoComplete, _inputContainer.InputContainer]).component('addressForm', {
    template: _addressForm2.default,
    bindings: {
        model: '=',
        autoCompletePrefix: '@',
        showCardholderNameInput: '<',
        shouldVerifyAddress: '<',
        verifiedMessage: '<'
    },
    controller: function () {
        AddressFormCtrl.$inject = ['$scope', '$timeout', 'addressVerificationService', 'shipToLocationsService'];

        function AddressFormCtrl($scope, $timeout, addressVerificationService, shipToLocationsService) {
            _classCallCheck(this, AddressFormCtrl);

            angular.extend(this, {
                $scope: $scope,
                $timeout: $timeout,
                addressVerificationService: addressVerificationService,
                shipToLocationsService: shipToLocationsService,
                AUTOCOMPLETE_COUNTRIES: _constants.AUTOCOMPLETE_COUNTRIES,
                ADMINISTRATIVE_AREA_LEVEL_1_LABELS: _constants.ADMINISTRATIVE_AREA_LEVEL_1_LABELS,
                DEAFULT_ADMINISTRATIVE_AREA_LEVEL_1_LABEL: _constants.DEAFULT_ADMINISTRATIVE_AREA_LEVEL_1_LABEL,
                countries: _countryData.countries,
                isAddressVerified: false
            });
        }

        _createClass(AddressFormCtrl, [{
            key: '$onInit',
            value: function $onInit() {
                var _this = this;

                this.shipToLocationsService.get().then(function (response) {
                    _this.shipToLocations = response.map(function (location) {
                        return _extends({}, location, {
                            name: _countryData.countries[location.country].name
                        });
                    });

                    _this.states = (0, _addressUtils.getStatesFromShipToLocationCountry)(_this.shipToLocations, _this.model && _this.model.country ? _this.model.country : 'US');
                });
                this._autoCompletePrefix = this.autoCompletePrefix ? this.autoCompletePrefix + ' ' : '';
                if (this.model) {
                    this.setAddressFormInputAndLabels(this.model.country);
                }

                var verifyAddress = (0, _debounce2.default)(this.verifyAddress.bind(this), 500);

                if (this.shouldVerifyAddress) {
                    ['address1', 'address2', 'city', 'state', 'zip'].forEach(function (formElement) {
                        _this.$scope.$watch('$ctrl.model.' + formElement, function (newValue, oldValue) {
                            if (newValue !== oldValue) {
                                verifyAddress();
                            }
                        });
                    });
                }

                this.searchText = this.model.address1;
            }
        }, {
            key: 'verifyAddress',
            value: function verifyAddress() {
                var _this2 = this;

                this.addressVerificationService.isAddressVerified(this.model).then(function (status) {
                    return _this2.isAddressVerified = status;
                });
            }
        }, {
            key: 'onCountryChange',
            value: function onCountryChange() {
                this.setAddressFormInputAndLabels(this.model.country);
                this.states = (0, _addressUtils.getStatesFromShipToLocationCountry)(this.shipToLocations, this.model.country);
            }
        }, {
            key: 'setAddressFormInputAndLabels',
            value: function setAddressFormInputAndLabels(country) {
                this.domesticAddress = country === 'US';
            }
        }, {
            key: 'onAddressChange',
            value: function onAddressChange() {
                var _this3 = this;

                if (this.selectedAddress && this.selectedAddress.placeId) {
                    this.addressVerificationService.getAutocompleteAddressParts(this.selectedAddress.placeId).then(function (address) {
                        return _this3.setAutocompleteAddressToModel(address);
                    });
                } else {
                    this.model.address1 = this.selectedAddress;
                }
            }
        }, {
            key: 'onSearchTextChange',
            value: function onSearchTextChange() {
                this.model.address1 = this.searchText;
            }
        }, {
            key: 'searchAddress',
            value: function searchAddress(searchText) {
                return this.addressVerificationService.autocompleteAddress(searchText, this.model.country);
            }
        }, {
            key: 'setAutocompleteAddressToModel',
            value: function setAutocompleteAddressToModel(addressFromAutocomplete) {
                this.selectedAddress = addressFromAutocomplete.address1;
                this.model.address1 = addressFromAutocomplete.address1;
                this.model.address2 = addressFromAutocomplete.address2;
                this.model.city = addressFromAutocomplete.locality;
                this.model.state = addressFromAutocomplete.administrativeArea;
                this.model.postalCode = addressFromAutocomplete.postalCode;
                this.model.country = addressFromAutocomplete.country;
            }
        }]);

        return AddressFormCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PaypalSdkService = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable no-unused-vars */


__webpack_require__(36);

var _scriptLoader = __webpack_require__(298);

var _api = __webpack_require__(14);

var _checkout = __webpack_require__(18);

var _cartUtils = __webpack_require__(19);

var PaypalSdkService = exports.PaypalSdkService = angular.module('checkout.services.paypalSdkService', [_scriptLoader.ScriptLoaderService, _api.ApiService, _checkout.CheckoutService]).service('paypalSdkService', ['scriptLoaderService', '$window', 'apiService', 'BN_CODE', 'PAYPAL_CLIENT_ID', 'DEFAULT_ERROR_MSG', 'checkoutService', '$q', '$rootScope', '$timeout', function (scriptLoaderService, $window, apiService, BN_CODE, PAYPAL_CLIENT_ID, DEFAULT_ERROR_MSG, checkoutService, $q, $rootScope, $timeout) {
    var merchantId = void 0;
    var intent = void 0;
    var useNewCarts = false;
    var paypalInfo = void 0;
    var total = void 0;
    var hostedFields = void 0;
    function init(_ref) {
        var storeInfo = _ref.storeInfo,
            cartId = _ref.cartId,
            bagId = _ref.bagId,
            grandTotal = _ref.grandTotal,
            _ref$newCarts = _ref.newCarts,
            newCarts = _ref$newCarts === undefined ? false : _ref$newCarts,
            getGiftCards = _ref.getGiftCards;

        merchantId = isValidMerchantId(storeInfo) ? storeInfo.paypal.merchantPayerId : undefined;
        intent = getPaymentAction(storeInfo);
        paypalInfo = storeInfo.paypal;
        total = grandTotal;
        useNewCarts = newCarts;
        loadCheckoutScript(cartId, bagId, getGiftCards);
    }
    function loadCheckoutScript(cartId, bagId, getGiftCards) {
        if (!$window.paypal) {
            var identityParams = 'client-id=' + PAYPAL_CLIENT_ID;
            if (merchantId) {
                identityParams += '&merchant-id=' + merchantId;
            }
            if (paypalInfo.acpStatus === 'SUBSCRIBED' && !paypalInfo.acpLimitReached) {
                var scriptUrl = 'https://www.paypal.com/sdk/js?components=hosted-fields,buttons,messages';
                var transactionParams = 'currency=USD&intent=' + intent + '&commit=false&enable-funding=venmo';
                var paypalJsUrl = scriptUrl + '&' + identityParams + '&' + transactionParams;
                apiService.getPayPalClientToken().then(function (_ref2) {
                    var clientToken = _ref2.client_token;

                    scriptLoaderService.loadScriptTag({
                        src: paypalJsUrl,
                        async: true,
                        attributes: [{ name: 'data-client-token', value: clientToken }, { name: 'data-partner-attribution-id', value: BN_CODE }],
                        onload: function onload() {
                            // Load acp fields and buttons
                            renderPaypalAcp(cartId, bagId);
                            renderAllPaypalButtons(cartId, bagId, getGiftCards);
                            renderPaypalMessages();
                        }
                    });
                }).catch(function (err) {
                    loadButtonsScript(cartId, bagId, identityParams, getGiftCards);
                });
            } else {
                loadButtonsScript(cartId, bagId, identityParams, getGiftCards);
            }
        }
    }
    function loadButtonsScript(cartId, bagId, identityParams, getGiftCards) {
        var scriptUrl = 'https://www.paypal.com/sdk/js?components=messages,buttons';
        var transactionParams = 'intent=' + intent + '&commit=false&enable-funding=venmo';
        var paypalJsUrl = scriptUrl + '&' + identityParams + '&' + transactionParams;
        scriptLoaderService.loadScriptTag({
            src: paypalJsUrl,
            async: true,
            onload: function onload() {
                renderAllPaypalButtons(cartId, bagId, getGiftCards);
                renderPaypalMessages();
            }
        });
    }
    function renderAllPaypalButtons(cartId, bagId, getGiftCards) {
        renderPaypalButtons(cartId, bagId, getGiftCards);
        renderPaypalSummaryButtons(cartId, bagId, getGiftCards);
    }
    function renderPaypalMessages() {
        if (!paypalInfo.payInFourEnabled || !$window.paypal) {
            return;
        }

        var messagesSelector = '.paypal-pay-in-four-messaging';
        var messagesContainer = $window.document.querySelector(messagesSelector);

        if (messagesContainer && messagesContainer.innerHTML.length > 0 && $window.paypal.messagesRendered) {
            // Messages already rendered, move them to PayPal label
            $timeout(function () {
                var inlinePaymentSelector = '.payment-method-form__pay-in-four';
                var inlinePaymentContainer = $window.document.querySelector(inlinePaymentSelector);
                if (inlinePaymentContainer) {
                    inlinePaymentContainer.appendChild(messagesContainer);
                    messagesContainer.style.display = 'block';
                }
            });
        } else if (messagesContainer && !$window.paypal.messagesRendered) {
            $timeout(function () {
                // https://developer.paypal.com/docs/business/pay-later/advanced/reference/#messages-function
                // eslint-disable-next-line new-cap
                $window.paypal.Messages({
                    amount: total || '',
                    style: {
                        layout: 'text',
                        logo: {
                            type: 'inline'
                        }
                    },
                    placement: 'payment'
                }).render(messagesContainer).then(function () {
                    // TODO Remove below once PayPal issue is addressed
                    // https://github.com/paypal/paypal-messaging-components/issues/463
                    var inlinePaymentSelector = '.payment-method-form__pay-in-four';
                    var inlinePaymentContainer = $window.document.querySelector(inlinePaymentSelector);
                    $window.paypal.messagesRendered = true;
                    if (inlinePaymentContainer) {
                        inlinePaymentContainer.appendChild(messagesContainer);
                    } else {
                        messagesContainer.style.display = 'none';
                    }
                });
            });
        }
    }
    function renderPaypalAcp(cartId, bagId) {
        var container = '#paypal-cc-form';
        // eslint-disable-next-line max-len
        if ($window.paypal && $window.document.querySelector(container) && $window.paypal.HostedFields.isEligible()) {
            $window.paypal.HostedFields.render({
                createOrder: function createOrder(data, actions) {
                    return useNewCarts ? startCheckoutFlow(cartId) : legacyStartCheckoutFlow(cartId);
                },
                styles: {
                    input: {
                        'font-size': '14px',
                        // eslint-disable-next-line max-len
                        'font-family': '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif',
                        color: '#333',
                        padding: '12px'
                    },
                    ':focus': {
                        color: 'black'
                    }
                },
                fields: {
                    number: {
                        selector: '#cardNumber',
                        placeholder: 'Credit Card Number'
                    },
                    cvv: {
                        selector: '#cvc',
                        placeholder: 'CVV'
                    },
                    expirationDate: {
                        selector: '#expiration',
                        placeholder: 'MM/YYYY'
                    }
                }
            }).then(function (cardFields) {
                cardFields.on('cardTypeChange', function (event) {
                    var cardType = event.cards.length === 1 ? event.cards[0].niceType : 'None';
                    $rootScope.$emit('paypal-card-type-change', { cardType: cardType });
                });
                hostedFields = cardFields;
            }).catch(function (err) {
                checkoutService.showErrorDialog(err.message);
            });
        }
    }
    function renderPaypalButtons(cartId, bagId, getGiftCards) {
        var container = '#paypal-sdk-button-container';
        if ($window.paypal && $window.document.querySelector(container)) {
            doRender({ cartId: cartId, bagId: bagId, container: container, getGiftCards: getGiftCards });
        }
    }
    function renderPaypalSummaryButtons(cartId, bagId, getGiftCards) {
        var container = '#paypal-sdk-summary-button-container';
        var style = { layout: 'horizontal' };
        if ($window.paypal && $window.document.querySelector(container)) {
            doRender({ cartId: cartId, bagId: bagId, container: container, style: style, getGiftCards: getGiftCards });
        }
    }
    function doRender(_ref3) {
        var cartId = _ref3.cartId,
            bagId = _ref3.bagId,
            container = _ref3.container,
            style = _ref3.style,
            getGiftCards = _ref3.getGiftCards;

        var giftCards = getGiftCards();
        if ($window.document.querySelector(container).innerHTML === '') {
            var returnUrlBase = '' + $window.location.origin + $window.location.pathname;
            // eslint-disable-next-line new-cap
            $window.paypal.Buttons({
                style: style,
                createOrder: function createOrder(data, actions) {
                    return useNewCarts ? startCheckoutFlow(cartId, getGiftCards) : legacyStartCheckoutFlow(cartId, getGiftCards);
                },
                onApprove: function onApprove(data, actions) {
                    // eslint-disable-next-line max-len
                    return actions.redirect(returnUrlBase + '?token=' + data.orderID + '&PayerID=' + data.payerID + '&paymentId=' + data.paymentID + '&bag=' + bagId);
                },
                onCancel: function onCancel(data, actions) {
                    actions.restart();
                },
                onError: function onError(err) {
                    // eslint-disable-next-line max-len
                    checkoutService.showErrorDialog('We were unable to connect to your Paypal account. Please check your Paypal account settings.');
                }
            }).render(container);
        }
    }
    function isValidMerchantId(storeInfo) {
        return angular.isDefined(storeInfo.paypal) && angular.isDefined(storeInfo.paypal.merchantPayerId) && storeInfo.paypal.merchantPayerId !== '' && (storeInfo.paypal.primaryEmailConfirmed === 'true' || storeInfo.paypal.primaryEmailConfirmed === true);
    }
    function savePaypalData(token, payerId) {
        return apiService.getPaypalExpressCheckout({ token: token, payerId: payerId }).then(function (paypalData) {
            return checkoutService.saveContactInfoAndShippingAddress({
                shippingAddressModel: {
                    firstName: paypalData.FIRSTNAME,
                    lastName: paypalData.LASTNAME,
                    address1: paypalData.PAYMENTREQUEST_0_SHIPTOSTREET,
                    address2: paypalData.PAYMENTREQUEST_0_SHIPTOSTREET2,
                    city: paypalData.PAYMENTREQUEST_0_SHIPTOCITY,
                    state: paypalData.PAYMENTREQUEST_0_SHIPTOSTATE,
                    postalCode: (0, _cartUtils.formatZipCode)(paypalData.PAYMENTREQUEST_0_SHIPTOZIP, paypalData.PAYMENTREQUEST_0_SHIPTOCOUNTRYCODE),
                    country: paypalData.PAYMENTREQUEST_0_SHIPTOCOUNTRYCODE,
                    shippingAsBilling: true
                },
                contactInfoModel: {
                    phone: paypalData.PHONENUM,
                    email: paypalData.EMAIL
                }
            }).then(function () {
                return paypalData;
            });
        });
    }
    function setPaypalDataToCart(token, payerId) {
        return apiService.getPaypalExpressCheckout({ token: token, payerId: payerId }).then(function (paypalData) {
            return checkoutService.applyContactInfoAndShippingAddressToCart({
                shippingAddressModel: {
                    firstName: paypalData.FIRSTNAME,
                    lastName: paypalData.LASTNAME,
                    address1: paypalData.PAYMENTREQUEST_0_SHIPTOSTREET,
                    address2: paypalData.PAYMENTREQUEST_0_SHIPTOSTREET2,
                    city: paypalData.PAYMENTREQUEST_0_SHIPTOCITY,
                    state: paypalData.PAYMENTREQUEST_0_SHIPTOSTATE,
                    postalCode: (0, _cartUtils.formatZipCode)(paypalData.PAYMENTREQUEST_0_SHIPTOZIP, paypalData.PAYMENTREQUEST_0_SHIPTOCOUNTRYCODE),
                    country: paypalData.PAYMENTREQUEST_0_SHIPTOCOUNTRYCODE,
                    shippingAsBilling: true
                },
                contactInfoModel: {
                    phone: paypalData.PHONENUM,
                    email: paypalData.EMAIL
                }
            }).then(function (updatedCart) {
                return { updatedCart: updatedCart, paypalData: paypalData };
            });
        });
    }
    function submitPayPalAcp() {
        if (!hostedFields) {
            return Promise.reject({ message: DEFAULT_ERROR_MSG });
        }
        return hostedFields.submit();
    }
    function applyPaypalAddressToCart(paypalData) {
        return checkoutService.getAndUpdateCart(function (cart) {
            var cartAddress = (0, _cartUtils.createCartAddress)(paypalData.PAYMENTREQUEST_0_SHIPTOSTREET, paypalData.PAYMENTREQUEST_0_SHIPTOSTREET2, paypalData.PAYMENTREQUEST_0_SHIPTOCITY, paypalData.PAYMENTREQUEST_0_SHIPTOSTATE, (0, _cartUtils.formatZipCode)(paypalData.PAYMENTREQUEST_0_SHIPTOZIP, paypalData.PAYMENTREQUEST_0_SHIPTOCOUNTRYCODE), paypalData.PAYMENTREQUEST_0_SHIPTOCOUNTRYCODE, paypalData.FIRSTNAME, paypalData.LASTNAME, paypalData.PHONENUM);
            return _extends({}, cart, {
                shippingAddress: cartAddress,
                billingAddress: cartAddress,
                postalCode: (0, _cartUtils.formatZipCode)(cartAddress.postalCode, cartAddress.country),
                state: cartAddress.state,
                country: cartAddress.country,
                selectedShippingAddressId: undefined
            });
        });
    }

    function startCheckoutFlow(cartId, getGiftCards) {
        // The following string is per PayPal API / Smart Button Documentation
        var returnUrlBase = 'https://www.paypal.com/checkoutnow/error';

        return apiService.createPaypalExpressCheckout({
            cartId: cartId,
            giftCards: getGiftCards()
        }).then(function (data) {
            if (data && data.id) {
                return data.id;
            }
            return $q.reject();
        }).catch(function (error) {
            return $q.reject(error);
        });
    }

    function legacyStartCheckoutFlow(cartId, getGiftCards) {
        // The following string is per PayPal API / Smart Button Documentation
        var returnUrlBase = 'https://www.paypal.com/checkoutnow/error';

        return apiService.legacyCreatePaypalExpressCheckout({
            returnUrl: returnUrlBase,
            cancelUrl: returnUrlBase,
            giftCards: getGiftCards(),
            cartId: cartId
        }).then(function (data) {
            if (data && data.token) {
                return data.token;
            }
            return $q.reject();
        }).catch(function (error) {
            return $q.reject(error);
        });
    }

    function paypalIsAvailablePaymentMethod(storeInfo) {
        return angular.isDefined(storeInfo.paypal) && storeInfo.paypal.isEnabled === true;
    }

    function hasPaypalQueryParams(params) {
        return angular.isDefined(params.token) && angular.isDefined(params.PayerID);
    }

    return {
        init: init,
        loadButtonsScript: loadButtonsScript,
        loadCheckoutScript: loadCheckoutScript,
        renderPaypalAcp: renderPaypalAcp,
        renderPaypalButtons: renderPaypalButtons,
        renderPaypalMessages: renderPaypalMessages,
        renderPaypalSummaryButtons: renderPaypalSummaryButtons,
        savePaypalData: savePaypalData,
        startCheckoutFlow: startCheckoutFlow,
        setPaypalDataToCart: setPaypalDataToCart,
        applyPaypalAddressToCart: applyPaypalAddressToCart,
        paypalIsAvailablePaymentMethod: paypalIsAvailablePaymentMethod,
        hasPaypalQueryParams: hasPaypalQueryParams,
        submitPayPalAcp: submitPayPalAcp
    };
}]).name;

function getPaymentAction(storeInfo) {
    if (storeInfo.paymentAutoCapture === true) {
        return 'capture';
    }
    if (storeInfo.paypal && storeInfo.paypal.merchantPayerId && storeInfo.paypal.primaryEmailConfirmed === true) {
        return 'authorize';
    }
    return 'capture';
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FullscreenLoaderService = undefined;

var _get = __webpack_require__(16);

var _get2 = _interopRequireDefault(_get);

var _fullscreenLoader = __webpack_require__(684);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullscreenLoaderService = exports.FullscreenLoaderService = angular.module('checkout.components.fullscreenLoader.service', [_fullscreenLoader.FullscreenLoader]).service('loadingService', ['$rootScope', function ($rootScope) {
    var storeInfo = void 0;

    $rootScope.loader = {};

    function setStoreInfo(info) {
        storeInfo = info;
    }

    function show(text) {
        var loaderAlreadyActive = $rootScope.loader.show;
        $rootScope.loader = {
            show: true,
            imageUri: (0, _get2.default)(storeInfo, 'logo.imageLink.fullUri'),
            titleText: loaderAlreadyActive && text ? text : (0, _get2.default)(storeInfo, 'name'),
            description: loaderAlreadyActive ? $rootScope.loader.description : text
        };
    }

    function hide() {
        $rootScope.loader = { show: false };
    }

    return {
        show: show,
        hide: hide,
        setStoreInfo: setStoreInfo
    };
}]).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AuthService = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _get = __webpack_require__(16);

var _get2 = _interopRequireDefault(_get);

var _angularJwt = __webpack_require__(713);

var _angularJwt2 = _interopRequireDefault(_angularJwt);

var _angularCookies = __webpack_require__(303);

var _angularCookies2 = _interopRequireDefault(_angularCookies);

var _angularjs = __webpack_require__(111);

var _angularjs2 = _interopRequireDefault(_angularjs);

var _moment = __webpack_require__(716);

var _moment2 = _interopRequireDefault(_moment);

var _fullscreenLoader = __webpack_require__(77);

var _checkout = __webpack_require__(18);

var _cartUtils = __webpack_require__(19);

__webpack_require__(36);

var _auth0sdk = __webpack_require__(717);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AuthService = exports.AuthService = angular.module('checkout.authService', ['ngMaterial', _angularJwt2.default, _angularCookies2.default, _angularjs2.default, 'app.constants', _auth0sdk.Auth0SdkServiceModule, _checkout.CheckoutService, _fullscreenLoader.FullscreenLoaderService]).service('authService', ['$window', '$state', '$cookies', '$location', 'jwtHelper', 'apiService', 'auth0SdkService', 'checkoutService', '$mdDialog', '$q', function ($window, $state, $cookies, $location, jwtHelper, apiService, auth0SdkService, checkoutService, $mdDialog, $q) {
    var globalCookieOptions = {
        secure: true,
        path: '/'
    };

    function useUniversalLogin() {
        // note, karma tests run under domain 'server'
        return (/myvolusion.com|volusionplatformdev.com|server|localhost|127.0.0.1$/.test($location.host())
        );
    }

    function clearUser() {
        clearTokenCookie();
        if ($window.Raven) {
            $window.Raven.setUserContext();
        }
    }

    function login(email, password) {
        clearUser();
        if (useUniversalLogin()) {
            auth0SdkService.loginWithRedirect({
                redirect_uri: $window.location.href,
                login_hint: email
            });
        } else {
            return apiService.account.login(email, password).then(function (response) {
                setTokenCookie(response.id_token);
                return apiService.setShopperId(getShopperIdFromToken(getIdToken()));
            });
        }
    }

    function getShopperIdFromToken(token) {
        return (0, _get2.default)(jwtHelper.decodeToken(token), '["https://api.material.com/user_metadata"].shopperId');
    }

    function getShopperId() {
        if (useUniversalLogin()) {
            return auth0SdkService.getUser().then(function (user) {
                return user && user['https://api.material.com/user_metadata'].shopperId;
            });
        }

        var token = getIdToken();
        if (!token) {
            return $q.resolve();
        }
        return $q.resolve(getShopperIdFromToken(token));
    }

    function logout(useNewCarts) {
        clearUser();
        apiService.setShopperId(null);

        if (useUniversalLogin()) {
            auth0SdkService.logout({
                returnTo: $window.location.href
            });
        }

        if (!useNewCarts) {
            return checkoutService.getAndUpdateCart(function (cart) {
                delete cart.shippingAddress;
                delete cart.contactInfo;
                delete cart.selectedShippingAddressId;
                return cart;
            }).then(function () {
                $mdDialog.cancel();
                return $state.reload();
            });
        }

        (0, _cartUtils.setSavedCartInfo)(_extends({}, (0, _cartUtils.getSavedCartInfo)(), {
            shippingAddress: undefined,
            contactInfo: undefined,
            selectedShippingAddressId: undefined
        }));

        $mdDialog.cancel();
        return $state.reload();
    }

    function isLoggedIn() {
        if (useUniversalLogin()) {
            return auth0SdkService.isAuthenticated().then(function (authenticated) {
                return authenticated;
            });
        }

        var idTokenCookie = $cookies.get(getIdTokenCookieName());
        return $q.resolve(angular.isDefined(idTokenCookie) && !jwtHelper.isTokenExpired(idTokenCookie));
    }

    function getIdToken() {
        return $cookies.get(getIdTokenCookieName(), globalCookieOptions);
    }

    function setTokenCookie(idToken) {
        var decodedToken = jwtHelper.decodeToken(idToken);
        var cookieOptions = _extends({}, globalCookieOptions, {
            expires: _moment2.default.unix(decodedToken.exp).toDate()
        });

        $cookies.put(getIdTokenCookieName(), idToken, cookieOptions);
    }

    function clearTokenCookie() {
        $cookies.put(getIdTokenCookieName(), '', globalCookieOptions);
        $cookies.remove(getIdTokenCookieName(), globalCookieOptions);
    }

    function getIdTokenCookieName() {
        return 'id_token';
    }

    function getAccessToken() {
        if (useUniversalLogin()) {
            return auth0SdkService.getTokenSilently().then(function (token) {
                return token;
            });
        }

        return $q.resolve(getIdToken());
    }

    function handleRedirectCallback() {
        return auth0SdkService.handleRedirectCallback();
    }

    return {
        handleRedirectCallback: handleRedirectCallback,
        login: login,
        logout: logout,
        isLoggedIn: isLoggedIn,
        getShopperId: getShopperId,
        getAccessToken: getAccessToken,
        useUniversalLogin: useUniversalLogin
    };
}]).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AddressVerificationService = undefined;

__webpack_require__(36);

var _api = __webpack_require__(14);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var AddressVerificationService = angular.module('checkout.addressVerificationService', [_api.ApiService, 'app.constants']).service('addressVerificationService', ['apiService', function (apiService) {
    function isAddressVerified(address) {
        return this.verifyAddress(address).then(function (_ref) {
            var verified = _ref.verified;
            return verified;
        });
    }

    function verifyAddress(address) {
        return apiService.verifyAddress(address).then(function (_ref2) {
            var verificationStatus = _ref2.verificationStatus,
                rest = _objectWithoutProperties(_ref2, ['verificationStatus']);

            if (verificationStatus === 'Verified') {
                var isSame = checkAddressSimilarity(address, rest);

                if (isSame.same) return { verified: true };

                return {
                    verified: true,
                    changes: isSame.changes
                };
            }

            if (verificationStatus === 'Partial') {
                return {
                    verified: false,
                    recommendations: rest.recommendations
                };
            }

            return { verified: false };
        }).catch(function () {
            return {
                verified: false
            };
        });
    }

    function checkAddressSimilarity(enteredAddress, returnedAddress) {
        var same = {
            address1: false,
            address2: false,
            city: false,
            state: false,
            postalCode: false
        };
        var changes = {};

        // consider both eAddress1 + ' ' +  eAddress2 === rAddress1 and
        //  eAddress1 === rAddress1 to be matching
        if (enteredAddress.address1 + ' ' + enteredAddress.address2 === returnedAddress.address1) {
            same.address1 = true;
            same.address2 = true;
        } else {
            same.address1 = (enteredAddress.address1 || '') === (returnedAddress.address1 || '');
            same.address2 = (enteredAddress.address2 || '') === (returnedAddress.address2 || '');
        }

        same.city = enteredAddress.city === (returnedAddress.locality || '');
        same.state = enteredAddress.state === (returnedAddress.administrativeArea || '');
        same.postalCode = enteredAddress.postalCode === (returnedAddress.postalCode || '');

        if (!same.address1) changes.address1 = returnedAddress.address1;
        if (!same.address2) changes.address2 = returnedAddress.address2;
        if (!same.city) changes.city = returnedAddress.locality;
        if (!same.state) changes.state = returnedAddress.administrativeArea;
        if (!same.postalCode) changes.postalCode = returnedAddress.postalCode;

        return {
            same: Object.values(same).every(function (el) {
                return el;
            }),
            changes: changes
        };
    }

    function getAutocompleteAddressParts(placeId) {
        return apiService.getAutocompleteAddressParts(placeId).then(function (parts) {
            return parts.data;
        });
    }

    function autocompleteAddress(address, country) {
        var components = [];
        if (country) {
            components.push('country:' + country);
        }
        return apiService.autocompleteAddress(address, components);
    }

    var service = {
        isAddressVerified: isAddressVerified,
        getAutocompleteAddressParts: getAutocompleteAddressParts,
        autocompleteAddress: autocompleteAddress,
        verifyAddress: verifyAddress
    };

    return service;
}]).name;
exports.AddressVerificationService = AddressVerificationService;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ShopperAccountService = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _find = __webpack_require__(76);

var _find2 = _interopRequireDefault(_find);

var _api = __webpack_require__(14);

var _checkout = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShopperAccountService = exports.ShopperAccountService = angular.module('checkout.shopperAccountService', [_api.ApiService, _checkout.CheckoutService]).service('shopperAccountService', ['checkoutService', 'apiService', '$q', function (checkoutService, apiService, $q) {
    function applyAccountInfoToCart(shopperAccount, shippingAddress) {
        if (!shippingAddress || !shopperAccount) return $q.reject();
        return checkoutService.getAndUpdateCart(function (cart) {
            var cartWithShippingAddress = applyShippingAddressToCartLogic(cart, shippingAddress);
            var cartWithContactAndShipping = applyContactInfoToCartLogic(cartWithShippingAddress, shopperAccount);
            return cartWithContactAndShipping;
        });
    }

    function applyShippingAddressToCart(shippingAddress) {
        if (!shippingAddress) return $q.reject();
        return checkoutService.getAndUpdateCart(function (cart) {
            return applyShippingAddressToCartLogic(cart, shippingAddress);
        });
    }

    function applyContactInfoToCart(shopperAccount) {
        return checkoutService.getAndUpdateCart(function (cart) {
            return applyContactInfoToCartLogic(cart, shopperAccount);
        });
    }

    function applyShippingAddressToCartLogic(cart, shippingAddress) {
        return _extends({}, cart, {
            shippingAddress: {
                firstName: shippingAddress.address.firstName,
                lastName: shippingAddress.address.lastName,
                address1: shippingAddress.address.address1,
                address2: shippingAddress.address.address2,
                city: shippingAddress.address.city,
                state: shippingAddress.address.state,
                postalCode: shippingAddress.address.postalCode,
                country: shippingAddress.address.country
            },
            selectedShippingAddressId: shippingAddress.id
        });
    }

    function applyContactInfoToCartLogic(cart, shopperAccount) {
        return _extends({}, cart, {
            contactInfo: {
                email: shopperAccount.emailAddress,
                phoneNumber: shopperAccount.phoneNumber
            },
            shopperId: shopperAccount.id
        });
    }

    function getAllShopperData() {
        return $q.all([apiService.account.get(), apiService.account.shippingAddress.getAll(), apiService.account.paymentMethod.getAll().catch(function (err) {
            if (err.status !== 400) {
                // stripe not connected
                return $q.reject(err);
            }
        })]).then(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 3),
                shopperAccount = _ref2[0],
                shippingAddresses = _ref2[1],
                paymentMethods = _ref2[2];

            return {
                shopperAccount: shopperAccount,
                shippingAddresses: shippingAddresses,
                paymentMethods: paymentMethods
            };
        });
    }

    function getDefaultShippingAddress(shippingAddresses) {
        var defaultShippingAddress = (0, _find2.default)(shippingAddresses.items, 'address.isDefault');
        if (defaultShippingAddress) return defaultShippingAddress;

        if (shippingAddresses.items.length > 0) {
            return shippingAddresses.items[0];
        }
    }

    // TODO: remove initShopperAccount (and most functions in this service) after migration to new carts
    function initShopperAccount(cart) {
        return getAllShopperData().then(function (_ref3) {
            var shopperAccount = _ref3.shopperAccount,
                shippingAddresses = _ref3.shippingAddresses,
                paymentMethods = _ref3.paymentMethods;

            var hasSavedShippingAddress = shippingAddresses && shippingAddresses.items.length > 0;

            // shopper does not have shipping address on cart, but they have a saved address. Apply it to cart
            if (hasSavedShippingAddress && !cart.shippingAddress) {
                var defaultShippingAddress = getDefaultShippingAddress(shippingAddresses);
                return defaultShippingAddress ? applyAccountInfoToCart(shopperAccount, defaultShippingAddress).then(function (updatedCart) {
                    return { updatedCart: updatedCart, shopperAccount: shopperAccount, shippingAddresses: shippingAddresses, paymentMethods: paymentMethods };
                }) : { shopperAccount: shopperAccount, shippingAddresses: shippingAddresses, paymentMethods: paymentMethods };
            }

            if (!cart.contactInfo || cart.contactInfo && cart.contactInfo.email !== shopperAccount.emailAddress) {
                return applyContactInfoToCart(shopperAccount).then(function (updatedCart) {
                    return { updatedCart: updatedCart, shopperAccount: shopperAccount, shippingAddresses: shippingAddresses, paymentMethods: paymentMethods };
                });
            }

            return $q.resolve({ shopperAccount: shopperAccount, shippingAddresses: shippingAddresses, paymentMethods: paymentMethods });
        });
    }

    return {
        applyAccountInfoToCart: applyAccountInfoToCart,
        applyShippingAddressToCart: applyShippingAddressToCart,
        applyContactInfoToCart: applyContactInfoToCart,
        applyShippingAddressToCartLogic: applyShippingAddressToCartLogic,
        applyContactInfoToCartLogic: applyContactInfoToCartLogic,
        getAllShopperData: getAllShopperData,
        getDefaultShippingAddress: getDefaultShippingAddress,
        initShopperAccount: initShopperAccount
    };
}]).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DisplayInfo = undefined;

var _displayInfo = __webpack_require__(785);

var _displayInfo2 = _interopRequireDefault(_displayInfo);

__webpack_require__(786);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DisplayInfo = exports.DisplayInfo = angular.module('checkout.components.displayInfo', []).component('displayInfo', {
    template: _displayInfo2.default,
    transclude: {
        title: '?displayInfoTitle',
        content: 'displayInfoContent',
        verified: '?displayInfoVerified'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DisplayStateName = undefined;

var _countryData = __webpack_require__(201);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DisplayStateName = exports.DisplayStateName = angular.module('checkout.components.displayStateName', []).component('displayStateName', {
    template: '{{$ctrl.countries[$ctrl.countryCode].provinces[$ctrl.stateCode] || $ctrl.stateCode || ""}}',
    bindings: {
        countryCode: '<',
        stateCode: '<'
    },
    controller: function DisplayStateNameCtrl() {
        _classCallCheck(this, DisplayStateNameCtrl);

        this.countries = _countryData.countries;
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DisplayCountryName = undefined;

var _countryData = __webpack_require__(201);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DisplayCountryName = exports.DisplayCountryName = angular.module('checkout.components.displayCountryName', []).component('displayCountryName', {
    template: '{{$ctrl.countries[$ctrl.countryCode].name || ""}}',
    bindings: {
        countryCode: '<'
    },
    controller: function DisplayCountryNameCtrl() {
        _classCallCheck(this, DisplayCountryNameCtrl);

        this.countries = _countryData.countries;
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ModalService = exports.ModalService = angular.module('checkout.services.modalService', ['ngMaterial']).service('modalService', ['$mdDialog', '$window', function ($mdDialog, $window) {
    function open(options) {
        return $mdDialog.cancel().then(function () {
            var modalBodyClass = 'checkout-modal-overrides';
            angular.element($window.document.body).addClass(modalBodyClass);
            return $mdDialog.show({
                controller: ['$scope', function ($scope) {
                    angular.extend($scope, options.data);
                }],
                onComplete: function onComplete() {
                    $window.document.querySelector('.md-dialog-container').scrollTop = 0;
                },
                template: '\n                        <md-dialog class="checkout checkout-modal ' + options.cssClass + '">' + options.template + '</md-dialog>\n                    ',
                targetEvent: options.$event,
                clickOutsideToClose: options.clickOutsideToClose
            }).finally(function (response) {
                angular.element($window.document.body).removeClass(modalBodyClass);
                return response;
            });
        });
    }

    return {
        open: open
    };
}]).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createStripeTokenMetadata = createStripeTokenMetadata;
function createStripeTokenMetadata(billingAddress) {
    return {
        name: billingAddress.firstName + ' ' + billingAddress.lastName,
        address_line1: billingAddress.address1,
        address_line2: billingAddress.address2,
        address_city: billingAddress.city,
        address_state: billingAddress.state,
        address_zip: billingAddress.postalCode,
        address_country: billingAddress.country
    };
}

var CreditCardService = exports.CreditCardService = angular.module('checkout.creditCardService', []).service('creditCardService', ['$q', '$window', function ($q, $window) {
    var convertExpStringToObject = function convertExpStringToObject(expString) {
        var exp = expString.split('/');
        return {
            expMonth: exp[0],
            expYear: exp[1]
        };
    };

    var createAuthorizeNetToken = function createAuthorizeNetToken(_ref) {
        var card = _ref.card,
            cart = _ref.cart,
            publicClientKey = _ref.publicClientKey,
            apiLoginId = _ref.apiLoginId;
        var _cart$billingAddress = cart.billingAddress,
            postalCode = _cart$billingAddress.postalCode,
            firstName = _cart$billingAddress.firstName,
            lastName = _cart$billingAddress.lastName;


        var expStringParts = card.expiration.split('/');
        var expMonth = expStringParts[0];
        var expYear = expStringParts[1].substring(2, 4) || expStringParts[1];

        var deferred = $q.defer();
        $window.Accept.dispatchData({
            authData: {
                clientKey: publicClientKey,
                apiLoginID: apiLoginId
            },
            cardData: {
                cardNumber: card.cardNumber,
                month: expMonth,
                year: expYear,
                cardCode: card.cvc,
                zip: postalCode,
                fullName: firstName + ' ' + lastName
            }
        }, function (data) {
            if (data.error) {
                deferred.reject(data.error);
            } else {
                deferred.resolve(data);
            }
        });
        return deferred.promise;
    };

    return {
        convertExpStringToObject: convertExpStringToObject,
        createAuthorizeNetToken: createAuthorizeNetToken
    };
}]).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SaveAndCancel = undefined;

__webpack_require__(879);

var SaveAndCancel = exports.SaveAndCancel = angular.module('checkout.components.saveAndCancel', []).component('saveAndCancel', {
    template: '\n            <div layout class="save-and-cancel">\n                <button \n                    class="checkout-button checkout-button--border"\n                    type="button"\n                    test-id="cancel-button"\n                    ng-click="$ctrl.onCancelClicked()">\n                    Cancel\n                </button>\n                <button\n                    class="checkout-button checkout-button--primary"\n                    type="button"\n                    ng-click="$ctrl.onSaveClicked()"\n                    test-id="save-button">\n                    <span ng-if="!$ctrl.showSaveLoader">Save</span>\n                    <md-progress-circular\n                        ng-if="$ctrl.showSaveLoader"\n                        md-diameter="15"\n                        md-mode="indeterminate">\n                    </md-progress-circular>\n                </button>\n            </div>\n        ',
    bindings: {
        onSaveClicked: '&',
        onCancelClicked: '&',
        showSaveLoader: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GaService = undefined;

var _has = __webpack_require__(196);

var _has2 = _interopRequireDefault(_has);

var _get = __webpack_require__(16);

var _get2 = _interopRequireDefault(_get);

var _storeInfo = __webpack_require__(192);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GaService = exports.GaService = angular.module('checkout.services.gaService', [_storeInfo.StoreInfoService]).service('gaService', ['storeInfoService', '$window', '$q', function (storeInfoService, $window, $q) {
    $window.dataLayer = $window.dataLayer || [];
    var tracked = { 1: false, 2: false, 3: false, 4: false, 5: false };
    function setTracked(stepNumber, isTracked) {
        tracked[stepNumber] = isTracked;
    }

    function getTracked(stepNumber) {
        return tracked[stepNumber];
    }

    function extractProductsFromCart(_ref) {
        var items = _ref.items;

        var promises = items.map(function (item) {
            return createProductPayload(item);
        });
        return $q.all(promises);
    }

    function createProductPayload(item) {
        var product = item.product,
            quantity = item.quantity;

        return storeInfoService.get().then(function (storeInfo) {
            var storeUrl = storeInfo.customDomain && storeInfo.customDomain !== '' ? storeInfo.customDomain : storeInfo.storeUrl;
            var payload = {
                dimension2: storeInfo.tenant,
                dimension3: storeInfo.name,
                dimension4: storeUrl
            };

            if (product) {
                // old cart shape
                Object.assign(payload, {
                    id: product.sku || product.id,
                    name: product.name,
                    price: product.price
                });
                if ((0, _get2.default)(product, 'availability.preOrder.enabled')) payload.dimension6 = 'pre-order';
            } else {
                // new cart shape
                Object.assign(payload, {
                    id: item.sku || item.productId,
                    name: item.productName,
                    price: item.price.amount / 100
                });
                if ((0, _get2.default)(item, 'preOrderAvailable')) payload.dimension6 = 'pre-order';
            }

            if (isFinite(quantity)) {
                payload.quantity = quantity;
            }

            if ((0, _has2.default)(product, 'images[0].imageLink.fullUri')) {
                payload.dimension5 = product.images[0].imageLink.fullUri;
            } else if ((0, _has2.default)(product, 'imageMetadata.imageLink.fullUri')) {
                payload.dimension5 = product.imageMetadata.imageLink.fullUri;
            } else if (item.imageSrc) {
                payload.dimension5 = item.imageSrc;
            }

            return payload;
        });
    }

    function logCheckoutStep(stepNumber, optionValue, cart) {
        if (getTracked(stepNumber)) return;
        extractProductsFromCart(cart).then(function (extractedProducts) {
            $window.dataLayer.push({
                event: 'checkout',
                ecommerce: {
                    checkout: {
                        actionField: { step: stepNumber, option: optionValue },
                        products: extractedProducts
                    }
                }
            });
        });
        setTracked(stepNumber, true);
    }

    function logPurchase(_ref2) {
        var orderNumber = _ref2.orderNumber,
            grandTotal = _ref2.grandTotal,
            taxAmount = _ref2.taxAmount,
            cart = _ref2.cart;

        var shippingCost = cart.shippingMethod && cart.shippingMethod.shippingCost ? cart.shippingMethod.shippingCost : 0;
        var couponCode = cart.discount && cart.discount.code ? cart.discount.code : '';

        extractProductsFromCart(cart).then(function (extractedProducts) {
            storeInfoService.get().then(function (storeInfo) {
                $window.dataLayer.push({
                    event: 'productPurchase',
                    adwords_conversion_id: (0, _get2.default)(storeInfo, 'thirdPartyIntegrations.adwordsConversionId', null),
                    adwords_conversion_label: (0, _get2.default)(storeInfo, 'thirdPartyIntegrations.adwordsConversionLabel', null),
                    ecommerce: {
                        purchase: {
                            actionField: {
                                id: orderNumber,
                                affiliation: storeInfo.tenant,
                                revenue: grandTotal,
                                tax: taxAmount,
                                shipping: shippingCost,
                                coupon: couponCode
                            },
                            products: extractedProducts
                        }
                    }
                });
            });
        });
    }

    function sendAppLoadedEvent(googleAnalyticsId) {
        $window.dataLayer.push({
            event: 'initialAppLoaded',
            U_GA_ID: googleAnalyticsId
        });
    }

    function sendOrderPlacementErrorEvent(errorResponse) {
        var eventLabel = (0, _get2.default)(errorResponse, 'data.items[0].message', 'Order Placement Error');
        var address = (0, _get2.default)(errorResponse, 'config.data.deliverTo.address', {});
        var doesAddressLine1StartWithoutANumber = address.country === 'US' && /^[^0-9]/.test(address.address1);
        $window.dataLayer.push({
            event: 'orderError',
            eventCategory: 'Errors',
            eventAction: 'place order',
            eventLabel: eventLabel,
            // Sending the eventValue as 1 if the address line 1 doesn't start with a number.
            // This will help us find out how many Order placement failures are due to the
            // address missing the street number.
            eventValue: doesAddressLine1StartWithoutANumber ? 1 : 0
        });
    }

    function sendVirtualPageViewEvent(path, title, tenantId) {
        $window.dataLayer.push({
            event: 'virtualPageView',
            virtualPage: path,
            virtualTitle: title,
            tenantID: tenantId
        });
    }

    return {
        logCheckoutStep: logCheckoutStep,
        logPurchase: logPurchase,
        sendAppLoadedEvent: sendAppLoadedEvent,
        sendVirtualPageViewEvent: sendVirtualPageViewEvent,
        sendOrderPlacementErrorEvent: sendOrderPlacementErrorEvent
    };
}]).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ContinueButton = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(749);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ContinueButton = exports.ContinueButton = angular.module('checkout.components.continueButton', []).component('continueButton', {
    transclude: true,
    template: '\n            <button\n                class="checkout-button checkout-button--primary checkout-button--large continue-button"\n                type="{{$ctrl.buttonType}}"\n                ng-disabled="$ctrl.isDisabled"\n                ng-click="$ctrl.onClicked({ $event: $event })">\n                <div layout layout-align="center center">\n                    <span ng-if="!$ctrl.isLoading">\n                        <ng-transclude></ng-transclude>\n                    </span>\n                    <md-progress-circular\n                        ng-if="$ctrl.isLoading"\n                        md-diameter="{{$ctrl.spinnerSize || 25}}"\n                        md-mode="indeterminate">\n                    </md-progress-circular>\n                </div>\n            </button>\n        ',
    bindings: {
        isDisabled: '<',
        isLoading: '<',
        onClicked: '&',
        spinnerSize: '<',
        buttonType: '@'
    },
    controller: function () {
        function ContinueButtonCtrl() {
            _classCallCheck(this, ContinueButtonCtrl);
        }

        _createClass(ContinueButtonCtrl, [{
            key: '$onInit',
            value: function $onInit() {
                this.buttonType = this.buttonType || 'button';
            }
        }]);

        return ContinueButtonCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CreditCardForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _angularCreditCards = __webpack_require__(750);

var _angularCreditCards2 = _interopRequireDefault(_angularCreditCards);

var _assign = __webpack_require__(44);

var _assign2 = _interopRequireDefault(_assign);

__webpack_require__(775);

var _inputContainer = __webpack_require__(37);

var _creditCardImage = __webpack_require__(203);

var _formatCardExpiration = __webpack_require__(777);

var _cvcInfo = __webpack_require__(779);

var _creditCardForm = __webpack_require__(782);

var _creditCardForm2 = _interopRequireDefault(_creditCardForm);

__webpack_require__(783);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CreditCardForm = exports.CreditCardForm = angular.module('checkout.components.creditCardForm', [_angularCreditCards2.default, 'angularPayments', _inputContainer.InputContainer, _creditCardImage.CreditCardImage, _cvcInfo.CvcInfo, _formatCardExpiration.FormatCardExpiration]).component('creditCardForm', {
    template: _creditCardForm2.default,
    bindings: {
        model: '=',
        disableCardNumberField: '<',
        hideCvcInput: '<',
        hideCreditCardImage: '<',
        onCreditCardTypeUpdated: '<'
    },
    controller: function () {
        CreditCardFormCtrl.$inject = ['$timeout'];

        function CreditCardFormCtrl($timeout) {
            _classCallCheck(this, CreditCardFormCtrl);

            (0, _assign2.default)(this, {
                $timeout: $timeout
            });
        }

        _createClass(CreditCardFormCtrl, [{
            key: '$onInit',
            value: function $onInit() {
                // Workaround for a bug with angular-payments https://github.com/laurihy/angular-payments/issues/93
                if (this.model) {
                    this.model.expiration = this.model.expiration || null;
                } else {
                    this.model = {
                        expiration: null
                    };
                }
            }
        }, {
            key: 'updateCreditCardType',
            value: function updateCreditCardType() {
                var _this = this;

                this.$timeout(function () {
                    _this.onCreditCardTypeUpdated(_this.creditCardForm.cardNumber.$ccType);
                });
            }
        }]);

        return CreditCardFormCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 132 */,
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StripeElementsForm = exports.stripeElementCardStyle = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(791);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var stripeElementCardStyle = exports.stripeElementCardStyle = {
    base: {
        color: 'rgba(0, 0, 0, 0.87)',
        // eslint-disable-next-line max-len
        fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '14px',
        '::placeholder': {
            color: 'rgba(0, 0, 0, 0.54)'
        }
    },
    invalid: {
        color: '#dd2c00',
        iconColor: '#dd2c00'
    }
};

var StripeElementsForm = exports.StripeElementsForm = angular.module('checkout.components.stripeElementsForm', []).component('stripeElementsForm', {
    template: '<div id="stripe-card-element"></div>',
    bindings: {
        stripeElementsCard: '<',
        onStripeElementsCardChange: '<'
    },
    controller: function () {
        StripeElementsFormCtrl.$inject = ['$timeout'];

        function StripeElementsFormCtrl($timeout) {
            _classCallCheck(this, StripeElementsFormCtrl);

            this.$timeout = $timeout;
        }

        _createClass(StripeElementsFormCtrl, [{
            key: '$onInit',
            value: function $onInit() {
                var _this = this;

                this.$timeout(function () {
                    _this.stripeElementsCard.mount('#stripe-card-element');
                    if (_this.onStripeElementsCardChange) {
                        _this.stripeElementsCard.addEventListener('change', _this.onStripeElementsCardChange);
                    }
                });
            }
        }, {
            key: '$onDestroy',
            value: function $onDestroy() {
                var _this2 = this;

                this.$timeout(function () {
                    return _this2.stripeElementsCard.unmount();
                });
            }
        }]);

        return StripeElementsFormCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ContactInfoForm = undefined;

var _validateEmail = __webpack_require__(796);

var _ignoreKeypress = __webpack_require__(797);

var _formatPhoneNumber = __webpack_require__(798);

var _inputContainer = __webpack_require__(37);

var _contactInfoForm = __webpack_require__(800);

var _contactInfoForm2 = _interopRequireDefault(_contactInfoForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ContactInfoForm = exports.ContactInfoForm = angular.module('checkout.components.contactInfoForm', [_validateEmail.ValidateEmailDirective, _ignoreKeypress.IgnoreKeypress, _formatPhoneNumber.FormatPhoneNumber, _inputContainer.InputContainer]).component('contactInfoForm', {
    template: _contactInfoForm2.default,
    bindings: {
        model: '=',
        phoneNumberRequired: '<',
        emailInputDisabled: '<'
    },
    controller: function ContactInfoFormCtrl() {
        _classCallCheck(this, ContactInfoFormCtrl);

        this.contactInfoModel = {};
        this.phoneIgnoreCharRegex = /[A-Za-z!@#$%^&*()/:=|{}:"'<>\\_+\-.,;/?]/;
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AddressVerificationForm = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _addressVerificationButton = __webpack_require__(801);

var _addressWithChanges = __webpack_require__(803);

var _addressVerificationForm = __webpack_require__(805);

var _addressVerificationForm2 = _interopRequireDefault(_addressVerificationForm);

__webpack_require__(806);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AddressVerificationForm = exports.AddressVerificationForm = angular.module('checkout.components.addressVerificationForm', [_addressWithChanges.AddressWithChanges, _addressVerificationButton.AddressVerificationButton]).component('addressVerificationForm', {
    template: _addressVerificationForm2.default,
    bindings: {
        address: '<',
        changes: '<',
        contactInfo: '<',
        loading: '<',
        onChooseAddress: '<',
        recommendations: '<'
    },
    controller: function () {
        function AddressVerificationFormController() {
            _classCallCheck(this, AddressVerificationFormController);

            Object.assign(this, {
                chooseEnteredAddressButtonClicked: false,
                chooseSuggestedAddressButtonClicked: false
            });
        }

        _createClass(AddressVerificationFormController, [{
            key: '$onInit',
            value: function $onInit() {
                this.verifiedWithChanges = this.changes && Object.keys(this.changes).length;
                this.hasRecommendations = !!this.recommendations;
                this.notVerified = !this.hasRecommendations && !this.verifiedWithChanges;

                // highlight incorrect address parts
                if (this.primaryInfoNeeded() || this.boxRouteNumberNeeded()) {
                    this.changes = {
                        address1: this.address.address1
                    };
                }

                if (this.secondaryInfoNeeded()) {
                    this.changes = {
                        address2: this.address.address2
                    };
                }
            }
        }, {
            key: 'primaryInfoNeeded',
            value: function primaryInfoNeeded() {
                var primaryInfoMessages = ['Primary Number Missing', 'Primary Number Invalid'];

                return (this.recommendations || []).some(function (r) {
                    return primaryInfoMessages.includes(r);
                });
            }
        }, {
            key: 'secondaryInfoNeeded',
            value: function secondaryInfoNeeded() {
                var secondaryInfoMessages = ['Missing Secondary Information', 'Secondary Information Unrecognized'];

                return (this.recommendations || []).some(function (r) {
                    return secondaryInfoMessages.includes(r);
                });
            }
        }, {
            key: 'boxRouteNumberNeeded',
            value: function boxRouteNumberNeeded() {
                var boxRouteInfoMessages = ['Box/Route Number Missing', 'Box/Route Number Invalid'];

                return (this.recommendations || []).some(function (r) {
                    return boxRouteInfoMessages.includes(r);
                });
            }
        }, {
            key: 'chooseEnteredAddress',
            value: function chooseEnteredAddress() {
                this.chooseEnteredAddressButtonClicked = true;
                this.onChooseAddress(this.address);
            }
        }, {
            key: 'chooseSuggestedAddress',
            value: function chooseSuggestedAddress() {
                this.chooseSuggestedAddressButtonClicked = true;
                var suggestedAddress = _extends({}, this.address, this.changes);
                this.onChooseAddress(suggestedAddress);
            }
        }, {
            key: 'editAddress',
            value: function editAddress() {
                this.onChooseAddress();
            }
        }]);

        return AddressVerificationFormController;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StoreInfoService = undefined;

var _api = __webpack_require__(14);

var StoreInfoService = exports.StoreInfoService = angular.module('checkout.storeInfoService', [_api.ApiService]).service('storeInfoService', ['apiService', '$q', function (apiService, $q) {
    var storeInfoCache = void 0;

    function get(refreshCache) {
        if (storeInfoCache && !refreshCache) {
            return $q.resolve(storeInfoCache);
        }
        return apiService.getStoreInformation().then(function (storeInfo) {
            storeInfoCache = storeInfo;
            return storeInfo;
        });
    }

    return {
        get: get
    };
}]).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 193 */,
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var ADMINISTRATIVE_AREA_LEVEL_1_LABELS = exports.ADMINISTRATIVE_AREA_LEVEL_1_LABELS = {
    US: 'State',
    MX: 'State',
    AU: 'State/Territory',
    MY: 'State/Territory',
    CN: 'Province',
    CA: 'Province',
    IT: 'Province',
    ID: 'Province',
    DZ: 'Province',
    TH: 'Province',
    UZ: 'Province',
    EG: 'Governorate',
    AE: 'Emirate',
    BR: 'State'
};

var DEAFULT_ADMINISTRATIVE_AREA_LEVEL_1_LABEL = exports.DEAFULT_ADMINISTRATIVE_AREA_LEVEL_1_LABEL = 'Region';

var AUTOCOMPLETE_COUNTRIES = exports.AUTOCOMPLETE_COUNTRIES = ['US', 'GB', 'AU', 'CA', 'BR', 'FR', 'IN'];

var SAVED_CART_KEY = exports.SAVED_CART_KEY = 'VOL_SAVED_CART';
var SAVED_STORECREDIT_KEY = exports.SAVED_STORECREDIT_KEY = 'VOL_SAVED_STORECREDIT';

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ShipToLocationsService = undefined;

var _api = __webpack_require__(14);

var ShipToLocationsService = exports.ShipToLocationsService = angular.module('checkout.ShipToLocationsService', [_api.ApiService]).service('shipToLocationsService', ['apiService', '$q', function (apiService, $q) {
    var shipToLocationCache = void 0;
    var getShipToLocationsPromise = void 0;

    function get(refreshCache) {
        if (getShipToLocationsPromise) return getShipToLocationsPromise;

        if (shipToLocationCache && !refreshCache) {
            return $q.resolve(shipToLocationCache);
        }

        getShipToLocationsPromise = apiService.getShipToLocations().then(function (shipToLocation) {
            shipToLocationCache = shipToLocation;
            getShipToLocationsPromise = undefined;
            return shipToLocation;
        });

        return getShipToLocationsPromise;
    }

    function isCountryAvailable(countryCode) {
        return getCountry(countryCode).then(function (country) {
            return country || $q.reject('Shipping country not available');
        });
    }

    function getCountry(countryCode) {
        return get().then(function (shipToLocations) {
            return shipToLocations.find(function (location) {
                return location.country === countryCode;
            });
        });
    }

    return {
        get: get,
        isCountryAvailable: isCountryAvailable
    };
}]).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FacebookPixelService = undefined;

var _cartUtils = __webpack_require__(19);

var FacebookPixelService = exports.FacebookPixelService = angular.module('checkout.services.facebookPixelService', []).service('facebookPixelService', ['$window', function ($window) {
    function getItemPrice(product) {
        var itemIsOnSale = (0, _cartUtils.productIsOnSale)(product);
        return itemIsOnSale ? (0, _cartUtils.getProductSalePrice)(product.pricing.salePrice) : (0, _cartUtils.getProductListPrice)(product);
    }

    function extractPayloadContentFromCartItem(cartItem) {
        if (cartItem.product) {
            return {
                id: cartItem.product.sku,
                quantity: cartItem.quantity,
                item_price: getItemPrice(cartItem.product)
            };
        }

        return {
            id: cartItem.sku,
            quantity: cartItem.quantity,
            item_price: cartItem.price.amount / 100
        };
    }

    function getContents(cartItems) {
        return cartItems.map(extractPayloadContentFromCartItem);
    }

    function calculateTotalQuantity(sum, cartItem) {
        return sum += cartItem.quantity;
    }

    function getTotalItems(cartItems) {
        return cartItems.reduce(calculateTotalQuantity, 0);
    }

    function getPayload(cart, cartGrandTotal) {
        var value = cartGrandTotal !== undefined && cartGrandTotal !== null ? cartGrandTotal : cart.grandTotal;
        return {
            value: value,
            currency: 'USD',
            content_type: 'product',
            contents: getContents(cart.items),
            num_items: getTotalItems(cart.items)
        };
    }

    function trackPurchaseEvent(cart) {
        if ($window.fbq) {
            var params = {};
            if (cart) {
                params = getPayload(cart);
            }
            $window.fbq('track', 'Purchase', params);
        }
    }

    function trackInitiateCheckoutEvent(cart, cartGrandTotal) {
        if ($window.fbq) {
            var params = {};
            if (cart) {
                params = getPayload(cart, cartGrandTotal);
            }
            $window.fbq('track', 'InitiateCheckout', params);
        }
    }

    return {
        trackInitiateCheckoutEvent: trackInitiateCheckoutEvent,
        trackPurchaseEvent: trackPurchaseEvent
    };
}]).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 201 */,
/* 202 */,
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CreditCardImage = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(776);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CreditCardImage = exports.CreditCardImage = angular.module('checkout.components.creditCardImage', []).component('creditCardImage', {
    template: '\n            <img ng-src="{{$ctrl.imageUrl}}" class="credit-card-image" />\n        ',
    bindings: {
        cardType: '<'
    },
    controller: function () {
        function CreditCardImageCtrl() {
            _classCallCheck(this, CreditCardImageCtrl);
        }

        _createClass(CreditCardImageCtrl, [{
            key: '$onChanges',
            value: function $onChanges(changesObj) {
                if (changesObj.cardType) {
                    var urlBase = '//d3dl6qv39aj0xv.cloudfront.net/assets/payment';
                    var imageFileName = this.getFileNameFromCardType(changesObj.cardType.currentValue);
                    this.imageUrl = urlBase + '/' + imageFileName;
                }
            }
        }, {
            key: 'getFileNameFromCardType',
            value: function getFileNameFromCardType(cardType) {
                switch (angular.isString(cardType) ? cardType.toUpperCase() : cardType) {
                    case 'AMEX':
                    case 'AMERICAN EXPRESS':
                        return 'cc_amex.svg';
                    case 'VISA':
                        return 'cc_visa.svg';
                    case 'MC':
                    case 'MASTERCARD':
                        return 'cc_mastercard.svg';
                    case 'DISC':
                    case 'DISCOVER':
                        return 'cc_discover.svg';
                    default:
                        return 'cc_default.png';
                }
            }
        }]);

        return CreditCardImageCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ShippingAddressForm = undefined;

var _addressForm = __webpack_require__(54);

var _shippingAddressForm = __webpack_require__(807);

var _shippingAddressForm2 = _interopRequireDefault(_shippingAddressForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShippingAddressForm = exports.ShippingAddressForm = angular.module('checkout.components.shippingAddressForm', [_addressForm.AddressForm]).component('shippingAddressForm', {
    template: _shippingAddressForm2.default,
    bindings: {
        shippingAddressForm: '=formController',
        model: '=',
        hideShippingAsBilling: '<',
        useAddressVerification: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ShippingMethodForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _shippingMethodForm = __webpack_require__(810);

var _shippingMethodForm2 = _interopRequireDefault(_shippingMethodForm);

__webpack_require__(811);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ShippingMethodForm = exports.ShippingMethodForm = angular.module('checkout.components.shippingMethodForm', []).component('shippingMethodForm', {
    template: _shippingMethodForm2.default,
    bindings: {
        shippingMethods: '<',
        selectedMethodIndex: '=',
        disableForm: '<'
    },
    controller: function () {
        function ShippingMethodFormController() {
            _classCallCheck(this, ShippingMethodFormController);
        }

        _createClass(ShippingMethodFormController, [{
            key: '$onInit',
            value: function $onInit() {
                var shippingMethods = this.shippingMethods || [];
                shippingMethods.forEach(function (method) {
                    method.deliveryEstimate = (method.deliveryEstimate || '').trim();
                });
            }
        }]);

        return ShippingMethodFormController;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ImageCircle = undefined;

__webpack_require__(815);

var ImageCircle = exports.ImageCircle = angular.module('checkout.components.orderSummary.imageCircle', []).component('imageCircle', {
    template: '\n            <img\n                class="image-circle"\n                ng-src="{{$ctrl.image || \'//d3dl6qv39aj0xv.cloudfront.net/assets/tcp-no-image.jpg\'}}" />\n        ',
    bindings: {
        image: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DisplayBillingAndPayment = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _creditCardImage = __webpack_require__(203);

var _displayInfo = __webpack_require__(81);

var _displayBillingAndPayment = __webpack_require__(850);

var _displayBillingAndPayment2 = _interopRequireDefault(_displayBillingAndPayment);

__webpack_require__(851);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DisplayBillingAndPayment = exports.DisplayBillingAndPayment = angular.module('checkout.components.displayBillingAndPayment', [_creditCardImage.CreditCardImage, _displayInfo.DisplayInfo]).component('displayBillingAndPayment', {
    template: _displayBillingAndPayment2.default,
    bindings: {
        cartAddress: '<',
        orderPlacedBy: '<',
        paymentMethod: '<',
        creditCardType: '<',
        creditCardLastFour: '<',
        paypalEmail: '<',
        paymentRequests: '<'
    },
    controller: function () {
        function DisplayBillingAndPaymentCtrl() {
            _classCallCheck(this, DisplayBillingAndPaymentCtrl);
        }

        _createClass(DisplayBillingAndPaymentCtrl, [{
            key: '$onInit',
            value: function $onInit() {
                if (this.cartAddress) {
                    this.address = this.cartAddress;
                } else if (this.orderPlacedBy) {
                    this.address = this.orderPlacedBy.address;
                    this.address.firstName = this.orderPlacedBy.firstName;
                    this.address.lastName = this.orderPlacedBy.lastName;
                    this.address.country = this.orderPlacedBy.address.country;
                }
            }
        }]);

        return DisplayBillingAndPaymentCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Header = undefined;

var _storeLogo = __webpack_require__(852);

var _secureLabel = __webpack_require__(854);

var _logoutButton = __webpack_require__(329);

var _header = __webpack_require__(858);

var _header2 = _interopRequireDefault(_header);

__webpack_require__(859);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = exports.Header = angular.module('checkout.components.header', [_storeLogo.StoreLogo, _secureLabel.SecureLabel, _logoutButton.LogoutButton]).component('checkoutHeader', {
    template: _header2.default,
    bindings: {
        storeInfo: '<',
        returnUrl: '<',
        isLoggedIn: '<',
        loggedInShopperName: '<',
        useNewCarts: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HeaderBackground = undefined;

__webpack_require__(860);

var HeaderBackground = exports.HeaderBackground = angular.module('checkout.components.headerBackground', []).component('headerBackground', {
    template: '\n            <div\n                class="header-background"\n                ng-class="{\'header-background--gradient\': $ctrl.storeInfo.logo.imageLink.fullUri}">\n                <ng-transclude></ng-transclude>\n            </div>\n        ',
    transclude: true,
    bindings: {
        storeInfo: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ScriptLoaderService = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _assign = __webpack_require__(44);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScriptLoaderService = exports.ScriptLoaderService = angular.module('ScriptLoaderService', []).service('scriptLoaderService', ['$document', '$window', '$q', function ($document, $window, $q) {
    function loadFacebookPixel(fbPixelId) {
        if (!$window.fbq) {
            loadScriptTag({
                text: '\n                        !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?\n                        n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;\n                        n.push=n;n.loaded=!0;n.version=\'2.0\';n.queue=[];t=b.createElement(e);t.async=!0;\n                        t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,\n                        document,\'script\',\'//connect.facebook.net/en_US/fbevents.js\');\n                        fbq(\'init\', \'' + fbPixelId + '\');\n                        fbq(\'track\', \'PageView\');\n                    '
            });
        }
    }

    function loadGTM(gtmId) {
        loadScriptTag({
            text: '\n                    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({\'gtm.start\':\n                    new Date().getTime(),event:\'gtm.js\'});var f=d.getElementsByTagName(s)[0],\n                    j=d.createElement(s),dl=l!=\'dataLayer\'?\'&l=\'+l:\'\';j.async=true;j.src=\n                    \'https://www.googletagmanager.com/gtm.js?id=\'+i+dl;f.parentNode.insertBefore(j,f);\n                    })(window,document,\'script\',\'dataLayer\', \'' + gtmId + '\');\n                '
        });
    }

    function loadScriptTag(options) {
        var script = $document[0].createElement('script');
        (0, _assign2.default)(script, options);
        script.type = 'text/javascript';
        if (options.attributes && options.attributes.length > 0) {
            Object.keys(options.attributes).forEach(function (key) {
                script.setAttribute(options.attributes[key].name, options.attributes[key].value);
            });
        }
        $document[0].body.appendChild(script);
    }

    function loadScriptTagPromise(options) {
        var deferred = $q.defer();
        loadScriptTag(_extends({}, options, {
            onload: deferred.resolve,
            onerror: deferred.reject
        }));
        return deferred.promise;
    }

    return {
        loadScriptTag: loadScriptTag,
        loadScriptTagPromise: loadScriptTagPromise,
        loadFacebookPixel: loadFacebookPixel,
        loadGTM: loadGTM
    };
}]).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OrderService = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _uuidV = __webpack_require__(729);

var _uuidV2 = _interopRequireDefault(_uuidV);

var _get = __webpack_require__(16);

var _get2 = _interopRequireDefault(_get);

var _angularCookies = __webpack_require__(303);

var _angularCookies2 = _interopRequireDefault(_angularCookies);

__webpack_require__(36);

var _constants = __webpack_require__(194);

var _facebookPixel = __webpack_require__(200);

var _ga = __webpack_require__(129);

var _api = __webpack_require__(14);

var _creditCard = __webpack_require__(94);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderService = exports.OrderService = angular.module('checkout.orderService', [_angularCookies2.default, _facebookPixel.FacebookPixelService, _ga.GaService, _api.ApiService, _creditCard.CreditCardService, 'app.constants']).service('orderService', ['$q', '$window', '$cookies', 'apiService', 'creditCardService', 'gaService', 'facebookPixelService', 'CART_LOCAL_STORAGE_KEY', 'TENANT_LOCAL_STORAGE_KEY', function ($q, $window, $cookies, apiService, creditCardService, gaService, facebookPixelService, CART_LOCAL_STORAGE_KEY, TENANT_LOCAL_STORAGE_KEY) {
    function placeOrder(orderOptions) {
        var cart = orderOptions.cart,
            authorizeNet = orderOptions.authorizeNet,
            paymentMethod = orderOptions.paymentMethod,
            card = orderOptions.card,
            stripe = orderOptions.stripe,
            stripeElementsCard = orderOptions.stripeElementsCard,
            stripeCreditCardId = orderOptions.stripeCreditCardId;
        var publicClientKey = authorizeNet.publicClientKey,
            apiLoginId = authorizeNet.apiLoginId;


        if (paymentMethod === 'Credit Card' && authorizeNet.isEnabled && card) {
            return creditCardService.createAuthorizeNetToken({ card: card, cart: cart, publicClientKey: publicClientKey, apiLoginId: apiLoginId }).then(function (response) {
                return submitOrderPayload(_extends({}, orderOptions, { authorizeNetToken: response.opaqueData }));
            }).then(function (order) {
                handleOrderCreated(order);
                return order;
            });
        } else if (paymentMethod === 'Credit Card' && stripe && stripeElementsCard && !stripeCreditCardId) {
            var deferred = $q.defer();
            orderOptions.stripe.createToken(orderOptions.stripeElementsCard, (0, _creditCard.createStripeTokenMetadata)(cart.billingAddress)).then(function (_ref) {
                var token = _ref.token,
                    error = _ref.error;

                if (error) throw new Error(error.message);
                return submitOrderPayload(_extends({}, orderOptions, { stripeToken: token }));
            }).then(function (order) {
                handleOrderCreated(order);
                return order;
            }).then(deferred.resolve).catch(deferred.reject);
            return deferred.promise;
        }

        return submitOrderPayload(orderOptions).then(function (order) {
            handleOrderCreated(order);
            return order;
        });
    }

    function submitOrderPayload(orderOptions) {
        var cart = orderOptions.cart,
            grandTotal = orderOptions.grandTotal,
            shopperNote = orderOptions.shopperNote,
            card = orderOptions.card,
            creditCardType = orderOptions.creditCardType,
            payPalExpressCheckoutToken = orderOptions.payPalExpressCheckoutToken,
            payPalPayerId = orderOptions.payPalPayerId,
            paymentMethod = orderOptions.paymentMethod,
            customerId = orderOptions.customerId,
            storeCreditInfo = orderOptions.storeCreditInfo,
            stripeCreditCardId = orderOptions.stripeCreditCardId,
            stripeToken = orderOptions.stripeToken,
            authorizeNetToken = orderOptions.authorizeNetToken,
            taxProvider = orderOptions.taxProvider;

        var creditCardLastFour = getCreditCardLastFour(card);

        var orderPayload = getOrderPayload({ cart: cart, shopperNote: shopperNote });

        if (customerId) {
            orderPayload.customerId = customerId;
        }

        if (stripeCreditCardId) {
            orderPayload.stripeCreditCardId = stripeCreditCardId;
        }

        if (creditCardLastFour) {
            orderPayload.creditCardLastFour = creditCardLastFour;
        }
        if (creditCardType) {
            orderPayload.creditCardType = creditCardType;
        }

        if (taxProvider) {
            orderPayload.taxProvider = taxProvider;
        }

        var paymentRequests = [];
        storeCreditInfo.items.forEach(function (item) {
            paymentRequests.push({
                amount: item.amountUsedInCents / 100,
                type: 'StoreCredit',
                paymentDetails: {
                    giftCardCode: item.giftCardCode
                }
            });
        });

        var chargeTotal = getChargeTotal({ cart: cart, grandTotal: grandTotal, storeCreditInfo: storeCreditInfo });
        if (chargeTotal > 0 || paymentRequests.length === 0) {
            if (stripeToken || stripeCreditCardId) {
                var paymentDetails = {
                    customerId: customerId,
                    stripeCreditCardId: stripeCreditCardId
                };
                if (stripeToken) {
                    paymentDetails.stripeCreditCardToken = stripeToken.id;
                }
                paymentRequests.push({
                    amount: chargeTotal,
                    type: 'Stripe',
                    paymentDetails: paymentDetails
                });
            } else if (authorizeNetToken) {
                paymentRequests.push({
                    amount: chargeTotal,
                    type: 'Authorize.net',
                    paymentDetails: {
                        authorizeNetOpaqueDataDescriptor: authorizeNetToken.dataDescriptor,
                        authorizeNetOpaqueDataValue: authorizeNetToken.dataValue,
                        creditCardLastFour: creditCardLastFour,
                        creditCardType: creditCardType
                    }
                });
            } else if (payPalExpressCheckoutToken) {
                paymentRequests.push({
                    amount: chargeTotal,
                    type: 'PayPal',
                    paymentDetails: {
                        token: payPalExpressCheckoutToken,
                        creditCardLastFour: creditCardLastFour,
                        creditCardType: creditCardType,
                        payPalPayerId: payPalPayerId
                    }
                });
            } else if (paymentMethod === 'Cash') {
                paymentRequests.push({
                    amount: chargeTotal,
                    type: 'Cash',
                    paymentDetails: {
                        type: 'Cash'
                    }
                });
            }
        }

        orderPayload.paymentRequests = paymentRequests;

        return apiService.createOrder(orderPayload).catch(function (err) {
            throw getError('Error creating the order', err);
        });
    }

    function getCreditCardLastFour(card) {
        if (!card) {
            return null;
        }

        if (card.cardNumber) {
            return card.cardNumber.slice(-4);
        }
        return card.creditCardLastFour || null;
    }

    function getOrderPayload(_ref2) {
        var cart = _ref2.cart,
            shopperNote = _ref2.shopperNote;

        var REQUEST_ID_CHAR_LIMIT = 20;
        var requestId = (0, _uuidV2.default)().replace(/-/g, '').substring(0, REQUEST_ID_CHAR_LIMIT);

        // TODO: remove when legacy carts are deprecated
        if (!cart.cartId) {
            return {
                taxAmount: cart.taxAmount,
                taxRate: cart.taxRate,
                grandTotal: cart.grandTotal,
                placedBy: {
                    firstName: cart.billingAddress.firstName,
                    lastName: cart.billingAddress.lastName,
                    emailAddress: cart.contactInfo.email,
                    phoneNumber: cart.contactInfo.phoneNumber,
                    emailOptIn: cart.emailOptIn,
                    address: cart.billingAddress
                },
                deliverTo: {
                    firstName: cart.shippingAddress.firstName,
                    lastName: cart.shippingAddress.lastName,
                    address: cart.shippingAddress,
                    isResidential: true
                },
                cart: cart,
                shopperNote: shopperNote,
                requestId: requestId
            };
        }

        // @FIXME: this transform is needed for "new" carts
        //         because the API expects the shipping method in the shape found in the legacy cart
        var transformedShippingMethod = {
            name: cart.shippingMethod.name,
            shippingBand: {
                shippingPrice: cart.shippingMethod.shippingPrice
            }
        };

        return {
            placedBy: {
                firstName: cart.billingAddress.firstName,
                lastName: cart.billingAddress.lastName,
                emailAddress: cart.contactInfo.email,
                phoneNumber: cart.contactInfo.phoneNumber,
                emailOptIn: cart.emailOptIn,
                address: cart.billingAddress
            },
            deliverTo: {
                firstName: cart.shippingAddress.firstName,
                lastName: cart.shippingAddress.lastName,
                address: cart.shippingAddress,
                isResidential: true
            },
            cartId: cart.cartId,
            shippingMethod: transformedShippingMethod,
            shopperNote: shopperNote,
            requestId: requestId
        };
    }

    function getChargeTotal(_ref3) {
        var cart = _ref3.cart,
            grandTotal = _ref3.grandTotal,
            storeCreditInfo = _ref3.storeCreditInfo;

        // TODO: remove when legacy carts are deprecated, possibly this entire function
        if (!cart.cartId) {
            return cart.grandTotal - storeCreditInfo.storeCreditAmountInCents / 100;
        }

        return grandTotal;
    }

    function handleOrderCreated(order) {
        gaService.logPurchase(order);
        facebookPixelService.trackPurchaseEvent(order.cart);
        clearCartSession();
    }

    function clearCartSession() {
        $window.sessionStorage.removeItem(CART_LOCAL_STORAGE_KEY);
        $window.sessionStorage.removeItem(TENANT_LOCAL_STORAGE_KEY);
        $window.sessionStorage.removeItem(_constants.SAVED_CART_KEY);
        $cookies.remove(CART_LOCAL_STORAGE_KEY);
        $cookies.remove(TENANT_LOCAL_STORAGE_KEY);
    }

    function getError(preface, err) {
        var errorDetail = getErrorDetail(err);
        return new Error(preface + ': ' + errorDetail);
    }

    function friendlyModelError(error) {
        if (error['order.PlacedBy.PhoneNumber']) return 'Invalid Phone Number';
        return undefined;
    }

    function friendlyMessageError(error) {
        if (error === 'Error creating the order: Missing or invalid parameter: Address Invalid Address Provided') {
            return 'We couldn\'t verify your address. You can try fixing it by checking for misspellings,\n                    or by moving your suite/apartment/unit number/company name to Address line 2';
        }
        // eslint-disable-next-line max-len
        if (error === 'Error creating the order: Missing or invalid parameter: order paymentMethod value must be one of Cash,Credit Card,PayPal,Purchase Order') {
            return 'There was a problem creating the order. Please check your payment\n                    information and try again.';
        }
        return error;
    }

    function getErrorDetail(response) {
        var dataItemsError = (0, _get2.default)(response, 'data.items[0].message');
        var itemsError = (0, _get2.default)(response, 'items[0].message');
        var modelError = friendlyModelError((0, _get2.default)(response, 'data.modelState', {}));
        var messageError = friendlyMessageError((0, _get2.default)(response, 'message'));
        var stringError = typeof response === 'string' ? response : undefined;
        var unknownDataError = JSON.stringify((0, _get2.default)(response, 'data'));
        var unknownError = JSON.stringify(response);
        return dataItemsError || itemsError || modelError || messageError || stringError || unknownDataError || unknownError;
    }

    var service = {
        getErrorDetail: getErrorDetail,
        handleOrderCreated: handleOrderCreated,
        placeOrder: placeOrder,
        submitOrderPayload: submitOrderPayload
    };

    return service;
}]).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.logPurchase = exports.logPaymentMethod = exports.logShippingInfo = exports.logShopperInfo = exports.logCheckoutStarted = exports.logPageView = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _get = __webpack_require__(16);

var _get2 = _interopRequireDefault(_get);

var _utils = __webpack_require__(306);

var _cart = __webpack_require__(730);

var _cartUtils = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var generateBasePayload = function generateBasePayload(tenantId) {
    return {
        device_id: (0, _utils.setCachedStorageValue)(window.localStorage, 'device_id', (0, _utils.generateId)()),
        session_id: (0, _utils.setCachedStorageValue)(window.sessionStorage, 'session_id', (0, _utils.generateId)()),
        timestamp: (0, _utils.getCurrentTimeAsUTC)(),
        tenant_id: tenantId
    };
};

var generateCheckoutStartedPayload = function generateCheckoutStartedPayload(tenantId) {
    var cart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var storeUrl = arguments[2];
    return _extends({}, generateBasePayload(tenantId), {
        checkout_started_data: {
            cart_items: (0, _cart.createCartItems)(cart.items, storeUrl),
            cart_value: (0, _cartUtils.getItemsTotal)(cart.items),
            checkout_url: (0, _utils.getCurrentUrl)()
        }
    });
};

var generateShopperInfoPayload = function generateShopperInfoPayload(tenantId) {
    var cart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _extends({}, generateBasePayload(tenantId), {
        shopper_info: (0, _cart.getCartShopperInfo)(cart)
    });
};

var generateShippingInfoPayload = function generateShippingInfoPayload(tenantId) {
    var cart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return _extends({}, generateBasePayload(tenantId), {
        shipping_method: (0, _get2.default)(cart, 'shippingMethod.name')
    });
};

var generatePaymentMethodPayload = function generatePaymentMethodPayload(tenantId, paymentMethod) {
    return _extends({}, generateBasePayload(tenantId), {
        payment_method: paymentMethod
    });
};

var generatePurchasePayload = function generatePurchasePayload(tenantId) {
    var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var storeUrl = arguments[2];
    return _extends({}, generateBasePayload(tenantId), {
        product_purchase_data: {
            tax: order.taxAmount,
            shipping: order.shippingCost,
            transaction_revenue: order.grandTotal,
            transaction_id: order.id,
            products: (0, _cart.createCartItems)((0, _get2.default)(order, 'cart.items'), storeUrl),
            customer_info: (0, _cart.getOrderContactInfo)(order),
            shipping_method: (0, _get2.default)(order, 'cart.shippingMethod.name'),
            payment_method: order.paymentMethod
        }
    });
};

var logPageView = exports.logPageView = function logPageView(tenantId) {
    (0, _utils.pushUniqueEventToDataLayer)('page_view', generateBasePayload(tenantId));
};

var logCheckoutStarted = exports.logCheckoutStarted = function logCheckoutStarted(tenantId, cart, storeUrl) {
    (0, _utils.pushUniqueEventToDataLayer)('checkout_started', generateCheckoutStartedPayload(tenantId, cart, storeUrl));
};

var logShopperInfo = exports.logShopperInfo = function logShopperInfo(tenantId, cart) {
    (0, _utils.pushEventToDataLayer)('shopper_info', generateShopperInfoPayload(tenantId, cart));
};

var logShippingInfo = exports.logShippingInfo = function logShippingInfo(tenantId, cart) {
    (0, _utils.pushEventToDataLayer)('shipping_info', generateShippingInfoPayload(tenantId, cart));
};

var logPaymentMethod = exports.logPaymentMethod = function logPaymentMethod(tenantId, paymentMethod) {
    (0, _utils.pushEventToDataLayer)('payment_method', generatePaymentMethodPayload(tenantId, paymentMethod));
};

var logPurchase = exports.logPurchase = function logPurchase(tenantId, order, storeUrl) {
    (0, _utils.pushUniqueEventToDataLayer)('product_purchase', generatePurchasePayload(tenantId, order, storeUrl));
};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var generateId = exports.generateId = function generateId() {
    return Date.now() + '.' + Math.floor(Math.random() * Date.now());
};

var setCachedStorageValue = exports.setCachedStorageValue = function setCachedStorageValue(storage, key, value) {
    var existingValue = storage.getItem(key);
    if (existingValue) {
        return existingValue;
    }
    storage.setItem(key, value);
    return value;
};

var initDataLayer = function initDataLayer() {
    window.dataLayer = window.dataLayer || [];
};

var pushEventToDataLayer = exports.pushEventToDataLayer = function pushEventToDataLayer(eventName, payload) {
    initDataLayer();
    window.dataLayer.push(_extends({}, payload, {
        event: eventName
    }));
};

var eventAlreadyLogged = exports.eventAlreadyLogged = function eventAlreadyLogged(eventName) {
    return window.dataLayer && window.dataLayer.length && window.dataLayer.find(function (item) {
        return item.event === eventName;
    });
};

var pushUniqueEventToDataLayer = exports.pushUniqueEventToDataLayer = function pushUniqueEventToDataLayer(eventId, payload) {
    if (!eventAlreadyLogged(eventId)) {
        pushEventToDataLayer(eventId, payload);
    }
};

var combineStringsWithSpace = exports.combineStringsWithSpace = function combineStringsWithSpace(strings) {
    return strings.reduce(function (acc, curr) {
        return curr ? acc + ' ' + curr : acc;
    }, '').trim();
};
var getCurrentTimeAsUTC = exports.getCurrentTimeAsUTC = function getCurrentTimeAsUTC() {
    return new Date().getTime();
};
var getCurrentUrl = exports.getCurrentUrl = function getCurrentUrl() {
    return window.location.href;
};

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Accordian = undefined;

var _textCircle = __webpack_require__(731);

var _accordian = __webpack_require__(734);

var _accordian2 = _interopRequireDefault(_accordian);

__webpack_require__(735);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Accordian = exports.Accordian = angular.module('checkout.components.accordian', [_textCircle.TextCircle]).component('accordian', {
    template: _accordian2.default,
    transclude: {
        content: 'accordianContent',
        headerContent: '?accordianHeaderContent'
    },
    bindings: {
        stepNumber: '@',
        headingText: '<',
        open: '<',
        light: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CheckoutWithPaypalSdkButton = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(747);

var _paypalSdk = __webpack_require__(67);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CheckoutWithPaypalSdkButton = exports.CheckoutWithPaypalSdkButton = angular.module('checkout.components.checkoutWithPaypalSdkButton', [_paypalSdk.PaypalSdkService]).component('checkoutWithPaypalSdkButton', {
    template: '<div id="paypal-sdk-button-container"></div>',
    bindings: {
        cartId: '<',
        bagId: '<',
        getGiftCards: '<'
    },
    controller: function () {
        PaypalButtonCtrl.$inject = ['paypalSdkService'];

        function PaypalButtonCtrl(paypalSdkService) {
            _classCallCheck(this, PaypalButtonCtrl);

            angular.extend(this, { paypalSdkService: paypalSdkService });
        }

        _createClass(PaypalButtonCtrl, [{
            key: '$onInit',
            value: function $onInit() {
                this.paypalSdkService.renderPaypalButtons(this.cartId, this.bagId, this.getGiftCards);
            }
        }]);

        return PaypalButtonCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CheckoutWithPaypalSdkSummaryButton = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(748);

var _paypalSdk = __webpack_require__(67);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CheckoutWithPaypalSdkSummaryButton = exports.CheckoutWithPaypalSdkSummaryButton = angular.module('checkout.components.checkoutWithPaypalSdkSummaryButton', [_paypalSdk.PaypalSdkService]).component('checkoutWithPaypalSdkSummaryButton', {
    template: '<div id="paypal-sdk-summary-button-container"></div>',
    bindings: {
        cartId: '<',
        bagId: '<'
    },
    controller: function () {
        PaypalSummaryButtonCtrl.$inject = ['paypalSdkService'];

        function PaypalSummaryButtonCtrl(paypalSdkService) {
            _classCallCheck(this, PaypalSummaryButtonCtrl);

            angular.extend(this, { paypalSdkService: paypalSdkService });
        }

        _createClass(PaypalSummaryButtonCtrl, [{
            key: '$onInit',
            value: function $onInit() {
                this.paypalSdkService.renderPaypalSummaryButtons(this.cartId, this.bagId);
            }
        }]);

        return PaypalSummaryButtonCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PaymentMethodForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _creditCardForm = __webpack_require__(131);

var _billingAddressForm = __webpack_require__(784);

var _creditCardList = __webpack_require__(789);

var _stripeElementsForm = __webpack_require__(133);

var _checkoutWithPaypalSdkAcp = __webpack_require__(315);

var _paypalSdk = __webpack_require__(67);

var _paymentMethodForm = __webpack_require__(794);

var _paymentMethodForm2 = _interopRequireDefault(_paymentMethodForm);

__webpack_require__(795);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PaymentMethodForm = exports.PaymentMethodForm = angular.module('checkout.components.paymentMethodForm', [_checkoutWithPaypalSdkAcp.CheckoutWithPaypalSdkAcp, _creditCardForm.CreditCardForm, _billingAddressForm.BillingAddressForm, _creditCardList.CreditCardList, _stripeElementsForm.StripeElementsForm, _paypalSdk.PaypalSdkService]).component('paymentMethodForm', {
    template: _paymentMethodForm2.default,
    bindings: {
        storeInfo: '<',
        availablePaymentMethods: '<',
        selectedPaymentMethod: '=',
        creditCardModel: '=',
        billingAddressModel: '=',
        billingSameAsShipping: '<',
        onCreditCardTypeUpdated: '<',
        stripeElementsCard: '<',
        onStripeElementsCardChange: '<',
        isShippingRequired: '<'
    },
    controller: function () {
        PaymentMethodForm.$inject = ['paypalSdkService'];

        function PaymentMethodForm(paypalSdkService) {
            _classCallCheck(this, PaymentMethodForm);

            angular.extend(this, { paypalSdkService: paypalSdkService });
        }

        _createClass(PaymentMethodForm, [{
            key: '$onInit',
            value: function $onInit() {
                this.paypalSdkService.renderPaypalMessages();
            }
        }, {
            key: 'shouldShowPayPalAcpFields',
            value: function shouldShowPayPalAcpFields() {
                var paypalAcpEnabled = this.storeInfo.paypal && this.storeInfo.paypal.acpStatus === 'SUBSCRIBED' && !this.storeInfo.paypal.acpLimitReached;
                var authorizeNetEnabled = this.storeInfo.authorizeNet && this.storeInfo.authorizeNet.isEnabled;
                var stripeEnabled = this.storeInfo.acceptsStripeAsPayment;
                return !authorizeNetEnabled && !stripeEnabled && paypalAcpEnabled;
            }
        }]);

        return PaymentMethodForm;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CheckoutWithPaypalSdkAcp = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _assign = __webpack_require__(44);

var _assign2 = _interopRequireDefault(_assign);

var _creditCardForm = __webpack_require__(131);

var _creditCardImage = __webpack_require__(203);

var _inputContainer = __webpack_require__(37);

var _paypalSdk = __webpack_require__(67);

var _checkoutWithPaypalSdkAcp = __webpack_require__(792);

var _checkoutWithPaypalSdkAcp2 = _interopRequireDefault(_checkoutWithPaypalSdkAcp);

__webpack_require__(793);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CheckoutWithPaypalSdkAcp = exports.CheckoutWithPaypalSdkAcp = angular.module('checkout.components.checkoutWithPaypalSdkAcp', [_paypalSdk.PaypalSdkService, _creditCardForm.CreditCardForm, _creditCardImage.CreditCardImage, _inputContainer.InputContainer]).component('checkoutWithPaypalSdkAcp', {
    template: _checkoutWithPaypalSdkAcp2.default,
    bindings: {
        cartId: '<',
        bagId: '<'
    },
    controller: function () {
        PaypalAcpCtrl.$inject = ['paypalSdkService', '$rootScope', '$timeout'];

        function PaypalAcpCtrl(paypalSdkService, $rootScope, $timeout) {
            var _this = this;

            _classCallCheck(this, PaypalAcpCtrl);

            angular.extend(this, { paypalSdkService: paypalSdkService });
            (0, _assign2.default)(this, {
                $timeout: $timeout
            });
            this.isSubmitting = false;
            // eslint-disable-next-line no-unused-vars
            $rootScope.$on('paypal-acp-submit-clicked', function (event, args) {
                _this.$timeout(function () {
                    _this.isSubmitting = true;
                });
            });
            // eslint-disable-next-line no-unused-vars
            $rootScope.$on('paypal-submit-error', function (event, args) {
                _this.$timeout(function () {
                    _this.isSubmitting = false;
                });
            });
            this.cardType = 'none';
            $rootScope.$on('paypal-card-type-change', function (event, args) {
                _this.$timeout(function () {
                    _this.cardType = args.cardType;
                });
            });
        }

        _createClass(PaypalAcpCtrl, [{
            key: '$onInit',
            value: function $onInit() {
                this.paypalSdkService.renderPaypalAcp(this.cartId, this.bagId);
            }
        }]);

        return PaypalAcpCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DisplayContactAndDelivery = undefined;

var _displayInfo = __webpack_require__(81);

var _displayStateName = __webpack_require__(82);

var _displayCountryName = __webpack_require__(83);

var _displayContactAndDelivery = __webpack_require__(808);

var _displayContactAndDelivery2 = _interopRequireDefault(_displayContactAndDelivery);

__webpack_require__(809);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DisplayContactAndDelivery = exports.DisplayContactAndDelivery = angular.module('checkout.components.displayContactAndDelivery', [_displayInfo.DisplayInfo, _displayStateName.DisplayStateName, _displayCountryName.DisplayCountryName]).component('displayContactAndDelivery', {
    template: _displayContactAndDelivery2.default,
    bindings: {
        cart: '<',
        isShippingRequired: '<',
        isShippingAddressVerified: '<',
        isBillingAddressVerified: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DisplayShippingMethod = undefined;

var _displayInfo = __webpack_require__(81);

var _modal = __webpack_require__(84);

var _displayShippingMethod = __webpack_require__(812);

var _displayShippingMethod2 = _interopRequireDefault(_displayShippingMethod);

__webpack_require__(813);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DisplayShippingMethod = exports.DisplayShippingMethod = angular.module('checkout.components.displayShippingMethod', [_displayInfo.DisplayInfo, _modal.ModalService]).component('displayShippingMethod', {
    template: _displayShippingMethod2.default,
    bindings: {
        shippingMethod: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ThankYou = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _assign = __webpack_require__(44);

var _assign2 = _interopRequireDefault(_assign);

var _get = __webpack_require__(16);

var _get2 = _interopRequireDefault(_get);

var _orderSummary = __webpack_require__(319);

var _displayDeliveryAndShipping = __webpack_require__(844);

var _displayBillingAndPayment = __webpack_require__(207);

var _header = __webpack_require__(208);

var _headerBackground = __webpack_require__(209);

var _createAccount = __webpack_require__(861);

var _auth = __webpack_require__(78);

var _checkout = __webpack_require__(18);

var _thankYouConfirmation = __webpack_require__(867);

var _thankYou = __webpack_require__(870);

var _thankYou2 = _interopRequireDefault(_thankYou);

__webpack_require__(871);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ThankYou = exports.ThankYou = angular.module('checkout.components.thankYou', [_thankYouConfirmation.ThankYouConfirmation, _orderSummary.OrderSummary, _displayDeliveryAndShipping.DisplayDeliveryAndShipping, _displayBillingAndPayment.DisplayBillingAndPayment, _header.Header, _headerBackground.HeaderBackground, _createAccount.CreateAccount, _auth.AuthService, _checkout.CheckoutService]).component('thankYou', {
    template: _thankYou2.default,
    bindings: {
        order: '<',
        storeCreditInfo: '<',
        returnUrl: '<',
        storeInfo: '<',
        showCreateAccount: '<',
        isLoggedIn: '<',
        stripeTokenForAccountCreation: '<'
    },
    controller: function () {
        ThankYouCtrl.$inject = ['$q', 'apiService', 'checkoutService', 'authService'];

        function ThankYouCtrl($q, apiService, checkoutService, authService) {
            _classCallCheck(this, ThankYouCtrl);

            (0, _assign2.default)(this, {
                $q: $q,
                apiService: apiService,
                checkoutService: checkoutService,
                authService: authService
            });
        }

        _createClass(ThankYouCtrl, [{
            key: 'onCreateAccountFormSubmit',
            value: function onCreateAccountFormSubmit(password) {
                var _this = this;

                if (!password) return;

                this.creatingAccount = true;

                var emailAddress = this.order.placedBy.emailAddress;

                this.apiService.account.create(emailAddress, password).then(function () {
                    _this.showAccountCreatedMessage = true;
                    return _this.authService.login(emailAddress, password);
                }).then(function () {
                    if (_this.stripeTokenForAccountCreation) {
                        return _this.apiService.account.paymentMethod.add(_this.stripeTokenForAccountCreation.token.id, true);
                    }
                    return _this.$q.resolve();
                }).catch(function (err) {
                    var title = 'Error creating account';
                    var message = (0, _get2.default)(err, 'data.message', title);

                    if (err.data && err.data.statusCode === 409) {
                        _this.showCreateAccount = false;
                    }

                    _this.checkoutService.showErrorDialog(message, title);
                }).finally(function () {
                    _this.creatingAccount = false;
                });
            }
        }, {
            key: 'onCreateAccountDismissClicked',
            value: function onCreateAccountDismissClicked() {
                this.createAccountDismissed = true;
            }
        }]);

        return ThankYouCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OrderSummary = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cartItem = __webpack_require__(814);

var _orderTotals = __webpack_require__(817);

var _collapsed = __webpack_require__(323);

var _orderNotes = __webpack_require__(324);

var _toggle = __webpack_require__(325);

var _promoCodeForm = __webpack_require__(326);

var _orderSummary = __webpack_require__(841);

var _orderSummary2 = _interopRequireDefault(_orderSummary);

__webpack_require__(327);

var _giftCardChips = __webpack_require__(328);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderSummary = exports.OrderSummary = angular.module('checkout.components.orderSummary', [_cartItem.CartItem, _orderTotals.OrderTotals, _collapsed.OrderSummaryCollapsed, _orderNotes.OrderNotes, _toggle.OrderSummaryToggle, _promoCodeForm.PromoCodeForm, _giftCardChips.GiftCardChips, 'ngMaterial']).component('orderSummary', {
    template: _orderSummary2.default,
    bindings: {
        cart: '<',
        storeCreditInfo: '<',
        removeStoreCreditItem: '<',
        orderNotes: '<',
        onOrderNotesChanged: '<',
        onRemovePromoClicked: '<',
        onApplyPromoClicked: '<',
        promoCodeNotFound: '<',
        promoCodeExpired: '<',
        inactiveGiftCard: '<',
        giftCardNotAllowed: '<',
        giftCardAlreadyApplied: '<',
        cannotAddMoreStoreCredit: '<',
        readOnly: '<',
        order: '<',
        returnUrl: '<',
        onCheckoutClicked: '<',
        checkoutButtonDisabled: '<',
        showCheckoutButton: '<',
        paymentMethod: '<',
        isReturnFromPaypal: '<',
        initPaypalSdkSummaryButton: '<',
        bag: '<'
    },
    controller: function () {
        OrderSummaryCtrl.$inject = ['$window', '$scope', '$mdMedia', '$rootScope', '$timeout'];

        function OrderSummaryCtrl($window, $scope, $mdMedia, $rootScope, $timeout) {
            _classCallCheck(this, OrderSummaryCtrl);

            angular.extend(this, {
                $window: $window,
                $scope: $scope,
                $mdMedia: $mdMedia,
                $rootScope: $rootScope,
                $timeout: $timeout,
                collapsable: true
            });
        }

        _createClass(OrderSummaryCtrl, [{
            key: '$onInit',
            value: function $onInit() {
                var _this = this;

                this.$scope.$watch(function () {
                    return _this.$mdMedia('gt-sm');
                }, function (desktop) {
                    _this.collapsable = !desktop;
                    _this.collapsed = !desktop;
                });

                this.unbindForcePromoInputVisible = this.$rootScope.$on('OrderSummaryCtrl:ForcePromoInputVisible', function () {
                    _this.collapsed = false;
                    _this.showPromoInput = true;
                    _this.$timeout(function () {
                        _this.$window.document.querySelector('promo-code-form input').focus();
                    });
                });
                if (this.orderNotes) {
                    this.showOrderNotes = true;
                }
            }
        }, {
            key: '$onDestroy',
            value: function $onDestroy() {
                this.unbindForcePromoInputVisible();
            }
        }, {
            key: 'goToStorefront',
            value: function goToStorefront() {
                this.$window.location.href = this.returnUrl;
            }
        }, {
            key: 'onShowPromoInputClicked',
            value: function onShowPromoInputClicked() {
                this.showPromoInput = true;
            }
        }, {
            key: 'openSummary',
            value: function openSummary() {
                if (!this.collapsable) return;
                this.collapsed = !this.collapsed;
            }
        }]);

        return OrderSummaryCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 320 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 321 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 322 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OrderSummaryCollapsed = undefined;

var _imageCircle = __webpack_require__(206);

var _collapsed = __webpack_require__(833);

var _collapsed2 = _interopRequireDefault(_collapsed);

__webpack_require__(834);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderSummaryCollapsed = exports.OrderSummaryCollapsed = angular.module('checkout.components.orderSummary.orderSummaryCollapsed', [_imageCircle.ImageCircle]).component('orderSummaryCollapsed', {
    template: _collapsed2.default,
    bindings: {
        grandTotal: '<',
        totalItems: '<',
        imageOne: '<',
        imageTwo: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OrderNotes = undefined;

var _ngFocusIf = __webpack_require__(136);

var _ngFocusIf2 = _interopRequireDefault(_ngFocusIf);

var _inputContainer = __webpack_require__(37);

var _orderNotes = __webpack_require__(836);

var _orderNotes2 = _interopRequireDefault(_orderNotes);

__webpack_require__(837);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderNotes = exports.OrderNotes = angular.module('checkout.components.orderSummary.orderNotes', [_ngFocusIf2.default, _inputContainer.InputContainer]).component('orderNotes', {
    template: _orderNotes2.default,
    bindings: {
        orderNotes: '<',
        onOrderNotesChanged: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OrderSummaryToggle = undefined;

__webpack_require__(838);

var OrderSummaryToggle = exports.OrderSummaryToggle = angular.module('checkout.components.orderSummary.orderSummaryToggle', []).component('orderSummaryToggle', {
    template: '\n            <button type="button" class="order-summary-toggle">\n                <div layout layout-align="start center">\n                    <span class="order-summary-toggle__text">\n                        <span ng-if="$ctrl.collapsed">Show details</span>\n                        <span ng-if="!$ctrl.collapsed">Hide details</span>\n                    </span>\n                    <i class="material-icons" ng-if="$ctrl.collapsed">arrow_drop_down</i>\n                    <i class="material-icons" ng-if="!$ctrl.collapsed">arrow_drop_up</i>\n                </div>\n            </button>\n        ',
    bindings: {
        collapsed: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PromoCodeForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ngFocusIf = __webpack_require__(136);

var _ngFocusIf2 = _interopRequireDefault(_ngFocusIf);

var _get = __webpack_require__(16);

var _get2 = _interopRequireDefault(_get);

var _inputContainer = __webpack_require__(37);

var _promoCodeForm = __webpack_require__(839);

var _promoCodeForm2 = _interopRequireDefault(_promoCodeForm);

__webpack_require__(840);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PromoCodeForm = exports.PromoCodeForm = angular.module('checkout.components.orderSummary.promoCodeForm', [_ngFocusIf2.default, _inputContainer.InputContainer]).component('promoCodeForm', {
    template: _promoCodeForm2.default,
    bindings: {
        onApplyPromoClicked: '<',
        promoCodeNotFound: '<',
        promoCodeExpired: '<',
        inactiveGiftCard: '<',
        giftCardNotAllowed: '<',
        giftCardAlreadyApplied: '<',
        cannotAddMoreStoreCredit: '<',
        discountCodeExistsInCart: '<',
        discountErrorMessage: '<'
    },
    controller: function () {
        function PromoCodeFormCtrl() {
            _classCallCheck(this, PromoCodeFormCtrl);
        }

        _createClass(PromoCodeFormCtrl, [{
            key: '$onChanges',
            value: function $onChanges(changesObj) {
                if (changesObj.promoCodeNotFound && !changesObj.promoCodeNotFound.isFirstChange()) {
                    this.setInputValidity('discountExists', !changesObj.promoCodeNotFound.currentValue);
                }

                if (changesObj.promoCodeExpired && !changesObj.promoCodeExpired.isFirstChange()) {
                    this.setInputValidity('discountExpired', !changesObj.promoCodeExpired.currentValue);
                }

                if (changesObj.inactiveGiftCard && !changesObj.inactiveGiftCard.isFirstChange()) {
                    this.setInputValidity('inactiveGiftCard', !changesObj.inactiveGiftCard.currentValue);
                }

                if (changesObj.giftCardNotAllowed && !changesObj.giftCardNotAllowed.isFirstChange()) {
                    this.setInputValidity('giftCardNotAllowed', !changesObj.giftCardNotAllowed.currentValue);
                }

                if (changesObj.giftCardAlreadyApplied && !changesObj.giftCardAlreadyApplied.isFirstChange()) {
                    this.setInputValidity('giftCardAlreadyApplied', !changesObj.giftCardAlreadyApplied.currentValue);
                }

                if (changesObj.cannotAddMoreStoreCredit && !changesObj.cannotAddMoreStoreCredit.isFirstChange()) {
                    this.setInputValidity('cannotAddMoreStoreCredit', !changesObj.cannotAddMoreStoreCredit.currentValue);
                }

                if (changesObj.discountCodeExistsInCart && !changesObj.discountCodeExistsInCart.isFirstChange()) {
                    this.setInputValidity('discountCodeExistsInCart', !changesObj.discountCodeExistsInCart.currentValue);
                }
            }
        }, {
            key: 'setInputValidity',
            value: function setInputValidity(validationKey, validity) {
                if (this.promoCodeForm) {
                    this.promoCodeForm.promoCode.$setValidity(validationKey, validity);
                }
            }
        }, {
            key: 'onApplyClicked',
            value: function onApplyClicked() {
                var _this = this;

                this.isApplying = true;
                this.onApplyPromoClicked(this.promoCode).finally(function () {
                    _this.isApplying = false;
                    _this.promoCode = '';
                });
            }
        }, {
            key: 'onPromoCodeInputChanged',
            value: function onPromoCodeInputChanged() {
                this.setInputValidity('discountExists', true);
                this.setInputValidity('discountExpired', true);
                this.setInputValidity('inactiveGiftCard', true);
                this.setInputValidity('giftCardNotAllowed', true);
                this.setInputValidity('cannotAddMoreStoreCredit', true);
                this.setInputValidity('discountCodeExistsInCart', true);
            }
        }, {
            key: 'getViewValueFromFormError',
            value: function getViewValueFromFormError(errorKey) {
                return (0, _get2.default)(this.promoCodeForm, '$error.' + errorKey + '[0].$viewValue');
            }
        }]);

        return PromoCodeFormCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GiftCardChips = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _inputContainer = __webpack_require__(37);

var _giftCardChips = __webpack_require__(842);

var _giftCardChips2 = _interopRequireDefault(_giftCardChips);

__webpack_require__(843);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GiftCardChips = exports.GiftCardChips = angular.module('checkout.components.orderSummary.giftCardChips', [_inputContainer.InputContainer]).component('giftCardChips', {
    template: _giftCardChips2.default,
    bindings: {
        storeCreditInfo: '<',
        removeStoreCreditItem: '<'
    },
    controller: function () {
        function GiftCardChipsCtrl() {
            _classCallCheck(this, GiftCardChipsCtrl);
        }

        _createClass(GiftCardChipsCtrl, [{
            key: 'onRemoveClicked',
            value: function onRemoveClicked(code) {
                this.removeStoreCreditItem(code);
            }
        }]);

        return GiftCardChipsCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LogoutButton = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _fullscreenLoader = __webpack_require__(77);

var _auth = __webpack_require__(78);

var _logoutButton = __webpack_require__(856);

var _logoutButton2 = _interopRequireDefault(_logoutButton);

__webpack_require__(857);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LogoutButton = exports.LogoutButton = angular.module('checkout.components.logoutButton', [_fullscreenLoader.FullscreenLoaderService, _auth.AuthService]).component('logoutButton', {
    template: _logoutButton2.default,
    bindings: {
        nameText: '<',
        smallWelcomeText: '<',
        useNewCarts: '<'
    },
    controller: function () {
        LogoutButtonCtrl.$inject = ['authService', 'loadingService'];

        function LogoutButtonCtrl(authService, loadingService) {
            _classCallCheck(this, LogoutButtonCtrl);

            this.authService = authService;
            this.loadingService = loadingService;
        }

        _createClass(LogoutButtonCtrl, [{
            key: 'onLogoutClicked',
            value: function onLogoutClicked() {
                this.loadingService.show('Logging out...');
                this.authService.logout(this.useNewCarts);
            }
        }]);

        return LogoutButtonCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EditShippingMethod = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _checkout = __webpack_require__(18);

var _cartUtils = __webpack_require__(19);

var _modal = __webpack_require__(84);

var _continueButton = __webpack_require__(130);

var _shippingMethodForm = __webpack_require__(205);

var _editShippingMethod = __webpack_require__(872);

var _editShippingMethod2 = _interopRequireDefault(_editShippingMethod);

__webpack_require__(873);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditShippingMethod = exports.EditShippingMethod = angular.module('checkout.components.editShippingMethod', ['ngMaterial', _checkout.CheckoutService, _modal.ModalService, _continueButton.ContinueButton, _shippingMethodForm.ShippingMethodForm]).service('editShippingMethodService', ['modalService', function (modalService) {
    return {
        open: function open($event) {
            var useNewCarts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var availableShippingMethods = arguments[2];
            var previouslySelectedShippingMethod = arguments[3];

            return modalService.open({
                $event: $event,
                cssClass: 'edit-shipping-method',
                template: '\n                        <edit-shipping-method\n                            layout="column"\n                            use-new-carts="useNewCarts"\n                            available-shipping-methods="availableShippingMethods"\n                            previously-selected-shipping-method="previouslySelectedShippingMethod">\n                        </edit-shipping-method>\n                    ',
                data: { useNewCarts: useNewCarts, availableShippingMethods: availableShippingMethods, previouslySelectedShippingMethod: previouslySelectedShippingMethod }
            });
        }
    };
}]).component('editShippingMethod', {
    bindings: {
        useNewCarts: '<',
        availableShippingMethods: '<',
        previouslySelectedShippingMethod: '<'
    },
    template: _editShippingMethod2.default,
    controller: function () {
        EditShippingMethodController.$inject = ['checkoutService', '$mdDialog'];

        function EditShippingMethodController(checkoutService, $mdDialog) {
            _classCallCheck(this, EditShippingMethodController);

            angular.extend(this, {
                checkoutService: checkoutService,
                $mdDialog: $mdDialog
            });
        }

        _createClass(EditShippingMethodController, [{
            key: '$onInit',
            value: function $onInit() {
                if (this.previouslySelectedShippingMethod) {
                    this.selectedShippingMethodIndex = (0, _cartUtils.getShippingMethodIndex)(this.availableShippingMethods, this.previouslySelectedShippingMethod);
                }
            }
        }, {
            key: 'save',
            value: function save() {
                var _this = this;

                if (this.editShippingMethodForm.$invalid) {
                    this.checkoutService.forceFormValidation(this.editShippingMethodForm);
                    return;
                }

                if (this.useNewCarts) {
                    this.$mdDialog.hide({
                        shippingMethod: this.availableShippingMethods[this.selectedShippingMethodIndex]
                    });
                    return;
                }

                this.isUpdatingCart = true;
                return this.checkoutService.applyShippingMethodToCart(this.selectedShippingMethodIndex).then(function (cart) {
                    _this.isUpdatingCart = false;
                    _this.$mdDialog.hide(cart);
                }).catch(function (err) {
                    _this.checkoutService.showErrorDialog(err);
                });
            }
        }, {
            key: 'cancel',
            value: function cancel() {
                this.$mdDialog.cancel();
            }
        }]);

        return EditShippingMethodController;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EditContactAndDelivery = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _checkout = __webpack_require__(18);

var _cartUtils = __webpack_require__(19);

var _modal = __webpack_require__(84);

var _contactInfoForm = __webpack_require__(134);

var _shippingAddressForm = __webpack_require__(204);

var _addressVerificationForm = __webpack_require__(135);

var _addressVerification = __webpack_require__(79);

var _editContactAndDelivery = __webpack_require__(874);

var _editContactAndDelivery2 = _interopRequireDefault(_editContactAndDelivery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditContactAndDelivery = exports.EditContactAndDelivery = angular.module('checkout.components.editContactAndDelivery', ['ngMaterial', _addressVerificationForm.AddressVerificationForm, _addressVerification.AddressVerificationService, _modal.ModalService, _checkout.CheckoutService, _contactInfoForm.ContactInfoForm, _shippingAddressForm.ShippingAddressForm]).service('editContactAndDeliveryService', ['modalService', function (modalService) {
    return {
        open: function open(cart, phoneNumberRequired, showShippingAsBilling, $event, onLoginClicked, isLoggedIn, isShippingRequired) {
            var useAddressVerification = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
            var useNewCarts = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : false;

            return modalService.open({
                $event: $event,
                template: '\n                        <edit-contact-and-delivery\n                            cart="cart"\n                            phone-number-required="phoneNumberRequired"\n                            show-shipping-as-billing="showShippingAsBilling"\n                            on-login-clicked="onLoginClicked"\n                            is-logged-in="isLoggedIn"\n                            is-shipping-required="isShippingRequired"\n                            use-new-carts="useNewCarts"\n                            use-address-verification="useAddressVerification"\n                            layout="column">\n                        </edit-contact-and-delivery>',
                data: {
                    cart: cart,
                    phoneNumberRequired: phoneNumberRequired,
                    showShippingAsBilling: showShippingAsBilling,
                    onLoginClicked: onLoginClicked,
                    isLoggedIn: isLoggedIn,
                    isShippingRequired: isShippingRequired,
                    useAddressVerification: useAddressVerification,
                    useNewCarts: useNewCarts
                }
            });
        }
    };
}]).component('editContactAndDelivery', {
    bindings: {
        cart: '<',
        phoneNumberRequired: '<',
        showShippingAsBilling: '<',
        onLoginClicked: '<',
        isLoggedIn: '<',
        isShippingRequired: '<',
        useAddressVerification: '<',
        useNewCarts: '<'
    },
    template: _editContactAndDelivery2.default,
    controller: function () {
        EditContactAndDeliveryController.$inject = ['$mdDialog', 'addressVerificationService', 'checkoutService'];

        function EditContactAndDeliveryController($mdDialog, addressVerificationService, checkoutService) {
            _classCallCheck(this, EditContactAndDeliveryController);

            angular.extend(this, {
                $mdDialog: $mdDialog,
                addressVerificationService: addressVerificationService,
                checkoutService: checkoutService
            });

            this.updateAddress = this.updateAddress.bind(this);
        }

        _createClass(EditContactAndDeliveryController, [{
            key: '$onInit',
            value: function $onInit() {
                this.setStateFromCart();
            }
        }, {
            key: 'setStateFromCart',
            value: function setStateFromCart() {
                this.contactInfoModel = {
                    phone: this.cart.contactInfo.phoneNumber,
                    email: this.cart.contactInfo.email,
                    emailOptIn: this.cart.emailOptIn
                };

                this.shippingAddressModel = angular.copy(this.cart.shippingAddress);

                if ((0, _cartUtils.isShippingAndBillingAddressSame)(this.cart) || !this.isShippingRequired) {
                    this.shippingAddressModel.shippingAsBilling = true;
                }
            }
        }, {
            key: 'save',
            value: function save() {
                var _this = this;

                if (this.contactAndDeliveryForm.$invalid) {
                    this.checkoutService.forceFormValidation(this.contactAndDeliveryForm['$ctrl.contactInfoForm']);
                    this.checkoutService.forceFormValidation(this.contactAndDeliveryForm['$ctrl.addressForm']);
                    return;
                }

                this.isUpdatingCart = true;

                if (this.useAddressVerification) {
                    this.addressVerificationService.verifyAddress(this.shippingAddressModel).then(function (_ref) {
                        var verified = _ref.verified,
                            changes = _ref.changes,
                            recommendations = _ref.recommendations;

                        if (!verified || changes) {
                            _this.isUpdatingCart = false;

                            _this.showAddressSuggestion = true;
                            _this.addressRecommendations = recommendations;
                            _this.addressChanges = changes;
                        } else {
                            _this.saveFormData();
                        }
                    });
                } else {
                    this.saveFormData();
                }
            }
        }, {
            key: 'saveFormData',
            value: function saveFormData() {
                var _this2 = this;

                var saveFormData = this.useNewCarts ? this.checkoutService.saveContactInfoAndShippingAddress : this.checkoutService.applyContactInfoAndShippingAddressToCart;
                saveFormData({
                    contactInfoModel: this.contactInfoModel,
                    shippingAddressModel: this.shippingAddressModel
                }).then(function (cart) {
                    _this2.$mdDialog.hide(cart);
                }).catch(function (err) {
                    _this2.checkoutService.showErrorDialog(err);
                }).finally(function () {
                    _this2.showAddressSuggestion = false;
                    _this2.isUpdatingCart = false;
                });
            }
        }, {
            key: 'updateAddress',
            value: function updateAddress(newAddress) {
                this.addressRecommendations = null;
                this.addressChanges = null;

                if (!newAddress) {
                    this.showAddressSuggestion = false;
                } else {
                    this.shippingAddressModel = _extends({}, this.shippingAddressModel, newAddress);
                    this.isUpdatingCart = true;
                    this.saveFormData();
                }
            }
        }, {
            key: 'cancel',
            value: function cancel() {
                this.$mdDialog.cancel();
            }
        }]);

        return EditContactAndDeliveryController;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PromoCodeLink = exports.PromoCodeLink = angular.module('checkout.components.promoCodeLink', []).component('promoCodeLink', {
    template: '\n            <button\n                class="checkout-button checkout-button--flat promo-code-link"\n                type="button"\n                ng-click="$ctrl.onLinkClicked()">\n                Have a promo code?\n            </button>\n        ',
    controller: function () {
        PromoCodeLinkCtrl.$inject = ['$rootScope', '$timeout', '$anchorScroll'];

        function PromoCodeLinkCtrl($rootScope, $timeout, $anchorScroll) {
            _classCallCheck(this, PromoCodeLinkCtrl);

            this.$rootScope = $rootScope;
            this.$timeout = $timeout;
            this.$anchorScroll = $anchorScroll;
        }

        _createClass(PromoCodeLinkCtrl, [{
            key: 'onLinkClicked',
            value: function onLinkClicked() {
                this.$rootScope.$emit('OrderSummaryCtrl:ForcePromoInputVisible');
                this.scrollToId('checkout-order-summary');
            }
        }, {
            key: 'scrollToId',
            value: function scrollToId(selector) {
                var _this = this;

                this.$timeout(function () {
                    _this.$anchorScroll(selector);
                });
            }
        }]);

        return PromoCodeLinkCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var EditStepButton = exports.EditStepButton = angular.module('checkout.components.editStepButton', []).component('editStepButton', {
    template: '\n            <button\n                class="checkout-button checkout-button--border"\n                type="button"\n                ng-click="$ctrl.onClick({ event: $event })">\n                Edit\n            </button>\n        ',
    bindings: {
        onClick: '&'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoginButton = undefined;

var _loginButton = __webpack_require__(875);

var _loginButton2 = _interopRequireDefault(_loginButton);

__webpack_require__(876);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginButton = exports.LoginButton = angular.module('checkout.components.loginButton', []).component('loginButton', {
    template: _loginButton2.default,
    bindings: {
        onLoginClicked: '&'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SecondaryLoginButton = undefined;

__webpack_require__(877);

var SecondaryLoginButton = exports.SecondaryLoginButton = angular.module('checkout.components.secondaryLoginButton', []).component('secondaryLoginButton', {
    template: '\n            <hr>\n            <div layout layout-align="end center">\n                <login-button\n                    on-login-clicked="$ctrl.onLoginClicked()">\n                </login-button>\n            </div>\n        ',
    bindings: {
        onLoginClicked: '&'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EditAccountContactAndDelivery = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _find = __webpack_require__(76);

var _find2 = _interopRequireDefault(_find);

var _shopperAccount = __webpack_require__(80);

var _modal = __webpack_require__(84);

var _api = __webpack_require__(14);

var _paypalSdk = __webpack_require__(67);

var _cartUtils = __webpack_require__(19);

var _addShippingAddress = __webpack_require__(878);

var _savedShippingAddress = __webpack_require__(882);

var _editAccountContactInfo = __webpack_require__(887);

var _displayPayPalAddress = __webpack_require__(893);

var _editAccountContactAndDelivery = __webpack_require__(895);

var _editAccountContactAndDelivery2 = _interopRequireDefault(_editAccountContactAndDelivery);

__webpack_require__(896);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditAccountContactAndDelivery = exports.EditAccountContactAndDelivery = angular.module('checkout.components.editAccountContactAndDelivery', [_addShippingAddress.AddShippingAddress, _savedShippingAddress.SavedShippingAddress, _editAccountContactInfo.EditAccountContactInfo, _displayPayPalAddress.DisplayPayPalAddress, _shopperAccount.ShopperAccountService, _modal.ModalService, _api.ApiService, _paypalSdk.PaypalSdkService]).service('editAccountContactAndDeliveryService', ['modalService', function (modalService) {
    return {
        open: function open(shopperAccount, phoneNumberRequired, initialShippingAddress, paypalData, isShippingRequired, $event, useAddressVerification, useNewCarts) {
            return modalService.open({
                $event: $event,
                template: '\n                        <edit-account-contact-and-delivery\n                            shopper-account="shopperAccount"\n                            phone-number-required="phoneNumberRequired"\n                            initial-shipping-address="initialShippingAddress"\n                            paypal-data="paypalData"\n                            is-shipping-required="isShippingRequired"\n                            layout="column"\n                            use-address-verification="useAddressVerification"\n                            use-new-carts="useNewCarts">\n                        </edit-account-contact-and-delivery>\n                    ',
                cssClass: 'edit-account-contact-and-delivery',
                data: {
                    shopperAccount: shopperAccount,
                    phoneNumberRequired: phoneNumberRequired,
                    initialShippingAddress: initialShippingAddress,
                    paypalData: paypalData,
                    isShippingRequired: isShippingRequired,
                    useAddressVerification: useAddressVerification,
                    useNewCarts: useNewCarts
                },
                clickOutsideToClose: false
            });
        }
    };
}]).component('editAccountContactAndDelivery', {
    bindings: {
        shopperAccount: '<',
        phoneNumberRequired: '<',
        initialShippingAddress: '<',
        paypalData: '<',
        isShippingRequired: '<',
        useAddressVerification: '<',
        useNewCarts: '<'
    },
    template: _editAccountContactAndDelivery2.default,
    controller: function () {
        EditAccountContactAndDeliveryController.$inject = ['$mdDialog', 'shopperAccountService', 'apiService', 'paypalSdkService', '$rootScope'];

        function EditAccountContactAndDeliveryController($mdDialog, shopperAccountService, apiService, paypalSdkService, $rootScope) {
            _classCallCheck(this, EditAccountContactAndDeliveryController);

            angular.extend(this, {
                $mdDialog: $mdDialog,
                shopperAccountService: shopperAccountService,
                apiService: apiService,
                paypalSdkService: paypalSdkService,
                $rootScope: $rootScope,
                shippingAddresses: []
            });

            this.onAddressEdited = this.onAddressEdited.bind(this);
            this.onAddAddressSaved = this.onAddAddressSaved.bind(this);
            this.onAddressDeleted = this.onAddressDeleted.bind(this);
        }

        _createClass(EditAccountContactAndDeliveryController, [{
            key: '$onInit',
            value: function $onInit() {
                var _this = this;

                this.fetchingShippingAddresses = true;
                this.getAndSetShippingAddresses().then(function () {
                    _this.selectedShippingAddress = _this.getBestDefault();
                }).finally(function () {
                    _this.fetchingShippingAddresses = false;
                });

                this.unbindListener = this.$rootScope.$on('editAccountContactAndDelivery:Editing', function (event, data) {
                    if (data !== 'newAddress') _this.showAddAddressForm = false;
                });
            }
        }, {
            key: '$onDestroy',
            value: function $onDestroy() {
                this.unbindListener();
            }
        }, {
            key: 'getBestDefault',
            value: function getBestDefault() {
                var bestDefault = void 0;
                var defaultShippingAddress = this.getDefaultShippingAddress();
                var initialShippingAddress = (0, _find2.default)(this.shippingAddresses, { id: this.initialShippingAddress });

                if (initialShippingAddress) {
                    bestDefault = initialShippingAddress.id;
                } else if (this.paypalData) {
                    bestDefault = 'PayPal';
                } else if (defaultShippingAddress) {
                    bestDefault = defaultShippingAddress.id;
                } else if (this.shippingAddresses && this.shippingAddresses.length > 0) {
                    bestDefault = this.shippingAddresses[0].id;
                }
                return bestDefault;
            }
        }, {
            key: 'getDefaultShippingAddress',
            value: function getDefaultShippingAddress() {
                return (0, _find2.default)(this.shippingAddresses, 'address.isDefault');
            }
        }, {
            key: 'onConfirmClicked',
            value: function onConfirmClicked() {
                if (this.useNewCarts) {
                    this.handleConfirm();
                } else {
                    this.handleLegacyConfirm();
                }
            }
        }, {
            key: 'handleLegacyConfirm',
            value: function handleLegacyConfirm() {
                var _this2 = this;

                this.isUpdatingCart = true;

                var selectedShippingAddress = (0, _find2.default)(this.shippingAddresses, { id: this.selectedShippingAddress });
                var applyShippingAddressToCart = this.selectedShippingAddress === 'PayPal' ? this.paypalSdkService.applyPaypalAddressToCart(this.paypalData) : this.shopperAccountService.applyShippingAddressToCart(selectedShippingAddress);

                applyShippingAddressToCart.then(function (updatedCart) {
                    _this2.cart = updatedCart;
                    _this2.close();
                }).finally(function () {
                    _this2.isUpdatingCart = false;
                });
            }
        }, {
            key: 'handleConfirm',
            value: function handleConfirm() {
                this.isUpdatingCart = true;
                var selectedShippingAddress = (0, _find2.default)(this.shippingAddresses, { id: this.selectedShippingAddress });
                var previousCart = (0, _cartUtils.getSavedCartInfo)();

                if (this.selectedShippingAddress === 'PayPal') {
                    var cartAddress = {
                        address1: this.paypalData.PAYMENTREQUEST_0_SHIPTOSTREET,
                        address2: this.paypalData.PAYMENTREQUEST_0_SHIPTOSTREET2,
                        city: this.paypalData.PAYMENTREQUEST_0_SHIPTOCITY,
                        state: this.paypalData.PAYMENTREQUEST_0_SHIPTOSTATE,
                        postalCode: (0, _cartUtils.formatZipCode)(this.paypalData.PAYMENTREQUEST_0_SHIPTOZIP, this.paypalData.PAYMENTREQUEST_0_SHIPTOCOUNTRYCODE),
                        country: this.paypalData.PAYMENTREQUEST_0_SHIPTOCOUNTRYCODE,
                        firstName: this.paypalData.FIRSTNAME,
                        lastName: this.paypalData.LASTNAME,
                        phoneNumber: this.paypalData.PHONENUM
                    };

                    (0, _cartUtils.setSavedCartInfo)(_extends({}, previousCart, {
                        shippingAddress: cartAddress,
                        billingAddress: cartAddress,
                        postalCode: (0, _cartUtils.formatZipCode)(cartAddress.postalCode, cartAddress.country),
                        state: cartAddress.state,
                        country: cartAddress.country,
                        selectedShippingAddressId: undefined
                    }));
                } else {
                    (0, _cartUtils.setSavedCartInfo)(_extends({}, previousCart, {
                        shippingAddress: {
                            firstName: selectedShippingAddress.address.firstName,
                            lastName: selectedShippingAddress.address.lastName,
                            address1: selectedShippingAddress.address.address1,
                            address2: selectedShippingAddress.address.address2,
                            city: selectedShippingAddress.address.city,
                            state: selectedShippingAddress.address.state,
                            postalCode: selectedShippingAddress.address.postalCode,
                            country: selectedShippingAddress.address.country
                        },
                        selectedShippingAddressId: selectedShippingAddress.id
                    }));
                }

                this.close();
            }
        }, {
            key: 'close',
            value: function close() {
                this.$mdDialog.hide({
                    cart: this.useNewCarts ? (0, _cartUtils.getSavedCartInfo)() : this.cart,
                    shopperAccount: this.shopperAccount
                });
            }
        }, {
            key: 'onContactInfoSaved',
            value: function onContactInfoSaved(shopperAccount, cart) {
                this.shopperAccount = shopperAccount;
                this.cart = cart;
            }
        }, {
            key: 'getAndSetShippingAddresses',
            value: function getAndSetShippingAddresses() {
                var _this3 = this;

                return this.apiService.account.shippingAddress.getAll().then(function (shippingAddresses) {
                    _this3.shippingAddresses = shippingAddresses.items;
                    return shippingAddresses;
                });
            }
        }, {
            key: 'onAddressEdited',
            value: function onAddressEdited() {
                return this.getAndSetShippingAddresses();
            }
        }, {
            key: 'onAddressDeleted',
            value: function onAddressDeleted() {
                var _this4 = this;

                return this.getAndSetShippingAddresses().then(function () {
                    _this4.selectedShippingAddress = _this4.getBestDefault();
                });
            }
        }, {
            key: 'onAddAddressClicked',
            value: function onAddAddressClicked() {
                this.showAddAddressForm = true;
                this.selectedShippingAddress = 'new';
                this.$rootScope.$emit('editAccountContactAndDelivery:Editing', 'newAddress');
            }
        }, {
            key: 'onAddAddressSaved',
            value: function onAddAddressSaved(address) {
                var _this5 = this;

                return this.getAndSetShippingAddresses().then(function () {
                    _this5.selectedShippingAddress = address.id;
                    _this5.showAddAddressForm = false;
                });
            }
        }, {
            key: 'onAddAddressCancelled',
            value: function onAddAddressCancelled() {
                this.showAddAddressForm = false;
                this.selectedShippingAddress = this.getBestDefault();
            }
        }, {
            key: 'shouldConfirmButtonBeDisabled',
            value: function shouldConfirmButtonBeDisabled() {
                return this.isUpdatingCart || !this.selectedShippingAddress || this.selectedShippingAddress === 'new';
            }
        }, {
            key: 'shouldShowAddressDeleteButton',
            value: function shouldShowAddressDeleteButton() {
                return this.shippingAddresses && this.shippingAddresses.length > 1;
            }
        }]);

        return EditAccountContactAndDeliveryController;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EditAccountPayment = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _find = __webpack_require__(76);

var _find2 = _interopRequireDefault(_find);

var _api = __webpack_require__(14);

var _modal = __webpack_require__(84);

var _savedPaymentMethod = __webpack_require__(897);

var _addPaymentMethod = __webpack_require__(902);

var _otherPaymentMethodsList = __webpack_require__(905);

var _editAccountPayment = __webpack_require__(908);

var _editAccountPayment2 = _interopRequireDefault(_editAccountPayment);

__webpack_require__(909);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditAccountPayment = exports.EditAccountPayment = angular.module('checkout.components.editAccountPayment', [_api.ApiService, _modal.ModalService, _savedPaymentMethod.SavedPaymentMethod, _addPaymentMethod.AddPaymentMethod, _otherPaymentMethodsList.OtherPaymentMethodsList]).service('editAccountPaymentService', ['modalService', function (modalService) {
    return {
        open: function open(initialPaymentMethod, stripe, $event) {
            return modalService.open({
                $event: $event,
                template: '\n                        <edit-account-payment\n                            stripe="stripe"\n                            initial-payment-method="initialPaymentMethod"\n                            layout="column">\n                        </edit-account-payment>\n                    ',
                cssClass: 'edit-account-payment',
                data: { initialPaymentMethod: initialPaymentMethod, stripe: stripe }
            });
        }
    };
}]).component('editAccountPayment', {
    bindings: {
        initialPaymentMethod: '<',
        stripe: '<'
    },
    template: _editAccountPayment2.default,
    controller: function () {
        EditAccountPaymentController.$inject = ['$mdDialog', 'checkoutService', 'apiService', '$rootScope', '$q', '$scope', '$mdMedia'];

        function EditAccountPaymentController($mdDialog, checkoutService, apiService, $rootScope, $q, $scope, $mdMedia) {
            _classCallCheck(this, EditAccountPaymentController);

            angular.extend(this, {
                $mdDialog: $mdDialog,
                checkoutService: checkoutService,
                apiService: apiService,
                $rootScope: $rootScope,
                $q: $q,
                $scope: $scope,
                $mdMedia: $mdMedia
            });

            this.onPaymentMethodEdited = this.onPaymentMethodEdited.bind(this);
            this.onPaymentMethodDeleted = this.onPaymentMethodDeleted.bind(this);
            this.onPaymentMethodAdded = this.onPaymentMethodAdded.bind(this);
        }

        _createClass(EditAccountPaymentController, [{
            key: '$onInit',
            value: function $onInit() {
                var _this = this;

                this.fetchingPaymentMethods = true;

                this.$q.all([this.getAndSetDefaultShippingAddress(), this.getAndSetSavedPaymentMethods(), this.getAndSetAvailablePaymentMethods()]).then(function () {
                    _this.selectedPaymentMethod = _this.getBestDefault();
                }).finally(function () {
                    _this.fetchingPaymentMethods = false;
                });

                this.unbindListener = this.$rootScope.$on('editAccountPayment:Editing', function (event, data) {
                    if (data !== 'newPayment') _this.showAddPaymentMethodForm = false;
                });

                this.$scope.$watch(function () {
                    return _this.$mdMedia('xs');
                }, function (isXs) {
                    _this.isMobile = isXs;
                });
            }
        }, {
            key: '$onDestroy',
            value: function $onDestroy() {
                this.unbindListener();
            }
        }, {
            key: 'getBestDefault',
            value: function getBestDefault() {
                var bestDefault = void 0;

                if (this.initialPaymentMethod === 'PayPal') {
                    bestDefault = 'PayPal';
                } else {
                    var defaultPaymentMethod = this.getDefaultPaymentMethod();
                    var initialPaymentMethod = (0, _find2.default)(this.savedPaymentMethods, { id: this.initialPaymentMethod });

                    if (initialPaymentMethod) {
                        bestDefault = initialPaymentMethod.id;
                    } else if (defaultPaymentMethod) {
                        bestDefault = defaultPaymentMethod.id;
                    } else if (this.savedPaymentMethods && this.savedPaymentMethods.length > 0) {
                        bestDefault = this.savedPaymentMethods[0].id;
                    }
                }

                return bestDefault;
            }
        }, {
            key: 'onConfirmClicked',
            value: function onConfirmClicked() {
                var returnData = this.selectedPaymentMethod === 'PayPal' ? 'PayPal' : (0, _find2.default)(this.savedPaymentMethods, { id: this.selectedPaymentMethod });
                this.$mdDialog.hide(returnData);
            }
        }, {
            key: 'getAndSetSavedPaymentMethods',
            value: function getAndSetSavedPaymentMethods() {
                var _this2 = this;

                return this.apiService.account.paymentMethod.getAll().then(function (paymentMethods) {
                    _this2.savedPaymentMethods = paymentMethods.items;
                    return paymentMethods;
                }).catch(function (err) {
                    if (err.status !== 400) {
                        // If Stripe is disabled
                        return _this2.$q.reject(err);
                    }
                });
            }
        }, {
            key: 'getAndSetAvailablePaymentMethods',
            value: function getAndSetAvailablePaymentMethods() {
                var _this3 = this;

                return this.checkoutService.getAvailablePaymentMethods().then(function (availablePaymentMethods) {
                    return _this3.otherPaymentMethods = availablePaymentMethods.filter(function (method) {
                        return method.type === 'other';
                    });
                });
            }
        }, {
            key: 'getAndSetDefaultShippingAddress',
            value: function getAndSetDefaultShippingAddress() {
                var _this4 = this;

                return this.apiService.account.shippingAddress.getAll().then(function (shippingAddresses) {
                    var defaultShippingAddress = (0, _find2.default)(shippingAddresses.items, 'address.isDefault');
                    if (defaultShippingAddress) {
                        _this4.defaultShippingAddress = defaultShippingAddress.address;
                    }
                    return _this4.defaultShippingAddress;
                });
            }
        }, {
            key: 'onAddPaymentMethodClicked',
            value: function onAddPaymentMethodClicked() {
                this.showAddPaymentMethodForm = true;
                this.selectedPaymentMethod = 'new';
                this.$rootScope.$emit('editAccountPayment:Editing', 'newPayment');
            }
        }, {
            key: 'onCancelAddClicked',
            value: function onCancelAddClicked() {
                this.showAddPaymentMethodForm = false;
                this.selectedPaymentMethod = this.getBestDefault();
            }
        }, {
            key: 'onPaymentMethodAdded',
            value: function onPaymentMethodAdded(paymentMethod) {
                var _this5 = this;

                return this.getAndSetSavedPaymentMethods().then(function () {
                    _this5.selectedPaymentMethod = paymentMethod.id;
                    _this5.showAddPaymentMethodForm = false;
                });
            }
        }, {
            key: 'onPaymentMethodEdited',
            value: function onPaymentMethodEdited() {
                return this.getAndSetSavedPaymentMethods();
            }
        }, {
            key: 'onPaymentMethodDeleted',
            value: function onPaymentMethodDeleted() {
                var _this6 = this;

                return this.getAndSetSavedPaymentMethods().then(function () {
                    _this6.selectedPaymentMethod = _this6.getBestDefault();
                });
            }
        }, {
            key: 'cancel',
            value: function cancel() {
                this.$mdDialog.cancel();
            }
        }, {
            key: 'shouldShowDeleteButton',
            value: function shouldShowDeleteButton() {
                return this.savedPaymentMethods && this.savedPaymentMethods.length > 1;
            }
        }, {
            key: 'getDefaultPaymentMethod',
            value: function getDefaultPaymentMethod() {
                return (0, _find2.default)(this.savedPaymentMethods, 'isDefault');
            }
        }, {
            key: 'shouldConfirmButtonBeDisabled',
            value: function shouldConfirmButtonBeDisabled() {
                return this.isUpdatingCart || !this.selectedPaymentMethod || this.selectedPaymentMethod === 'new';
            }
        }]);

        return EditAccountPaymentController;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DisplayBillingAddress = undefined;

var _displayInfo = __webpack_require__(81);

var _displayStateName = __webpack_require__(82);

var _displayCountryName = __webpack_require__(83);

var _displayBillingAddress = __webpack_require__(898);

var _displayBillingAddress2 = _interopRequireDefault(_displayBillingAddress);

__webpack_require__(899);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DisplayBillingAddress = exports.DisplayBillingAddress = angular.module('checkout.components.editAccountPayment.editAccountPaymentDisplayBillingAddress', [_displayInfo.DisplayInfo, _displayStateName.DisplayStateName, _displayCountryName.DisplayCountryName]).component('editAccountPaymentDisplayBillingAddress', {
    template: _displayBillingAddress2.default,
    bindings: {
        paymentMethod: '<',
        onChangeClicked: '&'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoginModal = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _loginForm = __webpack_require__(910);

var _forgotPassword = __webpack_require__(913);

var _loginModal = __webpack_require__(916);

var _loginModal2 = _interopRequireDefault(_loginModal);

__webpack_require__(917);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LoginModal = exports.LoginModal = angular.module('checkout.components.loginModal', [_loginForm.LoginForm, _forgotPassword.ForgotPassword]).service('loginModalService', ['modalService', function (modalService) {
    return {
        open: function open($event, initEmail, message) {
            return modalService.open({
                $event: $event,
                template: '\n                        <login-modal\n                            ' + (initEmail && 'init-email="' + initEmail + '"') + '\n                            ' + (message && 'message="' + message + '"') + '>\n                        </login-modal>',
                cssClass: 'login-modal',
                clickOutsideToClose: false
            });
        }
    };
}]).component('loginModal', {
    bindings: {
        initEmail: '@',
        message: '@'
    },
    template: _loginModal2.default,
    controller: function () {
        function LoginModalCtrl() {
            _classCallCheck(this, LoginModalCtrl);
        }

        _createClass(LoginModalCtrl, [{
            key: 'onForgotPasswordClicked',
            value: function onForgotPasswordClicked(email) {
                this.forgotPasswordEmail = email;
                this.showForgotPassword = true;
            }
        }, {
            key: 'onCancelForgotPasswordClicked',
            value: function onCancelForgotPasswordClicked() {
                this.showForgotPassword = false;
            }
        }]);

        return LoginModalCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AppModule = undefined;

__webpack_require__(342);

var _angularjs = __webpack_require__(111);

var _angularjs2 = _interopRequireDefault(_angularjs);

__webpack_require__(570);

__webpack_require__(571);

var _angularAnimate = __webpack_require__(572);

var _angularAnimate2 = _interopRequireDefault(_angularAnimate);

var _angularAria = __webpack_require__(574);

var _angularAria2 = _interopRequireDefault(_angularAria);

var _angularMessages = __webpack_require__(576);

var _angularMessages2 = _interopRequireDefault(_angularMessages);

var _ravenJs = __webpack_require__(578);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _angular = __webpack_require__(584);

var _angular2 = _interopRequireDefault(_angular);

var _get = __webpack_require__(16);

var _get2 = _interopRequireDefault(_get);

__webpack_require__(36);

var _favicon = __webpack_require__(613);

var _errorInterceptor = __webpack_require__(614);

var _api = __webpack_require__(14);

var _checkout = __webpack_require__(18);

var _launchDarkly = __webpack_require__(679);

var _ga = __webpack_require__(129);

var _scriptLoader = __webpack_require__(298);

var _storeInfo = __webpack_require__(192);

var _shipToLocations = __webpack_require__(195);

var _fullscreenLoader = __webpack_require__(77);

var _cartUtils = __webpack_require__(19);

var _api2 = __webpack_require__(687);

var _componentRouter = __webpack_require__(688);

__webpack_require__(929);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_ravenJs2.default.config('https://2e5e6b9cb952427f958bc6c04fcab3ea@sentry.io/92936', {
    release: "bf288288073399cfab1874753fd88d14f5d48ea1",
    environment: "production",
    ignoreUrls: [/localhost:\d+\//i, /127\.0\.0\.1:\d+\//i,
    // Chrome extensions
    /extensions\//i, /^chrome:\/\//i]
}).addPlugin(_angular2.default, angular).install();

var AppModule = exports.AppModule = angular.module('app', [_angularjs2.default, 'ngMaterial', _angularAnimate2.default, _angularAria2.default, _angularMessages2.default, _angular2.default.moduleName, 'app.constants', _errorInterceptor.ErrorInterceptor, _api.ApiService, _checkout.CheckoutService, _launchDarkly.LaunchDarklyService, _ga.GaService, _scriptLoader.ScriptLoaderService, _storeInfo.StoreInfoService, _fullscreenLoader.FullscreenLoaderService, _favicon.FaviconDirective, _shipToLocations.ShipToLocationsService, _componentRouter.ComponentRouter, _api2.ApiInterceptorModule]).config(['$httpProvider', function ($httpProvider) {
    $httpProvider.interceptors.push('apiInterceptor');
}]).config(['$provide', '$httpProvider', function ($provide, $httpProvider) {
    $provide.decorator('$exceptionHandler', ['$delegate', 'Raven', function ($delegate, Raven) {
        return function (exception, cause) {
            Raven.captureException(exception, {
                extra: cause
            });
            $delegate(exception, cause);
        };
    }]);

    $httpProvider.interceptors.push('errorInterceptor');
}]).config(['$compileProvider', function ($compileProvider) {
    $compileProvider.commentDirectivesEnabled(false);
    $compileProvider.cssClassDirectivesEnabled(false);
    $compileProvider.debugInfoEnabled(false);
}]).config(['$mdThemingProvider', function ($mdThemingProvider) {
    $mdThemingProvider.definePalette('checkoutPrimary', {
        50: '#000',
        100: '#000',
        200: '#000',
        300: '#000',
        400: '#000',
        500: '#000',
        600: '#000',
        700: '#000',
        800: '#000',
        900: '#000',
        A100: '#000',
        A200: '#000',
        A400: '#000',
        A700: '#000',
        contrastDefaultColor: 'light',
        contrastDarkColors: ['50', '100', '200', '300', '400', 'A100'],
        contrastLightColors: undefined
    }).theme('checkout').primaryPalette('checkoutPrimary').accentPalette('grey');

    $mdThemingProvider.setDefaultTheme('checkout');
}]).config(['$stateProvider', '$locationProvider', function ($stateProvider, $locationProvider) {
    $locationProvider.html5Mode(true);

    $stateProvider.state('root', {
        url: '',
        abstract: true,
        reloadOnSearch: false,
        template: '<ui-view></ui-view>',
        resolve: {
            bag: ['apiService', '$stateParams', '$window', '$q', 'CART_LOCAL_STORAGE_KEY', 'TENANT_LOCAL_STORAGE_KEY', 'USE_NEW_CART_SERVICE_KEY', function bag(apiService, $stateParams, $window, $q, CART_LOCAL_STORAGE_KEY, TENANT_LOCAL_STORAGE_KEY, USE_NEW_CART_SERVICE_KEY) {
                var localCartId = $window.sessionStorage.getItem(CART_LOCAL_STORAGE_KEY);
                var localTenantId = $window.sessionStorage.getItem(TENANT_LOCAL_STORAGE_KEY);
                var localUseNewCarts = $window.sessionStorage.getItem(USE_NEW_CART_SERVICE_KEY);

                if (localTenantId && (localCartId || localUseNewCarts)) {
                    return $q.resolve({
                        tenantId: localTenantId,
                        cartId: localCartId,
                        useNewCarts: true
                    });
                }
                return apiService.getBag($stateParams.bag).catch(function () {
                    $window.location.href = $window.location.origin;
                });
            }],
            useNewCarts: ['initLaunchDarkly', 'launchDarklyService', 'bag', function useNewCarts(initLaunchDarkly, launchDarklyService, bag) {
                return launchDarklyService.getFeature('use-new-carts-in-checkout', false) && bag.useNewCarts;
            }],
            tenantId: ['bag', function tenantId(bag) {
                return bag.tenantId;
            }],
            setApiServiceTenant: ['apiService', 'tenantId', function setApiServiceTenant(apiService, tenantId) {
                return apiService.setTenantId(tenantId);
            }],
            setAuth0Client: ['setApiServiceTenant', 'apiService', 'auth0SdkService', 'Raven', function setAuth0Client(setApiServiceTenant, apiService, auth0SdkService, Raven) {
                return apiService.getClientId().then(function (clientId) {
                    return auth0SdkService.setAuth0Client(clientId);
                }).catch(function (err) {
                    Raven.captureException(err);
                });
            }],
            getToken: ['setAuth0Client', 'authService', 'Raven', function getToken(setAuth0Client, authService, Raven) {
                return authService.getAccessToken().then(function (token) {
                    return token;
                }).catch(function (err) {
                    Raven.captureException(err);
                });
            }],
            handleRedirectCallback: ['setAuth0Client', '$window', 'authService', function handleRedirectCallback(setAuth0Client, $window, authService) {
                var params = new URL($window.location).searchParams;
                var code = params.get('code');
                var state = params.get('state');
                var shouldParseResult = code && state;

                if (shouldParseResult) {
                    var bag = new URL($window.location).searchParams.get('bag');
                    return authService.handleRedirectCallback().then(function () {
                        if (bag) {
                            $window.history.pushState({}, '', '/checkout/?bag=' + bag);
                        } else {
                            $window.history.pushState({}, '', '/checkout/');
                        }
                    });
                }
            }],
            isLoggedIn: ['getToken', 'setApiServiceTenant', 'handleRedirectCallback', 'authService', function isLoggedIn(getToken, setApiServiceTenant, handleRedirectCallback, authService) {
                return authService.isLoggedIn().then(function (authenticated) {
                    return authenticated;
                });
            }],
            setLoadingHooks: ['setApiServiceTenant', 'loadingService', 'paypalSdkService', '$location', '$transitions', 'isLoggedIn', function setLoadingHooks(setApiServiceTenant, loadingService, paypalSdkService, $location, $transitions, isLoggedIn) {
                if (!isLoggedIn && !paypalSdkService.hasPaypalQueryParams($location.search())) {
                    $transitions.onBefore({ to: 'checkout' }, function () {
                        return loadingService.show();
                    });
                    $transitions.onSuccess({ to: 'checkout' }, function () {
                        return loadingService.hide();
                    });
                    $transitions.onBefore({ to: 'thankYou' }, function () {
                        return loadingService.show();
                    });
                    $transitions.onSuccess({ to: 'thankYou' }, function () {
                        return loadingService.hide();
                    });
                }
            }],
            initLaunchDarkly: ['tenantId', 'launchDarklyService', function initLaunchDarkly(tenantId, launchDarklyService) {
                return launchDarklyService.init({ key: tenantId });
            }],
            storeInfo: ['setApiServiceTenant', 'storeInfoService', function storeInfo(setApiServiceTenant, storeInfoService) {
                return storeInfoService.get();
            }],
            returnUrl: ['storeInfo', function returnUrl(storeInfo) {
                return storeInfo.canonicalHost;
            }],
            shipToLocations: ['setApiServiceTenant', 'shipToLocationsService', function shipToLocations(setApiServiceTenant, shipToLocationsService) {
                return shipToLocationsService.get();
            }],
            initGa: ['storeInfo', 'gaService', function initGa(storeInfo, gaService) {
                var gaId = storeInfo.googleAnalyticsId && storeInfo.googleAnalyticsId !== '' ? storeInfo.googleAnalyticsId : null;
                gaService.sendAppLoadedEvent(gaId);
            }],
            favicon: ['$rootScope', 'storeInfo', function favicon($rootScope, storeInfo) {
                $rootScope.faviconImageUrl = (0, _get2.default)(storeInfo, 'favicon.imageLink.fullUri', '');
            }],
            pageTitle: ['$rootScope', 'storeInfo', function pageTitle($rootScope, storeInfo) {
                $rootScope.storeTitle = (0, _get2.default)(storeInfo, 'seo.metaTitle', storeInfo.name);
            }],
            updateLaunchDarkly: ['initLaunchDarkly', 'launchDarklyService', 'storeInfo', function updateLaunchDarkly(initLaunchDarkly, launchDarklyService, storeInfo) {
                launchDarklyService.updateUser({
                    key: storeInfo.tenant,
                    email: storeInfo.email,
                    custom: {
                        planType: storeInfo.materialPlan,
                        storeName: storeInfo.name,
                        storeUrl: storeInfo.storeUrl
                    }
                });
            }],
            loadFacebookPixel: ['storeInfo', 'scriptLoaderService', function loadFacebookPixel(storeInfo, scriptLoaderService) {
                var facebookTrackingPixelId = (0, _get2.default)(storeInfo, 'thirdPartyIntegrations.facebookTrackingPixelId');
                if (facebookTrackingPixelId) {
                    scriptLoaderService.loadFacebookPixel(facebookTrackingPixelId);
                }
            }],
            loadGTM: ['storeInfo', 'scriptLoaderService', function loadGTM(storeInfo, scriptLoaderService) {
                var googleTagManagerId = (0, _get2.default)(storeInfo, 'thirdPartyIntegrations.googleTagManagerId');
                if (googleTagManagerId) {
                    scriptLoaderService.loadGTM(googleTagManagerId);
                }
            }],
            setLoadingServiceData: ['storeInfo', 'loadingService', function setLoadingServiceData(storeInfo, loadingService) {
                return loadingService.setStoreInfo(storeInfo);
            }]
        }
    }).state('checkout', {
        url: '/?bag&token&PayerID',
        component: 'componentRouter',
        parent: 'root',
        resolvePolicy: { when: 'EAGER' },
        resolve: {
            cart: ['setApiServiceTenant', 'apiService', 'bag', '$window', 'returnUrl', 'useNewCarts', function cart(setApiServiceTenant, apiService, bag, $window, returnUrl, useNewCarts) {
                function redirectToStorefront() {
                    $window.location.href = returnUrl;
                }

                var getCart = useNewCarts ? apiService.getCart : apiService.getLegacyCart;

                return getCart(bag.cartId).then(function (cart) {
                    if (cart.items.length < 1) redirectToStorefront();
                    return cart;
                }).catch(function () {
                    return redirectToStorefront();
                });
            }],
            setCartId: ['checkoutService', 'cart', 'useNewCarts', function setCartId(checkoutService, cart, useNewCarts) {
                var cartId = useNewCarts ? cart.cartId : cart.id;
                checkoutService.setCartId(cartId);
            }],
            availablePaymentMethods: ['storeInfo', 'checkoutService', function availablePaymentMethods(storeInfo, checkoutService) {
                return checkoutService.getAvailablePaymentMethods();
            }],
            sendPageViewEvent: ['storeInfo', 'gaService', '$window', function sendPageViewEvent(storeInfo, gaService, $window) {
                gaService.sendVirtualPageViewEvent($window.location.pathname, 'checkout', storeInfo.id);
            }],
            shippingMethods: ['setApiServiceTenant', 'apiService', 'useNewCarts', 'cart', function shippingMethods(setApiServiceTenant, apiService, useNewCarts, cart) {
                if (useNewCarts) {
                    var _getSavedCartInfo = (0, _cartUtils.getSavedCartInfo)(),
                        shippingAddress = _getSavedCartInfo.shippingAddress;

                    var _ref = shippingAddress || { country: 'US' },
                        country = _ref.country,
                        state = _ref.state;

                    return apiService.fetchShippingMethods({ cartId: cart.cartId, country: country, state: state });
                }

                return apiService.getShippingMethods();
            }],
            useAddressVerification: ['storeInfo', function useAddressVerification(storeInfo) {
                return storeInfo.enableAddressVerification;
            }]
        }
    }).state('thankYou', {
        url: '/thankyou?bag&order&email&storeName',
        component: 'thankYou',
        parent: 'root',
        resolvePolicy: { when: 'EAGER' },
        resolve: {
            order: ['setApiServiceTenant', 'apiService', '$stateParams', 'tenantId', '$window', 'returnUrl', function order(setApiServiceTenant, apiService, $stateParams, tenantId, $window, returnUrl) {
                var hasOrderPlacedParams = $stateParams.order && $stateParams.email && $stateParams.storeName && $stateParams.bag;

                if (hasOrderPlacedParams) {
                    return apiService.getOrder(decodeURIComponent($stateParams.order), decodeURIComponent($stateParams.email), tenantId).catch(function () {
                        $window.location.href = returnUrl;
                    });
                }

                $window.location.href = returnUrl;
            }],
            sendPageViewEvent: ['storeInfo', 'gaService', '$location', function sendPageViewEvent(storeInfo, gaService, $location) {
                gaService.sendVirtualPageViewEvent($location.path(), 'thankYou', storeInfo.id);
            }]
        }
    });
}]).config(['$mdGestureProvider', function ($mdGestureProvider) {
    $mdGestureProvider.skipClickHijack(); // https://github.com/angular/material/issues/10572
}]).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var FaviconDirective = exports.FaviconDirective = angular.module('checkout.directives.favicon', []).directive('favicon', ['$window', function ($window) {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            faviconUrl: '<'
        },
        link: function link(scope) {
            var getFaviconLink = function getFaviconLink() {
                return $window.document.querySelector('link[rel="shortcut icon"]');
            };

            var setFaviconImage = function setFaviconImage(imageUrl) {
                var faviconLinkElement = getFaviconLink();
                if (faviconLinkElement && faviconLinkElement.length > 0) {
                    faviconLinkElement.setAttribute('href', imageUrl);
                } else {
                    $window.document.getElementsByTagName('head')[0].insertAdjacentHTML('afterBegin', '<link rel="shortcut icon" type="image/png" href="' + imageUrl + '" />');
                }
            };

            scope.$watch('faviconUrl', function (newValue, oldValue) {
                if (newValue && newValue !== oldValue) {
                    setFaviconImage(newValue);
                }
            });
        }
    };
}]).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ErrorInterceptor = exports.ErrorInterceptor = angular.module('checkout.ErrorInterceptor', []).factory('errorInterceptor', ['$q', '$window', 'Raven', function ($q, $window, Raven) {
    return {
        request: request,
        requestError: requestError,
        response: response,
        responseError: responseError
    };

    function request(config) {
        return config;
    }

    function requestError(rejection) {
        Raven.captureMessage('Failed $http request', { extra: rejection });
        return $q.reject(rejection);
    }

    function response(data) {
        return data;
    }

    function responseError(rejection) {
        Raven.captureMessage('Failed $http response', { extra: rejection });
        return $q.reject(rejection);
    }
}]).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LaunchDarklyService = undefined;

var _launchdarklyJsClientSdk = __webpack_require__(680);

var LDClient = _interopRequireWildcard(_launchdarklyJsClientSdk);

__webpack_require__(36);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var LaunchDarklyService = exports.LaunchDarklyService = angular.module('LaunchDarklyService', ['app.constants']).factory('launchDarklyService', ['$q', '$rootScope', 'LAUNCH_DARKLY_KEY', function ($q, $rootScope, LAUNCH_DARKLY_KEY) {
    var client;
    var initialized = false;
    var initDeferred = $q.defer();

    var service = {
        updateUser: updateUser,
        init: init,
        getFeature: getFeature,
        getFeaturePromise: getFeaturePromise,
        allFlags: allFlags,
        getClient: getClient,
        waitForInit: waitForInit
    };

    function updateUser(newUser) {
        return service.waitForInit().then(function () {
            var deferred = $q.defer();
            client.identify(newUser, null, function () {
                deferred.resolve();
            });
            return deferred.promise;
        });
    }

    function init(user) {
        if (initialized) {
            return $q.resolve();
        }
        if (!LDClient) {
            return $q.reject();
        }
        client = LDClient.initialize(LAUNCH_DARKLY_KEY, user);
        client.on('ready', function () {
            initialized = true;
            initDeferred.resolve();
            $rootScope.$apply();
        });

        return initDeferred.promise;
    }

    function getFeature(featureKey, defaultValue) {
        return service.waitForInit().then(function () {
            return client.variation(featureKey, defaultValue || false);
        });
    }

    function getFeaturePromise(featureKey, defaultValue) {
        return service.waitForInit().then(function () {
            return service.getFeature(featureKey, defaultValue || false).then(function (getsFeature) {
                return getsFeature ? $q.resolve() : $q.reject({ statusText: 'Unauthorized' });
            });
        });
    }

    function allFlags() {
        return service.waitForInit().then(function () {
            return client.allFlags();
        });
    }

    function getClient() {
        return service.waitForInit().then(function () {
            return client;
        });
    }

    function waitForInit() {
        if (initialized) {
            return $q.resolve();
        }
        return initDeferred.promise;
    }

    return service;
}]).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FullscreenLoader = undefined;

var _fullscreenLoader = __webpack_require__(685);

var _fullscreenLoader2 = _interopRequireDefault(_fullscreenLoader);

__webpack_require__(686);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullscreenLoader = exports.FullscreenLoader = angular.module('checkout.components.fullscreenLoader', []).component('fullscreenLoader', {
    template: _fullscreenLoader2.default,
    bindings: {
        titleText: '<',
        titleImage: '<',
        description: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 685 */
/***/ (function(module, exports) {

module.exports = "<div layout=\"column\" layout-align=\"center center\" class=\"fullscreen-loader\" ng-class=\"{'fullscreen-loader--white': $ctrl.titleImage}\"> <md-progress-circular md-diameter=\"60\" md-mode=\"indeterminate\" class=\"fullscreen-loader__animation\"> </md-progress-circular> <div class=\"fullscreen-loader__title-text\" ng-if=\"$ctrl.titleText && !$ctrl.titleImage\">{{$ctrl.titleText}}</div> <div class=\"fullscreen-loader__title-image\" ng-if=\"$ctrl.titleImage\"> <img ng-src=\"{{$ctrl.titleImage}}\"> </div> <div class=\"fullscreen-loader__description\" ng-if=\"$ctrl.description\">{{$ctrl.description}}</div> </div> ";

/***/ }),
/* 686 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ApiInterceptorModule = exports.ApiInterceptorModule = angular.module('app.services.apiInterceptor', ['ngRaven']).factory('apiInterceptor', ['$q', '$location', '$cookies', 'auth0SdkService', function ($q, $location, $cookies, auth0SdkService) {
    function useUniversalLogin() {
        return (/myvolusion.com|volusionplatformdev.com|localhost|127.0.0.1$/.test($location.host())
        );
    }

    return {
        requestError: function requestError(rejection) {
            return $q.reject(rejection);
        },
        responseError: function responseError(rejection) {
            return $q.reject(rejection);
        },


        request: function request(config) {
            if (!config.skipAuthorization) {
                if (useUniversalLogin()) {
                    return auth0SdkService.getTokenSilently().then(function (accessToken) {
                        config.headers.Authorization = 'Bearer ' + accessToken;
                        return config;
                    }).catch(function () {
                        return config;
                    });
                }

                var token = $cookies.get('id_token', {
                    secure: true,
                    path: '/'
                });

                config.headers.Authorization = 'Bearer ' + token;
                return $q.resolve(config);
            }
            return config;
        }
    };
}]).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ComponentRouter = undefined;

var _newCheckout = __webpack_require__(689);

var _checkout = __webpack_require__(927);

var ComponentRouter = exports.ComponentRouter = angular.module('checkout.componentRouter', [_newCheckout.NewCheckoutComponent, _checkout.CheckoutComponent]).component('componentRouter', {
    template: '\n            <checkout\n                ng-if="!$ctrl.useNewCarts"\n                cart="$ctrl.cart"\n                bag="$ctrl.bag"\n                store-info="$ctrl.storeInfo"\n                return-url="$ctrl.returnUrl"\n                available-payment-methods="$ctrl.availablePaymentMethods"\n                is-logged-in="$ctrl.isLoggedIn"\n                shipping-methods="$ctrl.shippingMethods"\n                stripe-publishable-key="$ctrl.stripePublishableKey"\n                use-address-verification="$ctrl.useAddressVerification"\n            ></checkout>\n            <new-checkout\n                ng-if="$ctrl.useNewCarts"\n                cart="$ctrl.cart"\n                bag="$ctrl.bag"\n                store-info="$ctrl.storeInfo"\n                return-url="$ctrl.returnUrl"\n                available-payment-methods="$ctrl.availablePaymentMethods"\n                is-logged-in="$ctrl.isLoggedIn"\n                shipping-methods="$ctrl.shippingMethods"\n                stripe-publishable-key="$ctrl.stripePublishableKey"\n                use-address-verification="$ctrl.useAddressVerification"\n                tenant-id="$ctrl.tenantId"\n            ></new-checkout>\n        ',
    bindings: {
        cart: '<',
        useNewCarts: '<',
        bag: '<',
        storeInfo: '<',
        returnUrl: '<',
        availablePaymentMethods: '<',
        isLoggedIn: '<',
        shippingMethods: '<',
        stripePublishableKey: '<',
        useAddressVerification: '<',
        tenantId: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.NewCheckoutComponent = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _assign = __webpack_require__(44);

var _assign2 = _interopRequireDefault(_assign);

var _get = __webpack_require__(16);

var _get2 = _interopRequireDefault(_get);

var _isEqual = __webpack_require__(193);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _cloneDeep = __webpack_require__(300);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _has = __webpack_require__(196);

var _has2 = _interopRequireDefault(_has);

var _find = __webpack_require__(76);

var _find2 = _interopRequireDefault(_find);

var _angularjs = __webpack_require__(111);

var _angularjs2 = _interopRequireDefault(_angularjs);

__webpack_require__(36);

var _checkout = __webpack_require__(18);

var _facebookPixel = __webpack_require__(200);

var _paypalSdk = __webpack_require__(67);

var _ga = __webpack_require__(129);

var _api = __webpack_require__(14);

var _auth = __webpack_require__(78);

var _addressVerification = __webpack_require__(79);

var _shopperAccount = __webpack_require__(80);

var _cartUtils = __webpack_require__(19);

var _order = __webpack_require__(304);

var _creditCard = __webpack_require__(94);

var _dataLayer = __webpack_require__(305);

var _accordian = __webpack_require__(307);

var _addressForm = __webpack_require__(54);

var _checkoutWithPaypalSdkButton = __webpack_require__(308);

var _checkoutWithPaypalSdkSummaryButton = __webpack_require__(309);

var _continueButton = __webpack_require__(130);

var _paymentMethodForm = __webpack_require__(310);

var _contactInfoForm = __webpack_require__(134);

var _addressVerificationForm = __webpack_require__(135);

var _shippingAddressForm = __webpack_require__(204);

var _displayContactAndDelivery = __webpack_require__(316);

var _shippingMethodForm = __webpack_require__(205);

var _displayShippingMethod = __webpack_require__(317);

var _thankYou = __webpack_require__(318);

var _displayBillingAndPayment = __webpack_require__(207);

var _displayCountryName = __webpack_require__(83);

var _displayStateName = __webpack_require__(82);

var _fullscreenLoader = __webpack_require__(77);

var _header = __webpack_require__(208);

var _editShippingMethod = __webpack_require__(330);

var _editContactAndDelivery = __webpack_require__(331);

var _headerBackground = __webpack_require__(209);

var _promoCodeLink = __webpack_require__(332);

var _editStepButton = __webpack_require__(333);

var _loginButton = __webpack_require__(334);

var _secondaryLoginButton = __webpack_require__(335);

var _editAccountContactAndDelivery = __webpack_require__(336);

var _editAccountPayment = __webpack_require__(337);

var _loginModal = __webpack_require__(339);

var _stripeElementsForm = __webpack_require__(133);

var _orderSummary = __webpack_require__(918);

var _newCheckout = __webpack_require__(926);

var _newCheckout2 = _interopRequireDefault(_newCheckout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var noShippingMethodsIndex = -1;
var DEFAULT_COUNTRY = 'US';

var STEP_ONE_HEADING_TEXT_NO_SHIPPING = 'Contact & Billing';
var STEP_ONE_HEADING_TEXT_WITH_SHIPPING = 'Contact & Delivery';
var STEP_TWO_HEADING_TEXT = 'Shipping Method';
var STEP_THREE_HEADING_TEXT = 'Payment & Review';

var NewCheckoutComponent = exports.NewCheckoutComponent = angular.module('checkout.newCheckout', [_angularjs2.default, 'app.constants', _addressVerificationForm.AddressVerificationForm, _addressVerification.AddressVerificationService, _checkout.CheckoutService, _facebookPixel.FacebookPixelService, _paypalSdk.PaypalSdkService, _ga.GaService, _api.ApiService, _auth.AuthService, _shopperAccount.ShopperAccountService, _order.OrderService, _accordian.Accordian, _addressForm.AddressForm, _checkoutWithPaypalSdkButton.CheckoutWithPaypalSdkButton, _checkoutWithPaypalSdkSummaryButton.CheckoutWithPaypalSdkSummaryButton, _continueButton.ContinueButton, _orderSummary.OrderSummary, _paymentMethodForm.PaymentMethodForm, _contactInfoForm.ContactInfoForm, _shippingAddressForm.ShippingAddressForm, _displayContactAndDelivery.DisplayContactAndDelivery, _shippingMethodForm.ShippingMethodForm, _displayShippingMethod.DisplayShippingMethod, _thankYou.ThankYou, _displayBillingAndPayment.DisplayBillingAndPayment, _displayCountryName.DisplayCountryName, _displayStateName.DisplayStateName, _fullscreenLoader.FullscreenLoaderService, _header.Header, _editShippingMethod.EditShippingMethod, _editContactAndDelivery.EditContactAndDelivery, _headerBackground.HeaderBackground, _promoCodeLink.PromoCodeLink, _editStepButton.EditStepButton, _loginButton.LoginButton, _secondaryLoginButton.SecondaryLoginButton, _editAccountContactAndDelivery.EditAccountContactAndDelivery, _editAccountPayment.EditAccountPayment, _loginModal.LoginModal]).component('newCheckout', {
    template: _newCheckout2.default,
    bindings: {
        cart: '<',
        bag: '<',
        tenantId: '<',
        storeInfo: '<',
        returnUrl: '<',
        availablePaymentMethods: '<',
        isLoggedIn: '<',
        shippingMethods: '<',
        useAddressVerification: '<',
        stripePublishableKey: '<'
    },
    controller: function () {
        CheckoutCtrl.$inject = ['$timeout', '$anchorScroll', '$stateParams', '$rootScope', '$scope', '$mdMedia', '$location', '$window', '$q', 'addressVerificationService', 'gaService', 'facebookPixelService', 'checkoutService', 'paypalSdkService', 'editContactAndDeliveryService', 'editShippingMethodService', 'editAccountContactAndDeliveryService', 'editAccountPaymentService', 'apiService', 'loginModalService', 'authService', 'orderService', 'shopperAccountService', 'loadingService', 'GA_CHECKOUT_STEPS', 'scriptLoaderService'];

        function CheckoutCtrl($timeout, $anchorScroll, $stateParams, $rootScope, $scope, $mdMedia, $location, $window, $q, addressVerificationService, gaService, facebookPixelService, checkoutService, paypalSdkService, editContactAndDeliveryService, editShippingMethodService, editAccountContactAndDeliveryService, editAccountPaymentService, apiService, loginModalService, authService, orderService, shopperAccountService, loadingService, GA_CHECKOUT_STEPS, scriptLoaderService) {
            _classCallCheck(this, CheckoutCtrl);

            (0, _assign2.default)(this, {
                $timeout: $timeout,
                $anchorScroll: $anchorScroll,
                $stateParams: $stateParams,
                $rootScope: $rootScope,
                $scope: $scope,
                $mdMedia: $mdMedia,
                $location: $location,
                $window: $window,
                $q: $q,
                addressVerificationService: addressVerificationService,
                gaService: gaService,
                facebookPixelService: facebookPixelService,
                checkoutService: checkoutService,
                paypalSdkService: paypalSdkService,
                editContactAndDeliveryService: editContactAndDeliveryService,
                editShippingMethodService: editShippingMethodService,
                editAccountContactAndDeliveryService: editAccountContactAndDeliveryService,
                editAccountPaymentService: editAccountPaymentService,
                apiService: apiService,
                loginModalService: loginModalService,
                authService: authService,
                orderService: orderService,
                shopperAccountService: shopperAccountService,
                loadingService: loadingService,
                curbsideShippingAvailable: false,
                GA_CHECKOUT_STEPS: GA_CHECKOUT_STEPS,
                scriptLoaderService: scriptLoaderService,
                isBillingAddressVerified: false,
                isShippingAddressVerified: false,

                steps: {
                    contactAndDelivery: { number: 1, complete: false },
                    shippingMethod: { number: 2, complete: false },
                    paymentAndReview: { number: 3, complete: false }
                },
                currentStep: 1,
                selectedPaymentMethod: 'Credit Card',
                shippingAddressModel: {
                    shippingAsBilling: true,
                    country: DEFAULT_COUNTRY
                },
                billingAddressModel: {
                    country: DEFAULT_COUNTRY
                },
                showPromoInput: false,
                orderSummaryCollapsed: true,
                saveLoggedInShopperInfo: true,
                availableShippingMethods: [],
                stepTwoHeadingText: STEP_TWO_HEADING_TEXT,
                stepThreeHeadingText: STEP_THREE_HEADING_TEXT,
                storeCreditInfo: { items: [], storeCreditAmountInCents: 0 }
            });

            this.updateCreditCardType = this.updateCreditCardType.bind(this);
            this.onStripeElementsCardChange = this.onStripeElementsCardChange.bind(this);
            this.removeDiscountCodeItem = this.removeDiscountCodeItem.bind(this);
            this.removeStoreCreditItem = this.removeStoreCreditItem.bind(this);
            this.applyPromoCode = this.applyPromoCode.bind(this);
            this.onOrderNotesChanged = this.onOrderNotesChanged.bind(this);
            this.onCheckoutClicked = this.onCheckoutClicked.bind(this);
            this.updateAddress = this.updateAddress.bind(this);
            this.getGiftCards = this.getGiftCards.bind(this);
        }

        _createClass(CheckoutCtrl, [{
            key: '$onInit',
            value: function $onInit() {
                var _this = this;

                this.cartAndSavedInfo = _extends({}, this.cart, (0, _cartUtils.getSavedCartInfo)());
                this.contactInfoModel = this.cartAndSavedInfo.contactInfo || this.contactInfoModel;
                this.shippingAddressModel = this.cartAndSavedInfo.shippingAddress || this.shippingAddressModel;
                this.billingAddressModel = this.cartAndSavedInfo.billingAddress || this.billingAddressModel;
                this.orderNotes = this.cartAndSavedInfo.orderNotes || '';

                this.loadingService.hide(); // Needed for logging out, which reloads state

                this.storeCreditInfo = (0, _cartUtils.getSavedStoreCreditInfo)();

                if (this.cart) {
                    this.setAvailableShippingMethods(this.shippingMethods);
                    this.fetchShippingMethods();
                    this.currentStep = this.steps.contactAndDelivery.number;
                    this.gaService.logCheckoutStep(this.GA_CHECKOUT_STEPS.entrance, null, this.cartAndSavedInfo);
                    (0, _dataLayer.logPageView)(this.tenantId);
                    (0, _dataLayer.logCheckoutStarted)(this.tenantId, this.cartAndSavedInfo, this.returnUrl);

                    this.selectedPaymentMethod = this.checkoutService.getOptimalDefaultPaymentMethod(this.availablePaymentMethods);

                    if (this.paypalSdkService.paypalIsAvailablePaymentMethod(this.storeInfo)) {
                        this.paypalSdkService.init({
                            storeInfo: this.storeInfo,
                            cartId: this.cart.cartId,
                            bagId: this.bag.id,
                            total: this.cart.grandTotal,
                            newCarts: true,
                            getGiftCards: this.getGiftCards
                        });
                    }
                }
                if (this.paypalSdkService.hasPaypalQueryParams(this.$stateParams)) {
                    this.initPaypalReturn();

                    if (this.isLoggedIn) {
                        // TODO update initShopperAccount to work with new carts it currently sets shipping address
                        // on the cart, but will need to be updated to store the shipping address elsewhere as new
                        // carts don't deal with shipping address
                        this.initShopperAccount(true);
                    }
                } else {
                    if (this.isLoggedIn) {
                        this.initShopperAccount();
                    }
                    this.setStateFromCart();
                    (0, _dataLayer.logCheckoutStarted)(this.tenantId, this.cartAndSavedInfo, this.returnUrl);
                }

                this.getTax();

                if ((0, _has2.default)(this.storeInfo, 'thirdPartyIntegrations.facebookTrackingPixelId')) {
                    this.facebookPixelService.trackInitiateCheckoutEvent(this.cart, this.grandTotal);
                }
                this.$scope.$watch(function () {
                    return _this.$mdMedia('xs');
                }, function (xs) {
                    _this.isMobile = xs;
                });

                if (this.storeInfo.acceptsStripeAsPayment) {
                    this.initStripeElements();
                }
            }
        }, {
            key: 'getGiftCards',
            value: function getGiftCards() {
                return this.storeCreditInfo.storeCreditAmountInCents;
            }
        }, {
            key: 'updateCartWithShopper',
            value: function updateCartWithShopper(shopperId, shopperEmail) {
                var _this2 = this;

                this.apiService.updateCart(this.cart.cartId, {
                    shopperId: shopperId,
                    shopperEmail: shopperEmail
                }).then(function () {
                    return _this2.apiService.getCart(_this2.cart.cartId);
                }).then(function (cart) {
                    return _this2.cart = cart;
                }).then(function () {
                    return _this2.getTax();
                });
            }
        }, {
            key: 'getTax',
            value: function getTax() {
                var _this3 = this;

                var shippingAmount = (0, _get2.default)(this.cartAndSavedInfo, 'shippingMethod.shippingPriceInCents');
                var hasShippingAddress = this.shippingAddressModel && this.shippingAddressModel.address1;

                if (hasShippingAddress && Number.isInteger(shippingAmount)) {
                    this.apiService.getTax(this.cart.cartId, shippingAmount, {
                        address1: this.shippingAddressModel.address1,
                        address2: this.shippingAddressModel.address2,
                        city: this.shippingAddressModel.city,
                        state: this.shippingAddressModel.state,
                        postalCode: this.shippingAddressModel.postalCode,
                        country: this.shippingAddressModel.country
                    }).then(function (_ref) {
                        var taxAmount = _ref.taxAmount,
                            provider = _ref.provider;

                        _this3.taxAmountInCents = taxAmount.amount;
                        _this3.taxProvider = provider;
                        _this3.setStateFromCart();
                    });
                }
            }
        }, {
            key: 'verifyBillingAddress',
            value: function verifyBillingAddress() {
                var _this4 = this;

                if (this.isBillingAddressVerified === true) {
                    return this.$q.resolve();
                }

                return this.addressVerificationService.isAddressVerified(this.cartAndSavedInfo.billingAddress).then(function (verified) {
                    return _this4.isBillingAddressVerified = verified;
                });
            }
        }, {
            key: 'verifyShippingAddress',
            value: function verifyShippingAddress() {
                var _this5 = this;

                if (this.isShippingAddressVerified === true) {
                    return this.$q.resolve();
                }

                return this.addressVerificationService.isAddressVerified(this.cartAndSavedInfo.shippingAddress).then(function (verified) {
                    return _this5.isShippingAddressVerified = verified;
                });
            }
        }, {
            key: 'verifyShippingAndBillingAddresses',
            value: function verifyShippingAndBillingAddresses() {
                var _this6 = this;

                this.$rootScope.$evalAsync(function () {
                    _this6.$q.all([_this6.verifyBillingAddress(), _this6.verifyShippingAddress()]);
                });
            }
        }, {
            key: 'setStateFromCart',
            value: function setStateFromCart() {
                var throwErrorForNoShippingMethods = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

                this.storeCreditInfo = this.applyGiftCardTotals(this.storeCreditInfo);
                (0, _cartUtils.setSavedStoreCreditInfo)(this.storeCreditInfo);

                this.grandTotal = (this.cartGrandTotalInCents() - this.storeCreditInfo.storeCreditAmountInCents) / 100;

                this.selectedShippingMethodIndex = this.getSelectedShippingMethodIndexOrDefault();
                this.isShippingRequired = (0, _cartUtils.isShippingRequiredOnCart)(this.cart.items);
                this.steps.contactAndDelivery.complete = this.isContactAndDeliveryComplete();

                if (this.cartAndSavedInfo.shippingAddress) {
                    this.shippingAddressModel = (0, _get2.default)(this.cartAndSavedInfo, 'shippingAddress', this.shippingAddressModel);
                    this.contactInfoModel = (0, _get2.default)(this.cartAndSavedInfo, 'contactInfo', this.contactInfoModel);

                    if (!this.isShippingRequired && this.steps.contactAndDelivery.complete) {
                        this.updateCartInfo({
                            billingAddress: this.cartAndSavedInfo.shippingAddress
                        });
                    }
                }
                this.billingSameAsShipping = (0, _cartUtils.isShippingAndBillingAddressSame)(this.cartAndSavedInfo);
                if (this.billingSameAsShipping) {
                    this.billingAddressModel = this.cartAndSavedInfo.billingAddress;
                }

                if (this.useAddressVerification) {
                    this.verifyShippingAndBillingAddresses();
                }

                if (this.isShippingStepComplete(this.cartAndSavedInfo.shippingMethod)) {
                    this.steps.shippingMethod.complete = true;
                }
                if (throwErrorForNoShippingMethods) this.throwIfNoShippingMethods();
                var currentStep = this.steps.contactAndDelivery.complete ? this.steps.shippingMethod.number : this.steps.contactAndDelivery.number;
                if (this.steps.shippingMethod.complete) {
                    currentStep = this.steps.paymentAndReview.number;
                }
                this.currentStep = currentStep;
                this.stepOneHeadingText = this.isShippingRequired ? STEP_ONE_HEADING_TEXT_WITH_SHIPPING : STEP_ONE_HEADING_TEXT_NO_SHIPPING;

                this.updateCartInfo();
            }
        }, {
            key: 'initStripeElements',
            value: function initStripeElements() {
                var _this7 = this;

                this.$q.all([this.scriptLoaderService.loadScriptTagPromise({
                    src: 'https://js.stripe.com/v3',
                    async: true
                }), this.apiService.getStripePublishableKey()]).then(function (_ref2) {
                    var _ref3 = _slicedToArray(_ref2, 2),
                        stripePublishableKey = _ref3[1].stripePublishableKey;

                    // eslint-disable-next-line new-cap
                    _this7.stripe = window.Stripe(stripePublishableKey);
                    _this7.stripeElements = _this7.stripe.elements();
                    _this7.stripeElementsCard = _this7.stripeElements.create('card', {
                        style: _stripeElementsForm.stripeElementCardStyle,
                        hidePostalCode: true
                    });
                });
            }
        }, {
            key: 'isShippingStepComplete',
            value: function isShippingStepComplete(shippingMethod) {
                return this.steps.contactAndDelivery.complete && !this.isShippingRequired || this.hasValidShippingSelection() && (this.didContinueStepTwo || (0, _cartUtils.hasValidShippingMethod)(this.availableShippingMethods, shippingMethod));
            }
        }, {
            key: 'applyGiftCardTotals',
            value: function applyGiftCardTotals(storeCreditInfo) {
                var grandTotalInCents = this.cartGrandTotalInCents();
                var storeCreditAmountInCents = 0;
                var items = storeCreditInfo.items.map(function (item) {
                    if (grandTotalInCents > item.balance) {
                        var _amountUsedInCents = item.balance;
                        storeCreditAmountInCents += item.balance;
                        grandTotalInCents -= item.balance;
                        return _extends({}, item, {
                            amountUsedInCents: _amountUsedInCents
                        });
                    }
                    if (grandTotalInCents < item.balance) {
                        var _amountUsedInCents2 = grandTotalInCents;
                        storeCreditAmountInCents += grandTotalInCents;
                        grandTotalInCents = 0;
                        return _extends({}, item, {
                            amountUsedInCents: _amountUsedInCents2
                        });
                    }
                    // only possibility left: grandTotalInCents === item.balance
                    var amountUsedInCents = grandTotalInCents;
                    storeCreditAmountInCents += grandTotalInCents;
                    grandTotalInCents = 0;
                    return _extends({}, item, {
                        amountUsedInCents: amountUsedInCents
                    });
                });
                return {
                    items: items,
                    storeCreditAmountInCents: storeCreditAmountInCents
                };
            }
        }, {
            key: 'hasValidShippingSelection',
            value: function hasValidShippingSelection() {
                return angular.isDefined(this.selectedShippingMethodIndex) && (!this.hasNoShippingMethodsForStore() || this.cartAndSavedInfo.shippingMethod) && this.cartAndSavedInfo.shippingAddress && this.cartAndSavedInfo.contactInfo && angular.isArray(this.availableShippingMethods) && this.availableShippingMethods.length > 0;
            }
        }, {
            key: 'hasNoShippingMethodsForStore',
            value: function hasNoShippingMethodsForStore() {
                return this.selectedShippingMethodIndex === noShippingMethodsIndex;
            }
        }, {
            key: 'throwIfNoShippingMethods',
            value: function throwIfNoShippingMethods() {
                if (this.hasNoShippingMethodsForStore()) {
                    throw new Error('This store does not have any shipping methods configured.');
                }
            }
        }, {
            key: 'updateAddress',
            value: function updateAddress(newAddress) {
                this.verificationRecommendations = null;
                this.verificationChanges = null;

                if (!newAddress) {
                    // edit address again
                    this.steps.contactAndDelivery.complete = false;
                    this.showAddressSuggestion = false;
                } else {
                    this.shippingAddressModel = _extends({}, newAddress);
                    this.steps.contactAndDelivery.complete = true;
                    this.showAddressSuggestion = false;

                    this.isUpdatingCart = true;
                    this.isStepOneLoading = true;
                    this.setContactInfoAndShippingAddress();
                }
            }
        }, {
            key: 'onStepOneContinueClicked',
            value: function onStepOneContinueClicked() {
                var _this8 = this;

                if (this.contactAndDeliveryForm.$invalid) {
                    this.checkoutService.forceFormValidation(this.contactAndDeliveryForm['$ctrl.contactInfoForm']);
                    this.checkoutService.forceFormValidation(this.contactAndDeliveryForm['$ctrl.addressForm']);
                    return;
                }

                this.isUpdatingCart = true;
                this.isStepOneLoading = true;

                if (this.useAddressVerification) {
                    // check address validity and display recommendations (if needed)
                    this.addressVerificationService.verifyAddress(this.shippingAddressModel).then(function (_ref4) {
                        var verified = _ref4.verified,
                            changes = _ref4.changes,
                            recommendations = _ref4.recommendations;

                        if (!verified || changes) {
                            _this8.isUpdatingCart = false;
                            _this8.isStepOneLoading = false;

                            _this8.showAddressSuggestion = true;
                            _this8.verificationRecommendations = recommendations;
                            _this8.verificationChanges = changes;
                        } else {
                            _this8.setContactInfoAndShippingAddress();
                        }
                    });
                } else {
                    this.setContactInfoAndShippingAddress();
                }
            }
        }, {
            key: 'setContactInfoAndShippingAddress',
            value: function setContactInfoAndShippingAddress() {
                var _this9 = this;

                this.checkoutService.saveContactInfoAndShippingAddress({
                    contactInfoModel: this.contactInfoModel,
                    shippingAddressModel: this.shippingAddressModel
                }).then(function () {
                    _this9.updateCartInfo(_extends({}, (0, _cartUtils.getSavedCartInfo)()) // session storage was updated outside of component
                    );
                    if (_this9.isShippingRequired) {
                        _this9.setStateFromCart();
                        _this9.scrollToCurrentStep();
                    }
                    _this9.trackStepOneEvents();
                    (0, _dataLayer.logShopperInfo)(_this9.tenantId, _this9.cartAndSavedInfo);

                    (_this9.$window.dataLayer || []).push({
                        event: 'contact_info',
                        contact_email: _this9.contactInfoModel.email,
                        contact_first_name: _this9.shippingAddressModel.firstName,
                        contact_last_name: _this9.shippingAddressModel.lastName,
                        contact_country: _this9.shippingAddressModel.country,
                        contact_address: _this9.shippingAddressModel.address1,
                        contact_city: _this9.shippingAddressModel.city,
                        contact_state: _this9.shippingAddressModel.state,
                        contact_zip: _this9.shippingAddressModel.postalCode
                    });
                    if (_this9.loggedInShopper && _this9.cartAndSavedInfo.contactInfo.phoneNumber !== undefined && _this9.cartAndSavedInfo.contactInfo.phoneNumber !== _this9.loggedInShopper.contactInformation.phoneNumber) {
                        _this9.checkoutService.applyUpdatedPhoneNumberToShopper(_this9.loggedInShopper, _this9.cartAndSavedInfo.contactInfo.phoneNumber).then(function (updatedShopper) {
                            if (updatedShopper) {
                                _this9.loggedInShopper = updatedShopper;
                            }
                        }).catch(function (err) {
                            _this9.checkoutService.showErrorDialog(err);
                        });
                    }

                    _this9.updateCartInfo();
                    _this9.getTax();
                }).then(this.fetchShippingMethods.bind(this)).then(function () {
                    if (!_this9.isShippingRequired) {
                        return _this9.onStepTwoContinueClicked(true);
                    }
                }).catch(function (err) {
                    _this9.checkoutService.showErrorDialog(err);
                }).finally(function () {
                    _this9.isUpdatingCart = false;
                    _this9.isStepOneLoading = false;
                });
            }
        }, {
            key: 'fetchShippingMethods',
            value: function fetchShippingMethods() {
                var _this10 = this;

                if (this.cart && (0, _get2.default)(this.shippingAddressModel, 'country')) {
                    return this.apiService.fetchShippingMethods({
                        cartId: this.cart.cartId,
                        country: this.shippingAddressModel.country,
                        state: this.shippingAddressModel.state
                    }).then(function (res) {
                        return _this10.setAvailableShippingMethods(res);
                    });
                }
            }
        }, {
            key: 'setAvailableShippingMethods',
            value: function setAvailableShippingMethods(availableShippingMethods) {
                this.availableShippingMethods = availableShippingMethods;
                this.curbsideShippingAvailable = !!this.availableShippingMethods.find(function (method) {
                    return method.name === 'Curbside Pickup';
                });
            }
        }, {
            key: 'onStepTwoContinueClicked',
            value: function onStepTwoContinueClicked(bypassShipping) {
                if (!bypassShipping && this.shippingMethodStepForm.$invalid) {
                    this.checkoutService.forceFormValidation(this.shippingMethodStepForm);
                    return;
                }
                if (this.hasNoShippingMethodsForStore()) {
                    try {
                        var throwIfNoShipping = this.isShippingRequired;
                        this.setStateFromCart(throwIfNoShipping);
                    } catch (err) {
                        var genericError = 'Problem processing order. Please review your Shipping Method and try again.';
                        var errorMessage = (0, _get2.default)(err, 'message', genericError);
                        this.checkoutService.showErrorDialog(errorMessage);
                    }
                } else {
                    var selectedShippingMethod = this.availableShippingMethods[this.selectedShippingMethodIndex];
                    this.cacheSelectedShippingMethod(selectedShippingMethod);
                    this.didContinueStepTwo = true;
                    var _throwIfNoShipping = true;
                    this.setStateFromCart(_throwIfNoShipping);
                    this.getTax();
                    this.scrollToCurrentStep();
                    this.trackStepTwoEvents();
                    (0, _dataLayer.logShippingInfo)(this.tenantId, this.cartAndSavedInfo);
                }
            }
        }, {
            key: 'cacheSelectedShippingMethod',
            value: function cacheSelectedShippingMethod(selectedShippingMethod) {
                var shippingPriceInCents = (0, _cartUtils.dollarsToCents)(selectedShippingMethod.shippingPrice);
                this.updateCartInfo({
                    shippingMethod: _extends({}, selectedShippingMethod, {
                        shippingPriceInCents: shippingPriceInCents
                    })
                });
            }
        }, {
            key: 'onCheckoutClicked',
            value: function onCheckoutClicked() {
                if (this.selectedPaymentMethod !== 'PayPal' || this.isReturnFromPaypal || !this.shouldShowPaymentTypeSelection()) {
                    this.validateAndPlaceOrder();
                }
            }
        }, {
            key: 'onStripeElementsCardChange',
            value: function onStripeElementsCardChange(_ref5) {
                var error = _ref5.error;

                this.stripeElementsError = error;
            }
        }, {
            key: 'validateAndPlaceOrder',
            value: function validateAndPlaceOrder() {
                var _this11 = this;

                if (this.paymentAndReviewForm && this.paymentAndReviewForm.$invalid || this.stripeElementsError) {
                    this.checkoutService.forceFormValidation(this.paymentAndReviewForm['$ctrl.addressForm']);
                    return;
                }

                var placeOrderPromise = this.isReturnFromPaypal ? this.placePaypalOrder : this.placeOrder;

                this.isUpdatingCart = true;
                this.loadingService.show('Completing your order...');

                this.trackStepThreeEvents();

                placeOrderPromise.bind(this)().finally(function () {
                    _this11.isUpdatingCart = false;
                    _this11.loadingService.hide();
                }).catch(function (err) {
                    if (err.message && err.title) {
                        _this11.checkoutService.showErrorDialog(err.message, err.title);
                    } else {
                        _this11.handleCheckoutError(err);
                    }
                });
            }
        }, {
            key: 'placeOrder',
            value: function placeOrder() {
                this.updateCartInfo({
                    billingAddress: this.checkoutService.createCartAddressFromForm(this.accountBillingAddress || this.billingAddressModel)
                });
                var throwIfNoShipping = true;
                this.setStateFromCart(throwIfNoShipping);
                return this.applyShippingMethodToCartIfNeeded().then(this.sendOrderOptions.bind(this)).then(_cartUtils.clearSavedStoreCreditInfo);
            }
        }, {
            key: 'handlePostOrderActions',
            value: function handlePostOrderActions() {
                var _this12 = this;

                var postOrderActions = [];
                var orderPaidEntirelyWithGiftCard = !this.shouldShowPaymentTypeSelection();
                var savedCartInfo = _extends({}, this.cartAndSavedInfo);

                if (this.isLoggedIn && this.saveLoggedInShopperInfo && this.stripe && this.stripeElementsCard && !(0, _get2.default)(this, 'savedPaymentMethods.length') && !orderPaidEntirelyWithGiftCard) {
                    // save payment method if shopper doesn't have one
                    postOrderActions.push(this.stripe.createToken(this.stripeElementsCard, (0, _creditCard.createStripeTokenMetadata)(savedCartInfo.billingAddress)).then(function (response) {
                        return _this12.apiService.account.paymentMethod.add(response.token.id, true);
                    }));
                } else {
                    postOrderActions.push(this.$q.resolve());
                }

                if (!this.isLoggedIn && this.stripe && this.stripeElementsCard && !orderPaidEntirelyWithGiftCard) {
                    // If order was from anonymous Stripe shopper,
                    // create a second token in case shopper wants to save card post checkout.
                    // This needs to be done before stripe elements is unmounted.
                    postOrderActions.push(this.stripe.createToken(this.stripeElementsCard, (0, _creditCard.createStripeTokenMetadata)(savedCartInfo.billingAddress)));
                }

                return this.$q.all(postOrderActions).then(function (_ref6) {
                    var _ref7 = _slicedToArray(_ref6, 2),
                        saveShopperAccountPaymentMethod = _ref7[0],
                        stripeTokenForAccountCreation = _ref7[1];

                    return {
                        saveShopperAccountPaymentMethod: saveShopperAccountPaymentMethod,
                        stripeTokenForAccountCreation: stripeTokenForAccountCreation
                    };
                });
            }
        }, {
            key: 'sendOrderOptions',
            value: function sendOrderOptions() {
                var _this13 = this;

                var placeOrderOptions = this.assembleOrderOptions();
                if (this.grandTotal <= 0) {
                    placeOrderOptions.paymentMethod = 'Cash';
                }

                return this.orderService.placeOrder(placeOrderOptions).then(function (order) {
                    return _this13.handlePostOrderActions().then(function (_ref8) {
                        var stripeTokenForAccountCreation = _ref8.stripeTokenForAccountCreation;
                        return { order: order, stripeTokenForAccountCreation: stripeTokenForAccountCreation };
                    });
                }).then(function (_ref9) {
                    var order = _ref9.order,
                        stripeTokenForAccountCreation = _ref9.stripeTokenForAccountCreation;

                    _this13.stripeTokenForAccountCreation = stripeTokenForAccountCreation;
                    _this13.order = order;
                    _this13.scrollToId('checkout');
                    (0, _dataLayer.logPaymentMethod)(_this13.tenantId, order.paymentMethod);
                    (0, _dataLayer.logPurchase)(_this13.tenantId, order, _this13.returnUrl);
                });
            }
        }, {
            key: 'assembleOrderOptions',
            value: function assembleOrderOptions() {
                var authorizeNet = this.storeInfo.authorizeNet || {};
                var placeOrderOptions = {
                    authorizeNet: authorizeNet,
                    cart: this.cartAndSavedInfo,
                    grandTotal: this.grandTotal,
                    paymentMethod: this.selectedPaymentMethod,
                    creditCardType: this.creditCardType,
                    shopperNote: this.orderNotes,
                    storeCreditInfo: this.storeCreditInfo,
                    stripe: this.stripe,
                    stripeElementsCard: this.stripeElementsCard,
                    taxProvider: this.taxProvider
                };
                if (this.isLoggedIn) {
                    placeOrderOptions.customerId = this.apiService.getShopperId();

                    if (this.selectedCard) {
                        placeOrderOptions.stripeCreditCardId = this.selectedCard.id;
                    } else {
                        placeOrderOptions.card = this.creditCardModel;
                    }
                } else {
                    placeOrderOptions.card = this.creditCardModel;
                }
                return placeOrderOptions;
            }
        }, {
            key: 'handleCheckoutError',
            value: function handleCheckoutError(response) {
                // TODO: handle invalid discounts error here when V2E-3772 is completed
                // TODO: handle invalid shipping method selected when V2E-3739 is completed

                this.gaService.sendOrderPlacementErrorEvent(response);
                var errorDetail = this.orderService.getErrorDetail(response);
                this.checkoutService.showErrorDialog(errorDetail);
            }
        }, {
            key: 'compareShippingMethodChanges',
            value: function compareShippingMethodChanges(before) {
                if (!(0, _isEqual2.default)(before, this.availableShippingMethods)) {
                    var useNewCart = true;
                    this.editShippingMethodService.open(undefined, useNewCart, this.availableShippingMethods, this.cartAndSavedInfo.shippingMethod).then(this.setStateFromCart.bind(this));
                }
            }
        }, {
            key: 'applyPromoCode',
            value: function applyPromoCode(code) {
                var _this14 = this;

                if (!code) return this.$q.reject('Cannot apply discount without code');

                this.promoCodeNotFound = false;
                this.promoCodeExpired = false;
                this.inactiveGiftCard = false;
                this.giftCardNotAllowed = false;
                this.giftCardAlreadyApplied = false;
                this.cannotAddMoreStoreCredit = false;
                this.discountCodeExistsInCart = false;
                this.isUpdatingCart = true;

                var storeCreditLengthBeforeChanges = this.storeCreditInfo.items.length;
                var cartDiscountLengthBeforeChanges = this.cart.discounts.length;
                var cartGrandTotal = this.cartGrandTotal();

                return this.checkoutService.applyPromoCode(code, this.storeCreditInfo, this.cart, cartGrandTotal).then(function (updatedCart) {
                    _this14.cart = updatedCart;

                    _this14.promoCodeNotFound = false;
                    _this14.setStateFromCart();
                    _this14.getTax();
                    if (_this14.cart.discounts.length === cartDiscountLengthBeforeChanges && _this14.storeCreditInfo.items.length === storeCreditLengthBeforeChanges) {
                        _this14.promoCodeNotFound = true;
                    }
                }).catch(function (error) {
                    if (error.message === 'inactiveGiftCard') {
                        _this14.inactiveGiftCard = true;
                    } else if (error.message === 'giftCardNotAllowed') {
                        _this14.giftCardNotAllowed = true;
                    } else if (error.message === 'cannotAddMoreStoreCredit') {
                        _this14.cannotAddMoreStoreCredit = true;
                    } else if (error.message === 'giftCardAlreadyApplied') {
                        _this14.giftCardAlreadyApplied = true;
                    } else if (error.message === 'promoCodeNotFound' || error.status === 404) {
                        _this14.promoCodeNotFound = true;
                    } else if (error.message === 'discountCodeExistsInCart') {
                        _this14.discountCodeExistsInCart = true;
                    } else {
                        _this14.promoCodeExpired = true;
                    }
                }).finally(function () {
                    _this14.isUpdatingCart = false;
                });
            }
        }, {
            key: 'removeDiscountCodeItem',
            value: function removeDiscountCodeItem(discountCode) {
                var _this15 = this;

                if (!this.cart.pricing.appliedDiscounts.length) {
                    return this.$q.reject('No promo code to remove');
                }

                this.promoCodeNotFound = false;
                this.promoCodeExpired = false;
                var shippingMethodsBefore = (0, _cloneDeep2.default)(this.availableShippingMethods);
                this.isUpdatingCart = true;

                return this.checkoutService.removeDiscountCodeItem(discountCode).then(function (updatedCart) {
                    _this15.cart = updatedCart;
                    _this15.setStateFromCart();
                    _this15.getTax();
                    _this15.compareShippingMethodChanges(shippingMethodsBefore);
                }).catch(function () {
                    _this15.checkoutService.showErrorDialog('Error removing promo code');
                }).finally(function () {
                    _this15.isUpdatingCart = false;
                });
            }
        }, {
            key: 'removeStoreCreditItem',
            value: function removeStoreCreditItem(code) {
                var storeCreditIndex = this.storeCreditInfo.items.findIndex(function (item) {
                    return item.giftCardCode === code;
                });
                if (storeCreditIndex > -1) {
                    this.storeCreditInfo.items.splice(storeCreditIndex, 1);
                }
                this.setStateFromCart();
            }
        }, {
            key: 'onOrderNotesChanged',
            value: function onOrderNotesChanged(orderNotes) {
                this.orderNotes = orderNotes;
                this.updateCartInfo({
                    orderNotes: orderNotes
                });
            }
        }, {
            key: 'getSelectedShippingMethodIndex',
            value: function getSelectedShippingMethodIndex() {
                if (this.cartAndSavedInfo.shippingMethod) {
                    return (0, _cartUtils.getShippingMethodIndex)(this.availableShippingMethods, this.cartAndSavedInfo.shippingMethod);
                } else if (!this.availableShippingMethods || !this.availableShippingMethods.length) {
                    // TODO: reference correct availableShippingMethods object
                    return noShippingMethodsIndex;
                }
            }
        }, {
            key: 'getSelectedShippingMethodIndexOrDefault',
            value: function getSelectedShippingMethodIndexOrDefault() {
                var defaultIndex = angular.isDefined(this.selectedShippingMethodIndex) ? this.selectedShippingMethodIndex : 0;
                var selectedShippingMethodIndex = this.getSelectedShippingMethodIndex();
                return angular.isDefined(selectedShippingMethodIndex) ? selectedShippingMethodIndex : defaultIndex;
            }
        }, {
            key: 'ensureShippingSelected',
            value: function ensureShippingSelected() {
                this.selectedShippingMethodIndex = this.getSelectedShippingMethodIndexOrDefault();
            }
        }, {
            key: 'onEditStepOneClicked',
            value: function onEditStepOneClicked($event) {
                var _this16 = this;

                var useNewCarts = true;
                if (this.isLoggedIn && this.savedShippingAddresses && this.savedShippingAddresses.items && this.savedShippingAddresses.items.length) {
                    // TODO: update this to use the new cart
                    this.editAccountContactAndDeliveryService.open(this.loggedInShopper, this.storeInfo.isCheckoutPhoneNumberRequired, this.cartAndSavedInfo.selectedShippingAddressId, this.paypalData, this.isShippingRequired, $event, this.useAddressVerification, useNewCarts).then(function (_ref10) {
                        var shopperAccount = _ref10.shopperAccount;

                        if (shopperAccount) _this16.loggedInShopper = shopperAccount;
                        _this16.contactInfoModel = { email: shopperAccount.emailAddress, phoneNumber: shopperAccount.phoneNumber };
                        _this16.updateCartInfo(_extends({}, (0, _cartUtils.getSavedCartInfo)()) // session storage was updated outside of component
                        );
                        _this16.setStateFromCart();
                        _this16.getTax();
                        (0, _dataLayer.logShopperInfo)(_this16.tenantId, _this16.cartAndSavedInfo);
                    });
                } else {
                    this.isShippingAddressVerified = false;
                    this.editContactAndDeliveryService.open(this.cartAndSavedInfo, this.storeInfo.isCheckoutPhoneNumberRequired, !this.isReturnFromPaypal && this.isShippingRequired, $event, this.onLoginClicked.bind(this), this.isLoggedIn, this.isShippingRequired, this.useAddressVerification, useNewCarts).then(function () {
                        _this16.updateCartInfo(_extends({}, (0, _cartUtils.getSavedCartInfo)()) // session storage was updated outside of component
                        );
                        _this16.setStateFromCart();
                        _this16.getTax();
                        (0, _dataLayer.logShopperInfo)(_this16.tenantId, _this16.cartAndSavedInfo);
                    });
                }
            }
        }, {
            key: 'onEditStepTwoClicked',
            value: function onEditStepTwoClicked($event) {
                var _this17 = this;

                var isNewCart = true;
                this.editShippingMethodService.open($event, isNewCart, this.availableShippingMethods, this.cartAndSavedInfo.shippingMethod).then(function (_ref11) {
                    var shippingMethod = _ref11.shippingMethod;

                    _this17.cacheSelectedShippingMethod(shippingMethod);
                    _this17.setStateFromCart();
                    _this17.getTax();
                    (0, _dataLayer.logShippingInfo)(_this17.tenantId, _this17.cartAndSavedInfo);
                });
            }
        }, {
            key: 'onEditStepThreeClicked',
            value: function onEditStepThreeClicked($event) {
                var _this18 = this;

                if (this.isLoggedIn) {
                    var selectedPaymentMethod = void 0;
                    if (this.selectedCard) {
                        selectedPaymentMethod = this.selectedCard.id;
                    } else if (this.isReturnFromPaypal) {
                        selectedPaymentMethod = 'PayPal';
                    } else {
                        selectedPaymentMethod = null;
                    }

                    this.editAccountPaymentService.open(selectedPaymentMethod, this.stripe, $event).then(function (paymentMethod) {
                        if (paymentMethod === 'PayPal') {
                            _this18.selectedPaymentMethod = paymentMethod;
                        } else {
                            if (_this18.isReturnFromPaypal) {
                                _this18.endPaypalSession();
                            }
                            _this18.setAccountPaymentInfo(paymentMethod);
                        }
                    });
                } else if (this.isReturnFromPaypal && !this.paypalCancelled) {
                    this.endPaypalSession();
                }
            }
        }, {
            key: 'scrollToCurrentStep',
            value: function scrollToCurrentStep() {
                this.scrollToId('checkout-step-' + this.currentStep);
            }
        }, {
            key: 'scrollToId',
            value: function scrollToId(selector) {
                var _this19 = this;

                this.$timeout(function () {
                    _this19.$anchorScroll(selector);
                });
            }
        }, {
            key: 'initPaypalReturn',
            value: function initPaypalReturn() {
                var _this20 = this;

                this.isReturnFromPaypal = true;
                this.loadingService.show('Returning to order review...');
                this.selectedPaymentMethod = 'PayPal';
                this.paypal = {
                    token: this.$stateParams.token,
                    payerId: this.$stateParams.PayerID
                };
                this.paypalSdkService.savePaypalData(this.paypal.token, this.paypal.payerId).then(function (paypalData) {
                    _this20.paypalData = paypalData;
                    _this20.ensureShippingSelected();
                    _this20.updateCartInfo(_extends({}, (0, _cartUtils.getSavedCartInfo)()) // session storage was updated outside of component
                    );
                    var throwIfNoShipping = true;
                    return _this20.setStateFromCart(throwIfNoShipping);
                }).then(function () {
                    return _this20.trackPaypalReturnEvents();
                }).catch(function (err) {
                    _this20.endPaypalSession();
                    _this20.checkoutService.showErrorDialog('Error with PayPal: ' + err, 'Error');
                }).finally(function () {
                    _this20.loadingService.hide();
                });
            }
        }, {
            key: 'endPaypalSession',
            value: function endPaypalSession() {
                this.$location.search('token', null);
                this.$location.search('PayerID', null);
                this.isReturnFromPaypal = false;
                this.setStateFromCart();
            }
        }, {
            key: 'applyShippingMethodToCartIfNeeded',
            value: function applyShippingMethodToCartIfNeeded() {
                if (!this.cartAndSavedInfo.shippingMethod) {
                    var selectedIndex = this.selectedShippingMethodIndex || 0;
                    var selectedShippingMethod = this.availableShippingMethods[selectedIndex];
                    var throwIfNoShipping = true;

                    this.cacheSelectedShippingMethod(selectedShippingMethod);
                    this.setStateFromCart(throwIfNoShipping);
                    this.getTax();
                }
                return this.$q.resolve();
            }
        }, {
            key: 'placePaypalOrder',
            value: function placePaypalOrder() {
                var _this21 = this;

                var placeOrderOptions = {
                    cart: this.cartAndSavedInfo,
                    grandTotal: this.grandTotal,
                    paymentMethod: this.selectedPaymentMethod,
                    payPalPayerId: this.paypal.payerId,
                    payPalExpressCheckoutToken: this.paypal.token,
                    storeCreditInfo: this.storeCreditInfo,
                    shopperNote: this.orderNotes,
                    authorizeNet: {}
                };

                if (this.isLoggedIn) {
                    placeOrderOptions.customerId = this.apiService.getShopperId();
                }

                return this.orderService.placeOrder(placeOrderOptions).then(function (order) {
                    _this21.order = order;
                    _this21.scrollToId('checkout');
                    (0, _cartUtils.clearSavedStoreCreditInfo)();
                });
            }
        }, {
            key: 'onLoginClicked',
            value: function onLoginClicked() {
                var _this22 = this;

                if (this.authService.useUniversalLogin()) {
                    this.authService.login();
                } else {
                    this.loginModalService.open().then(function () {
                        return _this22.handleShopperLoggedIn();
                    });
                }
            }
        }, {
            key: 'handleShopperLoggedIn',
            value: function handleShopperLoggedIn() {
                var _this23 = this;

                this.loadingService.show('Getting account info...');
                return this.shopperAccountService.getAllShopperData().then(function (_ref12) {
                    var shopperAccount = _ref12.shopperAccount,
                        shippingAddresses = _ref12.shippingAddresses,
                        paymentMethods = _ref12.paymentMethods;

                    _this23.setAccountInfo(shopperAccount, shippingAddresses, paymentMethods);
                }).finally(function () {
                    _this23.loadingService.hide();
                });
            }
        }, {
            key: 'initShopperAccount',
            value: function initShopperAccount(isReturnFromPaypal) {
                var _this24 = this;

                this.authService.getShopperId().then(function (shopperId) {
                    _this24.apiService.setShopperId(shopperId);
                    if (isReturnFromPaypal) {
                        _this24.apiService.account.get().then(function (shopperAccount) {
                            _this24.loggedInShopper = shopperAccount;
                        });
                    } else {
                        _this24.loadingService.show('Getting account information...');
                        _this24.shopperAccountService.getAllShopperData().then(function (_ref13) {
                            var shopperAccount = _ref13.shopperAccount,
                                shippingAddresses = _ref13.shippingAddresses,
                                paymentMethods = _ref13.paymentMethods;

                            return _this24.setAccountInfo(shopperAccount, shippingAddresses, paymentMethods);
                        }).finally(function () {
                            _this24.loadingService.hide();
                        });
                    }
                });
            }
        }, {
            key: 'updateCreditCardType',
            value: function updateCreditCardType(creditCardType) {
                this.creditCardType = creditCardType;
            }
        }, {
            key: 'setAccountInfo',
            value: function setAccountInfo(shopperAccount, shippingAddresses, paymentMethods) {
                if (paymentMethods) {
                    this.savedPaymentMethods = paymentMethods.items;
                }
                this.savedShippingAddresses = shippingAddresses;

                this.updateCartInfo();

                // don't overwrite the shipping address if they set one before logging in
                if (shippingAddresses && shippingAddresses.items && shippingAddresses.items.length && !this.cartAndSavedInfo.shippingAddress) {
                    var defaultShippingAddress = this.shopperAccountService.getDefaultShippingAddress(shippingAddresses);

                    if (defaultShippingAddress) {
                        this.updateCartInfo({
                            shippingAddress: defaultShippingAddress.address
                        });
                        this.setStateFromCart();
                    }
                }

                this.updateCartInfo({
                    contactInfo: {
                        email: shopperAccount.emailAddress || this.cartAndSavedInfo.contactInfo && this.cartAndSavedInfo.contactInfo.email,
                        phoneNumber: shopperAccount.phoneNumber || this.cartAndSavedInfo.contactInfo && this.cartAndSavedInfo.contactInfo.phoneNumber
                    }
                });

                this.updateCartWithShopper(shopperAccount.shopperId, shopperAccount.emailAddress);

                this.isLoggedIn = true;
                this.loggedInShopper = shopperAccount;
                if (!this.isReturnFromPaypal && paymentMethods) {
                    var defaultPaymentMethod = (0, _find2.default)(paymentMethods.items, 'isDefault');
                    if (defaultPaymentMethod) {
                        this.setAccountPaymentInfo(defaultPaymentMethod);
                    }
                }
                this.contactInfoModel = { email: shopperAccount.emailAddress, phoneNumber: shopperAccount.phoneNumber };

                this.setStateFromCart();
                this.getTax();
            }
        }, {
            key: 'setAccountPaymentInfo',
            value: function setAccountPaymentInfo(paymentMethod) {
                if (!paymentMethod) return;
                this.selectedPaymentMethod = 'Credit Card';
                this.selectedCard = paymentMethod;
                this.accountBillingAddress = {
                    firstName: paymentMethod.name,
                    address1: paymentMethod.address.line1,
                    address2: paymentMethod.address.line2,
                    city: paymentMethod.address.city,
                    state: paymentMethod.address.state,
                    postalCode: paymentMethod.address.zip,
                    country: paymentMethod.address.country
                };
            }
        }, {
            key: 'trackPaypalReturnEvents',
            value: function trackPaypalReturnEvents() {
                this.gaService.logCheckoutStep(this.GA_CHECKOUT_STEPS.contactInfo, 'PayPal', this.cartAndSavedInfo);
                this.gaService.logCheckoutStep(this.GA_CHECKOUT_STEPS.shippingAddress, 'PayPal', this.cartAndSavedInfo);
                this.gaService.logCheckoutStep(this.GA_CHECKOUT_STEPS.billingAddress, 'PayPal', this.cartAndSavedInfo);
                this.gaService.logCheckoutStep(this.GA_CHECKOUT_STEPS.paymentMethod, 'PayPal', this.cartAndSavedInfo);
                this.gaService.logCheckoutStep(this.GA_CHECKOUT_STEPS.shippingMethod, 'PayPal', this.cartAndSavedInfo);

                (0, _dataLayer.logCheckoutStarted)(this.tenantId, this.cartAndSavedInfo, this.returnUrl);
                (0, _dataLayer.logShopperInfo)(this.tenantId, this.cartAndSavedInfo);
                (0, _dataLayer.logShippingInfo)(this.tenantId, this.cartAndSavedInfo);
                (0, _dataLayer.logPaymentMethod)(this.tenantId, 'PayPal');
            }
        }, {
            key: 'trackStepOneEvents',
            value: function trackStepOneEvents() {
                this.gaService.logCheckoutStep(this.GA_CHECKOUT_STEPS.contactInfo, this.contactInfoModel.emailOptIn, this.cartAndSavedInfo);
                this.gaService.logCheckoutStep(this.GA_CHECKOUT_STEPS.shippingAddress, this.shippingAddressModel.state, this.cartAndSavedInfo);
            }
        }, {
            key: 'trackStepTwoEvents',
            value: function trackStepTwoEvents() {
                this.gaService.logCheckoutStep(this.GA_CHECKOUT_STEPS.shippingMethod, this.cartAndSavedInfo.shippingMethod.name || 'none', this.cartAndSavedInfo);
            }
        }, {
            key: 'trackStepThreeEvents',
            value: function trackStepThreeEvents() {
                this.gaService.logCheckoutStep(this.GA_CHECKOUT_STEPS.billingAddress, this.billingSameAsShipping, this.cartAndSavedInfo);
                this.gaService.logCheckoutStep(this.GA_CHECKOUT_STEPS.paymentMethod, this.selectedPaymentMethod, this.cartAndSavedInfo);
            }
        }, {
            key: 'shouldShowAccountPaymentAndBilling',
            value: function shouldShowAccountPaymentAndBilling() {
                return this.isLoggedIn && this.selectedPaymentMethod === 'Credit Card' && angular.isDefined(this.selectedCard) && angular.isDefined(this.accountBillingAddress);
            }
        }, {
            key: 'shouldShowCheckoutWithPaypalButton',
            value: function shouldShowCheckoutWithPaypalButton() {
                return this.selectedPaymentMethod === 'PayPal' && !this.isReturnFromPaypal;
            }
        }, {
            key: 'shouldShowEditStepTwoButton',
            value: function shouldShowEditStepTwoButton() {
                return this.steps.shippingMethod.complete && this.selectedShippingMethodIndex !== noShippingMethodsIndex && this.isShippingRequired;
            }
        }, {
            key: 'shouldShowEditStepThreeButton',
            value: function shouldShowEditStepThreeButton() {
                return this.isReturnFromPaypal && !this.paypalCancelled || this.isLoggedIn && this.savedPaymentMethods && this.savedPaymentMethods.length > 0;
            }
        }, {
            key: 'shouldShowPaymentMethodForm',
            value: function shouldShowPaymentMethodForm() {
                return (!this.isReturnFromPaypal || this.paypalCancelled) && !this.selectedCard && !this.accountBillingAddress;
            }
        }, {
            key: 'shouldShowLoginButton',
            value: function shouldShowLoginButton() {
                return !this.steps.contactAndDelivery.complete && !this.isLoggedIn;
            }
        }, {
            key: 'shouldShowSecondaryLoginButton',
            value: function shouldShowSecondaryLoginButton() {
                return this.isReturnFromPaypal && this.steps.contactAndDelivery.complete && !this.isLoggedIn;
            }
        }, {
            key: 'shouldShowPromoCodeLink',
            value: function shouldShowPromoCodeLink() {
                return this.isMobile && !this.shouldShowEditStepThreeButton() || !this.isMobile;
            }
        }, {
            key: 'shouldStepOneBeOpen',
            value: function shouldStepOneBeOpen() {
                return this.currentStep === this.steps.contactAndDelivery.number || this.steps.contactAndDelivery.complete;
            }
        }, {
            key: 'shouldStepTwoBeOpen',
            value: function shouldStepTwoBeOpen() {
                return this.currentStep === this.steps.shippingMethod.number || this.steps.shippingMethod.complete;
            }
        }, {
            key: 'shouldStepThreeBeOpen',
            value: function shouldStepThreeBeOpen() {
                return this.currentStep === this.steps.paymentAndReview.number || this.steps.paymentAndReview.complete;
            }
        }, {
            key: 'shouldShowStepTwoContinueButton',
            value: function shouldShowStepTwoContinueButton() {
                // TODO: reference appropriate availableShippingMethods object
                return this.steps.contactAndDelivery.complete && this.availableShippingMethods && this.availableShippingMethods.length > 0;
            }
        }, {
            key: 'isContactAndDeliveryComplete',
            value: function isContactAndDeliveryComplete() {
                if (this.cartAndSavedInfo.shippingAddress && this.cartAndSavedInfo.contactInfo) {
                    if (this.storeInfo.isCheckoutPhoneNumberRequired) {
                        return !!this.cartAndSavedInfo.contactInfo.email && !!this.cartAndSavedInfo.contactInfo.phoneNumber;
                    }
                    return !!this.cartAndSavedInfo.contactInfo.email && !!this.cartAndSavedInfo.shippingAddress.address1;
                }
                return false;
            }
        }, {
            key: 'cartGrandTotalInCents',
            value: function cartGrandTotalInCents() {
                var cartTotalAmountInCents = (0, _cartUtils.getCartTotalAmountInCents)(this.cart);
                var taxAmountInCents = (0, _get2.default)(this, 'taxAmountInCents', 0);
                var shippingAmountInCents = (0, _get2.default)(this.cartAndSavedInfo, 'shippingMethod.shippingPriceInCents', 0);

                return cartTotalAmountInCents + taxAmountInCents + shippingAmountInCents;
            }
        }, {
            key: 'cartGrandTotal',
            value: function cartGrandTotal() {
                return this.cartGrandTotalInCents() / 100;
            }
        }, {
            key: 'shouldShowPaymentTypeSelection',
            value: function shouldShowPaymentTypeSelection() {
                return this.grandTotal > 0;
            }
        }, {
            key: 'updateCartInfo',
            value: function updateCartInfo(cartInfoChanges) {
                this.cartAndSavedInfo = _extends({}, this.cart, this.cartAndSavedInfo, cartInfoChanges);
                (0, _cartUtils.setSavedCartInfo)(this.cartAndSavedInfo);
            }
        }]);

        return CheckoutCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Auth0SdkServiceModule = undefined;

var _auth0SpaJs = __webpack_require__(718);

var _api = __webpack_require__(14);

var env = __webpack_require__(726);

var Auth0SdkServiceModule = exports.Auth0SdkServiceModule = angular.module('app.services.auth0SdkService', [_api.ApiService]).service('auth0SdkService', ['$q', function ($q) {
    var auth0 = void 0;
    function setAuth0Client(clientId) {
        auth0 = window.crypto && clientId ? new _auth0SpaJs.Auth0Client({
            domain: env.AUTH0_DOMAIN,
            client_id: clientId,
            audience: env.AUTH0_AUDIENCE
        }) : null;
    }

    function handleRedirectCallback() {
        var deferred = $q.defer();
        if (!auth0) {
            deferred.resolve();
            return deferred.promise;
        }

        auth0.handleRedirectCallback().then(function () {
            deferred.resolve();
        }).catch(function (e) {
            deferred.reject(e);
        });
        return deferred.promise;
    }

    function loginWithRedirect(options) {
        var deferred = $q.defer();
        if (!auth0) {
            deferred.resolve();
            return deferred.promise;
        }

        auth0.loginWithRedirect(options).then(function () {
            deferred.resolve();
        }).catch(function (e) {
            deferred.reject(e);
        });
        return deferred.promise;
    }

    function isAuthenticated() {
        var deferred = $q.defer();
        if (!auth0) {
            deferred.resolve(false);
            return deferred.promise;
        }

        auth0.isAuthenticated().then(function (authenticated) {
            deferred.resolve(authenticated);
        }).catch(function () {
            deferred.resolve(false);
        });
        return deferred.promise;
    }

    function getTokenSilently() {
        var deferred = $q.defer();
        if (!auth0) {
            deferred.resolve(null);
            return deferred.promise;
        }

        auth0.getTokenSilently().then(function (token) {
            deferred.resolve(token);
        }).catch(function () {
            deferred.resolve(null);
        });
        return deferred.promise;
    }

    function getUser() {
        var deferred = $q.defer();
        if (!auth0) {
            deferred.resolve(null);
            return deferred.promise;
        }

        auth0.getUser().then(function (user) {
            deferred.resolve(user);
        }).catch(function () {
            deferred.resolve(null);
        });
        return deferred.promise;
    }

    function logout(options) {
        if (auth0) {
            auth0.logout(options);
        }
    }

    return {
        loginWithRedirect: loginWithRedirect,
        isAuthenticated: isAuthenticated,
        getTokenSilently: getTokenSilently,
        getUser: getUser,
        handleRedirectCallback: handleRedirectCallback,
        logout: logout,
        setAuth0Client: setAuth0Client
    };
}]).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var sandbox = __webpack_require__(727);
var production = __webpack_require__(728);

var environmentVariables = {
    sandbox: sandbox,
    production: production
};

var environment = "production";

module.exports = _extends({}, environment === 'development' ? environmentVariables.sandbox : environmentVariables.production);

/***/ }),
/* 727 */
/***/ (function(module, exports) {

module.exports = {"AUTH0_AUDIENCE":"https://sandbox.api.material.com","AUTH0_DOMAIN":"shopper-sandbox.auth0.com"}

/***/ }),
/* 728 */
/***/ (function(module, exports) {

module.exports = {"AUTH0_AUDIENCE":"https://api.material.com/","AUTH0_DOMAIN":"shopper-prod.auth0.com"}

/***/ }),
/* 729 */,
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getOrderContactInfo = exports.getCartShopperInfo = exports.createCartItems = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _get = __webpack_require__(16);

var _get2 = _interopRequireDefault(_get);

var _utils = __webpack_require__(306);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPrimaryImageFromCartItem = function getPrimaryImageFromCartItem(cartItem) {
    return (0, _get2.default)(cartItem, 'product.imageMetadata');
};

var getCartItemImage = function getCartItemImage(cartItem) {
    return (0, _get2.default)(getPrimaryImageFromCartItem(cartItem), 'imageLink.fullUri');
};

var getCartItemImageSmall = function getCartItemImageSmall(cartItem) {
    var image = getPrimaryImageFromCartItem(cartItem);
    return (0, _get2.default)(image, 'imageLink.uriBase') + 'w_250,h_250,c_fit/' + (0, _get2.default)(image, 'imageLink.imagePath');
};

var splitLink = function splitLink(cloudinaryLink) {
    if (!cloudinaryLink) return {};

    var splitKey = 'upload/';
    if (!cloudinaryLink.includes(splitKey)) return {};

    var indexOfSplit = cloudinaryLink.indexOf(splitKey) + splitKey.length;
    return {
        uriBase: cloudinaryLink.substring(0, indexOfSplit),
        imagePath: cloudinaryLink.substring(indexOfSplit)
    };
};

var cartItemMapper = function cartItemMapper(cartItem) {
    if (cartItem.product) {
        return {
            product_name: cartItem.product.name,
            product_url: cartItem.product.seoFriendlyName,
            product_sku: cartItem.product.sku,
            product_price: cartItem.product.pricing.listPrice,
            product_sale_price: cartItem.product.pricing.salePrice,
            product_variant: cartItem.product.productVariantId,
            product_image_url: getCartItemImage(cartItem),
            product_image_url_sm: getCartItemImageSmall(cartItem),
            product_product_categories: cartItem.product.categoryIds
        };
    }

    var legacyCartItemShape = {
        product: {
            imageMetadata: {
                imageLink: _extends({}, splitLink(cartItem.imageSrc))
            }
        }
    };

    var imageSm = getCartItemImageSmall(legacyCartItemShape);

    return {
        product_name: cartItem.productName,
        product_url: cartItem.seoFriendlyName,
        product_sku: cartItem.sku,
        product_price: cartItem.price.amount / 100,
        product_variant: cartItem.variantId,
        product_image_url: cartItem.imageSrc,
        product_image_url_sm: imageSm,
        product_product_categories: cartItem.categoryIds
    };
};

var createCartItems = exports.createCartItems = function createCartItems() {
    var cartItems = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var productBaseUrl = arguments[1];
    return cartItems.map(cartItemMapper).map(function (cartItem) {
        return _extends({}, cartItem, { product_url: productBaseUrl + '/p/' + cartItem.product_url });
    });
};

var getCartShopperInfo = exports.getCartShopperInfo = function getCartShopperInfo(cart) {
    return {
        email: (0, _get2.default)(cart, 'contactInfo.email'),
        first_name: (0, _get2.default)(cart, 'shippingAddress.firstName'),
        last_name: (0, _get2.default)(cart, 'shippingAddress.lastName'),
        address: (0, _utils.combineStringsWithSpace)([(0, _get2.default)(cart, 'shippingAddress.address1'), (0, _get2.default)(cart, 'shippingAddress.address2')]),
        city: (0, _get2.default)(cart, 'shippingAddress.city'),
        state: (0, _get2.default)(cart, 'shippingAddress.state'),
        zip: (0, _get2.default)(cart, 'shippingAddress.postalCode'),
        country: (0, _get2.default)(cart, 'shippingAddress.country'),
        phone: (0, _get2.default)(cart, 'contactInfo.phoneNumber')
    };
};

var getOrderContactInfo = exports.getOrderContactInfo = function getOrderContactInfo(order) {
    return {
        email: (0, _get2.default)(order, 'placedBy.emailAddress'),
        first_name: (0, _get2.default)(order, 'placedBy.firstName'),
        last_name: (0, _get2.default)(order, 'placedBy.lastName'),
        address: (0, _utils.combineStringsWithSpace)([(0, _get2.default)(order, 'placedBy.address.address1'), (0, _get2.default)(order, 'placedBy.address.address2')]),
        city: (0, _get2.default)(order, 'placedBy.address.city'),
        state: (0, _get2.default)(order, 'placedBy.address.state'),
        zip: (0, _get2.default)(order, 'placedBy.address.postalCode'),
        country: (0, _get2.default)(order, 'placedBy.address.country'),
        phone: (0, _get2.default)(order, 'placedBy.phoneNumber')
    };
};

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TextCircle = undefined;

var _textCircle = __webpack_require__(732);

var _textCircle2 = _interopRequireDefault(_textCircle);

__webpack_require__(733);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TextCircle = exports.TextCircle = angular.module('checkout.components.accordian.textCircle', []).component('textCircle', {
    template: _textCircle2.default,
    transclude: true,
    bindings: {
        lightTheme: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 732 */
/***/ (function(module, exports) {

module.exports = "<div class=\"text-circle\" ng-class=\"{'text-circle--light': $ctrl.lightTheme}\"> <ng-transclude></ng-transclude> </div> ";

/***/ }),
/* 733 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 734 */
/***/ (function(module, exports) {

module.exports = "<md-card class=\"accordian checkout-card\" ng-class=\"{'accordian--light': $ctrl.light, 'accordian--closed': !$ctrl.open}\"> <md-card-title> <text-circle light-theme=\"$ctrl.light || !$ctrl.open\">{{$ctrl.stepNumber}}</text-circle> <md-card-title-text> <span class=\"checkout-card-heading\">{{$ctrl.headingText}}</span> </md-card-title-text> <div ng-transclude=\"headerContent\" ng-if=\"$ctrl.open\"></div> </md-card-title> <md-card-content ng-if=\"$ctrl.open\"> <div ng-transclude=\"content\"></div> </md-card-content> </md-card> ";

/***/ }),
/* 735 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 736 */,
/* 737 */,
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ValidatePostalCode = exports.ValidatePostalCode = angular.module('checkout.filters.validatePostalCode', []).directive('validatePostalCode', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, element, attrs, ngModelCtrl) {
            ngModelCtrl.$validators.validPostalCode = function (modelValue, viewValue) {
                var value = modelValue || viewValue;
                if (value == null || value === '') return true;
                return (/^\d{5}(?:[-\s]\d{4})?$/.test(value)
                );
            };
        }
    };
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var FormatZip = exports.FormatZip = angular.module('checkout.directives.formatZip', []).directive('formatZip', function () {
    return {
        require: '?ngModel',
        link: function link(scope, element, attrs, ngModelController) {
            if (!ngModelController) {
                return;
            }

            var formatZip = function formatZip(value) {
                if (value === undefined) return '';
                value = value.toString();
                value = value.replace(/[^0-9]/g, '');
                if (value.length > 9) {
                    value = value.slice(0, 9);
                }
                if (value.length > 5) {
                    value = value.slice(0, 5) + '-' + value.slice(5);
                }

                return value;
            };

            var stripNonNumericCharacters = function stripNonNumericCharacters(inputValue) {
                if (!inputValue) {
                    return '';
                }

                // retrieve numbers from the string
                var numbersOnly = inputValue.replace(/[^\d]*/g, '');

                // if the input does not match expected value.. change the rendered view to correct format
                if (numbersOnly !== inputValue) {
                    ngModelController.$setViewValue(numbersOnly); // view value is updated
                    ngModelController.$render(); // view is updated
                }

                // return only the numbers from string
                return numbersOnly;
            };

            ngModelController.$parsers.unshift(function (value) {
                var viewValue = formatZip(stripNonNumericCharacters(value));
                element.val(viewValue);
                return viewValue;
            });

            ngModelController.$formatters.unshift(function () {
                return ngModelController.$modelValue;
            });
        }
    };
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GoogleAutoComplete = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(741);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GoogleAutoComplete = exports.GoogleAutoComplete = angular.module('checkout.components.googleAutocomplete', []).component('googleAutocomplete', {
    template: '<ng-transclude></ng-transclude>',
    bindings: {
        model: '=',
        formController: '=',
        country: '<',
        autocompleteCountries: '<'
    },
    transclude: true,
    controller: function () {
        GoogleAutocompleteCtrl.$inject = ['$window', '$timeout', '$rootScope', '$element'];

        function GoogleAutocompleteCtrl($window, $timeout, $rootScope, $element) {
            _classCallCheck(this, GoogleAutocompleteCtrl);

            angular.extend(this, {
                $window: $window,
                $timeout: $timeout,
                $rootScope: $rootScope,
                $element: $element
            });
        }

        _createClass(GoogleAutocompleteCtrl, [{
            key: '$onInit',
            value: function $onInit() {
                var _this = this;

                this.$timeout(function () {
                    _this.initGoogleAutocomplete();
                });
            }
        }, {
            key: '$onChanges',
            value: function $onChanges(changesObj) {
                if (changesObj.country && !changesObj.country.isFirstChange()) {
                    if (this.autocompleteCountries.includes(changesObj.country.currentValue)) {
                        this.setAutoCompleteVisible(true);
                        this.setCountryRestriction(changesObj.country.currentValue);
                    } else {
                        this.setAutoCompleteVisible(false);
                    }
                }
            }
        }, {
            key: 'setAutoCompleteVisible',
            value: function setAutoCompleteVisible(visibility) {
                angular.element(this.$window.document.body).toggleClass('google-autocomplete-hidden', !visibility);
            }
        }, {
            key: 'initGoogleAutocomplete',
            value: function initGoogleAutocomplete() {
                this.autocomplete = new this.$window.google.maps.places.Autocomplete(this.$element[0].querySelector('input[google-maps-autocomplete-input]'), {
                    types: ['address']
                });
                if (this.model && this.model.country) {
                    this.setCountryRestriction(this.model.country);
                }
                this.autocomplete.addListener('place_changed', this.onPlaceChanged.bind(this));
            }
        }, {
            key: 'clearAddress',
            value: function clearAddress() {
                this.model.address1 = '';
                this.model.address2 = '';
                this.model.city = '';
                this.model.state = '';
                this.model.country = '';
                this.model.postalCode = '';
                this.formController.$setUntouched();
                this.$rootScope.$apply();
            }
        }, {
            key: 'setGoogleAddressToModel',
            value: function setGoogleAddressToModel(addressFromGoogle) {
                if (addressFromGoogle.street_number && addressFromGoogle.route) {
                    this.model.address1 = addressFromGoogle.street_number + ' ' + addressFromGoogle.route;
                } else if (addressFromGoogle.route) {
                    this.model.address1 = addressFromGoogle.route;
                }

                this.model.city = addressFromGoogle.locality || addressFromGoogle.neighborhood || addressFromGoogle.administrative_area_level_2;
                this.model.state = addressFromGoogle.administrative_area_level_1;
                this.model.country = addressFromGoogle.country;
                this.model.postalCode = addressFromGoogle.postal_code;
            }
        }, {
            key: 'getFlattenedAddressObject',
            value: function getFlattenedAddressObject(place) {
                var addressFromGoogle = {};
                angular.forEach(place.address_components, function (addressComponent) {
                    var componentType = addressComponent.types[0];
                    addressFromGoogle[componentType] = addressComponent.short_name;
                });
                return addressFromGoogle;
            }
        }, {
            key: 'onPlaceChanged',
            value: function onPlaceChanged() {
                var place = this.autocomplete.getPlace();
                if (place.address_components.length > 0) {
                    this.clearAddress();
                    this.setGoogleAddressToModel(this.getFlattenedAddressObject(place));
                    this.$rootScope.$apply();
                }
            }
        }, {
            key: 'setCountryRestriction',
            value: function setCountryRestriction(setCountry) {
                this.autocomplete.setComponentRestrictions({ country: setCountry });
            }
        }]);

        return GoogleAutocompleteCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 741 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 742 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getStatesFromShipToLocationCountry = exports.getStatesFromShipToLocationCountry = function getStatesFromShipToLocationCountry(shipToLocations, countryCode) {
    return shipToLocations.find(function (country) {
        return country.country === countryCode;
    }).administrativeAreas;
};

/***/ }),
/* 744 */,
/* 745 */
/***/ (function(module, exports) {

module.exports = "<google-autocomplete model=\"$ctrl.model\" country=\"$ctrl.model.country\" autocomplete-countries=\"$ctrl.AUTOCOMPLETE_COUNTRIES\" form-controller=\"$ctrl.addressForm\"> <form name=\"$ctrl.addressForm\" novalidate=\"\"> <div layout ng-if=\"$ctrl.showCardholderNameInput\"> <input-container form-input=\"$ctrl.addressForm.name\" flex-xs=\"100\" flex-gt-xs=\"75\" class=\"input-container-first input-container-no-padding-xs\"> <label for=\"{{::$id}}-name\">Cardholder name</label> <input ng-model=\"$ctrl.model.name\" id=\"{{::$id}}-name\" name=\"name\" type=\"text\" required autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" autocomplete=\"{{$ctrl._autoCompletePrefix}}given-name\"> <div ng-messages=\"$ctrl.addressForm.name.$error\"> <div ng-message=\"required\">Cardholder name required</div> </div> </input-container> </div> <div layout ng-if=\"!$ctrl.showCardholderNameInput\"> <input-container form-input=\"$ctrl.addressForm.fname\" flex class=\"input-container-first\"> <label for=\"{{::$id}}-fname\">First name</label> <input ng-model=\"$ctrl.model.firstName\" id=\"{{::$id}}-fname\" name=\"fname\" type=\"text\" required autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" autocomplete=\"{{$ctrl._autoCompletePrefix}}given-name\"> <div ng-messages=\"$ctrl.addressForm.fname.$error\"> <div ng-message=\"required\">First name required</div> </div> </input-container> <input-container form-input=\"$ctrl.addressForm.lname\" flex class=\"input-container-last\"> <label for=\"{{::$id}}-lname\">Last name</label> <input ng-model=\"$ctrl.model.lastName\" id=\"{{::$id}}-lname\" name=\"lname\" type=\"text\" required autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" autocomplete=\"{{$ctrl._autoCompletePrefix}}family-name\"> <div ng-messages=\"$ctrl.addressForm.lname.$error\"> <div ng-message=\"required\">Last name required</div> </div> </input-container> </div> <div layout> <input-container form-input=\"$ctrl.addressForm.country\" flex class=\"input-container-no-padding\"> <label for=\"{{::$id}}-country\">Country</label> <select ng-model=\"$ctrl.model.country\" name=\"country\" id=\"{{::$id}}-country\" ng-change=\"$ctrl.onCountryChange()\" autocomplete=\"{{$ctrl._autoCompletePrefix}}country\"> <option ng-repeat=\"country in $ctrl.shipToLocations | orderBy:'name'\" value=\"{{country.country}}\">{{country.name}}</option> </select> <div ng-messages=\"$ctrl.addressForm.country.$error\" role=\"alert\"> <div ng-message=\"required\">Country is required.</div> <div ng-message=\"pattern\">Country must not contain special characters.</div> </div> </input-container> </div> <div layout> <input-container form-input=\"$ctrl.addressForm.address1\" flex class=\"input-container-no-padding\"> <label>Address line 1</label> <md-autocomplete class=\"address1-input\" name=\"address1\" required placeholder=\"Street address, P.O. Box, etc.\" md-selected-item=\"$ctrl.selectedAddress\" md-search-text=\"$ctrl.searchText\" md-search-text-change=\"$ctrl.onSearchTextChange()\" md-selected-item-change=\"$ctrl.onAddressChange()\" md-items=\"item in $ctrl.searchAddress($ctrl.searchText)\" md-item-text=\"item.description\" md-input-name=\"address1\" md-autoselect=\"false\" md-delay=\"250\" md-dropdown-items=\"5\" md-escape-options=\"none\" md-clear-button=\"false\"> <md-item-template> <div layout layout-align=\"start center\" class=\"address-autocomplete-item\"> <div class=\"autocomplete-item__icon\"><md-icon>place</md-icon></div> <div>{{item.description}}</div> </div> </md-item-template> </md-autocomplete> </input-container> </div> <div layout> <input-container form-input=\"$ctrl.addressForm.address2\" flex class=\"input-container-no-padding\"> <label for=\"{{::$id}}-address2\">Address line 2 (optional)</label> <input ng-model=\"$ctrl.model.address2\" id=\"{{::$id}}-address2\" name=\"address2\" type=\"text\" autocomplete=\"{{$ctrl._autoCompletePrefix}}address-line2\" placeholder=\"Apartment, suite, building, etc.\"> </input-container> </div> <div layout> <input-container form-input=\"$ctrl.addressForm.city\" flex class=\"input-container-first input-container-no-padding-xs\"> <label for=\"{{::$id}}-city\">City</label> <input ng-model=\"$ctrl.model.city\" id=\"{{::$id}}-city\" name=\"city\" type=\"text\" required autocomplete=\"{{$ctrl._autoCompletePrefix}}address-level2\"> <div ng-messages=\"$ctrl.addressForm.city.$error\" role=\"alert\"> <div ng-message=\"required\">City is required.</div> <div ng-message=\"pattern\">City must not contain special characters.</div> </div> </input-container> <input-container form-input=\"$ctrl.addressForm.state\" flex class=\"input-container-first-xs\"> <label for=\"{{::$id}}-state\">{{$ctrl.ADMINISTRATIVE_AREA_LEVEL_1_LABELS[$ctrl.model.country] || $ctrl.DEAFULT_ADMINISTRATIVE_AREA_LEVEL_1_LABEL}}</label> <select ng-model=\"$ctrl.model.state\" name=\"state\" id=\"{{::$id}}-state\" required autocomplete=\"{{$ctrl._autoCompletePrefix}}address-level1\" ng-if=\"$ctrl.states.length > 0\"> <option ng-repeat=\"state in $ctrl.states | orderBy:'name'\" value=\"{{state}}\">{{$ctrl.countries[$ctrl.model.country].provinces[state]}} </option> </select> <div ng-messages=\"$ctrl.addressForm.state.$error\" role=\"alert\" ng-if=\"$ctrl.addressForm.state.$touched\"> <div ng-message=\"required\">{{$ctrl.ADMINISTRATIVE_AREA_LEVEL_1_LABELS[$ctrl.model.country] || $ctrl.DEAFULT_ADMINISTRATIVE_AREA_LEVEL_1_LABEL}} is required.</div> </div> <input ng-model=\"$ctrl.model.state\" id=\"{{::$id}}-state\" name=\"state\" type=\"text\" ng-if=\"$ctrl.states.length === 0\" autocomplete=\"{{$ctrl._autoCompletePrefix}}address-level1\"> </input-container> <input-container form-input=\"$ctrl.addressForm.zip\" flex class=\"input-container-last\"> <label for=\"{{::$id}}-zip\"> {{$ctrl.domesticAddress ? 'ZIP code': 'Postal code'}} </label> <input ng-model=\"$ctrl.model.postalCode\" id=\"{{::$id}}-zip\" name=\"zip\" type=\"text\" required format-zip validate-postal-code maxlength=\"10\" autocomplete=\"{{$ctrl._autoCompletePrefix}}postal-code\" ng-if=\"$ctrl.domesticAddress\"> <div ng-messages=\"$ctrl.addressForm.zip.$error\" role=\"alert\" ng-if=\"$ctrl.addressForm.zip.$touched\"> <div ng-message=\"required\">ZIP code is required.</div> <div ng-message=\"validPostalCode\">ZIP code must be in the proper format.</div> </div> <input ng-model=\"$ctrl.model.postalCode\" id=\"{{::$id}}-zip\" name=\"zip\" type=\"text\" ng-if=\"!$ctrl.domesticAddress\" maxlength=\"10\" autocomplete=\"{{$ctrl._autoCompletePrefix}}postal-code\"> </input-container> </div> </form> </google-autocomplete> <div ng-if=\"$ctrl.isAddressVerified\" class=\"address-verified\"> <div layout=\"row\" layout-align=\"start center\"> <md-icon>done</md-icon> <div flex=\"noshrink\">Verified Address</div> </div> <div ng-if=\"$ctrl.verifiedMessage\" class=\"address-verified__message\">{{$ctrl.verifiedMessage}}</div> </div> ";

/***/ }),
/* 746 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 747 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 748 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 749 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FormatCardExpiration = undefined;

var _cardExpiration = __webpack_require__(778);

var FormatCardExpiration = exports.FormatCardExpiration = angular.module('checkout.directives.formatCardExpiration', [_cardExpiration.CardExpirationFilter]).directive('formatCardExpiration', ['$filter', '$browser', function ($filter, $browser) {
    return {
        require: '?ngModel',
        link: function link(scope, elem, attrs, ctrl) {
            if (!ctrl) {
                return;
            }

            var listener = function listener(key) {
                var value = elem.val().replace(/[^\d]+/g, '');
                if (value.length === 1 && value > 1 && key !== 8) {
                    return elem.val($filter('ccExpiration')('0' + value));
                }
                return elem.val($filter('ccExpiration')(value, key));
            };

            ctrl.$formatters.unshift(function () {
                return $filter('ccExpiration')(ctrl.$modelValue || '');
            });

            ctrl.$parsers.unshift(function (viewValue) {
                var plainNumber = viewValue.replace(/[^\d]+/g, '');
                var MM = plainNumber.slice(0, 2);
                var year = plainNumber.slice(2, 6);

                switch (true) {
                    case plainNumber.length === 1 && plainNumber > 1:
                        return '0' + plainNumber;
                    case year.length >= 2:
                        return MM + '/' + (year.length > 2 ? year : '20' + year);
                    default:
                        return MM;
                }
            });

            elem.on('keydown', function (event) {
                var key = event.keyCode;
                if (key === 8) return $browser.defer(function () {
                    return listener(key);
                });
                return $browser.defer(listener);
            });
        }
    };
}]).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var CardExpirationFilter = exports.CardExpirationFilter = angular.module('checkout.filters.ccExpiration', []).filter('ccExpiration', function () {
    return function (expry, key) {
        if (expry === null || expry === undefined) return '';
        var plainNumber = expry.replace(/[^\d]+/g, '');
        switch (true) {
            case plainNumber.length <= 1 || key === 8 && plainNumber.length === 2:
                return '' + plainNumber;
            case plainNumber.length === 2 && key !== 8:
                return plainNumber + ' / ';
            case plainNumber.length >= 3:
                return plainNumber.slice(0, 2) + ' / ' + plainNumber.slice(2, 6);
            default:
                return plainNumber;
        }
    };
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CvcInfo = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _cvcInfo = __webpack_require__(780);

var _cvcInfo2 = _interopRequireDefault(_cvcInfo);

__webpack_require__(781);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CvcInfo = exports.CvcInfo = angular.module('checkout.components.cvcInfo', ['ngMaterial']).component('cvcInfo', {
    template: '\n            <button class="cvc-info" ng-click="$ctrl.showInfoModal($event)" tabindex="-1">\n                <md-icon>info</md-icon>\n            </button>\n        ',
    controller: function () {
        CvcInfoCtrl.$inject = ['$mdDialog', '$window'];

        function CvcInfoCtrl($mdDialog, $window) {
            _classCallCheck(this, CvcInfoCtrl);

            this.$mdDialog = $mdDialog;
            this.$window = $window;
        }

        _createClass(CvcInfoCtrl, [{
            key: 'showInfoModal',
            value: function showInfoModal($event) {
                this.$mdDialog.show({
                    controller: ['$scope', '$mdDialog', function ($scope, $mdDialog) {
                        var vm = {
                            close: close
                        };
                        init();

                        function init() {
                            $scope.vm = vm;
                        }

                        function close() {
                            $mdDialog.hide();
                        }
                    }],
                    template: _cvcInfo2.default,
                    parent: angular.element(this.$window.document.body),
                    targetEvent: $event,
                    clickOutsideToClose: true,
                    multiple: true
                });
            }
        }]);

        return CvcInfoCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 780 */
/***/ (function(module, exports) {

module.exports = "<md-dialog class=\"checkout checkout-modal cvc-info-modal\"> <md-dialog-content class=\"md-dialog-content\"> <div layout layout-align=\"space-between center\" class=\"checkout-modal__header\"> <div class=\"checkout-card-heading\">What is CVC?</div> </div> <p>The CVC (also referred to as CVV) is the three- or four-digit number printed directly on the credit card, usually either on the signature strip or the front of the card.</p> </md-dialog-content> <md-dialog-actions layout class=\"checkout-modal__footer\"> <button class=\"checkout-button checkout-button--primary checkout-button--large\" type=\"button\" ng-click=\"vm.close()\"> Got it </button> </md-dialog-actions> </md-dialog> ";

/***/ }),
/* 781 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 782 */
/***/ (function(module, exports) {

module.exports = "<form name=\"$ctrl.creditCardForm\" novalidate=\"\" class=\"credit-card-form\"> <div layout-xs=\"{{$ctrl.hideCvcInput ? 'row' : 'column'}}\" layout-gt-xs=\"row\"> <div flex=\"{{$ctrl.hideCvcInput ? '50' : '100'}}\" flex-gt-xs=\"50\"> <div layout> <input-container form-input=\"$ctrl.creditCardForm.cardNumber\" flex class=\"input-container-first\" ng-class=\"{'input-container-no-padding-xs': !$ctrl.hideCvcInput}\"> <label for=\"cardNumber\">Card number</label> <input ng-model=\"$ctrl.model.cardNumber\" ng-disabled=\"true\" id=\"cardNumber\" name=\"cardNumber\" type=\"text\" class=\"credit-card-form__cc-input\" ng-if=\"$ctrl.disableCardNumberField\"> <input ng-model=\"$ctrl.model.cardNumber\" ng-if=\"!$ctrl.disableCardNumberField\" ng-change=\"$ctrl.updateCreditCardType()\" id=\"cardNumber\" name=\"cardNumber\" type=\"text\" required cc-format cc-number maxlength=\"19\" autocomplete=\"cc-number\" class=\"credit-card-form__cc-input\"> <credit-card-image card-type=\"$ctrl.creditCardForm.cardNumber.$ccType\" ng-if=\"!$ctrl.hideCreditCardImage\"></credit-card-image> <div ng-messages=\"$ctrl.creditCardForm.cardNumber.$error\"> <div ng-message=\"required\">Card number required</div> <div ng-message=\"ccNumber\">Card number must be valid</div> </div> </input-container> </div> </div> <div flex-xs=\"100\" flex-gt-xs=\"50\"> <div layout> <input-container form-input=\"$ctrl.creditCardForm.expiration\" flex-xs=\"{{$ctrl.hideCvcInput ? '100' : '50'}}\" flex-gt-xs=\"50\" ng-class=\"{'input-container-last-xs': $ctrl.hideCvcInput, 'input-container-first-xs': !$ctrl.hideCvcInput}\"> <label for=\"expiration\">Expiration</label> <input ng-model=\"$ctrl.model.expiration\" id=\"expiration\" name=\"expiration\" type=\"tel\" required payments-validate=\"expiry\" format-card-expiration autocomplete=\"cc-exp\" placeholder=\"MM/YY\"> <div ng-messages=\"$ctrl.creditCardForm.expiration.$error\"> <div ng-message=\"required\">Expiration required</div> <div ng-message=\"expiry\">Expiration must be valid</div> </div> </input-container> <input-container form-input=\"$ctrl.creditCardForm.cvc\" ng-if=\"!$ctrl.hideCvcInput\" flex=\"50\" class=\"input-container-last\"> <label for=\"cvc\">CVC</label> <cvc-info></cvc-info> <input ng-model=\"$ctrl.model.cvc\" id=\"cvc\" name=\"cvc\" type=\"text\" required cc-cvc autocomplete=\"cc-csc\" placeholder=\"3-4 digits\"> <div ng-messages=\"$ctrl.creditCardForm.cvc.$error\"> <div ng-message=\"required\">CVC required</div> <div ng-message=\"ccCvc\">CVC must be valid</div> </div> </input-container> </div> </div> </div> </form> ";

/***/ }),
/* 783 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BillingAddressForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _addressForm = __webpack_require__(54);

var _displayInfo = __webpack_require__(81);

var _billingAddressForm = __webpack_require__(787);

var _billingAddressForm2 = _interopRequireDefault(_billingAddressForm);

__webpack_require__(788);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BillingAddressForm = exports.BillingAddressForm = angular.module('checkout.components.billingAddressForm', [_displayInfo.DisplayInfo, _addressForm.AddressForm]).component('billingAddressForm', {
    template: _billingAddressForm2.default,
    bindings: {
        billingSameAsShipping: '<',
        model: '='
    },
    controller: function () {
        function BillingAddressFormCtrl() {
            _classCallCheck(this, BillingAddressFormCtrl);
        }

        _createClass(BillingAddressFormCtrl, [{
            key: 'onChangeBillingAddressClicked',
            value: function onChangeBillingAddressClicked() {
                this.billingSameAsShipping = false;
            }
        }]);

        return BillingAddressFormCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 785 */
/***/ (function(module, exports) {

module.exports = "<div ng-transclude=\"title\" class=\"display-info__title\"></div> <div ng-transclude=\"verified\" class=\"display-info__verified\"></div> <div ng-transclude=\"content\" class=\"display-info__content\"></div> ";

/***/ }),
/* 786 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 787 */
/***/ (function(module, exports) {

module.exports = "<div class=\"billing-address-form\"> <div layout ng-if=\"$ctrl.billingSameAsShipping\"> <div flex-xs=\"100\" flex-gt-xs=\"50\" class=\"billing-address-form__container\"> <div layout layout-align=\"space-between end\"> <display-info> <display-info-title>Billing address</display-info-title> <display-info-content>Same as shipping</display-info-content> </display-info> <div> <button type=\"button\" class=\"checkout-button checkout-button--border\" ng-click=\"$ctrl.onChangeBillingAddressClicked()\">Change</button> </div> </div> </div> </div> <div ng-if=\"!$ctrl.billingSameAsShipping\"> <h3 class=\"checkout-section-heading\">Billing address</h3> <address-form model=\"$ctrl.model\" auto-complete-prefix=\"section-billing\"></address-form> </div> </div> ";

/***/ }),
/* 788 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CreditCardList = undefined;

__webpack_require__(790);

var CreditCardList = exports.CreditCardList = angular.module('checkout.components.creditCardList', []).component('creditCardList', {
    template: '\n            <div layout layout-align="start center">\n                <credit-card-image card-type="\'mastercard\'"></credit-card-image>\n                <credit-card-image card-type="\'visa\'"></credit-card-image>\n                <credit-card-image card-type="\'discover\'"></credit-card-image>\n                <credit-card-image card-type="\'amex\'"></credit-card-image>\n            </div>\n        ',
    bindings: {
        cardType: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 790 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 791 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 792 */
/***/ (function(module, exports) {

module.exports = "<form id=\"paypal-cc-form\" class=\"credit-card-form\"> <div layout-xs=\"column\" layout-gt-xs=\"row\"> <div flex=\"100\" flex-gt-xs=\"50\"> <div layout> <input-container flex class=\"input-container-first\" ng-class=\"{'input-container-no-padding-xs': true}\"> <label for=\"card-number\">Card Number</label> <div id=\"cardNumber\" class=\"credit-card-form__cc-input acp-input-field\"></div> <credit-card-image card-type=\"$ctrl.cardType\"></credit-card-image> </input-container> </div> </div> <div flex-xs=\"100\" flex-gt-xs=\"50\"> <div layout> <input-container flex-xs=\"50\" flex-gt-xs=\"50\" ng-class=\"{'input-container-last-xs': false, 'input-container-first-xs': true}\"> <label for=\"expiration-date\">Expiration Date</label> <div id=\"expiration\" class=\"acp-input-field\"></div> </input-container> <input-container flex=\"50\" class=\"input-container-last\"> <label for=\"cvv\">CVV</label> <div id=\"cvc\" class=\"acp-input-field\"></div> </input-container> </div> </div> </div> </form> ";

/***/ }),
/* 793 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports = "<md-radio-group class=\"payment-method-form\" ng-model=\"$ctrl.selectedPaymentMethod\" required> <div ng-repeat=\"payment in $ctrl.availablePaymentMethods\" class=\"payment-method-form__method\" ng-class=\"{'payment-method-form__button-flex': payment.value === 'PayPal'}\"> <md-radio-button class=\"md-primary\" value=\"{{payment.value}}\"> <div layout layout-align=\"space-between center\" class=\"payment-method-form__button-content\"> <div> <credit-card-list ng-if=\"payment.value === 'Credit Card'\"></credit-card-list> <img ng-if=\"payment.value === 'PayPal'\" src=\"//d3dl6qv39aj0xv.cloudfront.net/assets/payment/paypal_logo.svg\" height=\"24px\" alt=\"PayPal\"> </div> </div> </md-radio-button> <div ng-if=\"payment.value === 'PayPal'\" class=\"payment-method-form__pay-in-four\"></div> <div ng-if=\"payment.value === 'Credit Card' && $ctrl.selectedPaymentMethod === 'Credit Card'\" class=\"payment-method-form__credit-card-method\"> <credit-card-form model=\"$ctrl.creditCardModel\" on-credit-card-type-updated=\"$ctrl.onCreditCardTypeUpdated\" ng-if=\"$ctrl.storeInfo.authorizeNet.isEnabled\"> </credit-card-form> <stripe-elements-form ng-if=\"$ctrl.storeInfo.acceptsStripeAsPayment && $ctrl.stripeElementsCard\" stripe-elements-card=\"$ctrl.stripeElementsCard\" on-stripe-elements-card-change=\"$ctrl.onStripeElementsCardChange\"> </stripe-elements-form> <checkout-with-paypal-sdk-acp ng-if=\"$ctrl.shouldShowPayPalAcpFields()\" cart-id=\"$ctrl.cart.id\" bag-id=\"$ctrl.bag.id\"> </checkout-with-paypal-sdk-acp> <billing-address-form billing-same-as-shipping=\"$ctrl.billingSameAsShipping\" model=\"$ctrl.billingAddressModel\" ng-if=\"$ctrl.isShippingRequired\"> </billing-address-form> </div> </div> </md-radio-group> ";

/***/ }),
/* 795 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var ValidateEmailDirective = exports.ValidateEmailDirective = angular.module('checkout.directives.validateEmail', []).directive('validateEmail', function () {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function link(scope, elm, attrs, ngModel) {
            ngModel.$validators.validEmail = function (modelValue) {
                return modelValue && /.+@.+\.[^\s]+/.test(modelValue);
            };
            ngModel.$validators.validLength = function (modelValue) {
                return modelValue && modelValue.length < 75;
            };
        }
    };
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var IgnoreKeypress = exports.IgnoreKeypress = angular.module('checkout.directives.ignoreKeypress', []).directive('ignoreKeypress', function () {
    return {
        restrict: 'A',
        require: '?ignoreKeypressRegex',
        scope: { ignoreKeypressRegex: '=' },
        replace: false,
        link: function link(scope, element) {
            element.bind('keypress', function (event) {
                var regex = new RegExp(scope.ignoreKeypressRegex);
                var key = String.fromCharCode(!event.keyCode ? event.which : event.keyCode);
                if (regex.test(key)) {
                    event.preventDefault();
                    return false;
                }
            });
        }
    };
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FormatPhoneNumber = undefined;

var _phone = __webpack_require__(799);

var FormatPhoneNumber = exports.FormatPhoneNumber = angular.module('checkout.directives.formatPhoneNumber', [_phone.PhoneFilter]).directive('formatPhoneNumber', ['$filter', function ($filter) {
    return {
        require: '?ngModel',
        link: function link(scope, elem, attrs, ctrl) {
            if (!ctrl) {
                return;
            }

            ctrl.$formatters.unshift(function () {
                return $filter('vPhone')(ctrl.$modelValue || '');
            });

            ctrl.$parsers.unshift(function (viewValue) {
                var plainNumber = viewValue.replace(/[^\d]+/g, '');
                elem.val($filter('vPhone')(plainNumber));
                return plainNumber;
            });
        }
    };
}]).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var PhoneFilter = exports.PhoneFilter = angular.module('checkout.filters.vPhone', []).filter('vPhone', function () {
    return function (input) {
        if (input === undefined || input === '') {
            return input;
        }
        input = input.replace(/[^\d]+/g, '');
        var city;
        var number;

        switch (input.length) {
            case 10:
                // PPP####### -> (PPP) ###-####
                city = input.slice(0, 3);
                number = input.slice(3);
                break;

            default:
                return input;
        }

        number = number.slice(0, 3) + '-' + number.slice(3);

        return ('(' + city + ') ' + number).trim();
    };
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports = "<form name=\"$ctrl.contactInfoForm\" novalidate=\"\"> <div layout-xs=\"column\" layout-gt-xs=\"row\"> <div flex> <div layout> <input-container form-input=\"$ctrl.contactInfoForm.email\" flex class=\"input-container-first input-container-no-padding-xs\"> <label for=\"email\">Email</label> <input ng-model=\"$ctrl.model.email\" id=\"email\" name=\"email\" type=\"email\" required validate-email autocomplete=\"section-contact email\" ng-disabled=\"$ctrl.emailInputDisabled\"> <div class=\"checkout-input-errors\" ng-messages=\"$ctrl.contactInfoForm.email.$error\"> <div ng-message=\"required\">Email required</div> <div ng-message=\"validEmail\">Valid email required</div> <div ng-message=\"validLength\">Email must be less than 75 characters</div> </div> </input-container> </div> </div> <div flex> <div layout> <input-container form-input=\"$ctrl.contactInfoForm.phone\" flex class=\"input-container-last input-container-no-padding-xs\"> <label for=\"phone\">Phone number{{$ctrl.phoneNumberRequired ? '' : ' (optional)'}}</label> <input ng-model=\"$ctrl.model.phone\" id=\"phone\" name=\"phone\" type=\"tel\" ng-required=\"$ctrl.phoneNumberRequired\" v-phone format-phone-number ignore-keypress ignore-keypress-regex=\"$ctrl.phoneIgnoreCharRegex\" maxlength=\"15\" ng-minlength=\"10\" autocomplete=\"section-contact tel\"> <div class=\"checkout-input-errors\" ng-messages=\"$ctrl.contactInfoForm.phone.$error\"> <div ng-message=\"minlength\">Phone number must be a valid format</div> <div ng-message=\"required\">Phone number required</div> </div> </input-container> </div> </div> </div> <md-checkbox ng-model=\"$ctrl.model.emailOptIn\" aria-label=\"Sign up for our newsletter\"> Sign up for our newsletter </md-checkbox> </form> ";

/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AddressVerificationButton = undefined;

__webpack_require__(802);

var AddressVerificationButton = exports.AddressVerificationButton = angular.module('checkout.components.addressVerificationForm.button', []).component('addressVerificationButton', {
    transclude: true,
    template: '\n            <button\n                class="address-verification-button"\n                ng-disabled="$ctrl.disabled"\n                ng-class="{\n                    \'address-verification-button--text\': $ctrl.variant === \'text\',\n                    \'address-verification-button--primary\': $ctrl.variant === \'primary\'\n                }"\n                type="button"\n                ng-click="$ctrl.onClick({ $event: $event })"\n            >\n                <div layout="flex" layout-align="center center">\n                    <ng-transclude />\n                </div>\n            </button>\n        ',
    bindings: {
        onClick: '&',
        variant: '<',
        disabled: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 802 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AddressWithChanges = undefined;

__webpack_require__(804);

var AddressWithChanges = exports.AddressWithChanges = angular.module('checkout.components.addressWithChanges', []).component('addressWithChanges', {
    template: '\n        <div class="address__address">\n            <span ng-class="{\n                \'address__address-changed\':$ctrl.changes[\'address1\'],\n                \'address__address-changed--error\':$ctrl.asError && $ctrl.changes[\'address1\']\n            }">\n                {{$ctrl.changes[\'address1\'] || $ctrl.address.address1}}\n            </span>\n            <span ng-class="{\n                \'address__address-changed\':$ctrl.changes[\'address2\'],\n                \'address__address-changed--error\':$ctrl.asError && $ctrl.changes[\'address2\']\n            }">\n                {{$ctrl.changes[\'address2\'] || $ctrl.address.address2}}\n            </span>\n            <span ng-class="{\n                \'address__address-changed\':$ctrl.changes[\'city\'],\n                \'address__address-changed--error\':$ctrl.asError && $ctrl.changes[\'city\']\n            }">\n                {{$ctrl.changes[\'city\'] || $ctrl.address.city}}\n            </span>\n            <span ng-class="{\n                \'address__address-changed\':$ctrl.changes[\'state\'],\n                \'address__address-changed--error\':$ctrl.asError && $ctrl.changes[\'state\']\n            }">\n                {{$ctrl.changes[\'state\'] || $ctrl.address.state}}\n            </span>\n            <span ng-class="{\n                \'address__address-changed\':$ctrl.changes[\'country\'],\n                \'address__address-changed--error\':$ctrl.asError && $ctrl.changes[\'country\']\n            }">\n                {{$ctrl.changes[\'country\'] || $ctrl.address.country}}\n            </span>\n            <span ng-class="{\n                \'address__address-changed\':$ctrl.changes[\'postalCode\'],\n                \'address__address-changed--error\':$ctrl.asError && $ctrl.changes[\'postalCode\']\n            }">\n                {{$ctrl.changes[\'postalCode\'] || $ctrl.address.postalCode}}\n            </span>\n        </div>\n        ',
    bindings: {
        address: '<',
        changes: '<',
        asError: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 804 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 805 */
/***/ (function(module, exports) {

module.exports = "<div ng-if=\"$ctrl.contactInfo\" class=\"verification-contact-info\"> <div class=\"verification-contact-info__header\">Contact Info</div> <div class=\"verification-contact-info__email\">{{$ctrl.contactInfo.email}}</div> <div class=\"verification-contact-info__phone\">{{$ctrl.contactInfo.phone | vPhone}}</div> </div> <div ng-if=\"$ctrl.verifiedWithChanges\" class=\"verification-address\" layout=\"column\" layout-align=\"center stretch\"> <div class=\"verification-address__header\"> <md-icon>pin_drop</md-icon> Address Verification </div> <div class=\"verification-address__address verification-address__address--entered\" layout=\"column\" layout-align=\"center center\"> <div class=\"address__title\">You Entered</div> <div class=\"address__address\"> {{$ctrl.address.address1}} {{$ctrl.address.address2}} {{$ctrl.address.city}}, {{$ctrl.address.state}} {{$ctrl.address.country}} {{$ctrl.address.postalCode}} </div> <address-verification-button on-click=\"$ctrl.chooseEnteredAddress()\" disabled=\"$ctrl.loading\"> <span ng-if=\"!$ctrl.loading || !$ctrl.chooseEnteredAddressButtonClicked\">Use This Address</span> <md-progress-circular ng-if=\"$ctrl.loading && $ctrl.chooseEnteredAddressButtonClicked\" md-diameter=\"20\" md-mode=\"indeterminate\"> </md-progress-circular> </address-verification-button> <address-verification-button class=\"address-verification-edit-button\" variant=\"'text'\" on-click=\"$ctrl.editAddress()\"> Edit </address-verification-button> </div> <div class=\"verification-address__separator\"></div> <div class=\"verification-address__address verification-address__address--suggested\" layout=\"column\" layout-align=\"center center\"> <div class=\"address__title\">Suggested Address</div> <address-with-changes address=\"$ctrl.address\" changes=\"$ctrl.changes\"></address-with-changes> <address-verification-button on-click=\"$ctrl.chooseSuggestedAddress()\" disabled=\"$ctrl.loading\"> <span ng-if=\"!$ctrl.loading || !$ctrl.chooseSuggestedAddressButtonClicked\">Use This Address</span> <md-progress-circular ng-if=\"$ctrl.loading && $ctrl.chooseSuggestedAddressButtonClicked\" md-diameter=\"20\" md-mode=\"indeterminate\"> </md-progress-circular> </address-verification-button> </div> </div> <div ng-if=\"$ctrl.hasRecommendations\" class=\"verification-address\" layout=\"column\" layout-align=\"center stretch\"> <div class=\"verification-address__header\"> <md-icon>pin_drop</md-icon> This Address Cannot be Validated </div> <div class=\"verification-address__address\" layout=\"column\" layout-align=\"center center\" layout-align-xs=\"center stretch\"> <div class=\"address__title\" ng-repeat=\"recommendation in $ctrl.recommendations\"> {{recommendation}} <div ng-if=\"$ctrl.secondaryInfoNeeded()\" class=\"recommendation-note\"> (ex. Suite or Aparment number) </div> </div> <address-with-changes address=\"$ctrl.address\" changes=\"$ctrl.changes\" as-error=\"true\"></address-with-changes> <div layout=\"row\" layout-align=\"center center\" layout-xs=\"column\" layout-align-xs=\"center stretch\" disabled=\"$ctrl.loading\"> <address-verification-button on-click=\"$ctrl.editAddress()\"> Edit Original Address </address-verification-button> <address-verification-button on-click=\"$ctrl.chooseEnteredAddress()\" disabled=\"$ctrl.loading\"> <span ng-if=\"!$ctrl.loading\">Use Address As Is</span> <md-progress-circular ng-if=\"$ctrl.loading\" md-diameter=\"20\" md-mode=\"indeterminate\"> </md-progress-circular> </address-verification-button> </div> </div> </div> <div ng-if=\"$ctrl.notVerified\" class=\"verification-address\" layout=\"column\" layout-align=\"center stretch\"> <div class=\"verification-address__header\"> <md-icon>pin_drop</md-icon> This Address Cannot be Validated </div> <div class=\"verification-address__address\" layout=\"column\" layout-align=\"center center\" layout-align-xs=\"center stretch\"> <div class=\"address__title\"> The address you entered cannot be verified. </div> <div class=\"address__warning\"> *Address as is may not be deliverable </div> <address-with-changes address=\"$ctrl.address\" changes=\"$ctrl.changes\" as-error=\"true\"></address-with-changes> <div layout=\"row\" layout-align=\"center center\" layout-xs=\"column\" layout-align-xs=\"center stretch\"> <address-verification-button on-click=\"$ctrl.editAddress()\" variant=\"'text'\"> Edit Original Address </address-verification-button> <address-verification-button on-click=\"$ctrl.chooseEnteredAddress()\" variant=\"'primary'\"> Use Address As Is </address-verification-button> </div> </div> </div> ";

/***/ }),
/* 806 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports = "<address-form form-controller=\"$ctrl.shippingAddressForm\" model=\"$ctrl.model\" auto-complete-prefix=\"section-shipping shipping\" should-verify-address=\"$ctrl.useAddressVerification\" verified-message=\"'Your address has been verified for shipping accuracy'\"></address-form> <md-checkbox ng-model=\"$ctrl.model.shippingAsBilling\" aria-label=\"Use as billing address\" ng-if=\"!$ctrl.hideShippingAsBilling\"> Use as billing address </md-checkbox> ";

/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports = "<div layout-xs=\"column\" layout-gt-xs=\"row\" class=\"display-contact-and-delivery\"> <display-info flex-xs=\"100\" flex-gt-xs=\"50\" class=\"display-info-margin-fix\"> <display-info-title>Contact info</display-info-title> <display-info-content> <div>{{$ctrl.cart.contactInfo.email}}</div> <div ng-if=\"$ctrl.cart.contactInfo.phoneNumber\">{{$ctrl.cart.contactInfo.phoneNumber | vPhone}}</div> </display-info-content> </display-info> <display-info ng-if=\"$ctrl.isShippingRequired\" flex-xs=\"100\" flex-gt-xs=\"50\"> <display-info-title ng-if=\"!$ctrl.isShippingAddressVerified\">Shipping address</display-info-title> <display-info-verified ng-if=\"$ctrl.isShippingAddressVerified\"> <md-icon>check_circle_outline</md-icon> Verified Shipping address </display-info-verified> <display-info-content> <div class=\"display-contact-and-delivery__name\">{{$ctrl.cart.shippingAddress.firstName}} {{$ctrl.cart.shippingAddress.lastName}}</div> <div>{{$ctrl.cart.shippingAddress.address1}}</div> <div ng-if=\"$ctrl.cart.shippingAddress.address2\">{{$ctrl.cart.shippingAddress.address2}}</div> <div> {{$ctrl.cart.shippingAddress.city}}, <display-state-name country-code=\"$ctrl.cart.shippingAddress.country\" state-code=\"$ctrl.cart.shippingAddress.state\"> </display-state-name> {{$ctrl.cart.shippingAddress.postalCode}} </div> <display-country-name country-code=\"$ctrl.cart.shippingAddress.country\"> </display-country-name> </display-info-content> </display-info> <display-info ng-if=\"!$ctrl.isShippingRequired\" flex-xs=\"100\" flex-gt-xs=\"50\"> <display-info-title ng-if=\"!$ctrl.isShippingRequired && !$ctrl.isBillingAddressVerified\">Billing address</display-info-title> <display-info-title ng-if=\"!$ctrl.isShippingRequired && $ctrl.isBillingAddressVerified\">Verified Billing address</display-info-title> <display-info-content> <div class=\"display-contact-and-delivery__name\">{{$ctrl.cart.billingAddress.firstName}} {{$ctrl.cart.billingAddress.lastName}}</div> <div>{{$ctrl.cart.billingAddress.address1}}</div> <div ng-if=\"$ctrl.cart.billingAddress.address2\">{{$ctrl.cart.billingAddress.address2}}</div> <div> {{$ctrl.cart.billingAddress.city}}, <display-state-name country-code=\"$ctrl.cart.billingAddress.country\" state-code=\"$ctrl.cart.billingAddress.state\"> </display-state-name> {{$ctrl.cart.billingAddress.postalCode}} </div> <display-country-name country-code=\"$ctrl.cart.billingAddress.country\"> </display-country-name> </display-info-content> </display-info> </div> ";

/***/ }),
/* 809 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 810 */
/***/ (function(module, exports) {

module.exports = "<md-radio-group ng-model=\"$ctrl.selectedMethodIndex\" ng-disabled=\"$ctrl.disableForm\" class=\"shipping-method-form\" required> <md-radio-button ng-repeat=\"method in $ctrl.shippingMethods track by $index\" ng-value=\"{{$index}}\" class=\"md-primary shipping-method\" ng-if=\"$ctrl.shippingMethods && $ctrl.shippingMethods.length > 0\"> <div layout=\"row\" layout-align=\"space-between center\"> <div> <div layout=\"column\"> <div class=\"shipping-method__name\">{{method.name === '' ? 'Standard Shipping' : method.name}}</div> <div class=\"shipping-method__subtext\" ng-if=\"method.deliveryEstimate && method.name !== 'Curbside Pickup'\"> Arrives in: {{method.deliveryEstimate}} </div> <div class=\"shipping-method__subtext\" ng-if=\"method.name === 'Curbside Pickup'\"> {{method.pickupAddress.address1}} {{method.pickupAddress.address2}}<br hide-gt-xs> {{method.pickupAddress.city}}, {{method.pickupAddress.state}} </div> </div> </div> <div class=\"shipping-method__price\"> {{method.shippingPrice | vCurrency}} </div> </div> </md-radio-button> <div class=\"error-message\" ng-if=\"!$ctrl.shippingMethods || $ctrl.shippingMethods.length === 0\" layout=\"row\" layout-align=\"space-between center\"> <div> <md-icon class=\"error-message__icon\">error_outline</md-icon> </div> <div>The items in your cart cannot be shipped to your country or state. Please select another shipping address.</div> </div> </md-radio-group> ";

/***/ }),
/* 811 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 812 */
/***/ (function(module, exports) {

module.exports = "<display-info ng-if=\"$ctrl.shippingMethod\"> <display-info-title> <span>{{$ctrl.shippingMethod.name}}</span> <span ng-if=\"$ctrl.shippingMethod.shippingPrice\"> ({{$ctrl.shippingMethod.shippingPrice | vCurrency}}) </span> </display-info-title> <display-info-content> <div ng-if=\"$ctrl.shippingMethod.deliveryEstimate\"> {{$ctrl.shippingMethod.deliveryEstimate}} </div> </display-info-content> </display-info> <display-info ng-if=\"!$ctrl.shippingMethod\"> <display-info-title> <span>Free shipping</span> </display-info-title> <display-info-content></display-info-content> </display-info>";

/***/ }),
/* 813 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CartItem = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = __webpack_require__(16);

var _get2 = _interopRequireDefault(_get);

var _cartUtils = __webpack_require__(19);

var _imageCircle = __webpack_require__(206);

var _cartItem = __webpack_require__(816);

var _cartItem2 = _interopRequireDefault(_cartItem);

__webpack_require__(320);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CartItem = exports.CartItem = angular.module('checkout.components.orderSummary.cartItem', [_imageCircle.ImageCircle]).component('cartItem', {
    template: _cartItem2.default,
    bindings: {
        item: '<'
    },
    controller: function () {
        function CartItemCtrl() {
            _classCallCheck(this, CartItemCtrl);
        }

        _createClass(CartItemCtrl, [{
            key: '$onInit',
            value: function $onInit() {
                this.subtotal = (0, _cartUtils.getProductSubtotal)(this.item.product, this.item.quantity);
                this.itemIsOnSale = (0, _cartUtils.productIsOnSale)(this.item.product);
                this.listPrice = (0, _cartUtils.getProductListPrice)(this.item.product);
                if (this.itemIsOnSale) {
                    this.salePrice = (0, _cartUtils.getProductSalePrice)(this.item.product.pricing.salePrice);
                }

                this.setCartItemImage(this.item);
            }
        }, {
            key: 'setCartItemImage',
            value: function setCartItemImage(cartItem) {
                var imageLink = (0, _get2.default)(cartItem, 'product.imageMetadata.imageLink');
                if (imageLink) {
                    this.cartItemImage = imageLink.uriBase + 'w_80,h_80,c_fill/' + imageLink.imagePath;
                }
            }
        }]);

        return CartItemCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 815 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports = "<div layout=\"row\" class=\"cart-item\"> <image-circle image=\"$ctrl.cartItemImage\"></image-circle> <div flex> <div layout=\"column\"> <div class=\"cart-item__name\">{{$ctrl.item.product.name}}</div> <div class=\"cart-item__variants\" ng-if=\"$ctrl.item.product.variants.length\"> {{ $ctrl.item.product.variants.join(', ') }} </div> <div layout layout-align=\"space-between center\"> <span layout layout-align=\"start center\"> <span class=\"cart-item__qty\">Qty: {{$ctrl.item.quantity | number}}</span> <span class=\"cart-item__qty-x\">x</span> <span class=\"cart-item__list-price\" ng-class=\"{'cart-item__list-price--strikethrough': $ctrl.itemIsOnSale}\">{{$ctrl.listPrice | currency}}</span> <span class=\"cart-item__sale-price\" ng-if=\"$ctrl.itemIsOnSale\">{{$ctrl.salePrice | currency}}</span> </span> <div class=\"cart-item__price\">{{$ctrl.subtotal | currency}}</div> </div> </div> </div> </div> ";

/***/ }),
/* 817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OrderTotals = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = __webpack_require__(16);

var _get2 = _interopRequireDefault(_get);

var _vCurrency = __webpack_require__(818);

var _orderTotalsLineItem = __webpack_require__(819);

var _discountLineItems = __webpack_require__(821);

var _storeCreditLineItems = __webpack_require__(825);

var _cartUtils = __webpack_require__(19);

var _orderTotals = __webpack_require__(831);

var _orderTotals2 = _interopRequireDefault(_orderTotals);

__webpack_require__(832);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderTotals = exports.OrderTotals = angular.module('checkout.components.orderSummary.orderTotals', [_vCurrency.CurrencyFilter, _orderTotalsLineItem.OrderTotalsLineItem, _discountLineItems.DiscountLineItems, _storeCreditLineItems.StoreCreditLineItems]).component('orderTotals', {
    template: _orderTotals2.default,
    bindings: {
        cart: '<',
        storeCreditInfo: '<',
        appliedDiscount: '<',
        onRemovePromoClicked: '<',
        order: '<'
    },
    controller: function () {
        function OrderTotalsCtrl() {
            _classCallCheck(this, OrderTotalsCtrl);
        }

        _createClass(OrderTotalsCtrl, [{
            key: '$onChanges',
            value: function $onChanges(changesObj) {
                var cartItems = (0, _get2.default)(changesObj, 'cart.currentValue.items');
                if (cartItems) {
                    this.itemsTotal = (0, _cartUtils.getItemsTotal)(cartItems);
                }
            }
        }]);

        return OrderTotalsCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var CurrencyFilter = exports.CurrencyFilter = angular.module('checkout.filters.vCurrency', []).filter('vCurrency', ['$filter', '$locale', function ($filter, $locale) {
    return function (amount, currencySymbol) {
        var currency = $filter('currency');

        if (amount === 0) {
            return 'Free';
        }

        if ($locale.id === 'en-us' && amount < 0) {
            return currency(amount, currencySymbol).replace('(', '-').replace(')', '');
        }

        return currency(amount, currencySymbol);
    };
}]).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OrderTotalsLineItem = undefined;

__webpack_require__(820);

var OrderTotalsLineItem = exports.OrderTotalsLineItem = angular.module('checkout.components.orderSummary.orderTotalsLineItem', []).component('orderTotalsLineItem', {
    template: '\n            <div\n                layout \n                layout-align="space-between start"\n                class="order-totals-line-item"\n                ng-class="{\'order-totals-line-item--bold\': $ctrl.bold}">\n                <div class="order-totals-line-item__title">{{$ctrl.titleText}}</div>\n                <div class="order-totals-line-item__value">{{$ctrl.valueText || \'-\'}}</div>\n            </div>\n        ',
    bindings: {
        titleText: '@',
        valueText: '@',
        bold: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 820 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DiscountLineItems = undefined;

var _promoCodeLineItem = __webpack_require__(822);

var _discountLineItems = __webpack_require__(824);

var _discountLineItems2 = _interopRequireDefault(_discountLineItems);

__webpack_require__(322);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DiscountLineItems = exports.DiscountLineItems = angular.module('checkout.components.orderSummary.discountLineItems', [_promoCodeLineItem.PromoCodeLineItem]).component('discountLineItems', {
    template: _discountLineItems2.default,
    bindings: {
        cart: '<',
        appliedDiscount: '<',
        onRemovePromoClicked: '<',
        hideRemoveButton: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PromoCodeLineItem = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _inputContainer = __webpack_require__(37);

var _promoCodeLineItem = __webpack_require__(823);

var _promoCodeLineItem2 = _interopRequireDefault(_promoCodeLineItem);

__webpack_require__(321);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PromoCodeLineItem = exports.PromoCodeLineItem = angular.module('checkout.components.orderSummary.promoCodeLineItem', [_inputContainer.InputContainer]).component('promoCodeLineItem', {
    template: _promoCodeLineItem2.default,
    bindings: {
        appliedDiscount: '<',
        onRemovePromoClicked: '<',
        hideRemoveButton: '<'
    },
    controller: function () {
        function PromoCodeLineItemCtrl() {
            _classCallCheck(this, PromoCodeLineItemCtrl);
        }

        _createClass(PromoCodeLineItemCtrl, [{
            key: '$onInit',
            value: function $onInit() {
                this.codeRequired = this.appliedDiscount ? this.appliedDiscount.discount.criteria.requiresCouponCode : '';
                this.discountName = this.appliedDiscount.discount.name;
            }
        }, {
            key: 'onRemoveClicked',
            value: function onRemoveClicked(discountId) {
                var _this = this;

                this.isRemoving = true;
                this.onRemovePromoClicked(discountId).finally(function () {
                    _this.isRemoving = false;
                });
            }
        }]);

        return PromoCodeLineItemCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports = "<div layout layout-align=\"space-between start\" class=\"promo-code-line-item order-totals-line-item order-totals-line-item--promo\"> <div class=\"promo-code-line-item__label\" flex=\"70\" layout=\"row\"> <span class=\"order-totals-line-item--promo__name\">{{$ctrl.appliedDiscount.discount.name}}</span> <button type=\"button\" ng-click=\"$ctrl.onRemoveClicked($ctrl.appliedDiscount.discount.id)\" ng-if=\"!$ctrl.isRemoving && !$ctrl.hideRemoveButton && $ctrl.codeRequired\" class=\"checkout-button checkout-button--icon-only\"> <i class=\"material-icons\">close</i> </button> <md-progress-circular md-mode=\"indeterminate\" ng-if=\"$ctrl.isRemoving\" md-diameter=\"18\"></md-progress-circular> </div> <div class=\"order-totals-line-item__value\" flex=\"30\"> <span ng-if=\"$ctrl.appliedDiscount.discountAmount > 0\">-</span> <span>{{$ctrl.appliedDiscount.discountAmount | currency}}</span> </div> </div> ";

/***/ }),
/* 824 */
/***/ (function(module, exports) {

module.exports = "<div class=\"discount-line-items\"> <div ng-if=\"!$ctrl.cart.discounts[0].discount.criteria\" layout=\"row\"> <div flex=\"70\" class=\"order-totals-line-item__title\"> Discount: </div> <div flex=\"30\" class=\"order-totals-line-item__value order-totals-line-item__value--right\"> {{ $ctrl.cart.discountAmount | currency }} </div> </div> <div ng-if=\"$ctrl.cart.discounts[0].discount.criteria\"> <div class=\"order-totals-line-item__title\">Discount:</div> <div ng-repeat=\"discount in $ctrl.cart.discounts\"> <promo-code-line-item applied-discount=\"discount\" hide-remove-button=\"$ctrl.hideRemoveButton\" on-remove-promo-clicked=\"$ctrl.onRemovePromoClicked\" remove-discount-code-item=\"$ctrl.removeDiscountCodeItem\"> </promo-code-line-item> </div> </div> </div> ";

/***/ }),
/* 825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StoreCreditLineItems = undefined;

var _giftCardLineItem = __webpack_require__(826);

var _storeCreditLineItems = __webpack_require__(829);

var _storeCreditLineItems2 = _interopRequireDefault(_storeCreditLineItems);

__webpack_require__(830);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StoreCreditLineItems = exports.StoreCreditLineItems = angular.module('checkout.components.orderSummary.storeCreditLineItems', [_giftCardLineItem.GiftCardLineItem]).component('storeCreditLineItems', {
    template: _storeCreditLineItems2.default,
    bindings: {
        storeCreditInfo: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GiftCardLineItem = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _inputContainer = __webpack_require__(37);

var _giftCardLineItem = __webpack_require__(827);

var _giftCardLineItem2 = _interopRequireDefault(_giftCardLineItem);

__webpack_require__(828);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GiftCardLineItem = exports.GiftCardLineItem = angular.module('checkout.components.orderSummary.giftCardLineItem', [_inputContainer.InputContainer]).component('giftCardLineItem', {
    template: _giftCardLineItem2.default,
    bindings: {
        appliedStoreCredit: '<'
    },
    controller: function () {
        function GiftCardLineItemCtrl() {
            _classCallCheck(this, GiftCardLineItemCtrl);
        }

        _createClass(GiftCardLineItemCtrl, [{
            key: '$onInit',
            value: function $onInit() {
                var giftCardCode = this.appliedStoreCredit.giftCardCode;
                this.giftCardName = '****' + giftCardCode.slice(giftCardCode.length - 4).toUpperCase();
            }
        }]);

        return GiftCardLineItemCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 827 */
/***/ (function(module, exports) {

module.exports = "<div layout layout-align=\"space-between start\" class=\"order-totals-line-item order-totals-line-item--gift-card\"> <div class=\"gift-card-line-item__label\" flex=\"70\" layout=\"row\"> <span class=\"order-totals-line-item--gift-card__name\">{{$ctrl.giftCardName}}</span> </div> <div class=\"order-totals-line-item__value\" flex=\"30\"> <span>- {{($ctrl.appliedStoreCredit.amountUsedInCents) / 100 | currency}}</span> </div> </div> ";

/***/ }),
/* 828 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports = "<div class=\"store-credit-line-items\"> <div class=\"order-totals-line-item__title\">Gift Cards:</div> <div ng-repeat=\"storeCredit in $ctrl.storeCreditInfo.items\"> <gift-card-line-item applied-store-credit=\"storeCredit\"> </gift-card-line-item> </div> </div> ";

/***/ }),
/* 830 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports = "<div class=\"order-totals\"> <order-totals-line-item title-text=\"Items total:\" value-text=\"{{ $ctrl.itemsTotal | currency }}\"> </order-totals-line-item> <discount-line-items ng-if=\"$ctrl.cart.discounts.length > 0\" cart=\"$ctrl.cart\" hide-remove-button=\"$ctrl.order\" on-remove-promo-clicked=\"$ctrl.onRemovePromoClicked\"> </discount-line-items> <order-totals-line-item title-text=\"Shipping:\" value-text=\"{{ $ctrl.cart.shippingMethod.shippingCost | vCurrency }}\"> </order-totals-line-item> <order-totals-line-item title-text=\"Taxes:\" value-text=\"{{ $ctrl.cart.taxAmount | currency }}\"> </order-totals-line-item> <store-credit-line-items ng-if=\"$ctrl.storeCreditInfo.items.length > 0\" store-credit-info=\"$ctrl.storeCreditInfo\" hide-remove-button=\"$ctrl.order\"> </store-credit-line-items> <hr class=\"checkout-line\"> <order-totals-line-item title-text=\"Order total:\" value-text=\"{{ $ctrl.cart.grandTotal - ($ctrl.storeCreditInfo.storeCreditAmountInCents / 100) | currency }}\" bold=\"true\"> </order-totals-line-item> </div> ";

/***/ }),
/* 832 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 833 */
/***/ (function(module, exports) {

module.exports = "<div class=\"order-summary-collapsed\" layout layout-align=\"space-between center\"> <div layout layout-align=\"start center\"> <div layout layout-align=\"start center\"> <image-circle image=\"$ctrl.imageOne\"></image-circle> <image-circle ng-if=\"$ctrl.imageTwo\" image=\"$ctrl.imageTwo\"></image-circle> </div> <ng-pluralize class=\"order-summary-collapsed__num-of-items\" count=\"$ctrl.totalItems\" when=\"{'one': '1 item', 'other': '{} items'}\"> </ng-pluralize> </div> <div class=\"order-summary-collapsed__total\"> {{$ctrl.grandTotal | currency}} </div> </div> ";

/***/ }),
/* 834 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 835 */,
/* 836 */
/***/ (function(module, exports) {

module.exports = "<ng-form name=\"$ctrl.orderNotesForm\"> <input-container form-input=\"$ctrl.orderNotesForm.orderNotes\" flex> <label for=\"orderNotes\">Order notes</label> <textarea id=\"orderNotes\" name=\"orderNotes\" ng-model=\"$ctrl.orderNotesModel\" ng-model-options=\"{ debounce: { default: 500, blur: 0 }}\" ng-value=\"$ctrl.orderNotes\" ng-change=\"$ctrl.onOrderNotesChanged($ctrl.orderNotesModel)\" maxlength=\"300\" focus-if>\n        </textarea> <div ng-messages=\"$ctrl.orderNotesForm.orderNotes.$error\" role=\"alert\"> <div ng-message=\"maxlength\">Order notes must be less than 300 characters</div> </div> </input-container> </ng-form> ";

/***/ }),
/* 837 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 838 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 839 */
/***/ (function(module, exports) {

module.exports = "<ng-form name=\"$ctrl.promoCodeForm\" layout> <input-container form-input=\"$ctrl.promoCodeForm.promoCode\" flex class=\"input-container-no-padding\"> <label ng-if=\"$ctrl.isShippingRequired\" for=\"promoCode\">Promo code or gift card</label> <label ng-if=\"!$ctrl.isShippingRequired\" for=\"promoCode\">Promo code</label> <div layout=\"row\"> <input ng-model=\"$ctrl.promoCode\" ng-change=\"$ctrl.onPromoCodeInputChanged()\" id=\"promoCode\" name=\"promoCode\" type=\"text\" ng-readonly=\"$ctrl.isApplying\" focus-if> <button type=\"button\" class=\"checkout-button checkout-button--border\" ng-click=\"$ctrl.onApplyClicked()\" ng-if=\"!$ctrl.isRemovingPromo\" ng-disabled=\"$ctrl.isApplying\" flex=\"noshrink\"> <div layout layout-align=\"center center\"> <span ng-if=\"!$ctrl.isApplying\">Apply</span> <md-progress-circular md-mode=\"indeterminate\" ng-if=\"$ctrl.isApplying\" md-diameter=\"18\"></md-progress-circular> </div> </button> </div> <div class=\"checkout-input-errors\" ng-messages=\"$ctrl.promoCodeForm.promoCode.$error\"> <div ng-message=\"discountExists\">Code {{$ctrl.getViewValueFromFormError('discountExists')}} is not valid.</div> <div ng-message=\"discountExpired\">Promo code {{$ctrl.getViewValueFromFormError('discountExpired')}} has expired.</div> <div ng-message=\"inactiveGiftCard\">Gift card is not active.</div> <div ng-message=\"giftCardNotAllowed\">Gift cards cannot be used when purchasing a Gift Card.</div> <div ng-message=\"cannotAddMoreStoreCredit\">Your order currently has a $0.00 balance, additional gift cards cannot be applied.</div> <div ng-message=\"discountCodeExistsInCart\">Discount code has already been applied</div> <div ng-message=\"giftCardAlreadyApplied\">Gift card has already been applied to the order.</div> </div> </input-container> </ng-form> ";

/***/ }),
/* 840 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 841 */
/***/ (function(module, exports) {

module.exports = "<md-card class=\"checkout-card order-summary\" id=\"checkout-order-summary\"> <div ng-if=\"$ctrl.showCheckoutButton && $ctrl.collapsable\"> <continue-button ng-if=\"($ctrl.paymentMethod !== 'PayPal') || ($ctrl.paymentMethod === 'PayPal' && $ctrl.isReturnFromPaypal)\" is-disabled=\"$ctrl.checkoutButtonDisabled\" on-clicked=\"$ctrl.onCheckoutClicked()\"> Complete your order </continue-button> <checkout-with-paypal-sdk-summary-button ng-if=\"!$ctrl.isReturnFromPaypal && $ctrl.paymentMethod === 'PayPal'\" cart-id=\"$ctrl.cart.id\" bag-id=\"$ctrl.bag.id\"> </checkout-with-paypal-sdk-summary-button> </div> <div ng-click=\"$ctrl.openSummary()\" layout=\"column\" class=\"order-summary__header\"> <div layout layout-align=\"space-between center\"> <span class=\"checkout-card-heading\">Order Summary</span> <ng-pluralize ng-if=\"!$ctrl.collapsable\" class=\"order-summary__num-of-items\" count=\"$ctrl.cart.totalItems\" when=\"{'one': '1 item', 'other': '{} items'}\"> </ng-pluralize> <order-summary-toggle ng-if=\"$ctrl.collapsable\" collapsed=\"$ctrl.collapsed\"> </order-summary-toggle> </div> <order-summary-collapsed ng-if=\"$ctrl.collapsable && $ctrl.collapsed\" grand-total=\"$ctrl.cart.grandTotal\" total-items=\"$ctrl.cart.totalItems\" image-one=\"$ctrl.cart.items[0].product.imageMetadata.imageLink.fullUri\" image-two=\"$ctrl.cart.items[1].product.images[0].imageLink.fullUri\"> </order-summary-collapsed> </div> <md-card-content ng-if=\"($ctrl.collapsable && !$ctrl.collapsed) || !$ctrl.collapsable\"> <cart-item ng-repeat=\"item in $ctrl.cart.items\" item=\"item\"></cart-item> <div ng-if=\"!$ctrl.order\"> <hr class=\"checkout-line\"> <button class=\"checkout-button checkout-button--flat\" type=\"button\" ng-click=\"$ctrl.onShowPromoInputClicked()\" ng-if=\"!$ctrl.showPromoInput\"> <div layout layout-align=\"center center\"> <i class=\"material-icons\">local_offer</i> <span ng-if=\"$ctrl.isShippingRequired\">Add a promo code or gift card</span> <span ng-if=\"!$ctrl.isShippingRequired\">Add a promo code</span> </div> </button> <promo-code-form ng-if=\"$ctrl.showPromoInput\" promo-code-not-found=\"$ctrl.promoCodeNotFound\" promo-code-expired=\"$ctrl.promoCodeExpired\" inactive-gift-card=\"$ctrl.inactiveGiftCard\" gift-card-not-allowed=\"$ctrl.giftCardNotAllowed\" cannot-add-more-store-credit=\"$ctrl.cannotAddMoreStoreCredit\" gift-card-already-applied=\"$ctrl.giftCardAlreadyApplied\" on-apply-promo-clicked=\"$ctrl.onApplyPromoClicked\"> </promo-code-form> <gift-card-chips store-credit-info=\"$ctrl.storeCreditInfo\" remove-store-credit-item=\"$ctrl.removeStoreCreditItem\"> </gift-card-chips> </div> <hr class=\"checkout-line\"> <order-totals cart=\"$ctrl.cart\" store-credit-info=\"$ctrl.storeCreditInfo\" on-remove-promo-clicked=\"$ctrl.onRemovePromoClicked\" order=\"$ctrl.order\"> </order-totals> <hr class=\"checkout-line\"> <div ng-if=\"!$ctrl.order\"> <button class=\"checkout-button checkout-button--flat\" type=\"button\" ng-click=\"$ctrl.showOrderNotes = true\" ng-if=\"!$ctrl.showOrderNotes\"> <div layout layout-align=\"center center\"> <i class=\"material-icons\">mode_edit</i> <span>Need to leave us a note?</span> </div> </button> <order-notes on-order-notes-changed=\"$ctrl.onOrderNotesChanged\" order-notes=\"$ctrl.orderNotes\" ng-if=\"$ctrl.showOrderNotes\"></order-notes> </div> <div ng-if=\"$ctrl.order\" class=\"order-summary__order-placed\"> <display-info ng-if=\"$ctrl.order.shopperNote\"> <display-info-title>Order notes</display-info-title> <display-info-content>{{$ctrl.order.shopperNote}}</display-info-content> </display-info> <button class=\"checkout-button checkout-button--border checkout-button--large\" type=\"button\" ng-click=\"$ctrl.goToStorefront()\"> Continue shopping </button> </div> </md-card-content> </md-card> ";

/***/ }),
/* 842 */
/***/ (function(module, exports) {

module.exports = "<div class=\"gift-card-chips\"> <div ng-repeat=\"storeCredit in $ctrl.storeCreditInfo.items\"> <div class=\"chip-line\"> <div class=\"chip\"> <md-icon class=\"chip-icon\">card_giftcard</md-icon> &bullet;&bullet;&bullet;&bullet; {{storeCredit.giftCardCode.slice(storeCredit.giftCardCode.length - 4).toUpperCase()}} <span class=\"closebtn\" ng-click=\"$ctrl.onRemoveClicked(storeCredit.giftCardCode)\">&times;</span> </div> <div class=\"remaining\" ng-if=\"storeCredit.amountUsedInCents !== undefined\"> {{(storeCredit.balance - storeCredit.amountUsedInCents) / 100 | currency}} will be left </div> </div> </div> </div> ";

/***/ }),
/* 843 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DisplayDeliveryAndShipping = undefined;

var _displayInfo = __webpack_require__(81);

var _googleMap = __webpack_require__(845);

var _displayStateName = __webpack_require__(82);

var _displayCountryName = __webpack_require__(83);

var _displayDeliveryAndShipping = __webpack_require__(848);

var _displayDeliveryAndShipping2 = _interopRequireDefault(_displayDeliveryAndShipping);

__webpack_require__(849);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DisplayDeliveryAndShipping = exports.DisplayDeliveryAndShipping = angular.module('checkout.components.displayDeliveryAndShipping', [_displayInfo.DisplayInfo, _googleMap.GoogleMap, _displayStateName.DisplayStateName, _displayCountryName.DisplayCountryName]).component('displayDeliveryAndShipping', {
    template: _displayDeliveryAndShipping2.default,
    bindings: {
        order: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.GoogleMap = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(36);

var _googleMap = __webpack_require__(846);

var _googleMap2 = _interopRequireDefault(_googleMap);

__webpack_require__(847);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GoogleMap = exports.GoogleMap = angular.module('checkout.components.googleMap', ['app.constants']).component('googleMap', {
    template: _googleMap2.default,
    bindings: {
        address: '<'
    },
    controller: function () {
        GoogleMapCtrl.$inject = ['GOOGLE_STATIC_MAPS_KEY'];

        function GoogleMapCtrl(GOOGLE_STATIC_MAPS_KEY) {
            _classCallCheck(this, GoogleMapCtrl);

            this.GOOGLE_STATIC_MAPS_KEY = GOOGLE_STATIC_MAPS_KEY;
        }

        _createClass(GoogleMapCtrl, [{
            key: '$onInit',
            value: function $onInit() {
                var formattedAddress = this.address.address1 + ' ' + (this.address.address2 ? this.address.address2 : '') + ', ' + this.address.city + ', ' + this.address.state + ', ' + this.address.postalCode; // eslint-disable-line max-len
                var encodedAddress = encodeURIComponent(formattedAddress);
                this.mapImageUrl = 'https://maps.googleapis.com/maps/api/staticmap?center=' + encodedAddress + '&scale=2&zoom=14&size=600x125&maptype=roadmap&markers=' + encodedAddress + '&key=' + this.GOOGLE_STATIC_MAPS_KEY; // eslint-disable-line max-len
                this.mapLinkUrl = 'https://google.com/maps/place/' + formattedAddress;
            }
        }]);

        return GoogleMapCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 846 */
/***/ (function(module, exports) {

module.exports = "<a target=\"_blank\" ng-href=\"{{$ctrl.mapLinkUrl}}\" class=\"google-map\" style=\"background-image:url(&quot;{{$ctrl.mapImageUrl}}&quot;)\"></a> ";

/***/ }),
/* 847 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 848 */
/***/ (function(module, exports) {

module.exports = "<md-card class=\"checkout-card delivery-and-shipping\"> <google-map address=\"$ctrl.order.deliverTo.address\"></google-map> <md-card-title> <md-card-title-text> <span class=\"checkout-card-heading\">Delivery &amp; Shipping</span> </md-card-title-text> </md-card-title> <md-card-content> <display-info class=\"delivery-and-shipping__row\"> <display-info-title>Contact info</display-info-title> <display-info-content> <div>{{$ctrl.order.placedBy.emailAddress}}</div> <div>{{$ctrl.order.placedBy.phoneNumber | vPhone}}</div> </display-info-content> </display-info> <div layout-xs=\"column\" layout-gt-xs=\"row\"> <display-info flex-xs=\"100\" flex-gt-xs=\"50\" class=\"display-info-margin-fix\"> <display-info-title>Shipping address</display-info-title> <display-info-content> <div>{{$ctrl.order.deliverTo.firstName}} {{$ctrl.order.deliverTo.lastName}}</div> <div>{{$ctrl.order.deliverTo.address.address1}}</div> <div ng-if=\"$ctrl.order.deliverTo.address.address2\">{{$ctrl.order.deliverTo.address.address2}}</div> <div> {{$ctrl.order.deliverTo.address.city}}, <display-state-name country-code=\"$ctrl.order.deliverTo.address.country\" state-code=\"$ctrl.order.deliverTo.address.state\"> </display-state-name> {{$ctrl.order.deliverTo.address.postalCode}} </div> <display-country-name country-code=\"$ctrl.order.deliverTo.address.country\"> </display-country-name> </display-info-content> </display-info> <display-info flex-xs=\"100\" flex-gt-xs=\"50\"> <display-info-title>Shipping Method</display-info-title> <display-info-content> <div> <span>{{$ctrl.order.cart.shippingMethod.name}}</span> <span ng-if=\"$ctrl.order.cart.shippingMethod.shippingCost\"> ({{$ctrl.order.cart.shippingMethod.shippingCost | vCurrency}}) </span> </div> <div ng-if=\"$ctrl.order.cart.shippingMethod.deliveryEstimate\"> {{$ctrl.order.cart.shippingMethod.deliveryEstimate}} </div> </display-info-content> </display-info> </div> </md-card-content> </md-card> ";

/***/ }),
/* 849 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 850 */
/***/ (function(module, exports) {

module.exports = "<div layout-xs=\"column\" layout-gt-xs=\"row\" class=\"billing-and-payment\"> <display-info flex-xs=\"100\" flex-gt-xs=\"50\" class=\"display-info-margin-fix\" ng-if=\"$ctrl.address\"> <display-info-title>Billing address</display-info-title> <display-info-content> <div>{{$ctrl.address.firstName}} {{$ctrl.address.lastName}}</div> <div>{{$ctrl.address.address1}}</div> <div ng-if=\"$ctrl.address.address2\">{{$ctrl.address.address2}}</div> <div> {{$ctrl.address.city}}, <display-state-name country-code=\"$ctrl.address.country\" state-code=\"$ctrl.address.state\"> </display-state-name> {{$ctrl.address.postalCode}} </div> <display-country-name country-code=\"$ctrl.address.country\"> </display-country-name> </display-info-content> </display-info> <display-info flex-xs=\"100\" flex-gt-xs=\"50\"> <display-info-title>Payment method</display-info-title> <display-info-content> <div ng-if=\"!$ctrl.paymentRequests && $ctrl.paymentMethod === 'Cash'\">Cash</div> <div ng-if=\"!$ctrl.paymentRequests && $ctrl.paymentMethod === 'Credit Card'\" layout layout-align=\"start center\"> <credit-card-image card-type=\"$ctrl.creditCardType\"></credit-card-image> <span>{{$ctrl.creditCardType}} ending in {{$ctrl.creditCardLastFour}}</span> </div> <div ng-if=\"!$ctrl.paymentRequests && $ctrl.paymentMethod === 'PayPal'\" class=\"billing-and-payment__paypal\"> <img src=\"//d3dl6qv39aj0xv.cloudfront.net/assets/payment/paypal_logo.svg\" height=\"20px\" alt=\"PayPal\"/> <div>{{$ctrl.paypalEmail}}</div> </div> <div ng-if=\"!!$ctrl.paymentRequests\" ng-repeat=\"payment in $ctrl.paymentRequests\"> <div ng-if=\"payment.type === 'StoreCredit'\">Gift Card ****{{payment.paymentDetails.transaction.giftCardLastFour}} - ${{payment.amount}}</div> <div ng-if=\"payment.type === 'Cash'\">Cash - ${{payment.amount}}</div> <div ng-if=\"payment.paymentDetails.creditCardType && payment.paymentDetails.creditCardLastFour\"> <credit-card-image card-type=\"payment.paymentDetails.creditCardType\"></credit-card-image> <span>{{payment.paymentDetails.creditCardType}} ending in {{payment.paymentDetails.creditCardLastFour}} - ${{payment.amount}}</span> </div> <div ng-if=\"payment.type === 'PayPal' && !payment.paymentDetails.creditCardType && !payment.paymentDetails.creditCardLastFour\" class=\"billing-and-payment__paypal\"> <img src=\"//d3dl6qv39aj0xv.cloudfront.net/assets/payment/paypal_logo.svg\" height=\"20px\" alt=\"PayPal\"/> <div>{{payment.paymentDetails.emailAddress}} - ${{payment.amount}}</div> </div> </div> </display-info-content> </display-info> </div> ";

/***/ }),
/* 851 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.StoreLogo = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(853);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var StoreLogo = exports.StoreLogo = angular.module('checkout.components.storeLogo', []).component('storeLogo', {
    template: '\n            <a ng-href="{{$ctrl.linkUrl}}" class="store-logo">\n                <img ng-if="$ctrl.logo" ng-src="{{$ctrl.logo}}" class="store-logo__image" />\n                <span ng-if="$ctrl.storeName" class="store-logo__name">{{$ctrl.storeName}}</span>\n            </a>\n        ',
    bindings: {
        storeInfo: '<',
        linkUrl: '<'
    },
    controller: function () {
        function StoreLogoCtrl() {
            _classCallCheck(this, StoreLogoCtrl);
        }

        _createClass(StoreLogoCtrl, [{
            key: '$onInit',
            value: function $onInit() {
                if (this.storeInfo && this.storeInfo.logo && this.storeInfo.logo.imageLink && this.storeInfo.logo.imageLink.fullUri) {
                    this.logo = this.storeInfo.logo.imageLink.fullUri;
                } else {
                    this.storeName = this.storeInfo.name;
                }
            }
        }]);

        return StoreLogoCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 853 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SecureLabel = undefined;

__webpack_require__(855);

var SecureLabel = exports.SecureLabel = angular.module('checkout.components.secureLabel', []).component('secureLabel', {
    template: '\n            <div class="secure-label" layout="row" layout-align="center center">\n                <div>\n                    <md-icon>lock</md-icon>\n                    <span>Safe &amp; secure checkout</span>\n                </div>\n            </div>\n        '
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 855 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 856 */
/***/ (function(module, exports) {

module.exports = "<div layout layout-align=\"space-between center\" class=\"logout-button\"> <span class=\"logout-button__message\" ng-class=\"{'logout-button__message--small': $ctrl.smallWelcomeText}\"> Welcome back, {{$ctrl.nameText}}. </span> <button type=\"buton\" ng-click=\"$ctrl.onLogoutClicked()\" class=\"logout-button__message-2\"> Not you? Sign out </button> </div> ";

/***/ }),
/* 857 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 858 */
/***/ (function(module, exports) {

module.exports = "<div class=\"checkout-header\"> <a ng-href=\"{{$ctrl.returnUrl}}\" class=\"checkout-header__continue-shopping-button checkout-button checkout-button--flat\"> <div layout layout-align=\"center center\"> <i class=\"material-icons\">arrow_back</i> <span class=\"checkout-header__continue-shopping-button-text\">Continue shopping</span> </div> </a> <div layout=\"column\" layout-align=\"center center\" class=\"checkout-header__inner\"> <store-logo store-info=\"$ctrl.storeInfo\" link-url=\"$ctrl.returnUrl\"></store-logo> <secure-label ng-if=\"!$ctrl.isLoggedIn\"></secure-label> <logout-button ng-if=\"$ctrl.isLoggedIn\" name-text=\"$ctrl.loggedInShopperName\" use-new-carts=\"$ctrl.useNewCarts\"></logout-button> </div> </div> ";

/***/ }),
/* 859 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 860 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CreateAccount = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _continueButton = __webpack_require__(130);

var _inputContainer = __webpack_require__(37);

var _validationRequirement = __webpack_require__(862);

var _createAccount = __webpack_require__(865);

var _createAccount2 = _interopRequireDefault(_createAccount);

__webpack_require__(866);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CreateAccount = exports.CreateAccount = angular.module('checkout.components.createAccount', [_continueButton.ContinueButton, _inputContainer.InputContainer, _validationRequirement.ValidationRequirement]).component('createAccount', {
    template: _createAccount2.default,
    bindings: {
        showLoader: '<',
        showAccountCreatedMessage: '<',
        onDismissClicked: '&',
        onFormSubmit: '&'
    },
    controller: function () {
        function CreateAccountCtrl() {
            _classCallCheck(this, CreateAccountCtrl);
        }

        _createClass(CreateAccountCtrl, [{
            key: 'onPasswordInputFocused',
            value: function onPasswordInputFocused() {
                this.passwordInputFocused = true;
            }
        }, {
            key: 'onPasswordInputBlurred',
            value: function onPasswordInputBlurred() {
                this.passwordInputFocused = false;
            }
        }]);

        return CreateAccountCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ValidationRequirement = undefined;

var _validationRequirement = __webpack_require__(863);

var _validationRequirement2 = _interopRequireDefault(_validationRequirement);

__webpack_require__(864);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ValidationRequirement = exports.ValidationRequirement = angular.module('checkout.components.validationRequirement', []).component('validationRequirement', {
    template: _validationRequirement2.default,
    bindings: {
        isInvalid: '<',
        validationMessage: '@'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 863 */
/***/ (function(module, exports) {

module.exports = "<div class=\"validation-requirement\" ng-class=\"{ 'validation-requirement--valid': !$ctrl.isInvalid }\"> <div class=\"validation-requirement__icon\"> <md-icon ng-if=\"$ctrl.isInvalid\"> clear </md-icon> <md-icon ng-if=\"!$ctrl.isInvalid\"> done </md-icon> </div> <div class=\"validation-requirement__text\"> {{ $ctrl.validationMessage }} </div> </div> ";

/***/ }),
/* 864 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 865 */
/***/ (function(module, exports) {

module.exports = "<md-card class=\"checkout-card create-account\"> <md-card-title> <md-card-title-text> <span class=\"checkout-card-heading\"> <span ng-if=\"!$ctrl.showAccountCreatedMessage\">Create an account</span> <span ng-if=\"$ctrl.showAccountCreatedMessage\">Account created</span> </span> </md-card-title-text> </md-card-title> <md-card-content> <div ng-if=\"!$ctrl.showAccountCreatedMessage\"> <p>Enter a password to be able to log in later and see order information.</p> <form name=\"$ctrl.accountForm\" ng-submit=\"$ctrl.onFormSubmit({ password: $ctrl.password })\"> <input-container form-input=\"$ctrl.accountForm.password\"> <div layout layout-align=\"start end\"> <div flex flex-gt-xs=\"50\"> <label for=\"password\">Password</label> <input ng-model=\"$ctrl.password\" id=\"password\" name=\"password\" type=\"password\" ng-minlength=\"8\" ng-pattern=\"/^(?=\\S*[a-z])(?=\\S*[A-Z])(?=\\S*\\d)(?=\\S*([^\\w\\s]|[_]))\\S{8,}$/\" ng-focus=\"$ctrl.onPasswordInputFocused()\" ng-blur=\"$ctrl.onPasswordInputBlurred()\" required> </div> <continue-button button-type=\"submit\" is-disabled=\"$ctrl.accountForm.$invalid\" is-loading=\"$ctrl.showLoader\" spinner-size=\"15\"> Create <span hide-xs>your </span>account </continue-button> </div> </input-container> </form> <div role=\"alert\" ng-if=\"$ctrl.passwordInputFocused || $ctrl.accountForm.password.$dirty\"> <validation-requirement is-invalid=\"$ctrl.accountForm.password.$error.minlength || $ctrl.accountForm.password.$error.required\" validation-message=\"Password must be at least 8 characters\"> </validation-requirement> <validation-requirement is-invalid=\"$ctrl.accountForm.password.$error.pattern || $ctrl.accountForm.password.$error.required\" validation-message=\"Password must contain one capital letter, one number, and one special character\"> </validation-requirement> </div> </div> <div ng-if=\"$ctrl.showAccountCreatedMessage\" class=\"create-account__created\"> <p>Your delivery and payment information has been saved. Use the email address in the confirmation above when signing in on your next visit.</p> <button class=\"checkout-button checkout-button--border\" type=\"button\" ng-click=\"$ctrl.onDismissClicked()\"> Dismiss this message </button> </div> </md-card-content> </md-card> ";

/***/ }),
/* 866 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ThankYouConfirmation = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _thankYouConfirmation = __webpack_require__(868);

var _thankYouConfirmation2 = _interopRequireDefault(_thankYouConfirmation);

__webpack_require__(869);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ThankYouConfirmation = exports.ThankYouConfirmation = angular.module('checkout.components.thankYouConfirmation', []).component('thankYouConfirmation', {
    template: _thankYouConfirmation2.default,
    bindings: {
        order: '<'
    },
    controller: function () {
        ThankYouConfirmationCtrl.$inject = ['$window'];

        function ThankYouConfirmationCtrl($window) {
            _classCallCheck(this, ThankYouConfirmationCtrl);

            this.$window = $window;
        }

        _createClass(ThankYouConfirmationCtrl, [{
            key: 'print',
            value: function print() {
                this.$window.print();
            }
        }]);

        return ThankYouConfirmationCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 868 */
/***/ (function(module, exports) {

module.exports = "<md-card class=\"checkout-card thank-you-confirmation\"> <md-card-content> <md-icon class=\"thank-you-confirmation__icon\">check</md-icon> <div class=\"thank-you-confirmation__title\">Thank you for your order</div> <div class=\"thank-you-confirmation__confirmation-email\"> <div>A confirmation email has been sent to</div> <div>{{$ctrl.order.placedBy.emailAddress}}</div> </div> <div class=\"thank-you-confirmation__order-number\">Your order number is: {{$ctrl.order.orderNumber}}</div> <button type=\"button\" class=\"checkout-button thank-you-confirmation__print\" ng-click=\"$ctrl.print()\"> <div layout layout-align=\"start center\"> <i class=\"material-icons\">receipt</i> <span>View and save your receipt</span> </div> </button> </md-card-content> </md-card> ";

/***/ }),
/* 869 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 870 */
/***/ (function(module, exports) {

module.exports = "<header-background store-info=\"$ctrl.storeInfo\"> <div class=\"checkout\"> <checkout-header store-info=\"$ctrl.storeInfo\" is-logged-in=\"$ctrl.isLoggedIn\" return-url=\"$ctrl.returnUrl\"> </checkout-header> <div layout=\"column\" layout-gt-sm=\"row\" class=\"thank-you\"> <div flex=\"100\" flex-gt-sm=\"60\"> <thank-you-confirmation order=\"$ctrl.order\"></thank-you-confirmation> <order-summary hide-gt-sm flex=\"100\" cart=\"$ctrl.order.cart\" order=\"$ctrl.order\" return-url=\"$ctrl.returnUrl\"> </order-summary> <create-account ng-if=\"$ctrl.showCreateAccount && !$ctrl.createAccountDismissed\" show-loader=\"$ctrl.creatingAccount\" on-form-submit=\"$ctrl.onCreateAccountFormSubmit(password)\" on-dismiss-clicked=\"$ctrl.onCreateAccountDismissClicked()\" show-account-created-message=\"$ctrl.showAccountCreatedMessage\"> </create-account> <display-delivery-and-shipping order=\"$ctrl.order\"></display-delivery-and-shipping> <md-card class=\"checkout-card\"> <md-card-title> <md-card-title-text> <span class=\"checkout-card-heading\">Payment</span> </md-card-title-text> </md-card-title> <md-card-content> <display-billing-and-payment payment-method=\"$ctrl.order.paymentMethod\" credit-card-type=\"$ctrl.order.creditCardType\" credit-card-last-four=\"$ctrl.order.creditCardLastFour\" order-placed-by=\"$ctrl.order.placedBy\" paypal-email=\"$ctrl.order.placedBy.emailAddress\" payment-requests=\"$ctrl.order.paymentRequests\"> </display-billing-and-payment> </md-card-content> </md-card> </div> <order-summary hide-xs hide-sm flex-gt-sm=\"40\" cart=\"$ctrl.order.cart\" order=\"$ctrl.order\" store-credit-info=\"$ctrl.storeCreditInfo\" return-url=\"$ctrl.returnUrl\"> </order-summary> </div> </div> </header-background> ";

/***/ }),
/* 871 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 872 */
/***/ (function(module, exports) {

module.exports = "<md-dialog-content class=\"md-dialog-content\"> <div layout layout-align=\"space-between center\" class=\"checkout-modal__header\"> <div class=\"checkout-card-heading\">Shipping Method</div> <md-button ng-click=\"$ctrl.cancel()\" class=\"md-icon-button\"> <md-icon>close</md-icon> </md-button> </div> <ng-form name=\"$ctrl.editShippingMethodForm\"> <shipping-method-form shipping-methods=\"$ctrl.availableShippingMethods\" selected-method-index=\"$ctrl.selectedShippingMethodIndex\" disable-form=\"$ctrl.isUpdatingCart\"> </shipping-method-form> </ng-form> </md-dialog-content> <md-dialog-actions layout=\"column\" layout-gt-xs=\"row\" class=\"checkout-modal__footer\"> <button class=\"checkout-button checkout-button--border checkout-button--large\" type=\"button\" ng-click=\"$ctrl.cancel()\" flex flex-gt-xs=\"nogrow\"> Cancel </button> <continue-button is-disabled=\"$ctrl.isUpdatingCart\" is-loading=\"$ctrl.isUpdatingCart\" on-clicked=\"$ctrl.save()\" flex flex-gt-xs=\"nogrow\" flex-order=\"-1\" flex-order-gt-xs=\"0\"> Save changes </continue-button> </md-dialog-actions> ";

/***/ }),
/* 873 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 874 */
/***/ (function(module, exports) {

module.exports = "<md-dialog-content class=\"md-dialog-content\"> <div layout layout-align=\"space-between center\" class=\"checkout-modal__header\"> <div class=\"checkout-card-heading\">Contact &amp; Delivery</div> <md-button ng-click=\"$ctrl.cancel()\" class=\"md-icon-button\"> <md-icon>close</md-icon> </md-button> </div> <ng-form name=\"$ctrl.contactAndDeliveryForm\" ng-if=\"!$ctrl.showAddressSuggestion\"> <div layout layout-align=\"space-between center\"> <h3 class=\"checkout-section-heading\">Contact info</h3> <login-button on-login-clicked=\"$ctrl.onLoginClicked()\" ng-if=\"!$ctrl.isLoggedIn\"></login-button> </div> <contact-info-form model=\"$ctrl.contactInfoModel\" phone-number-required=\"$ctrl.phoneNumberRequired\" email-input-disabled=\"$ctrl.isLoggedIn\"> </contact-info-form> <hr> <h3 class=\"checkout-section-heading\" ng-if=\"$ctrl.isShippingRequired\">Shipping address</h3> <h3 class=\"checkout-section-heading\" ng-if=\"!$ctrl.isShippingRequired\">Billing address</h3> <shipping-address-form model=\"$ctrl.shippingAddressModel\" use-address-verification=\"$ctrl.useAddressVerification\" hide-shipping-as-billing=\"!$ctrl.showShippingAsBilling\"> </shipping-address-form> </ng-form> <address-verification-form ng-if=\"$ctrl.showAddressSuggestion\" contact-info=\"$ctrl.contactInfoModel\" address=\"$ctrl.shippingAddressModel\" recommendations=\"$ctrl.addressRecommendations\" changes=\"$ctrl.addressChanges\" on-choose-address=\"$ctrl.updateAddress\" loading=\"$ctrl.isUpdatingCart\"/> </md-dialog-content> <md-dialog-actions ng-if=\"!$ctrl.showAddressSuggestion\" layout=\"column\" layout-gt-xs=\"row\" class=\"checkout-modal__footer\"> <button class=\"checkout-button checkout-button--border checkout-button--large\" type=\"button\" ng-click=\"$ctrl.cancel()\" flex flex-gt-xs=\"nogrow\"> Cancel </button> <continue-button is-disabled=\"$ctrl.isUpdatingCart\" is-loading=\"$ctrl.isUpdatingCart\" on-clicked=\"$ctrl.save()\" flex flex-gt-xs=\"nogrow\" flex-order=\"-1\" flex-order-gt-xs=\"0\"> Save changes </continue-button> </md-dialog-actions> ";

/***/ }),
/* 875 */
/***/ (function(module, exports) {

module.exports = "<div layout layout-align=\"start center\" class=\"login-button\"> <span hide-xs>Already have an account?</span> <button type=\"button\" class=\"checkout-button checkout-button--border\" ng-click=\"$ctrl.onLoginClicked()\"> Sign in </button> </div> ";

/***/ }),
/* 876 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 877 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AddShippingAddress = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _checkout = __webpack_require__(18);

var _api = __webpack_require__(14);

var _addressVerification = __webpack_require__(79);

var _addressForm = __webpack_require__(54);

var _saveAndCancel = __webpack_require__(95);

var _addressVerificationForm = __webpack_require__(135);

var _addShippingAddress = __webpack_require__(880);

var _addShippingAddress2 = _interopRequireDefault(_addShippingAddress);

__webpack_require__(881);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AddShippingAddress = exports.AddShippingAddress = angular.module('checkout.components.editAccountContactAndDelivery.addShippingAddress', [_addressVerificationForm.AddressVerificationForm, _addressVerification.AddressVerificationService, _checkout.CheckoutService, _api.ApiService, _addressForm.AddressForm, _saveAndCancel.SaveAndCancel]).component('addShippingAddress', {
    template: _addShippingAddress2.default,
    bindings: {
        onAddressSaved: '<',
        onCancelClicked: '&',
        isShippingRequired: '<',
        useAddressVerification: '<',
        useNewCarts: '<'
    },
    controller: function () {
        AddShippingAddressCtrl.$inject = ['apiService', 'checkoutService', 'addressVerificationService'];

        function AddShippingAddressCtrl(apiService, checkoutService, addressVerificationService) {
            _classCallCheck(this, AddShippingAddressCtrl);

            this.apiService = apiService;
            this.checkoutService = checkoutService;
            this.addressVerificationService = addressVerificationService;

            this.updateAddress = this.updateAddress.bind(this);
        }

        _createClass(AddShippingAddressCtrl, [{
            key: '$onInit',
            value: function $onInit() {
                this.address = { address: {} };
            }
        }, {
            key: 'onSaveClicked',
            value: function onSaveClicked() {
                var _this = this;

                if (this.addShippingAddressForm.$invalid) {
                    this.checkoutService.forceFormValidation(this.addShippingAddressForm['$ctrl.addressForm']);
                    return;
                }
                this.isAddressSaving = true;

                if (this.useNewCarts && this.useAddressVerification) {
                    this.addressVerificationService.verifyAddress(this.address.address).then(function (_ref) {
                        var verified = _ref.verified,
                            changes = _ref.changes,
                            recommendations = _ref.recommendations;

                        if (!verified || changes) {
                            _this.isAddressSaving = false;

                            _this.showAddressSuggestion = true;
                            _this.addressRecommendations = recommendations;
                            _this.addressChanges = changes;
                        } else {
                            _this.updateShippingAddress();
                        }
                    });
                } else {
                    this.updateShippingAddress();
                }
            }
        }, {
            key: 'updateAddress',
            value: function updateAddress(newAddress) {
                this.showAddressSuggestion = false;
                this.addressRecommendations = null;
                this.addressChanges = null;

                if (newAddress) {
                    this.address.address = _extends({}, this.address.address, newAddress);
                    this.isAddressSaving = true;
                    this.updateShippingAddress();
                }
            }
        }, {
            key: 'updateShippingAddress',
            value: function updateShippingAddress() {
                var _this2 = this;

                this.apiService.account.shippingAddress.add(this.address).then(function (address) {
                    return _this2.onAddressSaved(address);
                }).finally(function () {
                    _this2.isAddressSaving = false;
                });
            }
        }]);

        return AddShippingAddressCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 879 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 880 */
/***/ (function(module, exports) {

module.exports = "<div class=\"add-shipping-address\"> <div layout=\"row\" layout-align=\"start center\"> <div flex> <md-radio-button flex ng-value=\"'new'\" class=\"md-primary\"> <span class=\"edit-account-label\">New address</span> </md-radio-button> </div> <div> <save-and-cancel on-save-clicked=\"$ctrl.onSaveClicked()\" on-cancel-clicked=\"$ctrl.onCancelClicked()\" show-save-loader=\"$ctrl.isAddressSaving\"> </save-and-cancel> </div> </div> <div ng-if=\"!$ctrl.useNewCarts || !$ctrl.showAddressSuggestion\" class=\"checkout-left-padding\"> <ng-form name=\"$ctrl.addShippingAddressForm\"> <address-form model=\"$ctrl.address.address\" auto-complete-prefix=\"new-address\"></address-form> <div class=\"add-shipping-address__actions\"> <md-checkbox ng-if=\"$ctrl.isShippingRequired\" ng-model=\"$ctrl.address.address.isDefault\" aria-label=\"Set as default shipping address\"> Set as default shipping address </md-checkbox> </div> </ng-form> </div> <address-verification-form ng-if=\"$ctrl.useNewCarts && $ctrl.showAddressSuggestion\" address=\"$ctrl.address.address\" recommendations=\"$ctrl.addressRecommendations\" changes=\"$ctrl.addressChanges\" on-choose-address=\"$ctrl.updateAddress\"/> </div> ";

/***/ }),
/* 881 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SavedShippingAddress = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _api = __webpack_require__(14);

var _addressVerificationForm = __webpack_require__(135);

var _addressVerification = __webpack_require__(79);

var _checkout = __webpack_require__(18);

var _badge = __webpack_require__(883);

var _addressForm = __webpack_require__(54);

var _saveAndCancel = __webpack_require__(95);

var _displayStateName = __webpack_require__(82);

var _displayCountryName = __webpack_require__(83);

var _savedShippingAddress = __webpack_require__(885);

var _savedShippingAddress2 = _interopRequireDefault(_savedShippingAddress);

__webpack_require__(886);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SavedShippingAddress = exports.SavedShippingAddress = angular.module('checkout.components.editAccountContactAndDelivery.savedShippingAddress', [_addressVerificationForm.AddressVerificationForm, _addressVerification.AddressVerificationService, _api.ApiService, _checkout.CheckoutService, _badge.Badge, _addressForm.AddressForm, _saveAndCancel.SaveAndCancel, _displayStateName.DisplayStateName, _displayCountryName.DisplayCountryName]).component('savedShippingAddress', {
    template: _savedShippingAddress2.default,
    bindings: {
        address: '<',
        onAddressEdited: '<',
        onAddressDeleted: '<',
        showDeleteButton: '<',
        isShippingRequired: '<',
        useAddressVerification: '<',
        useNewCarts: '<'
    },
    controller: function () {
        SavedShippingAddressCtrl.$inject = ['addressVerificationService', 'apiService', 'checkoutService', '$rootScope'];

        function SavedShippingAddressCtrl(addressVerificationService, apiService, checkoutService, $rootScope) {
            _classCallCheck(this, SavedShippingAddressCtrl);

            this.addressVerificationService = addressVerificationService;
            this.apiService = apiService;
            this.checkoutService = checkoutService;
            this.$rootScope = $rootScope;

            this.updateAddress = this.updateAddress.bind(this);
        }

        _createClass(SavedShippingAddressCtrl, [{
            key: '$onInit',
            value: function $onInit() {
                var _this = this;

                this.unbindListener = this.$rootScope.$on('editAccountContactAndDelivery:Editing', function (event, data) {
                    if (data !== _this.address.id) {
                        _this.clearAddressSuggestions();
                        _this.onCancelClicked();
                    }
                });
            }
        }, {
            key: '$onDestroy',
            value: function $onDestroy() {
                this.unbindListener();
            }
        }, {
            key: '$onChanges',
            value: function $onChanges(changesObj) {
                if (changesObj.address && !changesObj.address.isFirstChange()) {
                    this.setAddressModel(changesObj.address.currentValue);
                }
            }
        }, {
            key: 'setAddressModel',
            value: function setAddressModel(address) {
                this.addressModel = angular.copy(address);
            }
        }, {
            key: 'onEditClicked',
            value: function onEditClicked() {
                this.isEditing = true;
                this.setAddressModel(this.address);
                this.$rootScope.$emit('editAccountContactAndDelivery:Editing', this.address.id);
            }
        }, {
            key: 'onCancelClicked',
            value: function onCancelClicked() {
                this.isEditing = false;
                this.showAddressSuggestion = false;
                this.addressRecommendations = null;
                this.addressChanges = null;
                this.setAddressModel(this.address);
            }
        }, {
            key: 'onSaveClicked',
            value: function onSaveClicked() {
                var _this2 = this;

                if (this.editShippingAddressForm.$invalid) {
                    this.checkoutService.forceFormValidation(this.editShippingAddressForm['$ctrl.addressForm']);
                    return;
                }
                this.addressSaving = true;

                if (this.useNewCarts && this.useAddressVerification) {
                    this.addressVerificationService.verifyAddress(this.addressModel.address).then(function (_ref) {
                        var verified = _ref.verified,
                            changes = _ref.changes,
                            recommendations = _ref.recommendations;

                        if (!verified || changes) {
                            _this2.addressSaving = false;

                            _this2.showAddressSuggestion = true;
                            _this2.addressRecommendations = recommendations;
                            _this2.addressChanges = changes;
                        } else {
                            _this2.updateShippingAddress();
                        }
                    });
                } else {
                    this.updateShippingAddress();
                }
            }
        }, {
            key: 'onDeleteClicked',
            value: function onDeleteClicked() {
                this.showDeleteConfirm = true;
            }
        }, {
            key: 'onCancelDeleteClicked',
            value: function onCancelDeleteClicked() {
                this.showDeleteConfirm = false;
            }
        }, {
            key: 'onConfirmDeleteClicked',
            value: function onConfirmDeleteClicked() {
                var _this3 = this;

                this.isDeleting = true;
                this.apiService.account.shippingAddress.delete(this.addressModel.id).then(function () {
                    return _this3.onAddressDeleted();
                }).finally(function () {
                    _this3.isDeleting = false;
                    _this3.showDeleteConfirm = false;
                });
            }
        }, {
            key: 'updateAddress',
            value: function updateAddress(newAddress) {
                this.clearAddressSuggestions();

                if (newAddress) {
                    this.addressModel.address = _extends({}, this.addressModel.address, newAddress);
                    this.addressSaving = true;
                    this.updateShippingAddress();
                }
            }
        }, {
            key: 'updateShippingAddress',
            value: function updateShippingAddress() {
                var _this4 = this;

                this.apiService.account.shippingAddress.update(this.addressModel.id, this.addressModel).then(function () {
                    return _this4.onAddressEdited().then(function () {
                        _this4.isEditing = false;
                    });
                }).finally(function () {
                    _this4.addressSaving = false;
                });
            }
        }, {
            key: 'clearAddressSuggestions',
            value: function clearAddressSuggestions() {
                this.showAddressSuggestion = false;
                this.addressRecommendations = null;
                this.addressChanges = null;
            }
        }]);

        return SavedShippingAddressCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Badge = undefined;

__webpack_require__(884);

var Badge = exports.Badge = angular.module('checkout.components.badge', []).component('badge', {
    transclude: true,
    template: '<ng-transclude></ng-transclude>'
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 884 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 885 */
/***/ (function(module, exports) {

module.exports = "<div class=\"saved-shipping-address\"> <div layout=\"row\" layout-align=\"start center\"> <div flex> <md-radio-button flex ng-value=\"$ctrl.address.id\" class=\"md-primary\"> <div ng-if=\"!$ctrl.isEditing\"> <div>{{$ctrl.address.address.firstName}} {{$ctrl.address.address.lastName}}</div> <div>{{$ctrl.address.address.address1}}</div> <div ng-if=\"$ctrl.address.address.address2\">{{$ctrl.address.address.address2}}</div> <div> {{$ctrl.address.address.city}}, <display-state-name country-code=\"$ctrl.address.address.country\" state-code=\"$ctrl.address.address.state\"> </display-state-name> {{$ctrl.address.address.postalCode}} </div> <display-country-name country-code=\"$ctrl.address.address.country\"> </display-country-name> </div> <div class=\"edit-account-label\" ng-if=\"$ctrl.isEditing\"> Edit address </div> </md-radio-button> </div> <div> <div layout=\"column\" layout-align=\"center end\" ng-if=\"!$ctrl.isEditing\"> <div><badge ng-if=\"$ctrl.address.address.isDefault\">Default</badge></div> <div> <edit-step-button on-click=\"$ctrl.onEditClicked()\" test-id=\"edit-saved-shipping-address-button\"></edit-step-button> </div> </div> <save-and-cancel ng-if=\"$ctrl.isEditing\" on-save-clicked=\"$ctrl.onSaveClicked()\" on-cancel-clicked=\"$ctrl.onCancelClicked()\" show-save-loader=\"$ctrl.addressSaving\"> </save-and-cancel> </div> </div> <div ng-if=\"$ctrl.isEditing\"> <div ng-if=\"!$ctrl.useNewCarts || !$ctrl.showAddressSuggestion\" class=\"checkout-left-padding\"> <ng-form name=\"$ctrl.editShippingAddressForm\"> <address-form model=\"$ctrl.addressModel.address\" auto-complete-prefix=\"edit-address\"></address-form> <div class=\"saved-shipping-address__actions\"> <div layout layout-align=\"space-between center\" ng-if=\"!$ctrl.showDeleteConfirm\"> <md-checkbox ng-if=\"$ctrl.isShippingRequired\" ng-model=\"$ctrl.addressModel.address.isDefault\" aria-label=\"Set as default shipping address\"> Set as default shipping address </md-checkbox> <button class=\"checkout-button checkout-button--border\" ng-click=\"$ctrl.onDeleteClicked()\" ng-if=\"$ctrl.showDeleteButton\" test-id=\"delete-saved-address-button\"> Delete this address </button> </div> <div layout layout-align=\"end center\" ng-if=\"$ctrl.showDeleteConfirm\" class=\"saved-shipping-address__delete-confirmation\"> <span>Are you sure?</span> <button class=\"checkout-button checkout-button--border\" ng-click=\"$ctrl.onConfirmDeleteClicked()\" test-id=\"delete-saved-address-confirmation-button\"> <div layout layout-align=\"center center\"> <span ng-if=\"!$ctrl.isDeleting\">Yes, delete</span> <md-progress-circular md-diameter=\"15\" md-mode=\"indeterminate\" ng-if=\"$ctrl.isDeleting\"></md-progress-circular> </div> </button> <button class=\"checkout-button checkout-button--primary\" ng-click=\"$ctrl.onCancelDeleteClicked()\"> No, don't delete </button> </div> </div> </ng-form> </div> <address-verification-form ng-if=\"$ctrl.useNewCarts && $ctrl.showAddressSuggestion\" address=\"$ctrl.addressModel.address\" recommendations=\"$ctrl.addressRecommendations\" changes=\"$ctrl.addressChanges\" on-choose-address=\"$ctrl.updateAddress\"/> </div> </div> ";

/***/ }),
/* 886 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EditAccountContactInfo = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _assign = __webpack_require__(44);

var _assign2 = _interopRequireDefault(_assign);

var _api = __webpack_require__(14);

var _shopperAccount = __webpack_require__(80);

var _logoutButton = __webpack_require__(329);

var _saveAndCancel = __webpack_require__(95);

var _contactInfoForm = __webpack_require__(134);

var _cartUtils = __webpack_require__(19);

var _displayContactInfo = __webpack_require__(888);

var _editAccountContactInfo = __webpack_require__(891);

var _editAccountContactInfo2 = _interopRequireDefault(_editAccountContactInfo);

__webpack_require__(892);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EditAccountContactInfo = exports.EditAccountContactInfo = angular.module('checkout.components.editAccountContactAndDelivery.editAccountContactInfo', [_api.ApiService, _shopperAccount.ShopperAccountService, _contactInfoForm.ContactInfoForm, _displayContactInfo.DisplayContactInfo, _logoutButton.LogoutButton, _saveAndCancel.SaveAndCancel]).component('editAccountContactInfo', {
    bindings: {
        shopperAccount: '<',
        phoneNumberRequired: '<',
        onContactInfoSaved: '&',
        useNewCarts: '<'
    },
    template: _editAccountContactInfo2.default,
    controller: function () {
        EditAccountContactInfoCtrl.$inject = ['apiService', 'checkoutService', '$mdDialog', '$q', 'shopperAccountService', '$rootScope'];

        function EditAccountContactInfoCtrl(apiService, checkoutService, $mdDialog, $q, shopperAccountService, $rootScope) {
            _classCallCheck(this, EditAccountContactInfoCtrl);

            (0, _assign2.default)(this, {
                apiService: apiService,
                checkoutService: checkoutService,
                $mdDialog: $mdDialog,
                $q: $q,
                shopperAccountService: shopperAccountService,
                $rootScope: $rootScope
            });
        }

        _createClass(EditAccountContactInfoCtrl, [{
            key: '$onInit',
            value: function $onInit() {
                var _this = this;

                this.unbindListener = this.$rootScope.$on('editAccountContactAndDelivery:Editing', function (event, data) {
                    if (data !== 'contactInfo') _this.onCancelClicked();
                });
            }
        }, {
            key: '$onDestroy',
            value: function $onDestroy() {
                this.unbindListener();
            }
        }, {
            key: '$onChanges',
            value: function $onChanges(changesObj) {
                if (changesObj && changesObj.shopperAccount) {
                    this.setFormModel(changesObj.shopperAccount.currentValue);
                }
            }
        }, {
            key: 'setFormModel',
            value: function setFormModel(shopperAccount) {
                this.formModel = {
                    email: shopperAccount.emailAddress,
                    phone: shopperAccount.phoneNumber,
                    firstName: shopperAccount.firstName,
                    lastName: shopperAccount.lastName,
                    emailOptIn: shopperAccount.emailOptIn
                };
            }
        }, {
            key: 'onEditClicked',
            value: function onEditClicked() {
                this.showForm = true;
                this.$rootScope.$emit('editAccountContactAndDelivery:Editing', 'contactInfo');
            }
        }, {
            key: 'onCancelClicked',
            value: function onCancelClicked() {
                this.showForm = false;
                this.setFormModel(this.shopperAccount);
            }
        }, {
            key: 'onSaveClicked',
            value: function onSaveClicked() {
                var _this2 = this;

                if (this.contactInfoForm.$invalid) {
                    this.checkoutService.forceFormValidation(this.contactInfoForm['$ctrl.contactInfoForm']);
                    return;
                }

                this.contactInfoSaving = true;

                var shopperAccount = _extends({}, this.shopperAccount, {
                    emailAddress: this.formModel.email,
                    phoneNumber: this.formModel.phone,
                    emailOptIn: this.formModel.emailOptIn,
                    firstName: this.formModel.firstName,
                    lastName: this.formModel.lastName
                });

                if (!this.useNewCarts) {
                    this.$q.all([this.apiService.account.update(shopperAccount), this.shopperAccountService.applyContactInfoToCart(shopperAccount)]).then(function (_ref) {
                        var _ref2 = _slicedToArray(_ref, 2),
                            updatedAccount = _ref2[0],
                            updatedCart = _ref2[1];

                        _this2.onContactInfoSaved({ shopperAccount: updatedAccount, cart: updatedCart });
                        _this2.showForm = false;
                    }).finally(function () {
                        _this2.contactInfoSaving = false;
                    });
                } else {
                    this.apiService.account.update(shopperAccount).then(function (updatedAccount) {
                        var updatedCart = _extends({}, (0, _cartUtils.getSavedCartInfo)(), {
                            contactInfo: {
                                email: shopperAccount.emailAddress,
                                phoneNumber: shopperAccount.phoneNumber
                            }
                        });
                        (0, _cartUtils.setSavedCartInfo)(updatedCart);

                        _this2.onContactInfoSaved({ shopperAccount: updatedAccount, cart: updatedCart });
                        _this2.showForm = false;
                    }).finally(function () {
                        _this2.contactInfoSaving = false;
                    });
                }
            }
        }]);

        return EditAccountContactInfoCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DisplayContactInfo = undefined;

var _displayContactInfo = __webpack_require__(889);

var _displayContactInfo2 = _interopRequireDefault(_displayContactInfo);

__webpack_require__(890);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DisplayContactInfo = exports.DisplayContactInfo = angular.module('checkout.components.editAccountContactAndDelivery.displayContactInfo', []).component('displayContactInfo', {
    template: _displayContactInfo2.default,
    bindings: {
        firstName: '<',
        lastName: '<',
        email: '<',
        phone: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports = "<div class=\"display-contact-info\"> <div class=\"display-contact-info__name\">{{$ctrl.firstName}} {{$ctrl.lastName}}</div> <div class=\"display-contact-info__contact\"> <div class=\"display-contact-info__email\">{{$ctrl.email}}</div> <div class=\"display-contact-info__phone\">{{$ctrl.phone}}</div> </div> </div> ";

/***/ }),
/* 890 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 891 */
/***/ (function(module, exports) {

module.exports = "<div class=\"edit-account-contact-info\"> <div layout layout-align=\"space-between center\"> <h3 class=\"checkout-section-heading\">Contact info</h3> <logout-button hide-xs name-text=\"$ctrl.shopperAccount.firstName || $ctrl.shopperAccount.emailAddress\" small-welcome-text=\"true\" use-new-carts=\"$ctrl.useNewCarts\"> </logout-button> </div> <div layout=\"row\" layout-align=\"start center\" class=\"edit-account-contact-info__radio\"> <div flex> <div layout layout-align=\"start center\"> <md-icon flex=\"none\">account_box</md-icon> <div flex> <display-contact-info ng-if=\"!$ctrl.showForm\" first-name=\"$ctrl.shopperAccount.firstName\" last-name=\"$ctrl.shopperAccount.lastName\" email=\"$ctrl.shopperAccount.emailAddress\" phone=\"$ctrl.shopperAccount.phoneNumber\"> </display-contact-info> <div class=\"edit-account-label\" ng-if=\"$ctrl.showForm\">Edit contact info</div> </div> </div> </div> <div> <edit-step-button on-click=\"$ctrl.onEditClicked()\" ng-if=\"!$ctrl.showForm\"></edit-step-button> <save-and-cancel ng-if=\"$ctrl.showForm\" on-save-clicked=\"$ctrl.onSaveClicked()\" on-cancel-clicked=\"$ctrl.onCancelClicked()\" show-save-loader=\"$ctrl.contactInfoSaving\"> </save-and-cancel> </div> </div> <div class=\"checkout-left-padding\" ng-if=\"$ctrl.showForm\"> <ng-form name=\"$ctrl.contactInfoForm\"> <div layout-xs=\"column\" layout-gt-xs=\"row\"> <div flex> <div layout> <input-container form-input=\"$ctrl.contactInfoForm.fname\" flex class=\"input-container-first input-container-no-padding-xs\"> <label for=\"{{::$id}}-fname\">First name</label> <input ng-model=\"$ctrl.formModel.firstName\" id=\"{{::$id}}-fname\" name=\"fname\" type=\"text\" pattern=\"^[\\w ]+$\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" autocomplete=\"edit-account-contact-info-given-name\"> <div ng-messages=\"$ctrl.contactInfoForm.fname.$error\"> <div ng-message=\"pattern\">First name must not contain special characters.</div> </div> </input-container> </div> </div> <div flex> <div layout> <input-container form-input=\"$ctrl.contactInfoForm.lname\" flex class=\"input-container-last input-container-no-padding-xs\"> <label for=\"{{::$id}}-lname\">Last name</label> <input ng-model=\"$ctrl.formModel.lastName\" id=\"{{::$id}}-lname\" name=\"lname\" type=\"text\" pattern=\"^[\\w ]+$\" autocorrect=\"off\" autocapitalize=\"off\" spellcheck=\"false\" autocomplete=\"edit-account-contact-info-family-name\"> <div ng-messages=\"$ctrl.contactInfoForm.lname.$error\"> <div ng-message=\"pattern\">Last name must not contain special characters.</div> </div> </input-container> </div> </div> </div> <contact-info-form model=\"$ctrl.formModel\" phone-number-required=\"$ctrl.phoneNumberRequired\" email-input-disabled=\"true\"> </contact-info-form> </ng-form> </div> </div> ";

/***/ }),
/* 892 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DisplayPayPalAddress = undefined;

var _displayPayPalAddress = __webpack_require__(894);

var _displayPayPalAddress2 = _interopRequireDefault(_displayPayPalAddress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DisplayPayPalAddress = exports.DisplayPayPalAddress = angular.module('checkout.components.editAccountContactAndDelivery.displayPayPalAddress', []).component('displayPaypalAddress', {
    template: _displayPayPalAddress2.default,
    bindings: {
        paypalData: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports = "<div layout=\"row\" layout-align=\"start center\"> <div flex> <md-radio-button flex ng-value=\"'PayPal'\" class=\"md-primary\"> <div> <div>{{$ctrl.paypalData.FIRSTNAME}} {{$ctrl.paypalData.LASTNAME}}</div> <div>{{$ctrl.paypalData.PAYMENTREQUEST_0_SHIPTOSTREET}}</div> <div ng-if=\"$ctrl.paypalData.PAYMENTREQUEST_0_SHIPTOSTREET2\">{{$ctrl.paypalData.PAYMENTREQUEST_0_SHIPTOSTREET2}}</div> <div>{{$ctrl.paypalData.PAYMENTREQUEST_0_SHIPTOCITY}}, {{$ctrl.paypalData.PAYMENTREQUEST_0_SHIPTOSTATE}} {{$ctrl.paypalData.PAYMENTREQUEST_0_SHIPTOZIP}}</div> </div> </md-radio-button> </div> <div> <div layout=\"column\" layout-align=\"center end\"> <div><badge>From PayPal</badge></div> </div> </div> </div>";

/***/ }),
/* 895 */
/***/ (function(module, exports) {

module.exports = "<md-dialog-content class=\"md-dialog-content\"> <div layout layout-align=\"space-between center\" class=\"checkout-modal__header\"> <div class=\"checkout-card-heading\" ng-if=\"$ctrl.isShippingRequired\">Contact &amp; Delivery</div> <div class=\"checkout-card-heading\" ng-if=\"!$ctrl.isShippingRequired\">Contact &amp; Billing</div> <md-button ng-click=\"$ctrl.close()\" class=\"md-icon-button\"> <md-icon>close</md-icon> </md-button> </div> <logout-button hide-gt-xs name-text=\"$ctrl.shopperAccount.firstName || $ctrl.shopperAccount.emailAddress\" small-welcome-text=\"true\" use-new-carts=\"$ctrl.useNewCarts\"> </logout-button> <edit-account-contact-info shopper-account=\"$ctrl.shopperAccount\" phone-number-required=\"$ctrl.phoneNumberRequired\" on-contact-info-saved=\"$ctrl.onContactInfoSaved(shopperAccount, cart)\" use-new-carts=\"$ctrl.useNewCarts\"> </edit-account-contact-info> <hr> <div class=\"edit-account-shipping-address\"> <h3 class=\"checkout-section-heading\" ng-if=\"$ctrl.isShippingRequired\">Shipping address</h3> <h3 class=\"checkout-section-heading\" ng-if=\"!$ctrl.isShippingRequired\">Billing address</h3> <md-radio-group required ng-model=\"$ctrl.selectedShippingAddress\"> <div class=\"shipping-address-picker\" ng-if=\"!$ctrl.fetchingShippingAddresses && $ctrl.shippingAddresses.length > 0\"> <div class=\"edit-account-shipping-address__item\" ng-repeat=\"address in $ctrl.shippingAddresses track by address.id\"> <saved-shipping-address address=\"address\" on-address-edited=\"$ctrl.onAddressEdited\" on-address-deleted=\"$ctrl.onAddressDeleted\" show-delete-button=\"$ctrl.shouldShowAddressDeleteButton()\" is-shipping-required=\"$ctrl.isShippingRequired\" use-address-verification=\"$ctrl.useAddressVerification\" use-new-carts=\"$ctrl.useNewCarts\"> </saved-shipping-address> <hr> </div> <div class=\"edit-account-shipping-address__item\" ng-if=\"$ctrl.paypalData\"> <display-paypal-address paypal-data=\"$ctrl.paypalData\"></display-paypal-address> <hr> </div> </div> <button class=\"checkout-button checkout-button--flat\" type=\"button\" ng-if=\"!$ctrl.showAddAddressForm && !$ctrl.fetchingShippingAddresses\" ng-click=\"$ctrl.onAddAddressClicked()\"> <div layout layout-align=\"center center\"> <i class=\"material-icons\">add</i> <span>Add a new address</span> </div> </button> <md-progress-circular md-diameter=\"40\" md-mode=\"indeterminate\" class=\"edit-account-shipping-address__loader\" ng-if=\"$ctrl.fetchingShippingAddresses\"> </md-progress-circular> <add-shipping-address ng-if=\"$ctrl.showAddAddressForm\" on-cancel-clicked=\"$ctrl.onAddAddressCancelled()\" on-address-saved=\"$ctrl.onAddAddressSaved\" is-shipping-required=\"$ctrl.isShippingRequired\" use-address-verification=\"$ctrl.useAddressVerification\" use-new-carts=\"$ctrl.useNewCarts\"></add-shipping-address> </md-radio-group> </div> </md-dialog-content> <md-dialog-actions layout=\"column\" layout-gt-xs=\"row\" class=\"checkout-modal__footer\"> <button class=\"checkout-button checkout-button--border checkout-button--large\" type=\"button\" ng-click=\"$ctrl.close()\" flex flex-gt-xs=\"nogrow\"> Cancel </button> <continue-button is-disabled=\"$ctrl.shouldConfirmButtonBeDisabled()\" is-loading=\"$ctrl.isUpdatingCart\" on-clicked=\"$ctrl.onConfirmClicked()\" flex flex-gt-xs=\"nogrow\" flex-order=\"-1\" flex-order-gt-xs=\"0\" test-id=\"use-shipping-address-button\"> Use this address </continue-button> </md-dialog-actions> ";

/***/ }),
/* 896 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SavedPaymentMethod = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _assign = __webpack_require__(44);

var _assign2 = _interopRequireDefault(_assign);

var _api = __webpack_require__(14);

var _checkout = __webpack_require__(18);

var _creditCard = __webpack_require__(94);

var _creditCardForm = __webpack_require__(131);

var _saveAndCancel = __webpack_require__(95);

var _addressForm = __webpack_require__(54);

var _displayBillingAddress = __webpack_require__(338);

var _savedPaymentMethod = __webpack_require__(900);

var _savedPaymentMethod2 = _interopRequireDefault(_savedPaymentMethod);

__webpack_require__(901);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SavedPaymentMethod = exports.SavedPaymentMethod = angular.module('checkout.components.editAccountPayment.savedPaymentMethod', [_api.ApiService, _checkout.CheckoutService, _creditCardForm.CreditCardForm, _addressForm.AddressForm, _saveAndCancel.SaveAndCancel, _displayBillingAddress.DisplayBillingAddress, _creditCard.CreditCardService]).component('savedPaymentMethod', {
    template: _savedPaymentMethod2.default,
    bindings: {
        paymentMethod: '<',
        onPaymentMethodSaved: '<',
        onPaymentMethodDeleted: '<',
        showDeleteButton: '<',
        isMobile: '<'
    },
    controller: function () {
        SavedPaymentMethodCtrl.$inject = ['apiService', 'checkoutService', 'creditCardService', '$rootScope'];

        function SavedPaymentMethodCtrl(apiService, checkoutService, creditCardService, $rootScope) {
            _classCallCheck(this, SavedPaymentMethodCtrl);

            (0, _assign2.default)(this, {
                apiService: apiService,
                checkoutService: checkoutService,
                creditCardService: creditCardService,
                $rootScope: $rootScope
            });
        }

        _createClass(SavedPaymentMethodCtrl, [{
            key: '$onInit',
            value: function $onInit() {
                var _this = this;

                this.unbindListener = this.$rootScope.$on('editAccountPayment:Editing', function (event, data) {
                    if (data !== _this.paymentMethod.id) _this.onCancelClicked();
                });
            }
        }, {
            key: '$onDestroy',
            value: function $onDestroy() {
                this.unbindListener();
            }
        }, {
            key: '$onChanges',
            value: function $onChanges(changesObj) {
                if (changesObj.paymentMethod && !changesObj.paymentMethod.isFirstChange()) {
                    this.setModels(changesObj.paymentMethod.currentValue);
                }
            }
        }, {
            key: 'setModels',
            value: function setModels(paymentMethod) {
                this.creditCardModel = {
                    cardNumber: '**** **** **** ' + paymentMethod.lastFour,
                    expiration: paymentMethod.expiration.month + '/' + paymentMethod.expiration.year
                };
                this.billingAddressModel = {
                    name: paymentMethod.name,
                    address1: paymentMethod.address.line1,
                    address2: paymentMethod.address.line2,
                    city: paymentMethod.address.city,
                    state: paymentMethod.address.state,
                    postalCode: paymentMethod.address.zip,
                    country: paymentMethod.address.country
                };
                this.isDefault = paymentMethod.isDefault;
            }
        }, {
            key: 'onEditClicked',
            value: function onEditClicked() {
                this.isEditing = true;
                this.setModels(this.paymentMethod);
                this.$rootScope.$emit('editAccountPayment:Editing', this.paymentMethod.id);
            }
        }, {
            key: 'onCancelClicked',
            value: function onCancelClicked() {
                this.isEditing = false;
                this.showDeleteConfirm = false;
                this.showBillingAddressForm = false;
                this.setModels(this.paymentMethod);
            }
        }, {
            key: 'onCancelDeleteClicked',
            value: function onCancelDeleteClicked() {
                this.showDeleteConfirm = false;
            }
        }, {
            key: 'onConfirmDeleteClicked',
            value: function onConfirmDeleteClicked() {
                var _this2 = this;

                this.isDeleting = true;
                return this.apiService.account.paymentMethod.delete(this.paymentMethod.id).then(function () {
                    return _this2.onPaymentMethodDeleted();
                }).finally(function () {
                    _this2.isDeleting = false;
                });
            }
        }, {
            key: 'onDeleteClicked',
            value: function onDeleteClicked() {
                this.showDeleteConfirm = true;
            }
        }, {
            key: 'onSaveClicked',
            value: function onSaveClicked() {
                var _this3 = this;

                if (this.editPaymentMethodForm.$invalid) {
                    this.checkoutService.forceFormValidation(this.editPaymentMethodForm['$ctrl.addressForm']);
                    this.checkoutService.forceFormValidation(this.editPaymentMethodForm['$ctrl.creditCardForm']);
                    return;
                }

                this.isSaving = true;
                var expirationObj = this.creditCardService.convertExpStringToObject(this.creditCardModel.expiration);
                var card = _extends({}, this.paymentMethod, {
                    isDefault: this.isDefault,
                    address: {
                        line1: this.billingAddressModel.address1,
                        line2: this.billingAddressModel.address2,
                        city: this.billingAddressModel.city,
                        state: this.billingAddressModel.state,
                        zip: this.billingAddressModel.postalCode,
                        country: this.billingAddressModel.country
                    },
                    expiration: {
                        month: expirationObj.expMonth,
                        year: expirationObj.expYear
                    },
                    name: this.billingAddressModel.name

                });

                return this.apiService.account.paymentMethod.update(this.paymentMethod.id, card).then(function () {
                    return _this3.onPaymentMethodSaved().then(function () {
                        _this3.isEditing = false;
                        _this3.showDeleteConfirm = false;
                        _this3.showBillingAddressForm = false;
                    });
                }).finally(function () {
                    _this3.isSaving = false;
                });
            }
        }, {
            key: 'onChangeBillingAddressClicked',
            value: function onChangeBillingAddressClicked() {
                this.showBillingAddressForm = true;
            }
        }]);

        return SavedPaymentMethodCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports = "<display-info class=\"edit-account-payment-display-billing-address\"> <display-info-title>Billing address</display-info-title> <display-info-content> <div layout> <div class=\"edit-account-payment-display-billing-address__address\"> <div>{{$ctrl.paymentMethod.name}}</div> <div>{{$ctrl.paymentMethod.address.line1}}</div> <div ng-if=\"$ctrl.paymentMethod.address.line2\"> {{$ctrl.paymentMethod.address.line2}} </div> <div>{{$ctrl.paymentMethod.address.city}}, {{$ctrl.paymentMethod.address.state}} {{$ctrl.paymentMethod.address.zip}}</div> <display-country-name country-code=\"$ctrl.paymentMethod.address.country\"> </display-country-name> </div> <div layout layout-align=\"center center\"> <button class=\"checkout-button checkout-button--border\" ng-click=\"$ctrl.onChangeClicked()\"> Change </button> </div> </div> </display-info-content> </display-info> ";

/***/ }),
/* 899 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 900 */
/***/ (function(module, exports) {

module.exports = "<div class=\"saved-payment-method\"> <div layout=\"row\" layout-align=\"start center\"> <div flex> <md-radio-button flex ng-value=\"$ctrl.paymentMethod.id\" class=\"md-primary\"> <div layout layout-align=\"start center\"> <credit-card-image card-type=\"$ctrl.paymentMethod.brand\" ng-if=\"!$ctrl.isMobile || ($ctrl.isMobile && !$ctrl.isEditing)\"> </credit-card-image> <div layout=\"column\" ng-if=\"!$ctrl.isMobile\"> <div class=\"edit-account-label\">{{$ctrl.paymentMethod.brand}} ending in {{$ctrl.paymentMethod.lastFour}}</div> <div class=\"saved-payment-method__expiration\"> <span>Exp: {{$ctrl.paymentMethod.expiration.month}}/{{$ctrl.paymentMethod.expiration.year}}</span> <badge ng-if=\"$ctrl.paymentMethod.isDefault\">Default</badge> </div> </div> <div ng-if=\"$ctrl.isMobile\"> <div layout=\"column\" ng-if=\"!$ctrl.isEditing\"> <div class=\"edit-account-label\">{{$ctrl.paymentMethod.brand}} ** {{$ctrl.paymentMethod.lastFour}}</div> <div class=\"saved-payment-method__expiration\"> <span>Exp: {{$ctrl.paymentMethod.expiration.month}}/{{$ctrl.paymentMethod.expiration.year}}</span> <badge ng-if=\"$ctrl.paymentMethod.isDefault\">Default</badge> </div> </div> <div ng-if=\"$ctrl.isEditing\"> <div class=\"edit-account-label\">{{$ctrl.paymentMethod.brand}}</div> <div class=\"saved-payment-method__expiration\">** {{$ctrl.paymentMethod.lastFour}}</div> </div> </div> </div> </md-radio-button> </div> <div> <div layout=\"column\" layout-align=\"center end\" ng-if=\"!$ctrl.isEditing\"> <div> <edit-step-button on-click=\"$ctrl.onEditClicked()\"></edit-step-button> </div> </div> <save-and-cancel ng-if=\"$ctrl.isEditing\" on-save-clicked=\"$ctrl.onSaveClicked()\" on-cancel-clicked=\"$ctrl.onCancelClicked()\" show-save-loader=\"$ctrl.isSaving\"> </save-and-cancel> </div> </div> <div class=\"checkout-left-padding\" ng-if=\"$ctrl.isEditing\"> <ng-form name=\"$ctrl.editPaymentMethodForm\"> <credit-card-form model=\"$ctrl.creditCardModel\" disable-card-number-field=\"true\" hide-cvc-input=\"true\" hide-credit-card-image=\"true\"> </credit-card-form> <edit-account-payment-display-billing-address ng-if=\"!$ctrl.showBillingAddressForm\" payment-method=\"$ctrl.paymentMethod\" on-change-clicked=\"$ctrl.onChangeBillingAddressClicked()\"> </edit-account-payment-display-billing-address> <address-form ng-if=\"$ctrl.showBillingAddressForm\" model=\"$ctrl.billingAddressModel\" show-cardholder-name-input=\"true\"> </address-form> <div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"center start\" layout-align-gt-xs=\"space-between center\" ng-if=\"!$ctrl.showDeleteConfirm\"> <md-checkbox ng-model=\"$ctrl.isDefault\" aria-label=\"Set as default payment method\"> Set as default payment method </md-checkbox> <button class=\"checkout-button checkout-button--border\" ng-click=\"$ctrl.onDeleteClicked()\" ng-if=\"$ctrl.showDeleteButton\"> Delete this card </button> </div> <div layout=\"column\" layout-gt-xs=\"row\" layout-align=\"center start\" layout-align-gt-xs=\"end center\" ng-if=\"$ctrl.showDeleteConfirm\" class=\"saved-payment-method__delete-confirmation\"> <span>Delete this card?</span> <button class=\"checkout-button checkout-button--border\" ng-click=\"$ctrl.onConfirmDeleteClicked()\"> <div layout layout-align=\"center center\"> <span ng-if=\"!$ctrl.isDeleting\">Yes, delete</span> <md-progress-circular md-diameter=\"15\" md-mode=\"indeterminate\" ng-if=\"$ctrl.isDeleting\"></md-progress-circular> </div> </button> <button class=\"checkout-button checkout-button--primary\" ng-click=\"$ctrl.onCancelDeleteClicked()\"> No, don't delete </button> </div> </ng-form> </div> </div> ";

/***/ }),
/* 901 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.AddPaymentMethod = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _api = __webpack_require__(14);

var _checkout = __webpack_require__(18);

var _creditCard = __webpack_require__(94);

var _saveAndCancel = __webpack_require__(95);

var _creditCardForm = __webpack_require__(131);

var _addressForm = __webpack_require__(54);

var _stripeElementsForm = __webpack_require__(133);

var _displayBillingAddress = __webpack_require__(338);

var _addPaymentMethod = __webpack_require__(903);

var _addPaymentMethod2 = _interopRequireDefault(_addPaymentMethod);

__webpack_require__(904);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AddPaymentMethod = exports.AddPaymentMethod = angular.module('checkout.components.editAccountPayment.addPaymentMethod', [_api.ApiService, _checkout.CheckoutService, _saveAndCancel.SaveAndCancel, _creditCardForm.CreditCardForm, _addressForm.AddressForm, _displayBillingAddress.DisplayBillingAddress]).component('addPaymentMethod', {
    template: _addPaymentMethod2.default,
    bindings: {
        onCancelClicked: '&',
        onPaymentMethodSaved: '<',
        initialShippingAddress: '<',
        stripe: '<'
    },
    controller: function () {
        AddPaymentMethodCtrl.$inject = ['apiService', 'checkoutService'];

        function AddPaymentMethodCtrl(apiService, checkoutService) {
            _classCallCheck(this, AddPaymentMethodCtrl);

            this.apiService = apiService;
            this.checkoutService = checkoutService;
            this.showAddressForm = true;
            this.onStripeElementsCardChange = this.onStripeElementsCardChange.bind(this);
        }

        _createClass(AddPaymentMethodCtrl, [{
            key: '$onInit',
            value: function $onInit() {
                if (this.initialShippingAddress) {
                    this.showAddressForm = false;
                    this.billingAddressModel = angular.copy(this.initialShippingAddress);
                    this.billingAddressModel.name = this.initialShippingAddress.firstName + ' ' + this.initialShippingAddress.lastName;

                    this.paymentMethodForDisplay = {
                        name: this.billingAddressModel.name,
                        address: {
                            line1: this.billingAddressModel.address1,
                            line2: this.billingAddressModel.address2,
                            city: this.billingAddressModel.city,
                            state: this.billingAddressModel.state,
                            zip: this.billingAddressModel.postalCode,
                            country: this.billingAddressModel.country
                        }
                    };
                }

                this.stripeElements = this.stripe.elements();
                this.stripeElementsCard = this.stripeElements.create('card', {
                    style: _stripeElementsForm.stripeElementCardStyle,
                    hidePostalCode: true
                });
            }
        }, {
            key: 'onChangeBillingAddressClicked',
            value: function onChangeBillingAddressClicked() {
                this.showAddressForm = true;
            }
        }, {
            key: 'onSaveClicked',
            value: function onSaveClicked() {
                var _this = this;

                if (this.addPaymentMethodForm.$invalid || this.stripeElementsError) {
                    this.checkoutService.forceFormValidation(this.addPaymentMethodForm['$ctrl.addressForm']);
                    return;
                }

                this.isSaving = true;

                this.stripe.createToken(this.stripeElementsCard, (0, _creditCard.createStripeTokenMetadata)(this.billingAddressModel)).then(function (_ref) {
                    var token = _ref.token;

                    return _this.apiService.account.paymentMethod.add(token.id, _this.setAsDefault).then(function (paymentMethod) {
                        return _this.onPaymentMethodSaved(paymentMethod);
                    });
                }).finally(function () {
                    _this.isSaving = false;
                });
            }
        }, {
            key: 'onStripeElementsCardChange',
            value: function onStripeElementsCardChange(_ref2) {
                var error = _ref2.error;

                this.stripeElementsError = error;
            }
        }]);

        return AddPaymentMethodCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 903 */
/***/ (function(module, exports) {

module.exports = "<div layout=\"row\" layout-align=\"start center\"> <div flex> <md-radio-button flex ng-value=\"'new'\" class=\"md-primary\"> <div class=\"edit-account-label\">New card</div> </md-radio-button> </div> <save-and-cancel on-save-clicked=\"$ctrl.onSaveClicked()\" on-cancel-clicked=\"$ctrl.onCancelClicked()\" show-save-loader=\"$ctrl.isSaving\"> </save-and-cancel> </div> <div class=\"checkout-left-padding\"> <ng-form name=\"$ctrl.addPaymentMethodForm\"> <stripe-elements-form ng-if=\"$ctrl.stripeElementsCard\" on-stripe-elements-card-change=\"$ctrl.onStripeElementsCardChange\" stripe-elements-card=\"$ctrl.stripeElementsCard\"> </stripe-elements-form> <address-form ng-if=\"$ctrl.showAddressForm\" model=\"$ctrl.billingAddressModel\" show-cardholder-name-input=\"true\"> </address-form> <edit-account-payment-display-billing-address ng-if=\"!$ctrl.showAddressForm\" payment-method=\"$ctrl.paymentMethodForDisplay\" on-change-clicked=\"$ctrl.onChangeBillingAddressClicked()\"> </edit-account-payment-display-billing-address> <md-checkbox ng-model=\"$ctrl.setAsDefault\" aria-label=\"Set as default payment method\"> Set as default payment method </md-checkbox> </ng-form> </div> ";

/***/ }),
/* 904 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OtherPaymentMethodsList = undefined;

var _otherPaymentMethodsList = __webpack_require__(906);

var _otherPaymentMethodsList2 = _interopRequireDefault(_otherPaymentMethodsList);

__webpack_require__(907);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OtherPaymentMethodsList = exports.OtherPaymentMethodsList = angular.module('checkout.components.editAccountPayment.otherPaymentMethodsList', []).component('otherPaymentMethodsList', {
    template: _otherPaymentMethodsList2.default,
    bindings: {
        paymentMethods: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 906 */
/***/ (function(module, exports) {

module.exports = "<div ng-repeat=\"paymentMethod in $ctrl.paymentMethods | filter:{ type: 'other' } track by $index\"> <md-radio-button ng-value=\"paymentMethod.value\" class=\"md-primary\"> <div layout layout-align=\"space-between center\"> <div class=\"edit-account-label\">{{paymentMethod.name}}</div> <img ng-src=\"{{paymentMethod.imageUrl}}\" ng-if=\"paymentMethod.imageUrl\" height=\"24px\"> </div> </md-radio-button> </div> ";

/***/ }),
/* 907 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 908 */
/***/ (function(module, exports) {

module.exports = "<md-dialog-content class=\"md-dialog-content\"> <div layout layout-align=\"space-between center\" class=\"checkout-modal__header\"> <div class=\"checkout-card-heading\">Payment</div> <md-button ng-click=\"$ctrl.cancel()\" class=\"md-icon-button\"> <md-icon>close</md-icon> </md-button> </div> <md-progress-circular md-diameter=\"40\" md-mode=\"indeterminate\" class=\"edit-account-payment__loader\" ng-if=\"$ctrl.fetchingPaymentMethods\"> </md-progress-circular> <md-radio-group required ng-model=\"$ctrl.selectedPaymentMethod\" ng-change=\"$ctrl.onPaymentMethodSelected($ctrl.selectedPaymentMethod)\" ng-if=\"!$ctrl.fetchingPaymentMethods\"> <div> <h3 class=\"checkout-section-heading\">Stored credit and debit cards</h3> <div ng-repeat=\"paymentMethod in $ctrl.savedPaymentMethods track by paymentMethod.id\"> <saved-payment-method payment-method=\"paymentMethod\" on-payment-method-saved=\"$ctrl.onPaymentMethodEdited\" on-payment-method-deleted=\"$ctrl.onPaymentMethodDeleted\" show-delete-button=\"$ctrl.shouldShowDeleteButton()\" is-mobile=\"$ctrl.isMobile\"> </saved-payment-method> <hr> </div> <button class=\"checkout-button checkout-button--flat\" type=\"button\" ng-if=\"!$ctrl.showAddPaymentMethodForm\" ng-click=\"$ctrl.onAddPaymentMethodClicked()\"> <div layout layout-align=\"center center\"> <i class=\"material-icons\">add</i> <span>Add a new credit/debit card</span> </div> </button> <add-payment-method ng-if=\"$ctrl.showAddPaymentMethodForm\" on-cancel-clicked=\"$ctrl.onCancelAddClicked()\" on-payment-method-saved=\"$ctrl.onPaymentMethodAdded\" initial-shipping-address=\"$ctrl.defaultShippingAddress\" stripe=\"$ctrl.stripe\"> </add-payment-method> </div> <div ng-if=\"$ctrl.otherPaymentMethods.length > 0\"> <h3 class=\"checkout-section-heading\">Other payment methods</h3> <other-payment-methods-list payment-methods=\"$ctrl.otherPaymentMethods\" ng-if=\"$ctrl.otherPaymentMethods.length > 0\"> </other-payment-methods-list> </div> </md-radio-group> </md-dialog-content> <md-dialog-actions layout=\"column\" layout-gt-xs=\"row\" class=\"checkout-modal__footer\"> <button class=\"checkout-button checkout-button--border checkout-button--large\" type=\"button\" ng-click=\"$ctrl.cancel()\" flex flex-gt-xs=\"nogrow\"> Cancel </button> <continue-button is-disabled=\"$ctrl.shouldConfirmButtonBeDisabled()\" is-loading=\"$ctrl.isUpdatingCart\" on-clicked=\"$ctrl.onConfirmClicked()\" flex flex-gt-xs=\"nogrow\" flex-order=\"-1\" flex-order-gt-xs=\"0\"> Use this payment method </continue-button> </md-dialog-actions> ";

/***/ }),
/* 909 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.LoginForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = __webpack_require__(16);

var _get2 = _interopRequireDefault(_get);

var _assign = __webpack_require__(44);

var _assign2 = _interopRequireDefault(_assign);

var _ngFocusIf = __webpack_require__(136);

var _ngFocusIf2 = _interopRequireDefault(_ngFocusIf);

var _fullscreenLoader = __webpack_require__(77);

var _auth = __webpack_require__(78);

var _api = __webpack_require__(14);

var _modal = __webpack_require__(84);

var _checkout = __webpack_require__(18);

var _shopperAccount = __webpack_require__(80);

var _loginForm = __webpack_require__(911);

var _loginForm2 = _interopRequireDefault(_loginForm);

__webpack_require__(912);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LoginForm = exports.LoginForm = angular.module('checkout.components.loginForm', [_ngFocusIf2.default, _fullscreenLoader.FullscreenLoaderService, _api.ApiService, _modal.ModalService, _auth.AuthService, _checkout.CheckoutService, _shopperAccount.ShopperAccountService]).component('loginForm', {
    template: _loginForm2.default,
    bindings: {
        onForgotPasswordClicked: '&',
        showPasswordResetSuccessMessage: '<',
        initEmail: '<',
        message: '<'
    },
    controller: function () {
        LoginFormCtrl.$inject = ['$mdDialog', 'checkoutService', 'authService', 'shopperAccountService', 'loadingService'];

        function LoginFormCtrl($mdDialog, checkoutService, authService, shopperAccountService, loadingService) {
            _classCallCheck(this, LoginFormCtrl);

            (0, _assign2.default)(this, {
                $mdDialog: $mdDialog,
                checkoutService: checkoutService,
                authService: authService,
                shopperAccountService: shopperAccountService,
                loadingService: loadingService,
                showPassword: false,
                model: {}
            });
        }

        _createClass(LoginFormCtrl, [{
            key: '$onInit',
            value: function $onInit() {
                if (this.initEmail) {
                    this.model.email = this.initEmail;
                }
            }
        }, {
            key: 'onCloseButtonClicked',
            value: function onCloseButtonClicked() {
                this.$mdDialog.cancel();
            }
        }, {
            key: 'onFormSubmit',
            value: function onFormSubmit() {
                this.login();
            }
        }, {
            key: 'login',
            value: function login() {
                var _this = this;

                if (this.loginForm.$invalid) {
                    this.checkoutService.forceFormValidation(this.loginForm);
                    return;
                }

                this.errorMessage = null;
                this.loadingService.show('Logging in...');

                return this.authService.login(this.model.email, this.model.password).then(function () {
                    return _this.$mdDialog.hide();
                }).catch(function (response) {
                    var errorReason = (0, _get2.default)(response, 'data.error', 'unknown');

                    if (errorReason === 'invalid_user_password' || errorReason === 'invalid_grant') {
                        _this.errorMessage = 'Invalid username or password';
                    } else if (errorReason === 'too_many_attempts') {
                        _this.errorMessage = 'Too many login attempts';
                    } else {
                        _this.errorMessage = 'Your email or password is incorrect. Please re-enter and try again.';
                    }

                    _this.loadingService.hide();

                    return response;
                });
            }
        }, {
            key: 'onTogglePasswordVisibilityClick',
            value: function onTogglePasswordVisibilityClick() {
                this.showPassword = !this.showPassword;
            }
        }]);

        return LoginFormCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 911 */
/***/ (function(module, exports) {

module.exports = "<div class=\"login-form\"> <div class=\"login-modal__header\"> <div layout layout-align=\"end center\"> <md-button ng-click=\"$ctrl.onCloseButtonClicked()\" class=\"md-icon-button login-modal__close-button\"> <md-icon>close</md-icon> </md-button> </div> <h2 class=\"login-modal__title\">Sign in</h2> <p class=\"login-modal__description\"> <span ng-if=\"$ctrl.message\">{{$ctrl.message}}</span> <span ng-if=\"$ctrl.showPasswordResetSuccessMessage\">Your password has been reset. Please enter your new account info to sign in.</span> </p> </div> <div class=\"login-modal__body\"> <form name=\"$ctrl.loginForm\" ng-submit=\"$ctrl.onFormSubmit()\" novalidate> <div layout=\"column\"> <input-container form-input=\"$ctrl.loginForm.email\" flex class=\"input-container-no-padding\"> <label for=\"loginEmail\">Email</label> <input ng-model=\"$ctrl.model.email\" id=\"loginEmail\" name=\"email\" type=\"email\" required validate-email autocomplete=\"section-login email\" focus-if=\"!$ctrl.initEmail\" focus-delay=\"300\"> <div class=\"checkout-input-errors\" ng-messages=\"$ctrl.loginForm.email.$error\"> <div ng-message=\"required\">Email required</div> <div ng-message=\"validEmail\">Valid email required</div> <div ng-message=\"validLength\">Email must be less than 75 characters</div> </div> </input-container> <input-container form-input=\"$ctrl.loginForm.password\" flex class=\"input-container-no-padding\"> <label for=\"password\">Password</label> <input class=\"login-form__password-input\" ng-model=\"$ctrl.model.password\" id=\"password\" name=\"password\" type=\"{{$ctrl.showPassword ? 'text' : 'password'}}\" required focus-if=\"$ctrl.initEmail\" focus-delay=\"300\"> <md-button ng-click=\"$ctrl.onTogglePasswordVisibilityClick()\" class=\"md-icon-button login-form__password-toggle\" tabindex=\"-1\"> <md-icon>{{$ctrl.showPassword ? 'visibility_off' : 'visibility'}}</md-icon> </md-button> <div class=\"checkout-input-errors\" ng-messages=\"$ctrl.loginForm.password.$error\"> <div ng-message=\"required\">Password is required</div> </div> </input-container> </div> <div class=\"login-modal__error\" ng-if=\"$ctrl.errorMessage\">{{$ctrl.errorMessage}}</div> <div layout layout-align=\"end center\" class=\"login-form__forgot-password\"> <button type=\"button\" tabindex=\"-1\" ng-click=\"$ctrl.onForgotPasswordClicked({ email: $ctrl.model.email })\" class=\"login-modal__link-button\">Forgot password?</button> </div> <continue-button button-type=\"submit\"> Sign in </continue-button> </form> </div> </div> ";

/***/ }),
/* 912 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ForgotPassword = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _assign = __webpack_require__(44);

var _assign2 = _interopRequireDefault(_assign);

var _ngFocusIf = __webpack_require__(136);

var _ngFocusIf2 = _interopRequireDefault(_ngFocusIf);

var _checkout = __webpack_require__(18);

var _api = __webpack_require__(14);

var _shopperAccount = __webpack_require__(80);

var _auth = __webpack_require__(78);

var _limitInputLength = __webpack_require__(914);

var _forgotPassword = __webpack_require__(915);

var _forgotPassword2 = _interopRequireDefault(_forgotPassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ForgotPassword = exports.ForgotPassword = angular.module('checkout.components.loginModal.forgotPassword', [_ngFocusIf2.default, _checkout.CheckoutService, _api.ApiService, _shopperAccount.ShopperAccountService, _auth.AuthService, _limitInputLength.LimitInputLength]).component('forgotPassword', {
    template: _forgotPassword2.default,
    bindings: {
        onCancelClicked: '&',
        email: '<'
    },
    controller: function () {
        ForgotPasswordCtrl.$inject = ['checkoutService', 'apiService', 'shopperAccountService', 'authService', '$mdDialog'];

        function ForgotPasswordCtrl(checkoutService, apiService, shopperAccountService, authService, $mdDialog) {
            _classCallCheck(this, ForgotPasswordCtrl);

            (0, _assign2.default)(this, {
                checkoutService: checkoutService,
                apiService: apiService,
                shopperAccountService: shopperAccountService,
                authService: authService,
                $mdDialog: $mdDialog,
                showCodeInput: false,
                showEmailInput: true
            });
        }

        _createClass(ForgotPasswordCtrl, [{
            key: 'onFormSubmit',
            value: function onFormSubmit() {
                if (this.showEmailInput) {
                    this.onSendEmailClicked();
                } else if (this.showCodeInput) {
                    this.onConfirmCodeClicked();
                } else if (this.showNewPasswordForm) {
                    this.onConfirmNewPasswordClicked();
                }
            }
        }, {
            key: 'onSendEmailClicked',
            value: function onSendEmailClicked() {
                var _this = this;

                if (this.forgotPasswordForm.$invalid) {
                    this.checkoutService.forceFormValidation(this.forgotPasswordForm);
                    return;
                }

                this.sendingEmail = true;
                this.apiService.account.sendPasswordResetEmail(this.email).then(function () {
                    _this.showEmailInput = false;
                    _this.showCodeInput = true;
                }).catch(function () {
                    _this.errorMessage = 'Could not send email';
                }).finally(function () {
                    _this.sendingEmail = false;
                });
            }
        }, {
            key: 'onConfirmCodeClicked',
            value: function onConfirmCodeClicked() {
                var _this2 = this;

                if (this.forgotPasswordForm.$invalid) {
                    this.checkoutService.forceFormValidation(this.forgotPasswordForm);
                    return;
                }

                this.confirmingCode = true;
                this.apiService.account.verifyResetPasswordCode(this.email, this.code).then(function () {
                    _this2.showCodeInput = false;
                    _this2.showNewPasswordForm = true;
                }).catch(function () {
                    _this2.errorMessage = 'Could not verify code';
                }).finally(function () {
                    _this2.confirmingCode = false;
                });
            }
        }, {
            key: 'onConfirmNewPasswordClicked',
            value: function onConfirmNewPasswordClicked() {
                var _this3 = this;

                if (this.forgotPasswordForm.$invalid) {
                    this.checkoutService.forceFormValidation(this.forgotPasswordForm);
                    return;
                }

                this.updatingPassword = true;
                this.apiService.account.updatePassword(this.email, this.password, this.code).then(function () {
                    return _this3.authService.login(_this3.email, _this3.password).then(function () {
                        return _this3.shopperAccountService.initShopperAccount().then(function (data) {
                            return _this3.$mdDialog.hide(data);
                        });
                    });
                }).catch(function () {
                    _this3.updatingPassword = false;
                    _this3.errorMessage = 'Could not update password';
                });
            }
        }, {
            key: 'onDidNotGetEmailClick',
            value: function onDidNotGetEmailClick() {
                var _this4 = this;

                this.apiService.account.sendPasswordResetEmail(this.email).then(function () {
                    _this4.showEmailResentMessage = true;
                }).catch(function () {
                    _this4.errorMessage = 'Could not send email';
                });
            }
        }, {
            key: 'onCloseButtonClicked',
            value: function onCloseButtonClicked() {
                this.$mdDialog.cancel();
            }
        }, {
            key: 'onTogglePasswordVisibilityClick',
            value: function onTogglePasswordVisibilityClick() {
                this.showPassword = !this.showPassword;
            }
        }]);

        return ForgotPasswordCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var LimitInputLength = exports.LimitInputLength = angular.module('checkout.directives.limitInputLength', []).directive('limitInputLength', function () {
    return {
        restrict: 'A',
        link: function link(scope, elem, attrs) {
            var limit = parseInt(attrs.limitInputLength);
            angular.element(elem).on('keypress', function (event) {
                if (this.value.length === limit && event.key !== 'Backspace') event.preventDefault();
            });
        }
    };
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 915 */
/***/ (function(module, exports) {

module.exports = "<div class=\"forgot-password\"> <div class=\"login-modal__header\"> <div layout layout-align=\"space-between center\"> <button type=\"button\" ng-click=\"$ctrl.onCancelClicked()\" class=\"login-modal__link-button\"> <md-icon>arrow_back</md-icon> <span>Sign in</span> </button> <md-button ng-click=\"$ctrl.onCloseButtonClicked()\" class=\"md-icon-button login-modal__close-button\"> <md-icon>close</md-icon> </md-button> </div> <h2 class=\"login-modal__title\"> <span ng-if=\"!$ctrl.showNewPasswordForm\">Forgot Password</span> <span ng-if=\"$ctrl.showNewPasswordForm\">Update password</span> </h2> <p class=\"login-modal__description\"> <span ng-if=\"$ctrl.showEmailInput\">Enter the email address associated with your account.</span> <span ng-if=\"$ctrl.showCodeInput\">We've sent a temporary access code to {{$ctrl.email}}.</span> <span ng-if=\"$ctrl.showNewPasswordForm\">Please enter a new password to use with your account.</span> </p> </div> <div class=\"login-modal__body\"> <form name=\"$ctrl.forgotPasswordForm\" ng-submit=\"$ctrl.onFormSubmit()\" novalidate> <div layout=\"column\"> <input-container form-input=\"$ctrl.forgotPasswordForm.email\" flex class=\"input-container-no-padding\" ng-if=\"$ctrl.showEmailInput || $ctrl.showNewPasswordForm\"> <label for=\"forgotPasswordEmail\">Email</label> <input ng-model=\"$ctrl.email\" id=\"forgotPasswordEmail\" name=\"email\" type=\"email\" required validate-email autocomplete=\"section-login email\" focus-if=\"{{$ctrl.showEmailInput && !$ctrl.showNewPasswordForm}}\" ng-disabled=\"$ctrl.showNewPasswordForm\"> <div class=\"checkout-input-errors\" ng-messages=\"$ctrl.forgotPasswordForm.email.$error\"> <div ng-message=\"required\">Email required</div> <div ng-message=\"validEmail\">Valid email required</div> <div ng-message=\"validLength\">Email must be less than 75 characters</div> </div> </input-container> <input-container form-input=\"$ctrl.forgotPasswordForm.password\" flex class=\"input-container-no-padding\" ng-if=\"$ctrl.showNewPasswordForm\"> <label for=\"password\">Password</label> <input class=\"login-form__password-input\" ng-model=\"$ctrl.password\" id=\"password\" name=\"password\" pattern=\"^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$\" type=\"{{$ctrl.showPassword ? 'text' : 'password'}}\" focus-if=\"$ctrl.showNewPasswordForm\" required> <md-button ng-click=\"$ctrl.onTogglePasswordVisibilityClick()\" class=\"md-icon-button login-form__password-toggle\" tabindex=\"-1\"> <md-icon>{{$ctrl.showPassword ? 'visibility_off' : 'visibility'}}</md-icon> </md-button> <div class=\"checkout-input-errors\" ng-messages=\"$ctrl.forgotPasswordForm.password.$error\"> <div ng-message=\"required\">Password is required</div> <div ng-message=\"pattern\">Password must be at least 8 characters and must contain at least one uppercase letter, one lowercase letter, and one number</div> </div> </input-container> <input-container form-input=\"$ctrl.forgotPasswordForm.code\" flex class=\"input-container-no-padding\" ng-if=\"$ctrl.showCodeInput\"> <label for=\"forgotPasswordCode\">6-digit access code</label> <input ng-model=\"$ctrl.code\" id=\"forgotPasswordCode\" name=\"code\" type=\"number\" max=\"999999\" focus-if=\"$ctrl.showCodeInput\" limit-input-length=\"6\" required> <div class=\"checkout-input-errors\" ng-messages=\"$ctrl.forgotPasswordForm.code.$error\"> <div ng-message=\"required\">Code required</div> <div ng-message=\"max\">Code must be 6 digits</div> </div> </input-container> </div> <div ng-if=\"$ctrl.showCodeInput\" layout layout-align=\"end center\" class=\"login-modal__resend-email\"> <button ng-if=\"!$ctrl.showEmailResentMessage\" class=\"login-modal__link-button\" ng-click=\"$ctrl.onDidNotGetEmailClick()\"> Didn't get it? </button> <div ng-if=\"$ctrl.showEmailResentMessage\" layout layout-align=\"end center\"> <md-icon>check</md-icon> <span>Email resent</span> </div> </div> <div ng-if=\"$ctrl.errorMessage\" class=\"login-modal__error\">{{$ctrl.errorMessage}}</div> <continue-button button-type=\"submit\" is-loading=\"$ctrl.sendingEmail\" ng-if=\"$ctrl.showEmailInput\"> Send email </continue-button> <continue-button button-type=\"submit\" is-loading=\"$ctrl.confirmingCode\" ng-if=\"$ctrl.showCodeInput\"> Update password </continue-button> <continue-button button-type=\"submit\" is-loading=\"$ctrl.updatingPassword\" ng-if=\"$ctrl.showNewPasswordForm\"> Update &amp; sign in </continue-button> </form> </div> </div> ";

/***/ }),
/* 916 */
/***/ (function(module, exports) {

module.exports = "<login-form ng-if=\"!$ctrl.showForgotPassword\" on-forgot-password-clicked=\"$ctrl.onForgotPasswordClicked(email)\" show-password-reset-success-message=\"$ctrl.showPasswordResetSuccessMessage\" init-email=\"$ctrl.initEmail\" message=\"$ctrl.message\"> </login-form> <forgot-password ng-if=\"$ctrl.showForgotPassword\" on-cancel-clicked=\"$ctrl.onCancelForgotPasswordClicked()\" email=\"$ctrl.forgotPasswordEmail\"> </forgot-password> ";

/***/ }),
/* 917 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.OrderSummary = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _collapsed = __webpack_require__(323);

var _orderNotes = __webpack_require__(324);

var _toggle = __webpack_require__(325);

var _giftCardChips = __webpack_require__(328);

var _promoCodeForm = __webpack_require__(326);

__webpack_require__(327);

var _cartUtils = __webpack_require__(19);

var _cartItem = __webpack_require__(919);

var _discountLineItems = __webpack_require__(921);

var _orderSummary = __webpack_require__(925);

var _orderSummary2 = _interopRequireDefault(_orderSummary);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var OrderSummary = exports.OrderSummary = angular.module('checkout.components.volt.orderSummary', [_cartItem.CartItem, _collapsed.OrderSummaryCollapsed, _orderNotes.OrderNotes, _toggle.OrderSummaryToggle, _promoCodeForm.PromoCodeForm, _giftCardChips.GiftCardChips, 'ngMaterial', _discountLineItems.DiscountLineItems]).component('voltOrderSummary', {
    template: _orderSummary2.default,
    bindings: {
        storeCreditInfo: '<',
        removeStoreCreditItem: '<',
        orderNotes: '<',
        onOrderNotesChanged: '<',
        onRemovePromoClicked: '<',
        onApplyPromoClicked: '<',
        promoCodeNotFound: '<',
        promoCodeExpired: '<',
        inactiveGiftCard: '<',
        giftCardNotAllowed: '<',
        giftCardAlreadyApplied: '<',
        cannotAddMoreStoreCredit: '<',
        discountCodeExistsInCart: '<',
        readOnly: '<',
        order: '<',
        returnUrl: '<',
        onCheckoutClicked: '<',
        checkoutButtonDisabled: '<',
        showCheckoutButton: '<',
        paymentMethod: '<',
        isReturnFromPaypal: '<',
        initPaypalSdkSummaryButton: '<',
        shippingAmount: '<',
        totalItems: '<',
        cartId: '<',
        cartItems: '<',
        subtotal: '<',
        taxAmount: '<',
        grandTotal: '<',
        discountAmount: '<',
        discounts: '<'
    },
    controller: function () {
        OrderSummaryCtrl.$inject = ['$window', '$scope', '$mdMedia', '$rootScope', '$timeout'];

        function OrderSummaryCtrl($window, $scope, $mdMedia, $rootScope, $timeout) {
            _classCallCheck(this, OrderSummaryCtrl);

            angular.extend(this, {
                $window: $window,
                $scope: $scope,
                $mdMedia: $mdMedia,
                $rootScope: $rootScope,
                $timeout: $timeout,
                collapsable: true
            });
        }

        _createClass(OrderSummaryCtrl, [{
            key: '$onInit',
            value: function $onInit() {
                var _this = this;

                this.$scope.$watch(function () {
                    return _this.$mdMedia('gt-sm');
                }, function (desktop) {
                    _this.collapsable = !desktop;
                    _this.collapsed = !desktop;
                });

                this.unbindForcePromoInputVisible = this.$rootScope.$on('OrderSummaryCtrl:ForcePromoInputVisible', function () {
                    _this.collapsed = false;
                    _this.showPromoInput = true;
                    _this.$timeout(function () {
                        _this.$window.document.querySelector('promo-code-form input').focus();
                    });
                });
                if (this.orderNotes) {
                    this.showOrderNotes = true;
                }

                this.totalItemCount = (0, _cartUtils.getNumberOfCartItems)(this.cartItems);
            }
        }, {
            key: '$onDestroy',
            value: function $onDestroy() {
                this.unbindForcePromoInputVisible();
            }
        }, {
            key: 'goToStorefront',
            value: function goToStorefront() {
                this.$window.location.href = this.returnUrl;
            }
        }, {
            key: 'onShowPromoInputClicked',
            value: function onShowPromoInputClicked() {
                this.showPromoInput = true;
            }
        }, {
            key: 'openSummary',
            value: function openSummary() {
                if (!this.collapsable) return;
                this.collapsed = !this.collapsed;
            }
        }]);

        return OrderSummaryCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CartItem = undefined;

var _imageCircle = __webpack_require__(206);

__webpack_require__(320);

var _cartItem = __webpack_require__(920);

var _cartItem2 = _interopRequireDefault(_cartItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CartItem = exports.CartItem = angular.module('checkout.components.volt.orderSummary.cartItem', [_imageCircle.ImageCircle]).component('voltCartItem', {
    template: _cartItem2.default,
    bindings: {
        quantity: '<',
        listPrice: '<',
        salePrice: '<',
        isOnSale: '<',
        productName: '<',
        variantName: '<',
        lineTotal: '<',
        imageSrc: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 920 */
/***/ (function(module, exports) {

module.exports = "<div layout=\"row\" class=\"cart-item\"> <image-circle image=\"$ctrl.imageSrc\"></image-circle> <div flex> <div layout=\"column\"> <div class=\"cart-item__name\">{{$ctrl.productName}}</div> <div class=\"cart-item__variants\" ng-if=\"$ctrl.variantName\"> {{ $ctrl.variantName }} </div> <div layout layout-align=\"space-between center\"> <span layout layout-align=\"start center\"> <span class=\"cart-item__qty\">Qty: {{$ctrl.quantity | number}}</span> <span class=\"cart-item__qty-x\">x</span> <span class=\"cart-item__list-price\" ng-class=\"{'cart-item__list-price--strikethrough': !!$ctrl.salePrice}\">{{$ctrl.listPrice | currency}}</span> <span class=\"cart-item__sale-price\" ng-if=\"$ctrl.isOnSale\">{{$ctrl.salePrice | currency}}</span> </span> <div class=\"cart-item__price\">{{$ctrl.lineTotal | currency}}</div> </div> </div> </div> </div> ";

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DiscountLineItems = undefined;

__webpack_require__(322);

var _promoCodeLineItem = __webpack_require__(922);

var _discountLineItems = __webpack_require__(924);

var _discountLineItems2 = _interopRequireDefault(_discountLineItems);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DiscountLineItems = exports.DiscountLineItems = angular.module('checkout.components.volt.orderSummary.discountLineItems', [_promoCodeLineItem.PromoCodeLineItem]).component('voltDiscountLineItems', {
    template: _discountLineItems2.default,
    bindings: {
        discounts: '<',
        appliedDiscount: '<',
        onRemovePromoClicked: '<'
    }
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.PromoCodeLineItem = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(321);

var _inputContainer = __webpack_require__(37);

var _promoCodeLineItem = __webpack_require__(923);

var _promoCodeLineItem2 = _interopRequireDefault(_promoCodeLineItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PromoCodeLineItem = exports.PromoCodeLineItem = angular.module('checkout.components.volt.orderSummary.promoCodeLineItem', [_inputContainer.InputContainer]).component('voltPromoCodeLineItem', {
    template: _promoCodeLineItem2.default,
    bindings: {
        discount: '<',
        onRemovePromoClicked: '<',
        hideRemoveButton: '<'
    },
    controller: function () {
        function PromoCodeLineItemCtrl() {
            _classCallCheck(this, PromoCodeLineItemCtrl);
        }

        _createClass(PromoCodeLineItemCtrl, [{
            key: '$onInit',
            value: function $onInit() {
                this.codeRequired = this.discount ? this.discount.discountCode : '';
                this.discountName = this.discount ? this.discount.name : '';
            }
        }, {
            key: 'onRemoveClicked',
            value: function onRemoveClicked(discountCode) {
                var _this = this;

                this.isRemoving = true;
                this.onRemovePromoClicked(discountCode).finally(function () {
                    _this.isRemoving = false;
                });
            }
        }]);

        return PromoCodeLineItemCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 923 */
/***/ (function(module, exports) {

module.exports = "<div layout layout-align=\"space-between start\" class=\"promo-code-line-item order-totals-line-item order-totals-line-item--promo\"> <div class=\"promo-code-line-item__label\" flex=\"70\" layout=\"row\" layout-align=\"start center\"> <span class=\"order-totals-line-item--promo__name\">{{$ctrl.discount.name}}</span> <button type=\"button\" layout=\"row\" layout-align=\"center center\" ng-click=\"$ctrl.onRemoveClicked($ctrl.discount.discountCode)\" ng-if=\"!$ctrl.isRemoving && !$ctrl.hideRemoveButton && $ctrl.codeRequired\" class=\"checkout-button checkout-button--icon-only volt-checkout-button\"> <i class=\"material-icons\">close</i> </button> <md-progress-circular md-mode=\"indeterminate\" ng-if=\"$ctrl.isRemoving\" md-diameter=\"18\"/> </div> <div class=\"order-totals-line-item__value\" flex=\"30\"> <span ng-if=\"$ctrl.discount.amount > 0\">-</span> <span>{{$ctrl.discount.amount / 100 | currency}}</span> </div> </div> ";

/***/ }),
/* 924 */
/***/ (function(module, exports) {

module.exports = "<div class=\"discount-line-items\"> <div class=\"order-totals-line-item__title\">Discount:</div> <div ng-repeat=\"discount in $ctrl.discounts\"> <volt-promo-code-line-item discount=\"discount\" hide-remove-button=\"!discount.discountCode\" on-remove-promo-clicked=\"$ctrl.onRemovePromoClicked\"/> </div> </div> ";

/***/ }),
/* 925 */
/***/ (function(module, exports) {

module.exports = "<md-card class=\"checkout-card order-summary\" id=\"checkout-order-summary\"> <div ng-if=\"$ctrl.showCheckoutButton && $ctrl.collapsable\"> <continue-button ng-if=\"($ctrl.paymentMethod !== 'PayPal') || ($ctrl.paymentMethod === 'PayPal' && $ctrl.isReturnFromPaypal)\" is-disabled=\"$ctrl.checkoutButtonDisabled\" on-clicked=\"$ctrl.onCheckoutClicked()\"> Complete your order </continue-button> <checkout-with-paypal-sdk-summary-button ng-if=\"!$ctrl.isReturnFromPaypal && $ctrl.paymentMethod === 'PayPal'\" cart-id=\"$ctrl.cartId\"> </checkout-with-paypal-sdk-summary-button> </div> <div ng-click=\"$ctrl.openSummary()\" layout=\"column\" class=\"order-summary__header\"> <div layout layout-align=\"space-between center\"> <span class=\"checkout-card-heading\">Order Summary</span> <ng-pluralize ng-if=\"!$ctrl.collapsable\" class=\"order-summary__num-of-items\" count=\"$ctrl.totalItemCount\" when=\"{'one': '1 item', 'other': '{} items'}\"> </ng-pluralize> <order-summary-toggle ng-if=\"$ctrl.collapsable\" collapsed=\"$ctrl.collapsed\"> </order-summary-toggle> </div> <order-summary-collapsed ng-if=\"$ctrl.collapsable && $ctrl.collapsed\" grand-total=\"$ctrl.grandTotal\" total-items=\"$ctrl.totalItemCount\" image-one=\"$ctrl.cartItems[0].imageSrc\" image-two=\"$ctrl.cartItems[1].imageSrc\"> </order-summary-collapsed> </div> <md-card-content ng-if=\"($ctrl.collapsable && !$ctrl.collapsed) || !$ctrl.collapsable\"> <volt-cart-item ng-repeat=\"item in $ctrl.cartItems\" quantity=\"item.quantity\" list-price=\"item.price.amount / 100\" sale-price=\"item.salePrice / 100\" is-on-sale=\"item.salePrice !== undefined\" product-name=\"item.productName\" variant-name=\"item.variantName\" line-total=\"item.quantity * item.price.amount / 100\" image-src=\"item.imageSrc\"> </volt-cart-item> <div ng-if=\"!$ctrl.order\"> <hr class=\"checkout-line\"> <button class=\"checkout-button checkout-button--flat\" type=\"button\" ng-click=\"$ctrl.onShowPromoInputClicked()\" ng-if=\"!$ctrl.showPromoInput\"> <div layout layout-align=\"center center\"> <i class=\"material-icons\">local_offer</i> <span ng-if=\"$ctrl.isShippingRequired\">Add a promo code or gift card</span> <span ng-if=\"!$ctrl.isShippingRequired\">Add a promo code</span> </div> </button> <promo-code-form ng-if=\"$ctrl.showPromoInput\" promo-code-not-found=\"$ctrl.promoCodeNotFound\" promo-code-expired=\"$ctrl.promoCodeExpired\" inactive-gift-card=\"$ctrl.inactiveGiftCard\" gift-card-not-allowed=\"$ctrl.giftCardNotAllowed\" gift-card-already-applied=\"$ctrl.giftCardAlreadyApplied\" cannot-add-more-store-credit=\"$ctrl.cannotAddMoreStoreCredit\" discount-code-exists-in-cart=\"$ctrl.discountCodeExistsInCart\" on-apply-promo-clicked=\"$ctrl.onApplyPromoClicked\"> </promo-code-form> <gift-card-chips store-credit-info=\"$ctrl.storeCreditInfo\" remove-store-credit-item=\"$ctrl.removeStoreCreditItem\"> </gift-card-chips> </div> <hr class=\"checkout-line\"> <order-totals-line-item title-text=\"Items total:\" value-text=\"{{ $ctrl.subtotal | currency }}\"> </order-totals-line-item> <volt-discount-line-items ng-if=\"$ctrl.discounts.length > 0\" discounts=\"$ctrl.discounts\" on-remove-promo-clicked=\"$ctrl.onRemovePromoClicked\"> </volt-discount-line-items> <order-totals-line-item title-text=\"Shipping:\" value-text=\"{{ $ctrl.shippingAmount | vCurrency }}\"> </order-totals-line-item> <order-totals-line-item title-text=\"Taxes:\" value-text=\"{{ $ctrl.taxAmount | currency }}\"> </order-totals-line-item> <store-credit-line-items ng-if=\"$ctrl.storeCreditInfo.items.length > 0\" store-credit-info=\"$ctrl.storeCreditInfo\" hide-remove-button=\"$ctrl.order\"> </store-credit-line-items> <hr class=\"checkout-line\"> <order-totals-line-item title-text=\"Order total:\" value-text=\"{{ $ctrl.grandTotal | currency }}\" bold=\"true\"> </order-totals-line-item> <hr class=\"checkout-line\"> <div ng-if=\"!$ctrl.order\"> <button class=\"checkout-button checkout-button--flat\" type=\"button\" ng-click=\"$ctrl.showOrderNotes = true\" ng-if=\"!$ctrl.showOrderNotes\"> <div layout layout-align=\"center center\"> <i class=\"material-icons\">mode_edit</i> <span>Need to leave us a note?</span> </div> </button> <order-notes on-order-notes-changed=\"$ctrl.onOrderNotesChanged\" order-notes=\"$ctrl.orderNotes\" ng-if=\"$ctrl.showOrderNotes\"></order-notes> </div> <div ng-if=\"$ctrl.order\" class=\"order-summary__order-placed\"> <display-info ng-if=\"$ctrl.order.shopperNote\"> <display-info-title>Order notes</display-info-title> <display-info-content>{{$ctrl.order.shopperNote}}</display-info-content> </display-info> <button class=\"checkout-button checkout-button--border checkout-button--large\" type=\"button\" ng-click=\"$ctrl.goToStorefront()\"> Continue shopping </button> </div> </md-card-content> </md-card> ";

/***/ }),
/* 926 */
/***/ (function(module, exports) {

module.exports = "<header-background store-info=\"$ctrl.storeInfo\"> <div class=\"checkout\" id=\"checkout\" ng-if=\"!$ctrl.order\"> <checkout-header store-info=\"$ctrl.storeInfo\" return-url=\"$ctrl.returnUrl\" is-logged-in=\"$ctrl.isLoggedIn\" logged-in-shopper-name=\"$ctrl.loggedInShopper.firstName || $ctrl.loggedInShopper.emailAddress\" use-new-carts=\"true\"> </checkout-header> <div layout=\"column\" layout-gt-sm=\"row\"> <div flex=\"100\" flex-gt-sm=\"60\"> <accordian heading-text=\"$ctrl.stepOneHeadingText\" step-number=\"1\" open=\"$ctrl.shouldStepOneBeOpen()\" light=\"$ctrl.steps.contactAndDelivery.complete\"> <accordian-header-content> <edit-step-button on-click=\"$ctrl.onEditStepOneClicked(event)\" ng-if=\"$ctrl.steps.contactAndDelivery.complete\"> </edit-step-button> <login-button ng-if=\"$ctrl.shouldShowLoginButton()\" on-login-clicked=\"$ctrl.onLoginClicked()\"> </login-button> </accordian-header-content> <accordian-content> <div ng-if=\"!$ctrl.steps.contactAndDelivery.complete && !$ctrl.showAddressSuggestion\"> <ng-form name=\"$ctrl.contactAndDeliveryForm\"> <h3 class=\"checkout-section-heading\">Contact info</h3> <contact-info-form phone-number-required=\"$ctrl.storeInfo.isCheckoutPhoneNumberRequired\" email-input-disabled=\"$ctrl.isLoggedIn\" model=\"$ctrl.contactInfoModel\"> </contact-info-form> <hr> <div class=\"checkout-section-heading\"> <h3 ng-if=\"$ctrl.isShippingRequired\" class=\"checkout-section-heading__title\">Shipping address</h3> <h3 ng-if=\"!$ctrl.isShippingRequired\" class=\"checkout-section-heading__title\">Billing address</h3> <div class=\"curbside-shipping-available\" ng-if=\"$ctrl.curbsideShippingAvailable\"> We offer Curbside Pickup as a shipping method. Please continue to enter your shipping address. </div> </div> <shipping-address-form model=\"$ctrl.shippingAddressModel\" use-address-verification=\"$ctrl.useAddressVerification\" hide-shipping-as-billing=\"!$ctrl.isShippingRequired\"> </shipping-address-form> </ng-form> <div layout layout-align-xs=\"center start\" layout-align-gt-xs=\"end start\" class=\"checkout-step-footer\"> <continue-button ng-if=\"$ctrl.isShippingRequired\" is-disabled=\"$ctrl.isUpdatingCart\" is-loading=\"$ctrl.isStepOneLoading\" on-clicked=\"$ctrl.onStepOneContinueClicked()\"> Continue to Shipping Method </continue-button> <continue-button ng-if=\"!$ctrl.isShippingRequired\" is-disabled=\"$ctrl.isUpdatingCart\" is-loading=\"$ctrl.isStepOneLoading\" on-clicked=\"$ctrl.onStepOneContinueClicked()\"> Skip to Payment &amp; Review </continue-button> </div> </div> <div ng-if=\"!$ctrl.steps.contactAndDelivery.complete && $ctrl.showAddressSuggestion\"> <address-verification-form contact-info=\"$ctrl.contactInfoModel\" address=\"$ctrl.shippingAddressModel\" recommendations=\"$ctrl.verificationRecommendations\" changes=\"$ctrl.verificationChanges\" on-choose-address=\"$ctrl.updateAddress\"/> </div> <display-contact-and-delivery ng-if=\"$ctrl.steps.contactAndDelivery.complete\" is-shipping-required=\"$ctrl.isShippingRequired\" is-shipping-address-verified=\"$ctrl.isShippingAddressVerified\" is-billing-address-verified=\"$ctrl.isBillingAddressVerified\" cart=\"$ctrl.cartAndSavedInfo\"> </display-contact-and-delivery> <secondary-login-button ng-if=\"$ctrl.shouldShowSecondaryLoginButton()\" on-login-clicked=\"$ctrl.onLoginClicked()\"> </secondary-login-button> </accordian-content> </accordian> <accordian heading-text=\"$ctrl.stepTwoHeadingText\" step-number=\"2\" open=\"$ctrl.shouldStepTwoBeOpen()\" light=\"$ctrl.steps.shippingMethod.complete\" id=\"checkout-step-2\"> <accordian-header-content> <edit-step-button on-click=\"$ctrl.onEditStepTwoClicked(event)\" ng-if=\"$ctrl.shouldShowEditStepTwoButton()\"> </edit-step-button> </accordian-header-content> <accordian-content> <div ng-if=\"!$ctrl.steps.shippingMethod.complete\"> <ng-form name=\"$ctrl.shippingMethodStepForm\"> <shipping-method-form shipping-methods=\"$ctrl.availableShippingMethods\" selected-method-index=\"$ctrl.selectedShippingMethodIndex\" disable-form=\"$ctrl.isUpdatingCart\"> </shipping-method-form> </ng-form> <div layout layout-align-xs=\"center start\" layout-align-gt-xs=\"end start\" class=\"checkout-step-footer\" ng-if=\"$ctrl.shouldShowStepTwoContinueButton()\"> <continue-button is-disabled=\"$ctrl.isUpdatingCart\" is-loading=\"$ctrl.isStepTwoLoading\" on-clicked=\"$ctrl.onStepTwoContinueClicked()\"> Continue to Payment &amp; Review </continue-button> </div> </div> <display-shipping-method ng-if=\"$ctrl.steps.shippingMethod.complete\" shipping-method=\"$ctrl.availableShippingMethods[$ctrl.selectedShippingMethodIndex]\"> </display-shipping-method> </accordian-content> </accordian> <accordian heading-text=\"$ctrl.stepThreeHeadingText\" step-number=\"3\" open=\"$ctrl.shouldStepThreeBeOpen()\" light=\"$ctrl.steps.paymentAndReview.complete\" id=\"checkout-step-3\" class=\"checkout-step-3\"> <accordian-header-content> <div layout layout-align=\"start center\"> <promo-code-link ng-if=\"$ctrl.shouldShowPromoCodeLink()\"></promo-code-link> <edit-step-button on-click=\"$ctrl.onEditStepThreeClicked()\" ng-if=\"$ctrl.shouldShowEditStepThreeButton()\"> </edit-step-button> </div> </accordian-header-content> <accordian-content> <div ng-if=\"$ctrl.shouldShowPaymentTypeSelection()\"> <ng-form name=\"$ctrl.paymentAndReviewForm\" ng-if=\"$ctrl.shouldShowPaymentMethodForm()\"> <payment-method-form available-payment-methods=\"$ctrl.availablePaymentMethods\" selected-payment-method=\"$ctrl.selectedPaymentMethod\" credit-card-model=\"$ctrl.creditCardModel\" on-credit-card-type-updated=\"$ctrl.updateCreditCardType\" billing-address-model=\"$ctrl.billingAddressModel\" billing-same-as-shipping=\"$ctrl.billingSameAsShipping\" store-info=\"$ctrl.storeInfo\" stripe-elements-card=\"$ctrl.stripeElementsCard\" on-stripe-elements-card-change=\"$ctrl.onStripeElementsCardChange\" is-shipping-required=\"$ctrl.isShippingRequired\"> </payment-method-form> </ng-form> <md-checkbox ng-model=\"$ctrl.saveLoggedInShopperInfo\" ng-if=\"$ctrl.isLoggedIn && (!$ctrl.savedShippingAddresses.items.length || !$ctrl.savedPaymentMethods.length)\" class=\"save-shopper-info-checkbox\"> Save my information for a faster checkout </md-checkbox> <display-billing-and-payment ng-if=\"$ctrl.isReturnFromPaypal\" payment-method=\"'PayPal'\" paypal-email=\"$ctrl.cart.contactInfo.email\"> </display-billing-and-payment> <display-billing-and-payment ng-if=\"$ctrl.shouldShowAccountPaymentAndBilling()\" payment-method=\"'Credit Card'\" credit-card-type=\"$ctrl.selectedCard.brand\" credit-card-last-four=\"$ctrl.selectedCard.lastFour\" cart-address=\"$ctrl.accountBillingAddress\"> </display-billing-and-payment> </div> <div ng-if=\"!$ctrl.shouldShowPaymentTypeSelection()\" class=\"no-payment-needed\"> Order total is {{$ctrl.grandTotal | currency}}. No additional payment necessary. </div> <div layout layout-align-sm=\"center start\" layout-align-gt-sm=\"end start\" class=\"checkout-step-footer\" ng-if=\"!$ctrl.shouldShowCheckoutWithPaypalButton() || !$ctrl.shouldShowPaymentTypeSelection()\"> <div layout=\"column\" layout-align=\"center center\" flex-xs=\"100\" flex-sm=\"100\"> <continue-button is-disabled=\"$ctrl.isUpdatingCart\" on-clicked=\"$ctrl.onCheckoutClicked()\"> Complete your order </continue-button> <secure-label></secure-label> </div> </div> <div layout=\"column\" layout-align=\"start center\" class=\"checkout-step-footer\" ng-if=\"$ctrl.shouldShowCheckoutWithPaypalButton() && $ctrl.shouldShowPaymentTypeSelection()\"> <div> <checkout-with-paypal-sdk-button cart-id=\"$ctrl.cart.cartId\" bag-id=\"$ctrl.bag.id\" get-gift-cards=\"$ctrl.getGiftCards\"> </checkout-with-paypal-sdk-button> <secure-label></secure-label> </div> </div> </accordian-content> </accordian> </div> <volt-order-summary flex=\"100\" flex-gt-sm=\"40\" flex-order=\"-1\" flex-order-gt-sm=\"0\" cart-items=\"$ctrl.cart.items\" subtotal=\"$ctrl.cart.pricing.subtotal.amount / 100\" tax-amount=\"$ctrl.taxAmountInCents / 100\" grand-total=\"$ctrl.grandTotal\" shipping-amount=\"$ctrl.cartAndSavedInfo.shippingMethod.shippingPrice\" discount-amount=\"$ctrl.cart.pricing.discount.amount / 100\" discounts=\"$ctrl.cart.pricing.appliedDiscounts\" cart-id=\"$ctrl.cart.id\" order-notes=\"$ctrl.orderNotes\" store-credit-info=\"$ctrl.storeCreditInfo\" on-apply-promo-clicked=\"$ctrl.applyPromoCode\" on-remove-promo-clicked=\"$ctrl.removeDiscountCodeItem\" remove-store-credit-item=\"$ctrl.removeStoreCreditItem\" promo-code-not-found=\"$ctrl.promoCodeNotFound\" promo-code-expired=\"$ctrl.promoCodeExpired\" inactive-gift-card=\"$ctrl.inactiveGiftCard\" gift-card-not-allowed=\"$ctrl.giftCardNotAllowed\" gift-card-already-applied=\"$ctrl.giftCardAlreadyApplied\" cannot-add-more-store-credit=\"$ctrl.cannotAddMoreStoreCredit\" discount-code-exists-in-cart=\"$ctrl.discountCodeExistsInCart\" on-order-notes-changed=\"$ctrl.onOrderNotesChanged\" show-checkout-button=\"$ctrl.currentStep === $ctrl.steps.paymentAndReview.number\" checkout-button-disabled=\"$ctrl.isUpdatingCart\" on-checkout-clicked=\"$ctrl.onCheckoutClicked\" payment-method=\"$ctrl.selectedPaymentMethod\" is-return-from-paypal=\"$ctrl.isReturnFromPaypal\" is-shipping-required=\"$ctrl.isShippingRequired\"> </volt-order-summary> </div> </div> <thank-you ng-if=\"$ctrl.order\" order=\"$ctrl.order\" store-credit-info=\"$ctrl.storeCreditInfo\" is-logged-in=\"$ctrl.isLoggedIn\" store-info=\"$ctrl.storeInfo\" return-url=\"$ctrl.returnUrl\" show-create-account=\"!$ctrl.isLoggedIn && !$ctrl.shopperIsRegistered\" stripe-token-for-account-creation=\"$ctrl.stripeTokenForAccountCreation\"> </thank-you> </header-background> <fullscreen-loader ng-if=\"$root.loader.show\" title-text=\"$root.loader.titleText\" title-image=\"$root.loader.imageUri\" description=\"$root.loader.description\"> </fullscreen-loader> ";

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(angular) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CheckoutComponent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _assign = __webpack_require__(44);

var _assign2 = _interopRequireDefault(_assign);

var _get = __webpack_require__(16);

var _get2 = _interopRequireDefault(_get);

var _isEqual = __webpack_require__(193);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _cloneDeep = __webpack_require__(300);

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _has = __webpack_require__(196);

var _has2 = _interopRequireDefault(_has);

var _find = __webpack_require__(76);

var _find2 = _interopRequireDefault(_find);

var _angularjs = __webpack_require__(111);

var _angularjs2 = _interopRequireDefault(_angularjs);

__webpack_require__(36);

var _checkout = __webpack_require__(18);

var _facebookPixel = __webpack_require__(200);

var _paypalSdk = __webpack_require__(67);

var _ga = __webpack_require__(129);

var _api = __webpack_require__(14);

var _auth = __webpack_require__(78);

var _shopperAccount = __webpack_require__(80);

var _cartUtils = __webpack_require__(19);

var _order = __webpack_require__(304);

var _creditCard = __webpack_require__(94);

var _dataLayer = __webpack_require__(305);

var _addressVerification = __webpack_require__(79);

var _accordian = __webpack_require__(307);

var _addressForm = __webpack_require__(54);

var _checkoutWithPaypalSdkAcp = __webpack_require__(315);

var _checkoutWithPaypalSdkButton = __webpack_require__(308);

var _checkoutWithPaypalSdkSummaryButton = __webpack_require__(309);

var _continueButton = __webpack_require__(130);

var _orderSummary = __webpack_require__(319);

var _paymentMethodForm = __webpack_require__(310);

var _contactInfoForm = __webpack_require__(134);

var _shippingAddressForm = __webpack_require__(204);

var _displayContactAndDelivery = __webpack_require__(316);

var _shippingMethodForm = __webpack_require__(205);

var _displayShippingMethod = __webpack_require__(317);

var _thankYou = __webpack_require__(318);

var _displayBillingAndPayment = __webpack_require__(207);

var _displayCountryName = __webpack_require__(83);

var _displayStateName = __webpack_require__(82);

var _fullscreenLoader = __webpack_require__(77);

var _header = __webpack_require__(208);

var _editShippingMethod = __webpack_require__(330);

var _editContactAndDelivery = __webpack_require__(331);

var _headerBackground = __webpack_require__(209);

var _promoCodeLink = __webpack_require__(332);

var _editStepButton = __webpack_require__(333);

var _loginButton = __webpack_require__(334);

var _secondaryLoginButton = __webpack_require__(335);

var _editAccountContactAndDelivery = __webpack_require__(336);

var _editAccountPayment = __webpack_require__(337);

var _loginModal = __webpack_require__(339);

var _stripeElementsForm = __webpack_require__(133);

var _checkout2 = __webpack_require__(928);

var _checkout3 = _interopRequireDefault(_checkout2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var noShippingMethodsIndex = -1;
var DEFAULT_COUNTRY = 'US';

var STEP_ONE_HEADING_TEXT_NO_SHIPPING = 'Contact & Billing';
var STEP_ONE_HEADING_TEXT_WITH_SHIPPING = 'Contact & Delivery';
var STEP_TWO_HEADING_TEXT = 'Shipping Method';
var STEP_THREE_HEADING_TEXT = 'Payment & Review';

var CheckoutComponent = exports.CheckoutComponent = angular.module('checkout.checkoutComponent', [_angularjs2.default, 'app.constants', _addressVerification.AddressVerificationService, _checkout.CheckoutService, _facebookPixel.FacebookPixelService, _paypalSdk.PaypalSdkService, _ga.GaService, _api.ApiService, _auth.AuthService, _shopperAccount.ShopperAccountService, _order.OrderService, _accordian.Accordian, _addressForm.AddressForm, _checkoutWithPaypalSdkAcp.CheckoutWithPaypalSdkAcp, _checkoutWithPaypalSdkButton.CheckoutWithPaypalSdkButton, _checkoutWithPaypalSdkSummaryButton.CheckoutWithPaypalSdkSummaryButton, _continueButton.ContinueButton, _orderSummary.OrderSummary, _paymentMethodForm.PaymentMethodForm, _contactInfoForm.ContactInfoForm, _shippingAddressForm.ShippingAddressForm, _displayContactAndDelivery.DisplayContactAndDelivery, _shippingMethodForm.ShippingMethodForm, _displayShippingMethod.DisplayShippingMethod, _thankYou.ThankYou, _displayBillingAndPayment.DisplayBillingAndPayment, _displayCountryName.DisplayCountryName, _displayStateName.DisplayStateName, _fullscreenLoader.FullscreenLoaderService, _header.Header, _editShippingMethod.EditShippingMethod, _editContactAndDelivery.EditContactAndDelivery, _headerBackground.HeaderBackground, _promoCodeLink.PromoCodeLink, _editStepButton.EditStepButton, _loginButton.LoginButton, _secondaryLoginButton.SecondaryLoginButton, _editAccountContactAndDelivery.EditAccountContactAndDelivery, _editAccountPayment.EditAccountPayment, _loginModal.LoginModal]).component('checkout', {
    template: _checkout3.default,
    bindings: {
        cart: '<',
        bag: '<',
        storeInfo: '<',
        returnUrl: '<',
        availablePaymentMethods: '<',
        isLoggedIn: '<',
        shippingMethods: '<',
        stripePublishableKey: '<',
        useAddressVerification: '<'
    },
    controller: function () {
        CheckoutCtrl.$inject = ['$timeout', '$anchorScroll', '$stateParams', '$rootScope', '$scope', '$mdMedia', '$location', '$window', '$q', 'addressVerificationService', 'gaService', 'facebookPixelService', 'checkoutService', 'paypalSdkService', 'editContactAndDeliveryService', 'editShippingMethodService', 'editAccountContactAndDeliveryService', 'editAccountPaymentService', 'apiService', 'loginModalService', 'authService', 'orderService', 'shopperAccountService', 'loadingService', 'GA_CHECKOUT_STEPS', 'scriptLoaderService'];

        function CheckoutCtrl($timeout, $anchorScroll, $stateParams, $rootScope, $scope, $mdMedia, $location, $window, $q, addressVerificationService, gaService, facebookPixelService, checkoutService, paypalSdkService, editContactAndDeliveryService, editShippingMethodService, editAccountContactAndDeliveryService, editAccountPaymentService, apiService, loginModalService, authService, orderService, shopperAccountService, loadingService, GA_CHECKOUT_STEPS, scriptLoaderService) {
            _classCallCheck(this, CheckoutCtrl);

            (0, _assign2.default)(this, {
                $timeout: $timeout,
                $anchorScroll: $anchorScroll,
                $stateParams: $stateParams,
                $rootScope: $rootScope,
                $scope: $scope,
                $mdMedia: $mdMedia,
                $location: $location,
                $window: $window,
                $q: $q,
                addressVerificationService: addressVerificationService,
                gaService: gaService,
                facebookPixelService: facebookPixelService,
                checkoutService: checkoutService,
                paypalSdkService: paypalSdkService,
                editContactAndDeliveryService: editContactAndDeliveryService,
                editShippingMethodService: editShippingMethodService,
                editAccountContactAndDeliveryService: editAccountContactAndDeliveryService,
                editAccountPaymentService: editAccountPaymentService,
                apiService: apiService,
                loginModalService: loginModalService,
                authService: authService,
                orderService: orderService,
                shopperAccountService: shopperAccountService,
                loadingService: loadingService,
                curbsideShippingAvailable: false,
                GA_CHECKOUT_STEPS: GA_CHECKOUT_STEPS,
                scriptLoaderService: scriptLoaderService,

                steps: {
                    contactAndDelivery: { number: 1, complete: false },
                    shippingMethod: { number: 2, complete: false },
                    paymentAndReview: { number: 3, complete: false }
                },
                selectedPaymentMethod: 'Credit Card',
                shippingAddressModel: {
                    shippingAsBilling: true,
                    country: DEFAULT_COUNTRY
                },
                billingAddressModel: {
                    country: DEFAULT_COUNTRY
                },
                showPromoInput: false,
                orderSummaryCollapsed: true,
                saveLoggedInShopperInfo: true
            });

            this.updateCreditCardType = this.updateCreditCardType.bind(this);
            this.onStripeElementsCardChange = this.onStripeElementsCardChange.bind(this);
            this.updateAddress = this.updateAddress.bind(this);
            this.getGiftCards = this.getGiftCards.bind(this);
        }

        _createClass(CheckoutCtrl, [{
            key: '$onInit',
            value: function $onInit() {
                var _this = this;

                this.loadingService.hide(); // Needed for logging out, which reloads state
                this.checkoutService.applyCheckoutUrl(this.bag.returnUri, this.bag.id);
                this.storeCreditInfo = (0, _cartUtils.getSavedStoreCreditInfo)();

                if (this.cart) {
                    this.currentStep = this.steps.contactAndDelivery.number;
                    this.gaService.logCheckoutStep(this.GA_CHECKOUT_STEPS.entrance, null, this.cart);
                    (0, _dataLayer.logPageView)(this.bag.tenantId);
                    (0, _dataLayer.logCheckoutStarted)(this.bag.tenantId, this.cart, this.returnUrl);

                    this.removeDiscountCodeItem = this.removeDiscountCodeItem.bind(this);
                    this.removeStoreCreditItem = this.removeStoreCreditItem.bind(this);
                    this.applyPromoCode = this.applyPromoCode.bind(this);
                    this.onOrderNotesChanged = this.onOrderNotesChanged.bind(this);
                    this.onCheckoutClicked = this.onCheckoutClicked.bind(this);

                    this.selectedPaymentMethod = this.checkoutService.getOptimalDefaultPaymentMethod(this.availablePaymentMethods);

                    var orderNotes = this.$window.localStorage.getItem(this.cart.id);
                    if (orderNotes) {
                        this.orderNotes = orderNotes;
                    }

                    if (this.paypalSdkService.paypalIsAvailablePaymentMethod(this.storeInfo)) {
                        this.paypalSdkService.init({
                            storeInfo: this.storeInfo,
                            cartId: this.cart.id,
                            bagId: this.bag.id,
                            total: this.cart.grandTotal,
                            getGiftCards: this.getGiftCards
                        });
                    }
                }
                if (this.paypalSdkService.hasPaypalQueryParams(this.$stateParams)) {
                    this.initPaypalReturn();

                    if (this.isLoggedIn) {
                        this.initShopperAccount(true);
                    }
                } else {
                    if (this.isLoggedIn) {
                        this.initShopperAccount();
                    }
                    this.setStateFromCart(this.cart);
                    (0, _dataLayer.logCheckoutStarted)(this.bag.tenantId, this.cart, this.returnUrl);
                }

                if ((0, _has2.default)(this.storeInfo, 'thirdPartyIntegrations.facebookTrackingPixelId')) {
                    this.facebookPixelService.trackInitiateCheckoutEvent(this.cart);
                }
                this.$scope.$watch(function () {
                    return _this.$mdMedia('xs');
                }, function (xs) {
                    _this.isMobile = xs;
                });

                if (this.storeInfo.acceptsStripeAsPayment) {
                    this.$q.all([this.scriptLoaderService.loadScriptTagPromise({
                        src: 'https://js.stripe.com/v3',
                        async: true
                    }), this.apiService.getStripePublishableKey()]).then(function (_ref) {
                        var _ref2 = _slicedToArray(_ref, 2),
                            stripePublishableKey = _ref2[1].stripePublishableKey;

                        // eslint-disable-next-line new-cap
                        _this.stripe = window.Stripe(stripePublishableKey);
                        _this.stripeElements = _this.stripe.elements();
                        _this.stripeElementsCard = _this.stripeElements.create('card', {
                            style: _stripeElementsForm.stripeElementCardStyle,
                            hidePostalCode: true
                        });
                    });
                }

                this.curbsideShippingAvailable = (0, _get2.default)(this.shippingMethods, 'shippingBands.curbside.enabled', false);
            }
        }, {
            key: 'getGiftCards',
            value: function getGiftCards() {
                return this.storeCreditInfo.items.map(function (item) {
                    return item.giftCardCode;
                });
            }
        }, {
            key: 'setStateFromCart',
            value: function setStateFromCart(cart) {
                var throwErrorForNoShippingMethods = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                this.cart = cart;

                this.storeCreditInfo = this.applyGiftCardTotals(this.cart, this.storeCreditInfo);
                (0, _cartUtils.setSavedStoreCreditInfo)(this.storeCreditInfo);

                this.selectedShippingMethodIndex = this.getSelectedShippingMethodIndexOrDefault(cart);

                this.isShippingRequired = (0, _cartUtils.isShippingRequiredOnCart)(this.cart.items);

                this.steps.contactAndDelivery.complete = this.isContactAndDeliveryComplete(this.cart);
                if (this.cart.shippingAddress) {
                    if (!this.steps.contactAndDelivery.complete) {
                        this.shippingAddressModel = this.cart.shippingAddress;
                        this.contactInfoModel = this.cart.contactInfo;
                    } else {
                        if (!this.isShippingRequired) {
                            this.cart.billingAddress = this.cart.shippingAddress;
                        }
                    }
                }
                this.billingSameAsShipping = (0, _cartUtils.isShippingAndBillingAddressSame)(this.cart);
                if (this.billingSameAsShipping) {
                    this.billingAddressModel = this.cart.billingAddress;
                }

                if (this.isShippingStepComplete(cart)) {
                    this.steps.shippingMethod.complete = true;
                }
                if (throwErrorForNoShippingMethods) this.throwIfNoShippingMethods();
                var currentStep = this.steps.contactAndDelivery.complete ? this.steps.shippingMethod.number : this.steps.contactAndDelivery.number;
                if (this.steps.shippingMethod.complete) {
                    currentStep = this.steps.paymentAndReview.number;
                }
                this.currentStep = currentStep;
                this.stepOneHeadingText = this.isShippingRequired ? STEP_ONE_HEADING_TEXT_WITH_SHIPPING : STEP_ONE_HEADING_TEXT_NO_SHIPPING;
                this.stepTwoHeadingText = STEP_TWO_HEADING_TEXT;
                this.stepThreeHeadingText = STEP_THREE_HEADING_TEXT;
            }
        }, {
            key: 'isShippingStepComplete',
            value: function isShippingStepComplete(cart) {
                return this.steps.contactAndDelivery.complete && !this.isShippingRequired || this.hasValidShippingSelection() && (this.didContinueStepTwo || (0, _cartUtils.hasValidShippingMethod)(cart.availableShippingMethods, cart.shippingMethod));
            }
        }, {
            key: 'applyGiftCardTotals',
            value: function applyGiftCardTotals(cart, storeCreditInfo) {
                var grandTotalInCents = cart.grandTotal * 100;
                var storeCreditAmountInCents = 0;
                var items = storeCreditInfo.items.map(function (item) {
                    if (grandTotalInCents > item.balance) {
                        var _amountUsedInCents = item.balance;
                        storeCreditAmountInCents += item.balance;
                        grandTotalInCents -= item.balance;
                        return _extends({}, item, {
                            amountUsedInCents: _amountUsedInCents
                        });
                    }
                    if (grandTotalInCents < item.balance) {
                        var _amountUsedInCents2 = grandTotalInCents;
                        storeCreditAmountInCents += grandTotalInCents;
                        grandTotalInCents = 0;
                        return _extends({}, item, {
                            amountUsedInCents: _amountUsedInCents2
                        });
                    }
                    // only possibility left: grandTotalInCents === item.balance
                    var amountUsedInCents = grandTotalInCents;
                    storeCreditAmountInCents += grandTotalInCents;
                    grandTotalInCents = 0;
                    return _extends({}, item, {
                        amountUsedInCents: amountUsedInCents
                    });
                });
                return {
                    items: items,
                    storeCreditAmountInCents: storeCreditAmountInCents
                };
            }
        }, {
            key: 'hasValidShippingSelection',
            value: function hasValidShippingSelection() {
                return angular.isDefined(this.selectedShippingMethodIndex) && (!this.hasNoShippingMethodsForStore() || this.cart.shippingMethod) && this.cart.shippingAddress && this.cart.contactInfo && angular.isArray(this.cart.availableShippingMethods) && this.cart.availableShippingMethods.length > 0;
            }
        }, {
            key: 'hasNoShippingMethodsForStore',
            value: function hasNoShippingMethodsForStore() {
                return this.selectedShippingMethodIndex === noShippingMethodsIndex;
            }
        }, {
            key: 'throwIfNoShippingMethods',
            value: function throwIfNoShippingMethods() {
                if (this.hasNoShippingMethodsForStore()) {
                    throw new Error('This store does not have any shipping methods configured.');
                }
            }
        }, {
            key: 'updateAddress',
            value: function updateAddress(newAddress) {
                var _this2 = this;

                if (!newAddress) {
                    // edit address again
                    this.verificationRecommendations = null;
                    this.verificationChanges = null;
                    this.steps.contactAndDelivery.complete = false;
                    this.showAddressSuggestion = false;
                } else {
                    this.shippingAddressModel = _extends({}, newAddress);
                    this.isUpdatingCart = true;
                    this.isStepOneLoading = true;

                    this.saveContactInfoAndShippingAddress().finally(function () {
                        _this2.verificationRecommendations = null;
                        _this2.verificationChanges = null;
                        _this2.steps.contactAndDelivery.complete = true;
                        _this2.showAddressSuggestion = false;
                    });
                }
            }
        }, {
            key: 'onStepOneContinueClicked',
            value: function onStepOneContinueClicked() {
                var _this3 = this;

                if (this.contactAndDeliveryForm.$invalid) {
                    this.checkoutService.forceFormValidation(this.contactAndDeliveryForm['$ctrl.contactInfoForm']);
                    this.checkoutService.forceFormValidation(this.contactAndDeliveryForm['$ctrl.addressForm']);
                    return;
                }
                this.isUpdatingCart = true;
                this.isStepOneLoading = true;

                if (this.useAddressVerification) {
                    // check address validity and display recommendations (if needed)
                    this.addressVerificationService.verifyAddress(this.shippingAddressModel).then(function (_ref3) {
                        var verified = _ref3.verified,
                            changes = _ref3.changes,
                            recommendations = _ref3.recommendations;

                        if (!verified || changes) {
                            _this3.isUpdatingCart = false;
                            _this3.isStepOneLoading = false;

                            _this3.showAddressSuggestion = true;
                            _this3.verificationRecommendations = recommendations;
                            _this3.verificationChanges = changes;
                        } else {
                            _this3.saveContactInfoAndShippingAddress();
                        }
                    });
                } else {
                    this.saveContactInfoAndShippingAddress();
                }
            }
        }, {
            key: 'saveContactInfoAndShippingAddress',
            value: function saveContactInfoAndShippingAddress() {
                var _this4 = this;

                return this.checkoutService.applyContactInfoAndShippingAddressToCart({
                    contactInfoModel: this.contactInfoModel,
                    shippingAddressModel: this.shippingAddressModel
                }).then(function (updatedCart) {
                    if (_this4.isShippingRequired) {
                        _this4.setStateFromCart(updatedCart);
                        _this4.scrollToCurrentStep();
                    }
                    _this4.trackStepOneEvents();
                    (0, _dataLayer.logShopperInfo)(_this4.bag.tenantId, updatedCart);

                    (_this4.$window.dataLayer || []).push({
                        event: 'contact_info',
                        contact_email: _this4.contactInfoModel.email,
                        contact_first_name: _this4.shippingAddressModel.firstName,
                        contact_last_name: _this4.shippingAddressModel.lastName,
                        contact_country: _this4.shippingAddressModel.country,
                        contact_address: _this4.shippingAddressModel.address1,
                        contact_city: _this4.shippingAddressModel.city,
                        contact_state: _this4.shippingAddressModel.state,
                        contact_zip: _this4.shippingAddressModel.postalCode
                    });
                    if (_this4.loggedInShopper && updatedCart.contactInfo.phoneNumber !== undefined && updatedCart.contactInfo.phoneNumber !== _this4.loggedInShopper.contactInformation.phoneNumber) {
                        _this4.checkoutService.applyUpdatedPhoneNumberToShopper(_this4.loggedInShopper, updatedCart.contactInfo.phoneNumber).then(function (updatedShopper) {
                            if (updatedShopper) {
                                _this4.loggedInShopper = updatedShopper;
                            }
                        }).catch(function (err) {
                            _this4.checkoutService.showErrorDialog(err);
                        });
                    }
                }).then(function () {
                    if (!_this4.isShippingRequired) {
                        return _this4.onStepTwoContinueClicked(true);
                    }
                }).catch(function (err) {
                    _this4.checkoutService.showErrorDialog(err);
                }).finally(function () {
                    _this4.isUpdatingCart = false;
                    _this4.isStepOneLoading = false;
                });
            }
        }, {
            key: 'onStepTwoContinueClicked',
            value: function onStepTwoContinueClicked(bypassShipping) {
                var _this5 = this;

                if (!bypassShipping && this.shippingMethodStepForm.$invalid) {
                    this.checkoutService.forceFormValidation(this.shippingMethodStepForm);
                    return;
                }
                var genericError = 'Problem processing order. Please review your Shipping Method and try again.';
                if (this.hasNoShippingMethodsForStore()) {
                    try {
                        var throwIfNoShipping = this.isShippingRequired;
                        this.setStateFromCart(this.cart, throwIfNoShipping);
                    } catch (err) {
                        var errorMessage = (0, _get2.default)(err, 'message', genericError);
                        this.checkoutService.showErrorDialog(errorMessage);
                    }
                } else {
                    if (!bypassShipping) {
                        this.isUpdatingCart = true;
                        this.isStepTwoLoading = true;
                    }
                    return this.checkoutService.applyShippingMethodToCart(this.selectedShippingMethodIndex).then(function (updatedCart) {
                        _this5.didContinueStepTwo = true;
                        var throwIfNoShipping = true;
                        _this5.setStateFromCart(updatedCart, throwIfNoShipping);
                        _this5.scrollToCurrentStep();
                        _this5.trackStepTwoEvents();
                        (0, _dataLayer.logShippingInfo)(_this5.bag.tenantId, updatedCart);
                    }).catch(function (err) {
                        var errorMessage = (0, _get2.default)(err, 'message', genericError);
                        _this5.checkoutService.showErrorDialog(errorMessage);
                    }).finally(function () {
                        if (!bypassShipping) {
                            _this5.isUpdatingCart = false;
                            _this5.isStepTwoLoading = false;
                        }
                    });
                }
            }
        }, {
            key: 'onCheckoutClicked',
            value: function onCheckoutClicked() {
                var _this6 = this;

                if (this.paymentAndReviewForm && this.paymentAndReviewForm.$invalid || this.stripeElementsError) {
                    this.checkoutService.forceFormValidation(this.paymentAndReviewForm['$ctrl.addressForm']);
                    return;
                }

                this.isUpdatingCart = true;
                this.loadingService.show('Completing your order...');

                if (this.selectedPaymentMethod === 'Credit Card' && !this.storeInfo.authorizeNet.isEnabled && !this.storeInfo.acceptsStripeAsPayment) {
                    this.paypalSdkService.submitPayPalAcp().then(function (payload) {
                        _this6.paypal = {
                            payerId: undefined,
                            token: payload.orderId,
                            creditCardLastFour: payload.card.last_digits,
                            creditCardType: payload.card.card_type.toLowerCase()
                        };
                        _this6.paypalAcpUsed = true;
                        _this6.selectedPaymentMethod = 'PayPal';
                        _this6.validateAndPlaceOrder();
                    }).catch(function (err) {
                        _this6.isUpdatingCart = false;
                        _this6.loadingService.hide();
                        _this6.checkoutService.showErrorDialog(err.message, err.title);
                    });
                } else if (this.selectedPaymentMethod !== 'PayPal' || this.isReturnFromPaypal || !this.shouldShowPaymentTypeSelection()) {
                    this.validateAndPlaceOrder();
                }
            }
        }, {
            key: 'onStripeElementsCardChange',
            value: function onStripeElementsCardChange(_ref4) {
                var error = _ref4.error;

                this.stripeElementsError = error;
            }
        }, {
            key: 'validateAndPlaceOrder',
            value: function validateAndPlaceOrder() {
                var _this7 = this;

                return this.checkoutService.validateDiscounts(this.cart).then(function () {
                    if (_this7.isReturnFromPaypal || _this7.paypalAcpUsed) {
                        _this7.placePaypalOrder();
                    } else {
                        _this7.placeOrder();
                    }
                    _this7.trackStepThreeEvents();
                }).catch(function (err) {
                    if (err.invalidDiscounts) {
                        _this7.isUpdatingCart = true;
                        var shippingMethodsBefore = (0, _cloneDeep2.default)(_this7.cart.availableShippingMethods);
                        _this7.checkoutService.legacyRemoveDiscountCodeItem(err.invalidDiscounts).then(function (updatedCart) {
                            _this7.setStateFromCart(updatedCart);
                            _this7.compareShippingMethodChanges(shippingMethodsBefore);
                        }).finally(function () {
                            _this7.isUpdatingCart = false;
                            _this7.loadingService.hide();
                        });
                    } else {
                        _this7.isUpdatingCart = false;
                        _this7.loadingService.hide();
                    }
                    _this7.checkoutService.showErrorDialog(err.message, err.title);
                });
            }
        }, {
            key: 'placeOrder',
            value: function placeOrder() {
                var _this8 = this;

                var billingAddress = this.accountBillingAddress || this.billingAddressModel;
                this.checkoutService.applyBillingAddressToCart(billingAddress).then(function (updatedCart) {
                    var throwIfNoShipping = true;
                    _this8.setStateFromCart(updatedCart, throwIfNoShipping);
                    return _this8.applyShippingMethodToCartIfNeeded().then(_this8.sendOrderOptions.bind(_this8));
                }).then(_cartUtils.clearSavedStoreCreditInfo).catch(this.handleCheckoutError.bind(this)).finally(function () {
                    _this8.isUpdatingCart = false;
                    _this8.loadingService.hide();
                });
            }
        }, {
            key: 'handlePostOrderActions',
            value: function handlePostOrderActions() {
                var _this9 = this;

                var postOrderActions = [];
                var orderPaidEntirelyWithGiftCard = !this.shouldShowPaymentTypeSelection();

                if (this.isLoggedIn && this.saveLoggedInShopperInfo && this.stripe && this.stripeElementsCard && !(0, _get2.default)(this, 'savedPaymentMethods.length') && !orderPaidEntirelyWithGiftCard) {
                    // save payment method if shopper doesn't have one
                    postOrderActions.push(this.stripe.createToken(this.stripeElementsCard, (0, _creditCard.createStripeTokenMetadata)(this.cart.billingAddress)).then(function (response) {
                        return _this9.apiService.account.paymentMethod.add(response.token.id, true);
                    }));
                } else {
                    postOrderActions.push(this.$q.resolve());
                }

                if (!this.isLoggedIn && this.stripe && this.stripeElementsCard && !orderPaidEntirelyWithGiftCard) {
                    // If order was from anonymous Stripe shopper,
                    // create a second token in case shopper wants to save card post checkout.
                    // This needs to be done before stripe elements is unmounted.
                    postOrderActions.push(this.stripe.createToken(this.stripeElementsCard, (0, _creditCard.createStripeTokenMetadata)(this.cart.billingAddress)));
                }

                return this.$q.all(postOrderActions).then(function (_ref5) {
                    var _ref6 = _slicedToArray(_ref5, 2),
                        saveShopperAccountPaymentMethod = _ref6[0],
                        stripeTokenForAccountCreation = _ref6[1];

                    return {
                        saveShopperAccountPaymentMethod: saveShopperAccountPaymentMethod,
                        stripeTokenForAccountCreation: stripeTokenForAccountCreation
                    };
                });
            }
        }, {
            key: 'sendOrderOptions',
            value: function sendOrderOptions() {
                var _this10 = this;

                var placeOrderOptions = this.assembleOrderOptions();
                if (this.cartGrandTotalAdjusted() <= 0) {
                    placeOrderOptions.paymentMethod = 'Cash';
                }

                return this.orderService.placeOrder(placeOrderOptions).then(function (order) {
                    return _this10.handlePostOrderActions().then(function (_ref7) {
                        var stripeTokenForAccountCreation = _ref7.stripeTokenForAccountCreation;
                        return { order: order, stripeTokenForAccountCreation: stripeTokenForAccountCreation };
                    });
                }).then(function (_ref8) {
                    var order = _ref8.order,
                        stripeTokenForAccountCreation = _ref8.stripeTokenForAccountCreation;

                    _this10.stripeTokenForAccountCreation = stripeTokenForAccountCreation;
                    _this10.order = order;
                    _this10.scrollToId('checkout');
                    (0, _dataLayer.logPaymentMethod)(_this10.bag.tenantId, order.paymentMethod);
                    (0, _dataLayer.logPurchase)(_this10.bag.tenantId, order, _this10.returnUrl);
                });
            }
        }, {
            key: 'assembleOrderOptions',
            value: function assembleOrderOptions() {
                var authorizeNet = this.storeInfo.authorizeNet || {};
                var placeOrderOptions = {
                    authorizeNet: authorizeNet,
                    cart: this.cart,
                    paymentMethod: this.selectedPaymentMethod,
                    creditCardType: this.creditCardType,
                    shopperNote: this.orderNotes,
                    storeCreditInfo: this.storeCreditInfo,
                    stripe: this.stripe,
                    stripeElementsCard: this.stripeElementsCard
                };
                if (this.isLoggedIn) {
                    placeOrderOptions.customerId = this.apiService.getShopperId();

                    if (this.selectedCard) {
                        placeOrderOptions.stripeCreditCardId = this.selectedCard.id;
                    } else {
                        placeOrderOptions.card = this.creditCardModel;
                    }
                } else {
                    placeOrderOptions.card = this.creditCardModel;
                }
                return placeOrderOptions;
            }
        }, {
            key: 'handleCheckoutError',
            value: function handleCheckoutError(response) {
                this.gaService.sendOrderPlacementErrorEvent(response);
                var errorDetail = this.orderService.getErrorDetail(response);
                this.checkoutService.showErrorDialog(errorDetail);
            }
        }, {
            key: 'compareShippingMethodChanges',
            value: function compareShippingMethodChanges(before) {
                if (!(0, _isEqual2.default)(before, this.cart.availableShippingMethods)) {
                    this.editShippingMethodService.open(null, false, this.cart.availableShippingMethods, this.cart.shippingMethod).then(this.setStateFromCart.bind(this));
                }
            }
        }, {
            key: 'applyPromoCode',
            value: function applyPromoCode(code) {
                var _this11 = this;

                if (!code) return this.$q.reject('Cannot apply discount without code');

                this.promoCodeNotFound = false;
                this.promoCodeExpired = false;
                this.inactiveGiftCard = false;
                this.giftCardNotAllowed = false;
                this.cannotAddMoreStoreCredit = false;
                this.giftCardAlreadyApplied = false;
                var shippingMethodsBefore = (0, _cloneDeep2.default)(this.cart.availableShippingMethods);
                this.isUpdatingCart = true;
                var storeCreditLengthBeforeChanges = this.storeCreditInfo.items.length;
                return this.checkoutService.legacyApplyPromoCode(code, this.storeCreditInfo, this.cart).then(function (updatedCart) {
                    _this11.setStateFromCart(updatedCart);
                    _this11.compareShippingMethodChanges(shippingMethodsBefore);
                    if (!_this11.cart.discount && _this11.storeCreditInfo.items.length === storeCreditLengthBeforeChanges) {
                        _this11.promoCodeNotFound = true;
                    }
                }).catch(function (error) {
                    if (error.message === 'inactiveGiftCard') {
                        _this11.inactiveGiftCard = true;
                    } else if (error.message === 'giftCardNotAllowed') {
                        _this11.giftCardNotAllowed = true;
                    } else if (error.message === 'cannotAddMoreStoreCredit') {
                        _this11.cannotAddMoreStoreCredit = true;
                    } else if (error.message === 'giftCardAlreadyApplied') {
                        _this11.giftCardAlreadyApplied = true;
                    } else if (error.status === 404) {
                        _this11.promoCodeNotFound = true;
                    } else {
                        _this11.promoCodeExpired = true;
                    }
                }).finally(function () {
                    _this11.isUpdatingCart = false;
                });
            }
        }, {
            key: 'removeDiscountCodeItem',
            value: function removeDiscountCodeItem(discountId) {
                var _this12 = this;

                if (!this.cart.discounts || this.cart.discounts.length === 0) {
                    return this.$q.reject('No promo code to remove');
                }

                this.promoCodeNotFound = false;
                this.promoCodeExpired = false;
                var shippingMethodsBefore = (0, _cloneDeep2.default)(this.cart.availableShippingMethods);
                this.isUpdatingCart = true;
                return this.checkoutService.legacyRemoveDiscountCodeItem(discountId).then(function (updatedCart) {
                    _this12.setStateFromCart(updatedCart);
                    _this12.compareShippingMethodChanges(shippingMethodsBefore);
                }).catch(function () {
                    _this12.checkoutService.showErrorDialog('Error removing promo code');
                }).finally(function () {
                    _this12.isUpdatingCart = false;
                });
            }
        }, {
            key: 'removeStoreCreditItem',
            value: function removeStoreCreditItem(code) {
                var storeCreditIndex = this.storeCreditInfo.items.findIndex(function (item) {
                    return item.giftCardCode === code;
                });
                if (storeCreditIndex > -1) {
                    this.storeCreditInfo.items.splice(storeCreditIndex, 1);
                }
                this.storeCreditInfo = this.applyGiftCardTotals(this.cart, this.storeCreditInfo);
                (0, _cartUtils.setSavedStoreCreditInfo)(this.storeCreditInfo);
            }
        }, {
            key: 'onOrderNotesChanged',
            value: function onOrderNotesChanged(orderNotes) {
                this.orderNotes = orderNotes;
                this.$window.localStorage.setItem(this.cart.id, orderNotes);
            }
        }, {
            key: 'getSelectedShippingMethodIndex',
            value: function getSelectedShippingMethodIndex(cart) {
                if (cart.shippingMethod) {
                    return (0, _cartUtils.getShippingMethodIndex)(cart.availableShippingMethods, cart.shippingMethod);
                } else if (!cart.availableShippingMethods) {
                    return noShippingMethodsIndex;
                }
            }
        }, {
            key: 'getSelectedShippingMethodIndexOrDefault',
            value: function getSelectedShippingMethodIndexOrDefault(cart) {
                var defaultIndex = angular.isDefined(this.selectedShippingMethodIndex) ? this.selectedShippingMethodIndex : 0;
                var selectedShippingMethodIndex = this.getSelectedShippingMethodIndex(cart);
                return angular.isDefined(selectedShippingMethodIndex) ? selectedShippingMethodIndex : defaultIndex;
            }
        }, {
            key: 'ensureShippingSelected',
            value: function ensureShippingSelected(cart) {
                this.selectedShippingMethodIndex = this.getSelectedShippingMethodIndexOrDefault(cart);
            }
        }, {
            key: 'onEditStepOneClicked',
            value: function onEditStepOneClicked($event) {
                var _this13 = this;

                if (this.isLoggedIn && this.savedShippingAddresses && this.savedShippingAddresses.items && this.savedShippingAddresses.items.length) {
                    this.editAccountContactAndDeliveryService.open(this.loggedInShopper, this.storeInfo.isCheckoutPhoneNumberRequired, this.cart.selectedShippingAddressId, this.paypalData, this.isShippingRequired, $event).then(function (_ref9) {
                        var shopperAccount = _ref9.shopperAccount,
                            cart = _ref9.cart;

                        if (shopperAccount) _this13.loggedInShopper = shopperAccount;
                        _this13.contactInfoModel = { email: shopperAccount.emailAddress, phoneNumber: shopperAccount.phoneNumber };
                        if (cart) _this13.setStateFromCart(cart);
                        (0, _dataLayer.logShopperInfo)(_this13.bag.tenantId, cart);
                    });
                } else {
                    this.editContactAndDeliveryService.open(this.cart, this.storeInfo.isCheckoutPhoneNumberRequired, !this.isReturnFromPaypal && this.isShippingRequired, $event, this.onLoginClicked.bind(this), this.isLoggedIn, this.isShippingRequired, this.useAddressVerification).then(function (cart) {
                        _this13.setStateFromCart(cart);
                        (0, _dataLayer.logShopperInfo)(_this13.bag.tenantId, cart);
                    });
                }
            }
        }, {
            key: 'onEditStepTwoClicked',
            value: function onEditStepTwoClicked($event) {
                var _this14 = this;

                this.editShippingMethodService.open($event, false, this.cart.availableShippingMethods, this.cart.shippingMethod).then(function (cart) {
                    _this14.setStateFromCart(cart);
                    (0, _dataLayer.logShippingInfo)(_this14.bag.tenantId, cart);
                });
            }
        }, {
            key: 'onEditStepThreeClicked',
            value: function onEditStepThreeClicked($event) {
                var _this15 = this;

                if (this.isLoggedIn) {
                    var selectedPaymentMethod = void 0;
                    if (this.selectedCard) {
                        selectedPaymentMethod = this.selectedCard.id;
                    } else if (this.isReturnFromPaypal) {
                        selectedPaymentMethod = 'PayPal';
                    } else {
                        selectedPaymentMethod = null;
                    }

                    this.editAccountPaymentService.open(selectedPaymentMethod, this.stripe, $event).then(function (paymentMethod) {
                        if (paymentMethod === 'PayPal') {
                            _this15.selectedPaymentMethod = paymentMethod;
                        } else {
                            if (_this15.isReturnFromPaypal) {
                                _this15.endPaypalSession();
                            }
                            _this15.setAccountPaymentInfo(paymentMethod);
                        }
                    });
                } else if (this.isReturnFromPaypal && !this.paypalCancelled) {
                    this.endPaypalSession();
                }
            }
        }, {
            key: 'scrollToCurrentStep',
            value: function scrollToCurrentStep() {
                this.scrollToId('checkout-step-' + this.currentStep);
            }
        }, {
            key: 'scrollToId',
            value: function scrollToId(selector) {
                var _this16 = this;

                this.$timeout(function () {
                    _this16.$anchorScroll(selector);
                });
            }
        }, {
            key: 'initPaypalReturn',
            value: function initPaypalReturn() {
                var _this17 = this;

                this.isReturnFromPaypal = true;
                this.loadingService.show('Returning to order review...');
                this.selectedPaymentMethod = 'PayPal';
                this.paypal = {
                    token: this.$stateParams.token,
                    payerId: this.$stateParams.PayerID
                };
                this.paypalSdkService.setPaypalDataToCart(this.paypal.token, this.paypal.payerId).then(function (_ref10) {
                    var updatedCart = _ref10.updatedCart,
                        paypalData = _ref10.paypalData;

                    _this17.paypalData = paypalData;
                    _this17.ensureShippingSelected(updatedCart);
                    var throwIfNoShipping = true;
                    return _this17.setStateFromCart(updatedCart, throwIfNoShipping);
                }).then(function () {
                    return _this17.trackPaypalReturnEvents();
                }).catch(function (err) {
                    _this17.endPaypalSession();
                    _this17.checkoutService.showErrorDialog('Error with PayPal: ' + err, 'Error');
                }).finally(function () {
                    _this17.loadingService.hide();
                });
            }
        }, {
            key: 'endPaypalSession',
            value: function endPaypalSession() {
                this.$location.search('token', null);
                this.$location.search('PayerID', null);
                this.isReturnFromPaypal = false;
                this.setStateFromCart(this.cart);
            }
        }, {
            key: 'applyShippingMethodToCartIfNeeded',
            value: function applyShippingMethodToCartIfNeeded() {
                if (!this.cart.shippingMethod) {
                    var selectedIndex = this.selectedShippingMethodIndex || 0;
                    return this.checkoutService.applyShippingMethodToCart(selectedIndex).then(this.setStateFromCart.bind(this));
                }
                return this.$q.resolve();
            }
        }, {
            key: 'placePaypalOrder',
            value: function placePaypalOrder() {
                var _this18 = this;

                this.isUpdatingCart = true;
                this.loadingService.show('Completing your order...');

                var placeOrderOptions = {
                    card: {
                        creditCardLastFour: this.paypal.creditCardLastFour
                    },
                    creditCardType: this.paypal.creditCardType,
                    cart: this.cart,
                    paymentMethod: this.selectedPaymentMethod,
                    payPalPayerId: this.paypal.payerId,
                    payPalExpressCheckoutToken: this.paypal.token,
                    storeCreditInfo: this.storeCreditInfo,
                    shopperNote: this.orderNotes,
                    authorizeNet: {}
                };

                if (this.isLoggedIn) {
                    placeOrderOptions.customerId = this.apiService.getShopperId();
                }

                return this.orderService.placeOrder(placeOrderOptions).then(function (order) {
                    _this18.order = order;
                    _this18.scrollToId('checkout');
                    (0, _cartUtils.clearSavedStoreCreditInfo)();
                }).catch(this.handleCheckoutError.bind(this)).finally(function () {
                    _this18.isUpdatingCart = false;
                    _this18.loadingService.hide();
                });
            }
        }, {
            key: 'onLoginClicked',
            value: function onLoginClicked() {
                var _this19 = this;

                if (this.authService.useUniversalLogin()) {
                    this.authService.login();
                } else {
                    this.loginModalService.open().then(function () {
                        return _this19.handleShopperLoggedIn();
                    });
                }
            }
        }, {
            key: 'handleShopperLoggedIn',
            value: function handleShopperLoggedIn() {
                var _this20 = this;

                this.loadingService.show('Getting account info...');
                return this.shopperAccountService.initShopperAccount(this.cart).then(function (_ref11) {
                    var shopperAccount = _ref11.shopperAccount,
                        shippingAddresses = _ref11.shippingAddresses,
                        paymentMethods = _ref11.paymentMethods,
                        updatedCart = _ref11.updatedCart;

                    _this20.setAccountInfo(shopperAccount, shippingAddresses, paymentMethods, updatedCart);
                }).finally(function () {
                    _this20.loadingService.hide();
                });
            }
        }, {
            key: 'initShopperAccount',
            value: function initShopperAccount(isReturnFromPaypal) {
                var _this21 = this;

                this.authService.getShopperId().then(function (shopperId) {
                    _this21.apiService.setShopperId(shopperId);
                    if (isReturnFromPaypal) {
                        _this21.apiService.account.get().then(function (shopperAccount) {
                            _this21.loggedInShopper = shopperAccount;
                        });
                    } else {
                        _this21.loadingService.show('Getting account information...');
                        _this21.shopperAccountService.initShopperAccount(_this21.cart).then(function (_ref12) {
                            var shopperAccount = _ref12.shopperAccount,
                                shippingAddresses = _ref12.shippingAddresses,
                                paymentMethods = _ref12.paymentMethods,
                                updatedCart = _ref12.updatedCart;

                            return _this21.setAccountInfo(shopperAccount, shippingAddresses, paymentMethods, updatedCart);
                        }).finally(function () {
                            _this21.loadingService.hide();
                        });
                    }
                });
            }
        }, {
            key: 'updateCreditCardType',
            value: function updateCreditCardType(creditCardType) {
                this.creditCardType = creditCardType;
            }
        }, {
            key: 'setAccountInfo',
            value: function setAccountInfo(shopperAccount, shippingAddresses, paymentMethods, updatedCart) {
                if (paymentMethods) {
                    this.savedPaymentMethods = paymentMethods.items;
                }
                this.savedShippingAddresses = shippingAddresses;
                if (updatedCart) {
                    this.setStateFromCart(updatedCart);
                }
                this.isLoggedIn = true;
                this.loggedInShopper = shopperAccount;
                if (!this.isReturnFromPaypal && paymentMethods && this.storeInfo.acceptsStripeAsPayment) {
                    var defaultPaymentMethod = (0, _find2.default)(paymentMethods.items, 'isDefault');
                    if (defaultPaymentMethod) {
                        this.setAccountPaymentInfo(defaultPaymentMethod);
                    }
                }
                this.contactInfoModel = { email: shopperAccount.emailAddress, phoneNumber: shopperAccount.phoneNumber };
            }
        }, {
            key: 'setAccountPaymentInfo',
            value: function setAccountPaymentInfo(paymentMethod) {
                if (!paymentMethod) return;
                this.selectedPaymentMethod = 'Credit Card';
                this.selectedCard = paymentMethod;
                this.accountBillingAddress = {
                    firstName: paymentMethod.name,
                    address1: paymentMethod.address.line1,
                    address2: paymentMethod.address.line2,
                    city: paymentMethod.address.city,
                    state: paymentMethod.address.state,
                    postalCode: paymentMethod.address.zip,
                    country: paymentMethod.address.country
                };
            }
        }, {
            key: 'trackPaypalReturnEvents',
            value: function trackPaypalReturnEvents() {
                this.gaService.logCheckoutStep(this.GA_CHECKOUT_STEPS.contactInfo, 'PayPal', this.cart);
                this.gaService.logCheckoutStep(this.GA_CHECKOUT_STEPS.shippingAddress, 'PayPal', this.cart);
                this.gaService.logCheckoutStep(this.GA_CHECKOUT_STEPS.billingAddress, 'PayPal', this.cart);
                this.gaService.logCheckoutStep(this.GA_CHECKOUT_STEPS.paymentMethod, 'PayPal', this.cart);
                this.gaService.logCheckoutStep(this.GA_CHECKOUT_STEPS.shippingMethod, 'PayPal', this.cart);

                (0, _dataLayer.logCheckoutStarted)(this.bag.tenantId, this.cart, this.returnUrl);
                (0, _dataLayer.logShopperInfo)(this.bag.tenantId, this.cart);
                (0, _dataLayer.logShippingInfo)(this.bag.tenantId, this.cart);
                (0, _dataLayer.logPaymentMethod)(this.bag.tenantId, 'PayPal');
            }
        }, {
            key: 'trackStepOneEvents',
            value: function trackStepOneEvents() {
                this.gaService.logCheckoutStep(this.GA_CHECKOUT_STEPS.contactInfo, this.contactInfoModel.emailOptIn, this.cart);
                this.gaService.logCheckoutStep(this.GA_CHECKOUT_STEPS.shippingAddress, this.shippingAddressModel.state, this.cart);
            }
        }, {
            key: 'trackStepTwoEvents',
            value: function trackStepTwoEvents() {
                this.gaService.logCheckoutStep(this.GA_CHECKOUT_STEPS.shippingMethod, this.cart.shippingMethod.name || 'none', this.cart);
            }
        }, {
            key: 'trackStepThreeEvents',
            value: function trackStepThreeEvents() {
                this.gaService.logCheckoutStep(this.GA_CHECKOUT_STEPS.billingAddress, this.billingSameAsShipping, this.cart);
                this.gaService.logCheckoutStep(this.GA_CHECKOUT_STEPS.paymentMethod, this.selectedPaymentMethod, this.cart);
            }
        }, {
            key: 'shouldShowAccountPaymentAndBilling',
            value: function shouldShowAccountPaymentAndBilling() {
                return this.isLoggedIn && this.selectedPaymentMethod === 'Credit Card' && angular.isDefined(this.selectedCard) && angular.isDefined(this.accountBillingAddress);
            }
        }, {
            key: 'shouldShowCheckoutWithPaypalButton',
            value: function shouldShowCheckoutWithPaypalButton() {
                return this.selectedPaymentMethod === 'PayPal' && !this.isReturnFromPaypal;
            }
        }, {
            key: 'shouldShowEditStepTwoButton',
            value: function shouldShowEditStepTwoButton() {
                return this.steps.shippingMethod.complete && this.selectedShippingMethodIndex !== noShippingMethodsIndex && this.isShippingRequired;
            }
        }, {
            key: 'shouldShowEditStepThreeButton',
            value: function shouldShowEditStepThreeButton() {
                return this.isReturnFromPaypal && !this.paypalCancelled || this.isLoggedIn && this.savedPaymentMethods && this.savedPaymentMethods.length > 0;
            }
        }, {
            key: 'shouldShowPaymentMethodForm',
            value: function shouldShowPaymentMethodForm() {
                return (!this.isReturnFromPaypal || this.paypalCancelled) && !this.selectedCard && !this.accountBillingAddress;
            }
        }, {
            key: 'shouldShowLoginButton',
            value: function shouldShowLoginButton() {
                return !this.steps.contactAndDelivery.complete && !this.isLoggedIn;
            }
        }, {
            key: 'shouldShowSecondaryLoginButton',
            value: function shouldShowSecondaryLoginButton() {
                return this.isReturnFromPaypal && this.steps.contactAndDelivery.complete && !this.isLoggedIn;
            }
        }, {
            key: 'shouldShowPromoCodeLink',
            value: function shouldShowPromoCodeLink() {
                return this.isMobile && !this.shouldShowEditStepThreeButton() || !this.isMobile;
            }
        }, {
            key: 'shouldStepOneBeOpen',
            value: function shouldStepOneBeOpen() {
                return this.currentStep === this.steps.contactAndDelivery.number || this.steps.contactAndDelivery.complete;
            }
        }, {
            key: 'shouldStepTwoBeOpen',
            value: function shouldStepTwoBeOpen() {
                return this.currentStep === this.steps.shippingMethod.number || this.steps.shippingMethod.complete;
            }
        }, {
            key: 'shouldStepThreeBeOpen',
            value: function shouldStepThreeBeOpen() {
                return this.currentStep === this.steps.paymentAndReview.number || this.steps.paymentAndReview.complete;
            }
        }, {
            key: 'shouldShowStepTwoContinueButton',
            value: function shouldShowStepTwoContinueButton() {
                return this.steps.contactAndDelivery.complete && this.cart.availableShippingMethods.length > 0;
            }
        }, {
            key: 'isContactAndDeliveryComplete',
            value: function isContactAndDeliveryComplete(cart) {
                if (cart.shippingAddress && cart.contactInfo) {
                    if (this.storeInfo.isCheckoutPhoneNumberRequired) {
                        return !!cart.contactInfo.email && !!cart.contactInfo.phoneNumber;
                    }
                    return true;
                }
                return false;
            }
        }, {
            key: 'cartGrandTotalAdjusted',
            value: function cartGrandTotalAdjusted() {
                return this.cart.grandTotal - this.storeCreditInfo.storeCreditAmountInCents / 100;
            }
        }, {
            key: 'shouldShowPaymentTypeSelection',
            value: function shouldShowPaymentTypeSelection() {
                return this.cartGrandTotalAdjusted() > 0;
            }
        }]);

        return CheckoutCtrl;
    }()
}).name;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 928 */
/***/ (function(module, exports) {

module.exports = "<header-background store-info=\"$ctrl.storeInfo\"> <div class=\"checkout\" id=\"checkout\" ng-if=\"!$ctrl.order\"> <checkout-header store-info=\"$ctrl.storeInfo\" return-url=\"$ctrl.returnUrl\" is-logged-in=\"$ctrl.isLoggedIn\" logged-in-shopper-name=\"$ctrl.loggedInShopper.firstName || $ctrl.loggedInShopper.emailAddress\"> </checkout-header> <div class=\"paypal-pay-in-four-messaging\"></div> <div layout=\"column\" layout-gt-sm=\"row\"> <div flex=\"100\" flex-gt-sm=\"60\"> <accordian heading-text=\"$ctrl.stepOneHeadingText\" step-number=\"1\" open=\"$ctrl.shouldStepOneBeOpen()\" light=\"$ctrl.steps.contactAndDelivery.complete\"> <accordian-header-content> <edit-step-button on-click=\"$ctrl.onEditStepOneClicked(event)\" ng-if=\"$ctrl.steps.contactAndDelivery.complete\"> </edit-step-button> <login-button ng-if=\"$ctrl.shouldShowLoginButton()\" on-login-clicked=\"$ctrl.onLoginClicked()\"> </login-button> </accordian-header-content> <accordian-content> <div ng-if=\"!$ctrl.steps.contactAndDelivery.complete && !$ctrl.showAddressSuggestion\"> <ng-form name=\"$ctrl.contactAndDeliveryForm\"> <h3 class=\"checkout-section-heading\">Contact info</h3> <contact-info-form phone-number-required=\"$ctrl.storeInfo.isCheckoutPhoneNumberRequired\" email-input-disabled=\"$ctrl.isLoggedIn\" model=\"$ctrl.contactInfoModel\"> </contact-info-form> <hr> <div class=\"checkout-section-heading\"> <h3 ng-if=\"$ctrl.isShippingRequired\" class=\"checkout-section-heading__title\">Shipping address</h3> <h3 ng-if=\"!$ctrl.isShippingRequired\" class=\"checkout-section-heading__title\">Billing address</h3> <div class=\"curbside-shipping-available\" ng-if=\"$ctrl.curbsideShippingAvailable\"> We offer Curbside Pickup as a shipping method. Please continue to enter your shipping address. </div> </div> <shipping-address-form model=\"$ctrl.shippingAddressModel\" use-address-verification=\"$ctrl.useAddressVerification\" hide-shipping-as-billing=\"!$ctrl.isShippingRequired\"> </shipping-address-form> </ng-form> <div layout layout-align-xs=\"center start\" layout-align-gt-xs=\"end start\" class=\"checkout-step-footer\"> <continue-button ng-if=\"$ctrl.isShippingRequired\" is-disabled=\"$ctrl.isUpdatingCart\" is-loading=\"$ctrl.isStepOneLoading\" on-clicked=\"$ctrl.onStepOneContinueClicked()\"> Continue to Shipping Method </continue-button> <continue-button ng-if=\"!$ctrl.isShippingRequired\" is-disabled=\"$ctrl.isUpdatingCart\" is-loading=\"$ctrl.isStepOneLoading\" on-clicked=\"$ctrl.onStepOneContinueClicked()\"> Skip to Payment &amp; Review </continue-button> </div> </div> <div ng-if=\"!$ctrl.steps.contactAndDelivery.complete && $ctrl.showAddressSuggestion\"> <address-verification-form contact-info=\"$ctrl.contactInfoModel\" address=\"$ctrl.shippingAddressModel\" recommendations=\"$ctrl.verificationRecommendations\" changes=\"$ctrl.verificationChanges\" on-choose-address=\"$ctrl.updateAddress\" loading=\"$ctrl.isStepOneLoading\"/> </div> <display-contact-and-delivery ng-if=\"$ctrl.steps.contactAndDelivery.complete\" is-shipping-required=\"$ctrl.isShippingRequired\" cart=\"$ctrl.cart\"> </display-contact-and-delivery> <secondary-login-button ng-if=\"$ctrl.shouldShowSecondaryLoginButton()\" on-login-clicked=\"$ctrl.onLoginClicked()\"> </secondary-login-button> </accordian-content> </accordian> <accordian heading-text=\"$ctrl.stepTwoHeadingText\" step-number=\"2\" open=\"$ctrl.shouldStepTwoBeOpen()\" light=\"$ctrl.steps.shippingMethod.complete\" id=\"checkout-step-2\"> <accordian-header-content> <edit-step-button on-click=\"$ctrl.onEditStepTwoClicked(event)\" ng-if=\"$ctrl.shouldShowEditStepTwoButton()\"> </edit-step-button> </accordian-header-content> <accordian-content> <div ng-if=\"!$ctrl.steps.shippingMethod.complete\"> <ng-form name=\"$ctrl.shippingMethodStepForm\"> <shipping-method-form shipping-methods=\"$ctrl.cart.availableShippingMethods\" selected-method-index=\"$ctrl.selectedShippingMethodIndex\" disable-form=\"$ctrl.isUpdatingCart\"> </shipping-method-form> </ng-form> <div layout layout-align-xs=\"center start\" layout-align-gt-xs=\"end start\" class=\"checkout-step-footer\" ng-if=\"$ctrl.shouldShowStepTwoContinueButton()\"> <continue-button is-disabled=\"$ctrl.isUpdatingCart\" is-loading=\"$ctrl.isStepTwoLoading\" on-clicked=\"$ctrl.onStepTwoContinueClicked()\"> Continue to Payment &amp; Review </continue-button> </div> </div> <display-shipping-method ng-if=\"$ctrl.steps.shippingMethod.complete\" shipping-method=\"$ctrl.cart.availableShippingMethods[$ctrl.selectedShippingMethodIndex]\"> </display-shipping-method> </accordian-content> </accordian> <accordian heading-text=\"$ctrl.stepThreeHeadingText\" step-number=\"3\" open=\"$ctrl.shouldStepThreeBeOpen()\" light=\"$ctrl.steps.paymentAndReview.complete\" id=\"checkout-step-3\" class=\"checkout-step-3\"> <accordian-header-content> <div layout layout-align=\"start center\"> <promo-code-link ng-if=\"$ctrl.shouldShowPromoCodeLink()\"></promo-code-link> <edit-step-button on-click=\"$ctrl.onEditStepThreeClicked()\" ng-if=\"$ctrl.shouldShowEditStepThreeButton()\"> </edit-step-button> </div> </accordian-header-content> <accordian-content> <div ng-if=\"$ctrl.shouldShowPaymentTypeSelection()\"> <ng-form name=\"$ctrl.paymentAndReviewForm\" ng-if=\"$ctrl.shouldShowPaymentMethodForm()\"> <payment-method-form available-payment-methods=\"$ctrl.availablePaymentMethods\" selected-payment-method=\"$ctrl.selectedPaymentMethod\" credit-card-model=\"$ctrl.creditCardModel\" on-credit-card-type-updated=\"$ctrl.updateCreditCardType\" billing-address-model=\"$ctrl.billingAddressModel\" billing-same-as-shipping=\"$ctrl.billingSameAsShipping\" store-info=\"$ctrl.storeInfo\" stripe-elements-card=\"$ctrl.stripeElementsCard\" on-stripe-elements-card-change=\"$ctrl.onStripeElementsCardChange\" is-shipping-required=\"$ctrl.isShippingRequired\" cart-id=\"$ctrl.cart.id\" bag-id=\"$ctrl.bag.id\"> </payment-method-form> </ng-form> <md-checkbox ng-model=\"$ctrl.saveLoggedInShopperInfo\" ng-if=\"$ctrl.isLoggedIn && (!$ctrl.savedShippingAddresses.items.length || !$ctrl.savedPaymentMethods.length)\" class=\"save-shopper-info-checkbox\"> Save my information for a faster checkout </md-checkbox> <display-billing-and-payment ng-if=\"$ctrl.isReturnFromPaypal && !$ctrl.paypalAcpUsed\" payment-method=\"'PayPal'\" paypal-email=\"$ctrl.cart.contactInfo.email\"> </display-billing-and-payment> <display-billing-and-payment ng-if=\"$ctrl.shouldShowAccountPaymentAndBilling()\" payment-method=\"'Credit Card'\" credit-card-type=\"$ctrl.selectedCard.brand\" credit-card-last-four=\"$ctrl.selectedCard.lastFour\" cart-address=\"$ctrl.accountBillingAddress\"> </display-billing-and-payment> </div> <div ng-if=\"!$ctrl.shouldShowPaymentTypeSelection()\" class=\"no-payment-needed\"> Order total is {{$ctrl.cartGrandTotalAdjusted() | currency}}. No additional payment necessary. </div> <div layout layout-align-sm=\"center start\" layout-align-gt-sm=\"end start\" class=\"checkout-step-footer\" ng-if=\"!$ctrl.shouldShowCheckoutWithPaypalButton() || !$ctrl.shouldShowPaymentTypeSelection()\"> <div layout=\"column\" layout-align=\"center center\" flex-xs=\"100\" flex-sm=\"100\"> <continue-button is-disabled=\"$ctrl.isUpdatingCart\" on-clicked=\"$ctrl.onCheckoutClicked()\"> Complete your order </continue-button> <secure-label></secure-label> </div> </div> <div layout=\"column\" layout-align=\"start center\" class=\"checkout-step-footer\" ng-if=\"$ctrl.shouldShowCheckoutWithPaypalButton() && $ctrl.shouldShowPaymentTypeSelection()\"> <div> <checkout-with-paypal-sdk-button cart-id=\"$ctrl.cart.id\" bag-id=\"$ctrl.bag.id\" get-gift-cards=\"$ctrl.getGiftCards\"> </checkout-with-paypal-sdk-button> <secure-label></secure-label> </div> </div> </accordian-content> </accordian> </div> <order-summary flex=\"100\" flex-gt-sm=\"40\" flex-order=\"-1\" flex-order-gt-sm=\"0\" cart=\"$ctrl.cart\" bag=\"$ctrl.bag\" order-notes=\"$ctrl.orderNotes\" store-credit-info=\"$ctrl.storeCreditInfo\" on-apply-promo-clicked=\"$ctrl.applyPromoCode\" on-remove-promo-clicked=\"$ctrl.removeDiscountCodeItem\" remove-discount-code-item=\"$ctrl.removeDiscountCodeItem\" remove-store-credit-item=\"$ctrl.removeStoreCreditItem\" promo-code-not-found=\"$ctrl.promoCodeNotFound\" promo-code-expired=\"$ctrl.promoCodeExpired\" gift-card-already-applied=\"$ctrl.giftCardAlreadyApplied\" inactive-gift-card=\"$ctrl.inactiveGiftCard\" gift-card-not-allowed=\"$ctrl.giftCardNotAllowed\" cannot-add-more-store-credit=\"$ctrl.cannotAddMoreStoreCredit\" on-order-notes-changed=\"$ctrl.onOrderNotesChanged\" show-checkout-button=\"$ctrl.currentStep === $ctrl.steps.paymentAndReview.number\" checkout-button-disabled=\"$ctrl.isUpdatingCart\" on-checkout-clicked=\"$ctrl.onCheckoutClicked\" payment-method=\"$ctrl.selectedPaymentMethod\" is-return-from-paypal=\"$ctrl.isReturnFromPaypal\" is-shipping-required=\"$ctrl.isShippingRequired\"> </order-summary> </div> </div> <thank-you ng-if=\"$ctrl.order\" order=\"$ctrl.order\" store-credit-info=\"$ctrl.storeCreditInfo\" is-logged-in=\"$ctrl.isLoggedIn\" store-info=\"$ctrl.storeInfo\" return-url=\"$ctrl.returnUrl\" show-create-account=\"!$ctrl.isLoggedIn && !$ctrl.shopperIsRegistered\" stripe-token-for-account-creation=\"$ctrl.stripeTokenForAccountCreation\"> </thank-you> </header-background> <fullscreen-loader ng-if=\"$root.loader.show\" title-text=\"$root.loader.titleText\" title-image=\"$root.loader.imageUri\" description=\"$root.loader.description\"> </fullscreen-loader> ";

/***/ }),
/* 929 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[340]);


// WEBPACK FOOTER //
// js/app.3393410156275814016c.js